import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
};

export enum AcTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Payment = 'PAYMENT',
  Purchase = 'PURCHASE',
  Refund = 'REFUND',
  Signup = 'SIGNUP',
  Transfer = 'TRANSFER'
}

export enum AccountType {
  Main = 'MAIN',
  Sub = 'SUB'
}

export enum AccountTypeFilter {
  Member = 'MEMBER',
  NonMember = 'NON_MEMBER',
  Staff = 'STAFF',
  Test = 'TEST'
}

export type AceCoinLedgerTransaction = {
  __typename?: 'AceCoinLedgerTransaction';
  account?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  description: Scalars['String'];
  direction: Scalars['Int'];
  id: Scalars['Int'];
  invoiceNo?: Maybe<Scalars['String']>;
  lineTotal: Scalars['Float'];
  transactionDateTime: Scalars['DateTime'];
  transactionId: Scalars['String'];
  type: AcTransactionType;
  venue?: Maybe<Scalars['String']>;
};

export type AceCoinRatioInput = {
  amtAward?: InputMaybe<Scalars['Int']>;
  amtPurchase?: InputMaybe<Scalars['Int']>;
};

export type AceCoinTransaction = {
  __typename?: 'AceCoinTransaction';
  account?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  description: Scalars['String'];
  direction: Scalars['Int'];
  id: Scalars['Int'];
  invoiceNo?: Maybe<Scalars['String']>;
  transactionDateTime: Scalars['DateTime'];
  transactionId: Scalars['String'];
  type: AcTransactionType;
  venue?: Maybe<Scalars['String']>;
};

export enum AceCoinTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  AwardDiscount = 'AWARD_DISCOUNT',
  Discount = 'DISCOUNT',
  Payment = 'PAYMENT',
  Purchase = 'PURCHASE',
  Refund = 'REFUND',
  Transfer = 'TRANSFER'
}

export type Admin = SystemUser & {
  __typename?: 'Admin';
  authorizedClubhouses?: Maybe<Array<Maybe<Scalars['String']>>>;
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins?: Maybe<Array<Maybe<LoginInfo>>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  permissions: Array<Maybe<Scalars['String']>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type AdminActivateMembershipInput = {
  activationOrderNo: Scalars['String'];
  membershipUuid: Scalars['String'];
  paymentMethod: PaymentMethod;
  paymentProvider: PaymentProvider;
  paymentRef?: InputMaybe<Scalars['String']>;
};

export type AdminAdminUpdatePasswordInput = {
  adminId: Scalars['String'];
  password: Scalars['String'];
};

export type AdminArgs = {
  userId: Scalars['String'];
};

export type AdminAuthResponse = {
  __typename?: 'AdminAuthResponse';
  accessToken: Scalars['String'];
  authenticatedAdmin: AuthenticatedAdmin;
};

export type AdminBasic = {
  __typename?: 'AdminBasic';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
  userName: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type AdminBooking = {
  __typename?: 'AdminBooking';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  cancellationNotificationByAppSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationByEmailSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationBySmsSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationMessage?: Maybe<Scalars['String']>;
  cancellationNotificationSentBy?: Maybe<SentBy>;
  cancellationNotificationSentByAdminId?: Maybe<Scalars['String']>;
  cancellationNotificationSentByAdminName?: Maybe<Scalars['String']>;
  cancellationNotificationSentDateTime?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<CancelledBy>;
  cancelledByAdminName?: Maybe<Scalars['String']>;
  clubhouseCode?: Maybe<Scalars['String']>;
  coachDateId?: Maybe<Scalars['String']>;
  coachId?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  commentAdminToCoach?: Maybe<Scalars['String']>;
  commentAdminToMember?: Maybe<Scalars['String']>;
  commentByCoach?: Maybe<Scalars['String']>;
  commentByCoachId?: Maybe<Scalars['String']>;
  commentInternal?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dateMonthStr?: Maybe<Scalars['String']>;
  dateStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  durationStr?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  endTimeStr?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<GameCourseType>;
  groupBookingId?: Maybe<Scalars['String']>;
  groupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  id: Scalars['String'];
  isGroupBooking: Scalars['Boolean'];
  lateCancellationDetails?: Maybe<Scalars['JSON']>;
  member: Scalars['String'];
  memberHasGroupMembers: Scalars['Boolean'];
  memberIndividualId: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  noOfPlayers: Scalars['Int'];
  playerName?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  startTimeStr?: Maybe<Scalars['String']>;
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type AdminBookingArgs = {
  bookingId: Scalars['String'];
};

export type AdminBookingAvailabilityArgs = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  durationType?: InputMaybe<DurationType>;
  facilityType?: InputMaybe<FacilityType>;
};

export type AdminBookingBasic = {
  __typename?: 'AdminBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  coachDisplayName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dateMonthStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  durationStr?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  endTimeStr?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<GameCourseType>;
  groupBookingId?: Maybe<Scalars['String']>;
  groupBookingIds: Array<Maybe<Scalars['String']>>;
  id: Scalars['String'];
  isGroupBooking: Scalars['Boolean'];
  lateCancellationDetails?: Maybe<Scalars['JSON']>;
  member: Scalars['String'];
  memberUuid: Scalars['String'];
  playerName?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  startTimeStr?: Maybe<Scalars['String']>;
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type AdminBookingBasicMember = {
  __typename?: 'AdminBookingBasicMember';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminBookingBlackoutBasic = {
  __typename?: 'AdminBookingBlackoutBasic';
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouseName?: Maybe<Scalars['String']>;
  coachDisplayName?: Maybe<Scalars['String']>;
  coachSlug?: Maybe<Scalars['String']>;
  countryCode?: Maybe<CountryCode>;
  date: Scalars['String'];
  type: Scalars['String'];
};

export type AdminBookingBlackoutClubhouse = {
  __typename?: 'AdminBookingBlackoutClubhouse';
  block08: Scalars['Boolean'];
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  block21: Scalars['Boolean'];
  block22: Scalars['Boolean'];
  block23: Scalars['Boolean'];
  clubhouseCode?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  facilityObjs: Array<Maybe<AdminClubhouseFacilityAvailabilityFacilityObj>>;
  isDayBlocked: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AdminBookingBlackoutClubhouseArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
};

export type AdminBookingBlackoutClubhouseUpdateInput = {
  block08: Scalars['Boolean'];
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  block21: Scalars['Boolean'];
  block22: Scalars['Boolean'];
  block23: Scalars['Boolean'];
  blockDay: Scalars['Boolean'];
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  facilityAvailability: Array<InputMaybe<AdminBookingBlackoutCreateFacilityAvailabilityInput>>;
};

export type AdminBookingBlackoutCoach = {
  __typename?: 'AdminBookingBlackoutCoach';
  block08: Scalars['Boolean'];
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  block21: Scalars['Boolean'];
  coachDisplayName: Scalars['String'];
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  isDayBlocked: Scalars['Boolean'];
};

export type AdminBookingBlackoutCoachArgs = {
  coachSlug: Scalars['String'];
  date: Scalars['String'];
};

export type AdminBookingBlackoutCoachUpdateInput = {
  block08: Scalars['Boolean'];
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  block21: Scalars['Boolean'];
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  isDayBlocked: Scalars['Boolean'];
};

export type AdminBookingBlackoutCreate = {
  __typename?: 'AdminBookingBlackoutCreate';
  errorMessage: Scalars['String'];
  isCreateAllowed: Scalars['Boolean'];
};

export type AdminBookingBlackoutCreateFacilityAvailabilityInput = {
  facilityCode: Scalars['String'];
  isBlocked: Scalars['Boolean'];
  time: Scalars['String'];
};

export type AdminBookingBlackoutCreateInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  coachSlug?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<CountryCode>;
  date: Scalars['String'];
  type: AdminBookingBlackoutCreateType;
};

export enum AdminBookingBlackoutCreateType {
  Clubhouse = 'CLUBHOUSE',
  Coach = 'COACH',
  Country = 'COUNTRY'
}

export type AdminBookingBlackoutDeleteInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  coachSlug?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<CountryCode>;
  date: Scalars['String'];
  type?: InputMaybe<AdminBookingBlackoutCreateType>;
};

export type AdminBookingBlackoutsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminBookingBookingFacilityUpdateInput = {
  bookingId: Scalars['String'];
  facilityCode: Scalars['String'];
};

export type AdminBookingCancelInput = {
  bookingId: Scalars['String'];
  cancellationReason?: InputMaybe<Scalars['String']>;
  groupCancel?: InputMaybe<Scalars['Boolean']>;
  imposePenalty?: InputMaybe<Scalars['Boolean']>;
  isSameDay?: InputMaybe<Scalars['Boolean']>;
  nextHour?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  removeFromSystem?: InputMaybe<Scalars['Boolean']>;
};

export type AdminBookingCheckout = {
  __typename?: 'AdminBookingCheckout';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  balanceBefore: Scalars['String'];
  description: Scalars['String'];
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
};

export type AdminBookingCoach = {
  __typename?: 'AdminBookingCoach';
  baseCountryCode?: Maybe<CountryCode>;
  coachPublished?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type AdminBookingCoachAvailabilityCalendarItems = {
  __typename?: 'AdminBookingCoachAvailabilityCalendarItems';
  calendarItems: Array<Maybe<CoachAvailabilityCalendarItems>>;
  clubhouses: Array<Maybe<CoachClubhouse>>;
};

export type AdminBookingCoachAvailabilityCalendarItemsArgs = {
  coachId: Scalars['String'];
  currentDate: Scalars['String'];
  mode: CoachAvailabilityCalendarItemsMode;
};

export type AdminBookingCoachAvailabilityDayItem = {
  __typename?: 'AdminBookingCoachAvailabilityDayItem';
  bi0800?: Maybe<Scalars['String']>;
  bi0900?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  bi2100?: Maybe<Scalars['String']>;
  blockedClubhousesDay: Array<Maybe<Scalars['String']>>;
  blockedClubhousesHours: Array<Maybe<Scalars['String']>>;
  bs0800?: Maybe<Scalars['String']>;
  bs0900?: Maybe<Scalars['String']>;
  bs1000?: Maybe<Scalars['String']>;
  bs1100?: Maybe<Scalars['String']>;
  bs1200?: Maybe<Scalars['String']>;
  bs1300?: Maybe<Scalars['String']>;
  bs1400?: Maybe<Scalars['String']>;
  bs1500?: Maybe<Scalars['String']>;
  bs1600?: Maybe<Scalars['String']>;
  bs1700?: Maybe<Scalars['String']>;
  bs1800?: Maybe<Scalars['String']>;
  bs1900?: Maybe<Scalars['String']>;
  bs2000?: Maybe<Scalars['String']>;
  bs2100?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  l0800?: Maybe<Scalars['String']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
  l2100?: Maybe<Scalars['String']>;
};

export type AdminBookingCoachAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export type AdminBookingCoachAvailabilitySlotItem = {
  __typename?: 'AdminBookingCoachAvailabilitySlotItem';
  hr1?: Maybe<SlotItem>;
  hr2?: Maybe<SlotItem>;
};

export type AdminBookingCoachAvailabilitySlotItemArgs = {
  clubhouseCode: Scalars['String'];
  dateId: Scalars['String'];
  ignoreCoachAvailability?: InputMaybe<Scalars['Boolean']>;
  time: Scalars['String'];
};

export type AdminBookingCombinedCoachAvailabilityDayItem = {
  __typename?: 'AdminBookingCombinedCoachAvailabilityDayItem';
  bi0800?: Maybe<Scalars['String']>;
  bi0900?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  bi2100?: Maybe<Scalars['String']>;
  biOutdoor?: Maybe<Scalars['String']>;
  bs0800?: Maybe<Scalars['String']>;
  bs0900?: Maybe<Scalars['String']>;
  bs1000?: Maybe<Scalars['String']>;
  bs1100?: Maybe<Scalars['String']>;
  bs1200?: Maybe<Scalars['String']>;
  bs1300?: Maybe<Scalars['String']>;
  bs1400?: Maybe<Scalars['String']>;
  bs1500?: Maybe<Scalars['String']>;
  bs1600?: Maybe<Scalars['String']>;
  bs1700?: Maybe<Scalars['String']>;
  bs1800?: Maybe<Scalars['String']>;
  bs1900?: Maybe<Scalars['String']>;
  bs2000?: Maybe<Scalars['String']>;
  bs2100?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<CoachClubhouse>>;
  date?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  hasOutdoorBooking?: Maybe<Scalars['Boolean']>;
  l0800?: Maybe<Scalars['String']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
  l2100?: Maybe<Scalars['String']>;
};

export type AdminBookingCombinedCoachAvailabilityDayItemArgs = {
  coachId: Scalars['String'];
  dateId: Scalars['String'];
};

export type AdminBookingEdge = {
  __typename?: 'AdminBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminBookingBasic>;
};

export type AdminBookingFacilityAvailabilityCalendarItems = {
  __typename?: 'AdminBookingFacilityAvailabilityCalendarItems';
  calendarItems: Array<Maybe<FacilityAvailabilityCalendarItems>>;
};

export type AdminBookingFacilityAvailabilityCalendarItemsArgs = {
  clubhouseCode: Scalars['String'];
  currentDate: Scalars['String'];
};

export type AdminBookingFacilityAvailabilityDayItem = {
  __typename?: 'AdminBookingFacilityAvailabilityDayItem';
  nonPutting?: Maybe<NonPuttingFacilityDayItem>;
  putting?: Maybe<PuttingFacilityDayItem>;
};

export type AdminBookingFacilityAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export type AdminBookingFacilityAvailabilitySlotItem = {
  __typename?: 'AdminBookingFacilityAvailabilitySlotItem';
  hr1?: Maybe<SlotItem>;
  hr2?: Maybe<SlotItem>;
  hr3?: Maybe<SlotItem>;
  hr4?: Maybe<SlotItem>;
  hr5?: Maybe<SlotItem>;
  putting30?: Maybe<SlotItem>;
  putting60?: Maybe<SlotItem>;
};

export type AdminBookingFacilityAvailabilitySlotItemArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  isPutting: Scalars['Boolean'];
  time: Scalars['String'];
};

export type AdminBookingGameCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType: GameType;
  memberUuid: Scalars['String'];
  noOfPlayers: Scalars['Int'];
};

export type AdminBookingGameCreate = {
  __typename?: 'AdminBookingGameCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingGameCreateInput = {
  clubhouseCode: Scalars['String'];
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityCode: Scalars['String'];
  gameType: GameType;
  isTrial: Scalars['Boolean'];
  memberUuid?: InputMaybe<Scalars['String']>;
  noOfPlayers: Scalars['Int'];
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  rebookId?: InputMaybe<Scalars['String']>;
  time: Scalars['String'];
};

export type AdminBookingGroupMember = {
  __typename?: 'AdminBookingGroupMember';
  individualId: Scalars['String'];
  memberName: Scalars['String'];
  memberUuid: Scalars['String'];
  selfPackageId: Scalars['String'];
  selfPackageName: Scalars['String'];
};

export type AdminBookingGroupMembers = {
  __typename?: 'AdminBookingGroupMembers';
  members: Array<Maybe<AdminBookingGroupMember>>;
};

export type AdminBookingGroupMembersArgs = {
  membershipUuid: Scalars['String'];
  serviceId?: InputMaybe<Scalars['String']>;
};

export type AdminBookingLessonIndoorCheckoutArgs = {
  coachId: Scalars['String'];
  isLessonExtended: Scalars['Boolean'];
  lessonType: IndoorLessonType;
  memberUuid: Scalars['String'];
};

export type AdminBookingLessonIndoorCreate = {
  __typename?: 'AdminBookingLessonIndoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingLessonIndoorCreateInput = {
  clubhouseCode: Scalars['String'];
  coachSlug: Scalars['String'];
  commentAdminToCoach?: InputMaybe<Scalars['String']>;
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  facilityCode: Scalars['String'];
  isTrial: Scalars['Boolean'];
  isTwoHours: Scalars['Boolean'];
  memberUuid?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  partner?: InputMaybe<GroupLessonPartner>;
  time: Scalars['String'];
};

export type AdminBookingLessonOutdoorCheckoutArgs = {
  coachId: Scalars['String'];
  memberUuid: Scalars['String'];
};

export type AdminBookingLessonOutdoorCreate = {
  __typename?: 'AdminBookingLessonOutdoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingLessonOutdoorCreateInput = {
  coachSlug: Scalars['String'];
  commentAdminToCoach?: InputMaybe<Scalars['String']>;
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  details: Scalars['String'];
  memberUuid?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  rebookId?: InputMaybe<Scalars['String']>;
  teeTime: Scalars['String'];
  venue: Scalars['String'];
};

export type AdminBookingOptionalPlayerNameUpdateInput = {
  bookingId: Scalars['String'];
  name: Scalars['String'];
};

export type AdminBookingPractiseCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  memberUuid: Scalars['String'];
  noOfPlayers: Scalars['Int'];
};

export type AdminBookingPractiseCreate = {
  __typename?: 'AdminBookingPractiseCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingPractiseCreateInput = {
  clubhouseCode: Scalars['String'];
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityCode: Scalars['String'];
  isTrial: Scalars['Boolean'];
  memberUuid?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  rebookId?: InputMaybe<Scalars['String']>;
  time: Scalars['String'];
};

export type AdminBookingResponse = {
  __typename?: 'AdminBookingResponse';
  edges?: Maybe<Array<Maybe<AdminBookingEdge>>>;
  firstBookingDate?: Maybe<Scalars['DateTime']>;
  lastBookingDate?: Maybe<Scalars['DateTime']>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminBookingSendCancellationNotificationInput = {
  bookingId: Scalars['String'];
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
};

export type AdminBookingSettings = {
  __typename?: 'AdminBookingSettings';
  cancellationConditions: CancellationConditions;
};

export type AdminBookingSettingsArgs = {
  bookingId: Scalars['String'];
};

export type AdminBookingUpdateInput = {
  bookingId: Scalars['String'];
  commentAdminToCoach?: InputMaybe<Scalars['String']>;
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  fieldLessonDetails?: InputMaybe<Scalars['String']>;
  groupBookingId?: InputMaybe<Scalars['String']>;
};

export type AdminBookingUpdateToGroupInput = {
  bookingId: Scalars['String'];
  facilityCode: Scalars['String'];
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  partnerMemberUuid: Scalars['String'];
};

export type AdminBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  bookingIdFilter?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<BookingType>;
  coachId?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BookingStatus>;
  venueFilter?: InputMaybe<Scalars['String']>;
};

export type AdminClientLoginGuestInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  nickName: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminClientSetupInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
};

export type AdminClientStatusArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminClubhouse = {
  __typename?: 'AdminClubhouse';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressCountryIso?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouseId: Scalars['String'];
  colorCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  kGolfClientId?: Maybe<Scalars['String']>;
  kGolfClientSecret?: Maybe<Scalars['String']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfShopGuid?: Maybe<Scalars['String']>;
  kGolfUsername?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noOfPrivateRooms?: Maybe<Scalars['Int']>;
  noOfPuttingGreen?: Maybe<Scalars['Int']>;
  noOfSimulators?: Maybe<Scalars['Int']>;
  organization: ClubhouseOrganization;
  organizationId: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminClubhouseArgs = {
  clubhouseId: Scalars['String'];
};

export type AdminClubhouseBasic = {
  __typename?: 'AdminClubhouseBasic';
  addressCountryIso?: Maybe<CountryCode>;
  clubhouseCode: Scalars['String'];
  clubhouseId: Scalars['String'];
  name: Scalars['String'];
};

export type AdminClubhouseEdge = {
  __typename?: 'AdminClubhouseEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminClubhouseBasic>;
};

export type AdminClubhouseFacilitiesArgs = {
  shopGuid: Scalars['String'];
};

export type AdminClubhouseFacilityAvailability = {
  __typename?: 'AdminClubhouseFacilityAvailability';
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  facilityObjs: Array<Maybe<AdminClubhouseFacilityAvailabilityFacilityObj>>;
  isDayBlocked: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AdminClubhouseFacilityAvailabilityArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
};

export type AdminClubhouseFacilityAvailabilityFacilityObj = {
  __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj';
  availability: AdminClubhouseFacilityAvailabilityFacilityObjAvailability;
  facilityCode: Scalars['String'];
  facilityName: Scalars['String'];
  facilityType: FacilityType;
};

export type AdminClubhouseFacilityAvailabilityFacilityObjAvailability = {
  __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability';
  bi0800?: Maybe<Scalars['String']>;
  bi0830?: Maybe<Scalars['String']>;
  bi0900?: Maybe<Scalars['String']>;
  bi0930?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1030?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1130?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1230?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1330?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1430?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1530?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1630?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1730?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1830?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi1930?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  bi2030?: Maybe<Scalars['String']>;
  bi2100?: Maybe<Scalars['String']>;
  bi2130?: Maybe<Scalars['String']>;
  bi2200?: Maybe<Scalars['String']>;
  bi2230?: Maybe<Scalars['String']>;
  bi2300?: Maybe<Scalars['String']>;
  bi2330?: Maybe<Scalars['String']>;
};

export type AdminClubhouseResponse = {
  __typename?: 'AdminClubhouseResponse';
  edges?: Maybe<Array<Maybe<AdminClubhouseEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminClubhousesArgs = {
  after?: InputMaybe<Scalars['String']>;
  countryFilter?: InputMaybe<CountryCode>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminCoach = {
  __typename?: 'AdminCoach';
  baseCountryCode?: Maybe<CountryCode>;
  clubhouses?: Maybe<Array<Maybe<CoachClubhouse>>>;
  coachBirthPlace?: Maybe<Scalars['String']>;
  coachBirthdate?: Maybe<Scalars['String']>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLevel?: Maybe<CoachLevel>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAType?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  coachPublished?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type AdminCoachArgs = {
  userId: Scalars['String'];
};

export type AdminCoachAvailabilityCalendarItemsArgs = {
  coachId: Scalars['String'];
  currentDate: Scalars['String'];
};

export type AdminCoachBasic = {
  __typename?: 'AdminCoachBasic';
  baseCountryCode?: Maybe<CountryCode>;
  coachPublished?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type AdminCoachCombinedAvailability = {
  __typename?: 'AdminCoachCombinedAvailability';
  coachId: Scalars['String'];
  coachSlug: Scalars['String'];
  dateObjs: Array<Maybe<AdminCoachCombinedAvailabilityDateObj>>;
  name: Scalars['String'];
};

export type AdminCoachCombinedAvailabilityArgs = {
  currentDate: Scalars['String'];
};

export type AdminCoachCombinedAvailabilityDateObj = {
  __typename?: 'AdminCoachCombinedAvailabilityDateObj';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
  hasIndoorBooking: Scalars['Boolean'];
  hasOutdoorBooking: Scalars['Boolean'];
  isDayBlocked: Scalars['Boolean'];
};

export type AdminCoachEdge = {
  __typename?: 'AdminCoachEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminCoachBasic>;
};

export type AdminCoachResponse = {
  __typename?: 'AdminCoachResponse';
  edges?: Maybe<Array<Maybe<AdminCoachEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminCoachesArgs = {
  after?: InputMaybe<Scalars['String']>;
  countryFilter?: InputMaybe<CountryCode>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminCreateAdminInput = {
  authorizedClubhouses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  baseCountryCode?: InputMaybe<CountryCode>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
  userType?: InputMaybe<UserType>;
};

export type AdminCreateMembershipInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  companyContactPersonDesignation?: InputMaybe<Scalars['String']>;
  companyContactPersonEmail?: InputMaybe<Scalars['String']>;
  companyContactPersonFirstName?: InputMaybe<Scalars['String']>;
  companyContactPersonLastName?: InputMaybe<Scalars['String']>;
  companyIndustry?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  mainAceCoinRatio?: InputMaybe<AceCoinRatioInput>;
  mainMembers?: InputMaybe<Array<InputMaybe<CreateMemberInput>>>;
  membershipSlug: Scalars['String'];
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentOption: AdminCreateMembershipPaymentOption;
  paymentProvider?: InputMaybe<PaymentProvider>;
  paymentRef?: InputMaybe<Scalars['String']>;
  reservedId?: InputMaybe<Scalars['String']>;
  subAceCoinRatio?: InputMaybe<AceCoinRatioInput>;
  subMembers?: InputMaybe<Array<InputMaybe<CreateMemberInput>>>;
};

export enum AdminCreateMembershipPaymentOption {
  Later = 'LATER',
  Now = 'NOW'
}

export type AdminCreditTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminDeleteAdminInput = {
  userId: Scalars['String'];
};

export type AdminDeleteCoachInput = {
  userId: Scalars['String'];
};

export type AdminDeleteMembershipInput = {
  membershipUuid: Scalars['String'];
};

export type AdminEdge = {
  __typename?: 'AdminEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminBasic>;
};

export type AdminExtendClientTimeInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  shopGuid: Scalars['String'];
  timeInSeconds: Scalars['Int'];
};

export type AdminForgotPasswordInput = {
  email: Scalars['String'];
};

export type AdminForgotPasswordResponse = {
  __typename?: 'AdminForgotPasswordResponse';
  email: Scalars['String'];
  resetToken: Scalars['String'];
};

export type AdminForgotPasswordSubmitInput = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type AdminGameHistory = {
  __typename?: 'AdminGameHistory';
  currentPage: Scalars['Int'];
  list: Array<Maybe<AdminGameHistoryListItem>>;
  maxPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminGameHistoryArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  bays?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  gameTypeField?: InputMaybe<Scalars['Boolean']>;
  gameTypeFourSome?: InputMaybe<Scalars['Boolean']>;
  gameTypePutting?: InputMaybe<Scalars['Boolean']>;
  gameTypeShot?: InputMaybe<Scalars['Boolean']>;
  gameTypeShotContest?: InputMaybe<Scalars['Boolean']>;
  gameTypeStroke?: InputMaybe<Scalars['Boolean']>;
  nickName?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type AdminGameHistoryListItem = {
  __typename?: 'AdminGameHistoryListItem';
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  endTime?: Maybe<Scalars['Float']>;
  gameRoundId: Scalars['Int'];
  gameType: Scalars['String'];
  gameTypeCode: Scalars['Int'];
  playerCount: Scalars['Int'];
  startTime: Scalars['Float'];
};

export type AdminGameRoundScoreCard = {
  __typename?: 'AdminGameRoundScoreCard';
  gameRoundInfo: GameRoundGameInfo;
  players: Array<Maybe<GameRoundPlayerInfo>>;
};

export type AdminGroupBooking = {
  __typename?: 'AdminGroupBooking';
  clubhouseCode?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  commentAdminToCoach?: Maybe<Scalars['String']>;
  commentAdminToMember?: Maybe<Scalars['String']>;
  commentInternal?: Maybe<Scalars['String']>;
  dateMonthStr?: Maybe<Scalars['String']>;
  dateStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  durationStr?: Maybe<Scalars['String']>;
  endTimeStr: Scalars['String'];
  facilityMode?: Maybe<Scalars['String']>;
  facilityStartTime?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<GameCourseType>;
  id: Scalars['String'];
  member: Scalars['String'];
  memberIndividualId: Scalars['String'];
  mobileNumber: Scalars['String'];
  noOfPlayers: Scalars['Int'];
  resourceName?: Maybe<Scalars['String']>;
  startTimeStr?: Maybe<Scalars['String']>;
  status?: Maybe<BookingStatus>;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type AdminGroupBookingsArgs = {
  bookingIds: Array<Scalars['String']>;
};

export type AdminJwtAccessToken = {
  __typename?: 'AdminJwtAccessToken';
  adminName?: Maybe<Scalars['String']>;
  baseCountryCode?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<Scalars['String']>>;
  organizationId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  ud?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AdminJwtRefreshToken = {
  __typename?: 'AdminJwtRefreshToken';
  adminName?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AdminKGolfMember = {
  __typename?: 'AdminKGolfMember';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  connectKakao?: Maybe<Scalars['Boolean']>;
  connectWechat?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Int']>;
  handed?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isTermsAgreeNotificationEmail?: Maybe<Scalars['Boolean']>;
  isTermsAgreeNotificationSMS?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  mobilePhoneCountry?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AdminKGolfMemberArgs = {
  memberUuid: Scalars['String'];
};

export type AdminLockClientInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AdminManagementSystemAppMainSlider = {
  __typename?: 'AdminManagementSystemAppMainSlider';
  baseCountryCode: CountryCode;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isVideo?: Maybe<Scalars['Boolean']>;
  isYoutube?: Maybe<Scalars['Boolean']>;
  linkRoute?: Maybe<Scalars['String']>;
  linkTitle?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  posterPayload?: Maybe<Scalars['JSON']>;
  posterTitle?: Maybe<Scalars['String']>;
  posterUri?: Maybe<Scalars['String']>;
  publish?: Maybe<Scalars['Boolean']>;
  slidePayload?: Maybe<Scalars['JSON']>;
  slideUri?: Maybe<Scalars['String']>;
  webViewUrl?: Maybe<Scalars['String']>;
};

export type AdminManagementSystemAppMainSliderArgs = {
  id: Scalars['String'];
};

export type AdminManagementSystemAppMainSliderCreateInput = {
  baseCountryCode: CountryCode;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  isVideo?: InputMaybe<Scalars['Boolean']>;
  isYoutube?: InputMaybe<Scalars['Boolean']>;
  linkRoute?: InputMaybe<Scalars['String']>;
  linkTitle?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  posterPayload?: InputMaybe<Scalars['JSON']>;
  posterTitle?: InputMaybe<Scalars['String']>;
  posterUri?: InputMaybe<Scalars['String']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  slidePayload?: InputMaybe<Scalars['JSON']>;
  slideUri: Scalars['String'];
  transaction?: InputMaybe<AdminManagementSystemTransactionInput>;
  webViewUrl?: InputMaybe<Scalars['String']>;
};

export type AdminManagementSystemAppMainSliderDeleteInput = {
  id: Scalars['String'];
  transaction?: InputMaybe<AdminManagementSystemTransactionInput>;
};

export type AdminManagementSystemAppMainSliderUpdateInput = {
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isVideo?: InputMaybe<Scalars['Boolean']>;
  isYoutube?: InputMaybe<Scalars['Boolean']>;
  linkRoute?: InputMaybe<Scalars['String']>;
  linkTitle?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  posterPayload?: InputMaybe<Scalars['JSON']>;
  posterTitle?: InputMaybe<Scalars['String']>;
  posterUri?: InputMaybe<Scalars['String']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  slidePayload?: InputMaybe<Scalars['JSON']>;
  slideUri?: InputMaybe<Scalars['String']>;
  transaction?: InputMaybe<AdminManagementSystemTransactionInput>;
  webViewUrl?: InputMaybe<Scalars['String']>;
};

export type AdminManagementSystemAppMainSliderUploadInput = {
  baseKey?: InputMaybe<Scalars['String']>;
  fileType: Scalars['String'];
};

export type AdminManagementSystemAppMainSliderUploadResponse = {
  __typename?: 'AdminManagementSystemAppMainSliderUploadResponse';
  fields: Scalars['JSONObject'];
  fileUrl: Scalars['String'];
  isVideo: Scalars['Boolean'];
  key: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type AdminManagementSystemAppMainSlidersArgs = {
  baseCountryCode?: InputMaybe<CountryCode>;
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  includeUnpublished?: InputMaybe<Scalars['Boolean']>;
};

export type AdminManagementSystemProps = {
  __typename?: 'AdminManagementSystemProps';
  currentAppVersion: Scalars['String'];
};

export type AdminManagementSystemReportingInput = {
  action: Scalars['String'];
  payload?: InputMaybe<Scalars['JSON']>;
};

export type AdminManagementSystemSupportTicket = {
  __typename?: 'AdminManagementSystemSupportTicket';
  approvedBy?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  bodyUpdatedAt?: Maybe<Scalars['DateTime']>;
  category?: Maybe<SupportTicketCategory>;
  dateClosed?: Maybe<Scalars['DateTime']>;
  dateOpened?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  manHoursRequired: Scalars['Int'];
  openedBy: Scalars['String'];
  priority?: Maybe<SupportTicketPriority>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SupportTicketStatus>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userProfileImageUrl?: Maybe<Scalars['String']>;
};

export type AdminManagementSystemSupportTicketArgs = {
  id: Scalars['String'];
};

export type AdminManagementSystemSupportTicketBasic = {
  __typename?: 'AdminManagementSystemSupportTicketBasic';
  dateClosed?: Maybe<Scalars['DateTime']>;
  dateOpened?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  initiatorId?: Maybe<Scalars['String']>;
  initiatorName?: Maybe<Scalars['String']>;
  priority?: Maybe<SupportTicketPriority>;
  status?: Maybe<SupportTicketStatus>;
  title?: Maybe<Scalars['String']>;
};

export type AdminManagementSystemSupportTicketComment = {
  __typename?: 'AdminManagementSystemSupportTicketComment';
  editedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  message: Scalars['String'];
  postedOn: Scalars['DateTime'];
  userId: Scalars['String'];
  userName: Scalars['String'];
  userProfileImageUrl?: Maybe<Scalars['String']>;
};

export type AdminManagementSystemSupportTicketCommentAddInput = {
  message: Scalars['String'];
  supportTicketId: Scalars['String'];
};

export type AdminManagementSystemSupportTicketCommentDeleteInput = {
  commentId: Scalars['String'];
};

export type AdminManagementSystemSupportTicketCommentUpdateInput = {
  commentId: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  supportTicketId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type AdminManagementSystemSupportTicketCommentsArgs = {
  supportTicketId: Scalars['String'];
};

export type AdminManagementSystemSupportTicketCreate = {
  __typename?: 'AdminManagementSystemSupportTicketCreate';
  id: Scalars['String'];
};

export type AdminManagementSystemSupportTicketCreateInput = {
  body: Scalars['String'];
  category: SupportTicketCategory;
  priority: SupportTicketPriority;
  title: Scalars['String'];
  userId: Scalars['String'];
};

export type AdminManagementSystemSupportTicketDeleteInput = {
  supportTicketId: Scalars['String'];
};

export type AdminManagementSystemSupportTicketEdge = {
  __typename?: 'AdminManagementSystemSupportTicketEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminManagementSystemSupportTicketBasic>;
};

export type AdminManagementSystemSupportTicketResponse = {
  __typename?: 'AdminManagementSystemSupportTicketResponse';
  edges?: Maybe<Array<Maybe<AdminManagementSystemSupportTicketEdge>>>;
  firstTicketDate?: Maybe<Scalars['DateTime']>;
  lastTicketDate?: Maybe<Scalars['DateTime']>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminManagementSystemSupportTicketUpdateInput = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<SupportTicketCategory>;
  manHour?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<SupportTicketPriority>;
  status?: InputMaybe<SupportTicketStatus>;
  supportTicketId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type AdminManagementSystemSupportTicketUser = {
  __typename?: 'AdminManagementSystemSupportTicketUser';
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type AdminManagementSystemSupportTicketsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type AdminManagementSystemTransactionInput = {
  action: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
};

export type AdminManagementSystemUserTelemetryInput = {
  pageName: Scalars['String'];
  resourceId?: InputMaybe<Scalars['String']>;
  resourceName?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<UserTelemetryResourceType>;
  ts?: InputMaybe<Scalars['String']>;
};

export type AdminMember = {
  __typename?: 'AdminMember';
  accountType?: Maybe<AccountType>;
  activationLineItems: Array<Maybe<AdminMemberActivationLineItem>>;
  activationOrderNo: Scalars['String'];
  activationPrice: Scalars['Float'];
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  companyContactPersonEmail?: Maybe<Scalars['String']>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  credit: Scalars['Float'];
  creditSpent: Scalars['Float'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gameCredit: Scalars['Float'];
  gender?: Maybe<Gender>;
  handed: Handed;
  hasGroupMembers: Scalars['Boolean'];
  hasSimulatorPrivilege: Scalars['Boolean'];
  hasSubscriptions: Scalars['Boolean'];
  individualId: Scalars['String'];
  internalAccountType?: Maybe<InternalAccountType>;
  isSimulatorUseRedeemed: Scalars['Boolean'];
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  locker: Scalars['Boolean'];
  memberStatus: MemberStatus;
  memberUuid: Scalars['String'];
  members: Array<Maybe<AdminMemberMember>>;
  membershipStatus: MembershipStatus;
  membershipType?: Maybe<MembershipTypeBasic>;
  membershipUuid: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  partialNricOrFin?: Maybe<Scalars['String']>;
  practiseCredit: Scalars['Float'];
  profileImageUrl?: Maybe<Scalars['String']>;
  pushTokens: Array<Maybe<Scalars['String']>>;
  relationshipToMainMember?: Maybe<Relationship>;
  serviceNote?: Maybe<Scalars['String']>;
  signUpSidasInsoles: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  termEndDate?: Maybe<Scalars['DateTime']>;
  voucherField: Scalars['Float'];
  voucherIndoor: Scalars['Float'];
};

export type AdminMemberAcTransactionEdge = {
  __typename?: 'AdminMemberAcTransactionEdge';
  cursor?: Maybe<Scalars['Int']>;
  node?: Maybe<AceCoinTransaction>;
};

export type AdminMemberAcTransactionResponse = {
  __typename?: 'AdminMemberAcTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminMemberAcTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMemberAcTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid?: InputMaybe<Scalars['String']>;
  membershipUuid?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
  transactionTypeFilter?: InputMaybe<AcTransactionType>;
};

export type AdminMemberActivationLineItem = {
  __typename?: 'AdminMemberActivationLineItem';
  itemName: Scalars['String'];
  salesPrice: Scalars['Float'];
};

export type AdminMemberArgs = {
  memberUuid: Scalars['String'];
};

export type AdminMemberBdfAddInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry: Scalars['String'];
  addressPostalCode: Scalars['String'];
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1: Scalars['String'];
  addressStreet2?: InputMaybe<Scalars['String']>;
  birthdayDay: Scalars['String'];
  birthdayMonth: Scalars['String'];
  birthdayYear: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  lastName: Scalars['String'];
  membershipUuid: Scalars['String'];
  mobileNumber: Scalars['String'];
  nationality?: InputMaybe<Scalars['String']>;
  partialNricOrFin?: InputMaybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
  paymentProvider: PaymentProvider;
  paymentRef?: InputMaybe<Scalars['String']>;
  providedPassword?: InputMaybe<Scalars['String']>;
  relationshipToMainMember?: InputMaybe<Relationship>;
  sameAddressAsMainMember?: InputMaybe<Scalars['Boolean']>;
};

export type AdminMemberBasic = {
  __typename?: 'AdminMemberBasic';
  accountType?: Maybe<AccountType>;
  aceCoins?: Maybe<Scalars['Float']>;
  appVersion?: Maybe<Scalars['String']>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  credits?: Maybe<Scalars['Float']>;
  firstName: Scalars['String'];
  hasGroupMembers?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  individualId: Scalars['String'];
  internalAccountType?: Maybe<InternalAccountType>;
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  lessonIndoorCredits?: Maybe<Scalars['Float']>;
  memberName?: Maybe<Scalars['String']>;
  memberStatus?: Maybe<MemberStatus>;
  membershipId: Scalars['String'];
  membershipType?: Maybe<MembershipTypeBasic>;
  practiseCredits?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMemberCreateKGolfAccountInput = {
  memberUuid: Scalars['String'];
};

export type AdminMemberCreditUpdateInput = {
  amount: Scalars['Float'];
  description: Scalars['String'];
  invoiceNo?: InputMaybe<Scalars['String']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentProvider?: InputMaybe<PaymentProvider>;
  paymentRef?: InputMaybe<Scalars['String']>;
  transactionType: TransactionType;
  type: AceCoinTransactionType;
};

export type AdminMemberEdge = {
  __typename?: 'AdminMemberEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMemberBasic>;
};

export type AdminMemberInvoiceDeleteInput = {
  invoiceNo: Scalars['String'];
};

export type AdminMemberInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  individualIdFilter?: InputMaybe<Scalars['String']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  paymentMethodFilter?: InputMaybe<PaymentMethod>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminMemberLessonNoteMember = {
  __typename?: 'AdminMemberLessonNoteMember';
  id: Scalars['String'];
  memberIndividualId: Scalars['String'];
  memberName: Scalars['String'];
  noOfLessonNotes?: Maybe<Scalars['Int']>;
};

export type AdminMemberLessonNoteMemberEdge = {
  __typename?: 'AdminMemberLessonNoteMemberEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMemberLessonNoteMember>;
};

export type AdminMemberLessonNoteMemberResponse = {
  __typename?: 'AdminMemberLessonNoteMemberResponse';
  edges?: Maybe<Array<Maybe<AdminMemberLessonNoteMemberEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMemberLessonNoteMembersArgs = {
  nameFilter?: InputMaybe<Scalars['String']>;
};

export type AdminMemberMember = {
  __typename?: 'AdminMemberMember';
  accountType?: Maybe<AccountType>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminMemberNotificationEdge = {
  __typename?: 'AdminMemberNotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminNotificationBasic>;
};

export type AdminMemberNotificationResponse = {
  __typename?: 'AdminMemberNotificationResponse';
  edges?: Maybe<Array<Maybe<AdminMemberNotificationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMemberNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMemberProductGroupPackage = {
  __typename?: 'AdminMemberProductGroupPackage';
  amount: Scalars['Float'];
  individualId: Scalars['String'];
  isShareGroupPaused: Scalars['Boolean'];
  memberName: Scalars['String'];
  packageName: Scalars['String'];
  serviceId: Scalars['String'];
};

export type AdminMemberProductGroupPackages = {
  __typename?: 'AdminMemberProductGroupPackages';
  packages?: Maybe<Array<Maybe<AdminMemberProductGroupPackage>>>;
};

export type AdminMemberProductGroupPackagesArgs = {
  membershipUuid?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
};

export type AdminMemberProductPackage = {
  __typename?: 'AdminMemberProductPackage';
  amount: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  expiryDateStr: Scalars['String'];
  expiryWarning?: Maybe<Scalars['Boolean']>;
  extensions: Array<Maybe<AdminMemberProductPackageExtension>>;
  forfeitureAmount: Scalars['Float'];
  forfeitureDate?: Maybe<Scalars['DateTime']>;
  forfeitureDateStr?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  groupServices?: Maybe<Array<Maybe<AdminMemberProductGroupPackage>>>;
  hasSupplementaryRedemption: Scalars['Boolean'];
  individualId?: Maybe<Scalars['String']>;
  isDaily: Scalars['Boolean'];
  isDailyRedeemed: Scalars['Boolean'];
  isGroup: Scalars['Boolean'];
  isReActivateable: Scalars['Boolean'];
  isShareGroupPaused: Scalars['Boolean'];
  memberName?: Maybe<Scalars['String']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  packageName: Scalars['String'];
  packageType: Scalars['String'];
  parentServiceId?: Maybe<Scalars['String']>;
  pauseHistory?: Maybe<Array<AdminMemberProductPackagePause>>;
  pauseReason?: Maybe<Scalars['String']>;
  pausedAt?: Maybe<Scalars['DateTime']>;
  pausedBy?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  subServices?: Maybe<Array<Maybe<AdminMemberProductPackageSubService>>>;
  supplementaryAmount: Scalars['Float'];
  supplementaryUnitName: Scalars['String'];
  transactions: Array<Maybe<ServiceTransactionBasic>>;
  type?: Maybe<Scalars['String']>;
  unitType: Scalars['String'];
};

export type AdminMemberProductPackageArgs = {
  serviceId: Scalars['String'];
};

export type AdminMemberProductPackageDeleteInput = {
  serviceId: Scalars['String'];
};

export type AdminMemberProductPackageExtension = {
  __typename?: 'AdminMemberProductPackageExtension';
  authorizedAdjusterName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  dateExtended?: Maybe<Scalars['DateTime']>;
  daysAdded?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  newExpiryDate?: Maybe<Scalars['DateTime']>;
  prevExpiryDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMemberProductPackageExtensionUpdateInput = {
  comment?: InputMaybe<Scalars['String']>;
  extensionId: Scalars['String'];
};

export type AdminMemberProductPackageExtensions = {
  __typename?: 'AdminMemberProductPackageExtensions';
  extensions?: Maybe<Array<Maybe<AdminMemberProductPackageExtension>>>;
};

export type AdminMemberProductPackageExtensionsArgs = {
  serviceId: Scalars['String'];
};

export type AdminMemberProductPackageGroupInput = {
  mode: AdminMemberProductPackageGroupMode;
  sourceServiceId: Scalars['String'];
  targetServiceId: Scalars['String'];
};

export enum AdminMemberProductPackageGroupMode {
  Link = 'LINK',
  Unlink = 'UNLINK'
}

export type AdminMemberProductPackageManageInput = {
  comment?: InputMaybe<Scalars['String']>;
  mode: AdminMemberProductPackageManageMode;
  newExpiryDate?: InputMaybe<Scalars['String']>;
  serviceId: Scalars['String'];
};

export enum AdminMemberProductPackageManageMode {
  Extend = 'EXTEND',
  Forfeit = 'FORFEIT',
  Pause = 'PAUSE',
  Resume = 'RESUME',
  Update = 'UPDATE'
}

export type AdminMemberProductPackagePause = {
  __typename?: 'AdminMemberProductPackagePause';
  action: Scalars['String'];
  authorizedAdjusterName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  dateChanged: Scalars['DateTime'];
  newExpiryDate?: Maybe<Scalars['DateTime']>;
  prevExpiryDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMemberProductPackageReActivateInput = {
  amount: Scalars['Float'];
  expiry: Scalars['String'];
  serviceId: Scalars['String'];
};

export type AdminMemberProductPackageShareInput = {
  amount: Scalars['Float'];
  comment?: InputMaybe<Scalars['String']>;
  serviceId: Scalars['String'];
  targetMemberUuid: Scalars['String'];
};

export type AdminMemberProductPackageSubService = {
  __typename?: 'AdminMemberProductPackageSubService';
  amount: Scalars['Float'];
  dateAdded: Scalars['DateTime'];
  individualId: Scalars['String'];
  memberName: Scalars['String'];
  memberUuid: Scalars['String'];
  parentServiceId: Scalars['String'];
  serviceId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type AdminMemberProductPackageTransferInput = {
  amount: Scalars['Float'];
  direction: Scalars['String'];
  sourceServiceId: Scalars['String'];
  targetServiceId: Scalars['String'];
};

export type AdminMemberProfileUpdate = {
  __typename?: 'AdminMemberProfileUpdate';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  member: AdminMember;
};

export type AdminMemberProfileUpdateInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  bankTransferRef?: InputMaybe<Scalars['String']>;
  birthdayDay?: InputMaybe<Scalars['String']>;
  birthdayMonth?: InputMaybe<Scalars['String']>;
  birthdayYear?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  handed?: InputMaybe<Handed>;
  lastName?: InputMaybe<Scalars['String']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Scalars['String']>;
  partialNricOrFin?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
  relationshipToMainMember?: InputMaybe<Relationship>;
  sameAddressAsMainMember?: InputMaybe<Scalars['Boolean']>;
  serviceNote?: InputMaybe<Scalars['String']>;
};

export type AdminMemberReassignMembershipIdInput = {
  membershipUuid?: InputMaybe<Scalars['String']>;
  proposedId?: InputMaybe<Scalars['String']>;
};

export type AdminMemberResendOnboardingEmailInput = {
  membershipUuid: Scalars['String'];
};

export type AdminMemberResponse = {
  __typename?: 'AdminMemberResponse';
  edges?: Maybe<Array<Maybe<AdminMemberEdge>>>;
  pageInfo?: Maybe<AdminMemberResponsePageInfo>;
};

export type AdminMemberResponsePageInfo = {
  __typename?: 'AdminMemberResponsePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  failedKGolfAccounts?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type AdminMemberSendResetPasswordEmailInput = {
  memberUuid: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};

export type AdminMemberServiceTransactionDeleteInput = {
  serviceTransactionId: Scalars['String'];
};

export type AdminMemberServiceTransactionEdge = {
  __typename?: 'AdminMemberServiceTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ServiceTransactionBasic>;
};

export type AdminMemberServiceTransactionResponse = {
  __typename?: 'AdminMemberServiceTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminMemberServiceTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMemberServiceTransactionUpdateInput = {
  amount?: InputMaybe<Scalars['Float']>;
  coach?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<Scalars['String']>;
  serviceTransactionId: Scalars['String'];
  venue?: InputMaybe<Scalars['String']>;
};

export type AdminMemberServiceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
  serviceTypeFilter?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  transactionTypeFilter?: InputMaybe<ServiceTransactionType>;
};

export type AdminMemberServiceUpdateInput = {
  amount: Scalars['Float'];
  coach?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  date?: InputMaybe<Scalars['DateTime']>;
  direction: ServiceTransactionDirection;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  facilityType?: InputMaybe<Scalars['String']>;
  isSupplementaryRedemption?: InputMaybe<Scalars['Boolean']>;
  mainPackageOnly?: InputMaybe<Scalars['Boolean']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  serviceId?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<Scalars['String']>;
  transactionType: ServiceTransactionType;
  venue?: InputMaybe<Scalars['String']>;
};

export type AdminMemberSimulatorUseUpdateInput = {
  comment: Scalars['String'];
  date?: InputMaybe<Scalars['DateTime']>;
  facilityType?: InputMaybe<Scalars['String']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  venue?: InputMaybe<Scalars['String']>;
};

export type AdminMemberSubscriptionEdge = {
  __typename?: 'AdminMemberSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMembershipSubscription>;
};

export type AdminMemberSubscriptionResponse = {
  __typename?: 'AdminMemberSubscriptionResponse';
  edges?: Maybe<Array<Maybe<AdminMemberSubscriptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionEndDate?: Maybe<Scalars['DateTime']>;
  subscriptionStartDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMemberSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMemberTierUpdateInput = {
  adjustment: Scalars['Float'];
  amountPaid?: InputMaybe<Scalars['Float']>;
  award: Scalars['Int'];
  invoiceNo?: InputMaybe<Scalars['String']>;
  lessonIndoor: Scalars['Int'];
  lessonOutdoor: Scalars['Int'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  paymentMethod?: InputMaybe<PaymentMethod>;
  purchase: Scalars['Int'];
  versionSlug: Scalars['String'];
};

export type AdminMemberTransferCreditInput = {
  creditAmount: Scalars['Float'];
  sourceMemberUuid: Scalars['String'];
  targetMemberUuid: Scalars['String'];
};

export type AdminMemberTypeUpdateInput = {
  internalAccountType: InternalAccountType;
  membershipUuid: Scalars['String'];
};

export type AdminMemberUpdatePasswordInput = {
  memberUuid: Scalars['String'];
  password: Scalars['String'];
};

export type AdminMembersArgs = {
  accountTypeFilter?: InputMaybe<AccountTypeFilter>;
  after?: InputMaybe<Scalars['String']>;
  countryFilter?: InputMaybe<CountryCode>;
  excludeMemberUuidFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<AdminMembersMode>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  statusFilter?: InputMaybe<MemberStatus>;
  tierFilter?: InputMaybe<Scalars['String']>;
};

export enum AdminMembersMode {
  Booking = 'BOOKING'
}

export type AdminMembershipService = {
  __typename?: 'AdminMembershipService';
  amount: Scalars['Float'];
  countryCode?: Maybe<CountryCode>;
  dateAdded?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  expiryWarning?: Maybe<Scalars['Boolean']>;
  groupServiceId?: Maybe<Scalars['String']>;
  hasSupplementaryRedemption: Scalars['Boolean'];
  isDaily: Scalars['Boolean'];
  isDailyRedeemed: Scalars['Boolean'];
  isGroup: Scalars['Boolean'];
  isShareGroupPaused: Scalars['Boolean'];
  memberName?: Maybe<Scalars['String']>;
  orderNo?: Maybe<Scalars['String']>;
  packageType: Scalars['String'];
  parentServiceId?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  serviceName: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  supplementaryAmount: Scalars['Float'];
  supplementaryUnitName: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  unitType: Scalars['String'];
};

export type AdminMembershipServiceEdge = {
  __typename?: 'AdminMembershipServiceEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMembershipService>;
};

export type AdminMembershipServiceResponse = {
  __typename?: 'AdminMembershipServiceResponse';
  edges?: Maybe<Array<Maybe<AdminMembershipServiceEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMembershipServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  checkIsDailyRedeemed?: InputMaybe<Scalars['Boolean']>;
  countryFilter?: InputMaybe<CountryCode>;
  expiryMode?: InputMaybe<AdminMembershipServicesExpiryMode>;
  first?: InputMaybe<Scalars['Int']>;
  itemCodeFilter?: InputMaybe<Scalars['String']>;
  membershipUuid?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  serviceIdFilter?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdminMembershipServicesStatus>;
};

export enum AdminMembershipServicesExpiryMode {
  NoExpiry = 'NO_EXPIRY',
  Week_1 = 'WEEK_1',
  Week_2 = 'WEEK_2',
  Week_3 = 'WEEK_3',
  Week_4 = 'WEEK_4'
}

export enum AdminMembershipServicesStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Paused = 'PAUSED'
}

export type AdminMembershipSubscription = {
  __typename?: 'AdminMembershipSubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMembershipSubscriptionActionDatesInput = {
  membershipUuid: Scalars['String'];
  resetPause?: InputMaybe<Scalars['Boolean']>;
  resetStart?: InputMaybe<Scalars['Boolean']>;
};

export type AdminMembershipSubscriptionBasic = {
  __typename?: 'AdminMembershipSubscriptionBasic';
  aceCoins: Scalars['Float'];
  endDate?: Maybe<Scalars['DateTime']>;
  mainMemberMainId: Scalars['String'];
  mainMemberName: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status: SubscriptionStatus;
  subscriptionBalance: Scalars['Float'];
};

export type AdminMembershipSubscriptionEdge = {
  __typename?: 'AdminMembershipSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMembershipSubscriptionBasic>;
};

export type AdminMembershipSubscriptionPauseInput = {
  endPauseDate?: InputMaybe<Scalars['String']>;
  immediatePause: Scalars['Boolean'];
  membershipUuid: Scalars['String'];
  startPauseDate?: InputMaybe<Scalars['String']>;
  withEndDate: Scalars['Boolean'];
};

export type AdminMembershipSubscriptionResponse = {
  __typename?: 'AdminMembershipSubscriptionResponse';
  edges?: Maybe<Array<Maybe<AdminMembershipSubscriptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMembershipSubscriptionStartInput = {
  immediateStart: Scalars['Boolean'];
  membershipUuid: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type AdminMembershipSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  status?: InputMaybe<SubscriptionStatus>;
};

export type AdminMembershipType = {
  __typename?: 'AdminMembershipType';
  baseCountryCode?: Maybe<CountryCode>;
  compDailySimulatorUse?: Maybe<Scalars['Int']>;
  compDailySimulatorUseType?: Maybe<CompDailySimulatorUseType>;
  compFieldLessons?: Maybe<Scalars['Int']>;
  compIndoorLessons?: Maybe<Scalars['Int']>;
  compLocker?: Maybe<Scalars['Boolean']>;
  designatedPrivateRoom?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  initialCredits?: Maybe<Scalars['Int']>;
  internalName?: Maybe<Scalars['String']>;
  isCorporate?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  lineItemCode?: Maybe<Scalars['String']>;
  loungeAccess?: Maybe<Scalars['Boolean']>;
  mainTypeSlug?: Maybe<Scalars['String']>;
  monthlySub?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  publicName?: Maybe<Scalars['String']>;
  signupProductSidasInsoles?: Maybe<Scalars['Boolean']>;
  subscriptionlineItemCode?: Maybe<Scalars['String']>;
  supplementaryTypeSlug?: Maybe<Scalars['String']>;
  tagBgColorCode?: Maybe<Scalars['String']>;
  tagText?: Maybe<Scalars['String']>;
  tagTextColorCode?: Maybe<Scalars['String']>;
  tier?: Maybe<MembershipTypeTier>;
  versionSlug?: Maybe<Scalars['String']>;
};

export type AdminMembershipTypeArgs = {
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type AdminMembershipTypeBasic = {
  __typename?: 'AdminMembershipTypeBasic';
  baseCountryCode?: Maybe<CountryCode>;
  id?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  tier?: Maybe<MembershipTypeTier>;
  versionSlug?: Maybe<Scalars['String']>;
};

export type AdminMembershipTypes = {
  __typename?: 'AdminMembershipTypes';
  lifestyle?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
  numberOfTypes?: Maybe<Scalars['Int']>;
  premium?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
  vip?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
};

export type AdminMembershipTypesArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminNewMembership = {
  __typename?: 'AdminNewMembership';
  fileUploadCredentials?: Maybe<AdminNewMembershipFileUploadCredentials>;
  memberUuid?: Maybe<Scalars['String']>;
  payment?: Maybe<HitPayPaymentRequest>;
};

export type AdminNewMembershipFileUploadCredentials = {
  __typename?: 'AdminNewMembershipFileUploadCredentials';
  mainMembers?: Maybe<Array<Maybe<FileUploadObject>>>;
  subMembers?: Maybe<Array<Maybe<FileUploadObject>>>;
};

export type AdminNotification = {
  __typename?: 'AdminNotification';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminNotificationArgs = {
  notificationId: Scalars['String'];
};

export type AdminNotificationBasic = {
  __typename?: 'AdminNotificationBasic';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminNotificationCreateInput = {
  expiry: Scalars['Boolean'];
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  memberUuid?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  mode: NotificationMode;
  title: Scalars['String'];
};

export type AdminNotificationDeleteInput = {
  notificationId: Scalars['String'];
};

export type AdminNotificationEdge = {
  __typename?: 'AdminNotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminNotificationBasic>;
};

export type AdminNotificationMemberDeleteInput = {
  memberUuid: Scalars['String'];
  notificationId: Scalars['String'];
};

export type AdminNotificationResponse = {
  __typename?: 'AdminNotificationResponse';
  edges?: Maybe<Array<Maybe<AdminNotificationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  mode: NotificationMode;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminOrganization = {
  __typename?: 'AdminOrganization';
  businessName: Scalars['String'];
  clubhouses?: Maybe<Array<Maybe<BasicClubhouseDetails>>>;
  id: Scalars['String'];
};

export type AdminProduct = {
  __typename?: 'AdminProduct';
  baseCountryCode: CountryCode;
  name: Scalars['String'];
};

export type AdminProductBasic = {
  __typename?: 'AdminProductBasic';
  baseCountryCode: CountryCode;
  itemCode: Scalars['String'];
  name: Scalars['String'];
  packageType: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  priceAceCoins?: Maybe<Scalars['Float']>;
  priceCurrency?: Maybe<Scalars['String']>;
  validity?: Maybe<Scalars['String']>;
};

export type AdminProductEdge = {
  __typename?: 'AdminProductEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminProductBasic>;
};

export type AdminProductPackageAddInput = {
  description?: InputMaybe<Scalars['String']>;
  invoiceNo?: InputMaybe<Scalars['String']>;
  itemCode: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentProvider?: InputMaybe<PaymentProvider>;
  paymentRef?: InputMaybe<Scalars['String']>;
};

export type AdminProductResponse = {
  __typename?: 'AdminProductResponse';
  edges?: Maybe<Array<Maybe<AdminProductEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  countryFilter?: InputMaybe<CountryCode>;
  first?: InputMaybe<Scalars['Int']>;
  mainCategory?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminReportAcTransactionDeleteInput = {
  transactionId: Scalars['String'];
};

export type AdminReportAcTransactionEdge = {
  __typename?: 'AdminReportAcTransactionEdge';
  cursor?: Maybe<Scalars['Int']>;
  node?: Maybe<AceCoinTransaction>;
};

export type AdminReportAcTransactionResponse = {
  __typename?: 'AdminReportAcTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminReportAcTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportAcTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
  transactionTypeFilter?: InputMaybe<AcTransactionType>;
};

export type AdminReportHitPayCharge = {
  __typename?: 'AdminReportHitPayCharge';
  amount?: Maybe<Scalars['String']>;
  buyer_email?: Maybe<Scalars['String']>;
  buyer_name: Scalars['String'];
  buyer_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  payment_method?: Maybe<Scalars['String']>;
  payment_type?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  refunded_amount?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

export type AdminReportHitPayChargeArgs = {
  paymentRef: Scalars['String'];
};

export type AdminReportHitPayChargeEdge = {
  __typename?: 'AdminReportHitPayChargeEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportHitPayCharge>;
};

export type AdminReportHitPayChargeResponse = {
  __typename?: 'AdminReportHitPayChargeResponse';
  edges?: Maybe<Array<Maybe<AdminReportHitPayChargeEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportHitPayChargesArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  paymentMethodFilter?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportInvoiceArgs = {
  date: Scalars['String'];
  invoiceNo: Scalars['String'];
};

export type AdminReportInvoiceEdge = {
  __typename?: 'AdminReportInvoiceEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<InvoiceBasic>;
};

export type AdminReportInvoiceResponse = {
  __typename?: 'AdminReportInvoiceResponse';
  edges?: Maybe<Array<Maybe<AdminReportInvoiceEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  invoiceNumberFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  paymentMethodFilter?: InputMaybe<PaymentMethod>;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum AdminReportMemberStatType {
  CreditTransactionCount = 'CREDIT_TRANSACTION_COUNT',
  LessonRedemptionCount = 'LESSON_REDEMPTION_COUNT',
  OrderCount = 'ORDER_COUNT',
  SubscriptionCount = 'SUBSCRIPTION_COUNT'
}

export type AdminResendOnboardingEmailInput = {
  userId: Scalars['String'];
};

export type AdminReservedId = {
  __typename?: 'AdminReservedId';
  id?: Maybe<Scalars['Int']>;
  membershipId?: Maybe<Scalars['String']>;
  onHoldExpiresAt?: Maybe<Scalars['DateTime']>;
  onHoldFor?: Maybe<Scalars['String']>;
  status?: Maybe<ReservedIdStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminReservedIds = {
  __typename?: 'AdminReservedIds';
  idOnHold?: Maybe<Scalars['String']>;
  idOnHoldExpiresAt?: Maybe<Scalars['DateTime']>;
  reservedIds?: Maybe<Array<Maybe<AdminReservedId>>>;
};

export type AdminReservedIdsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminResponse = {
  __typename?: 'AdminResponse';
  edges?: Maybe<Array<Maybe<AdminEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminScoreCard = {
  __typename?: 'AdminScoreCard';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<AdminGameRoundScoreCard>>;
};

export type AdminScoreCardArgs = {
  accessToken: Scalars['String'];
  gameRoundId: Scalars['Int'];
};

export type AdminShopDetails = {
  __typename?: 'AdminShopDetails';
  CDN?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  clientType?: Maybe<AdminShopDetailsClientType>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  isEquipmentStorage?: Maybe<Scalars['Boolean']>;
  isLeftHanded?: Maybe<Scalars['Boolean']>;
  isParking?: Maybe<Scalars['Boolean']>;
  isProLesson?: Maybe<Scalars['Boolean']>;
  isShopCloseNextDay?: Maybe<Scalars['Boolean']>;
  isSwingplate?: Maybe<Scalars['Boolean']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerMobilePhone?: Maybe<Scalars['String']>;
  ownerMobilePhoneCountry?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  shopCloseTime?: Maybe<Scalars['String']>;
  shopGuid?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  shopOpenTime?: Maybe<Scalars['String']>;
  shopPhone?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AdminShopDetailsArg = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopDetailsClientType = {
  __typename?: 'AdminShopDetailsClientType';
  lesson?: Maybe<Scalars['Boolean']>;
  practice?: Maybe<Scalars['Boolean']>;
  screen?: Maybe<Scalars['Boolean']>;
};

export type AdminShopGetNotificationInput = {
  accessToken: Scalars['String'];
  notificationId: Scalars['String'];
};

export type AdminShopNotification = {
  __typename?: 'AdminShopNotification';
  message: Scalars['String'];
};

export type AdminShopOptionsDrivingRange = {
  __typename?: 'AdminShopOptionsDrivingRange';
  courseId?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['Int']>;
  distanceUnit?: Maybe<Scalars['Int']>;
  isBallTrajectory?: Maybe<Scalars['Boolean']>;
  isFixedCamera?: Maybe<Scalars['Boolean']>;
  isSwingVideo?: Maybe<Scalars['Boolean']>;
  teeHeight?: Maybe<Scalars['Int']>;
  useSwingPlate?: Maybe<Scalars['Int']>;
  windSpeed?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsDrivingRangeArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopOptionsRealTime = {
  __typename?: 'AdminShopOptionsRealTime';
  drivingRangeTimeLimit?: Maybe<Scalars['Int']>;
  gameHoleTypeLimit?: Maybe<Scalars['Int']>;
  gameTypeLimit?: Maybe<Scalars['Int']>;
  isContentLimit?: Maybe<Scalars['Boolean']>;
  paymentType?: Maybe<Scalars['Int']>;
  playerCountLimit?: Maybe<Scalars['Int']>;
  usageTime?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsRealTimeArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopOptionsRound = {
  __typename?: 'AdminShopOptionsRound';
  concede?: Maybe<Scalars['Float']>;
  distanceUnit?: Maybe<Scalars['Int']>;
  greenLocation?: Maybe<Scalars['Int']>;
  greenSpeed?: Maybe<Scalars['Int']>;
  holeCupLocation?: Maybe<Scalars['Int']>;
  isBestVideo?: Maybe<Scalars['Boolean']>;
  isCaddyVoice?: Maybe<Scalars['Boolean']>;
  isUseObHazardTee?: Maybe<Scalars['Boolean']>;
  mulliganCount?: Maybe<Scalars['Int']>;
  puttingLine?: Maybe<Scalars['Int']>;
  useSwingPlate?: Maybe<Scalars['Int']>;
  windSpeed?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsRoundArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopSendNotificationInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  message: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopTokensInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminSimulatorUsageArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminStaffBasic = {
  __typename?: 'AdminStaffBasic';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type AdminStaffEdge = {
  __typename?: 'AdminStaffEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminStaffBasic>;
};

export type AdminStaffResponse = {
  __typename?: 'AdminStaffResponse';
  edges?: Maybe<Array<Maybe<AdminStaffEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminStaffsArgs = {
  after?: InputMaybe<Scalars['String']>;
  countryFilter?: InputMaybe<CountryCode>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export enum AdminStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export type AdminTerminateMembershipInput = {
  membershipUuid: Scalars['String'];
};

export type AdminUnlockClientInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  drivingRangeTimeLimit: Scalars['Int'];
  gameHoleTypeLimit: Scalars['String'];
  gameTypeLimit: Scalars['String'];
  isContentLimit: Scalars['Boolean'];
  paymentType: Scalars['String'];
  playerCountLimit: Scalars['String'];
  shopGuid: Scalars['String'];
  usageTime: Scalars['Int'];
};

export type AdminUpdateAdminArgs = {
  userId: Scalars['String'];
};

export type AdminUpdateAdminInput = {
  authorizedClubhouses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  baseCountryCode?: InputMaybe<CountryCode>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
};

export type AdminUpdateClientContentLimitInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  players: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminUpdateCoachArgs = {
  userId: Scalars['String'];
};

export type AdminUpdateCoachBookable = {
  __typename?: 'AdminUpdateCoachBookable';
  isBookable: Scalars['Boolean'];
};

export type AdminUpdateCoachBookableInput = {
  isBookable: Scalars['Boolean'];
};

export type AdminUpdateCoachInput = {
  baseCountryCode?: InputMaybe<CountryCode>;
  coachBirthPlace?: InputMaybe<Scalars['String']>;
  coachBirthdate?: InputMaybe<Scalars['String']>;
  coachExperiences?: InputMaybe<Scalars['JSON']>;
  coachExpertise?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  coachLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  coachLevel?: InputMaybe<CoachLevel>;
  coachListOrder?: InputMaybe<Scalars['Int']>;
  coachPGANo?: InputMaybe<Scalars['String']>;
  coachPGAType?: InputMaybe<Scalars['String']>;
  coachPGAYear?: InputMaybe<Scalars['String']>;
  coachPublished?: InputMaybe<Scalars['Boolean']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
};

export type AdminUpdateFacilityInput = {
  facilityName?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<FacilityType>;
  id: Scalars['String'];
};

export type AdminUpdateMembershipTypeInput = {
  baseCountryCode?: InputMaybe<CountryCode>;
  compDailySimulatorUse?: InputMaybe<Scalars['Int']>;
  compDailySimulatorUseType?: InputMaybe<CompDailySimulatorUseType>;
  compFieldLessons?: InputMaybe<Scalars['Int']>;
  compIndoorLessons?: InputMaybe<Scalars['Int']>;
  compLocker?: InputMaybe<Scalars['Boolean']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  designatedPrivateRoom?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Int']>;
  imageFile?: InputMaybe<File>;
  initialCredits?: InputMaybe<Scalars['Int']>;
  internalName?: InputMaybe<Scalars['String']>;
  isCorporate?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lineItemCode?: InputMaybe<Scalars['String']>;
  loungeAccess?: InputMaybe<Scalars['Boolean']>;
  mainTypeSlug?: InputMaybe<Scalars['String']>;
  monthlySub?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  publicName?: InputMaybe<Scalars['String']>;
  signupProductSidasInsoles?: InputMaybe<Scalars['Boolean']>;
  subscriptionlineItemCode?: InputMaybe<Scalars['String']>;
  supplementaryTypeSlug?: InputMaybe<Scalars['String']>;
  tagBgColorCode?: InputMaybe<Scalars['String']>;
  tagText?: InputMaybe<Scalars['String']>;
  tagTextColorCode?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<MembershipTypeTier>;
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateNicknameInput = {
  memberUuid: Scalars['String'];
  newNickname: Scalars['String'];
};

export type AdminUpdateOrganizationInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AdminUpdatePricingInput = {
  sgBayHourlyRate?: InputMaybe<Scalars['Int']>;
  sgBayHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgBayMaxHours?: InputMaybe<Scalars['Int']>;
  sgBayMaxPlayers?: InputMaybe<Scalars['Int']>;
  sgBookingCancellationPenalty?: InputMaybe<Scalars['Int']>;
  sgBookingLapsedPenalty?: InputMaybe<Scalars['Int']>;
  sgHole9MaxHours?: InputMaybe<Scalars['Int']>;
  sgHole9MaxPlayers?: InputMaybe<Scalars['Int']>;
  sgHole9PerPlayerRate?: InputMaybe<Scalars['Int']>;
  sgHole9PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  sgHole18MaxHours?: InputMaybe<Scalars['Int']>;
  sgHole18MaxPlayers?: InputMaybe<Scalars['Int']>;
  sgHole18PerPlayerRate?: InputMaybe<Scalars['Int']>;
  sgHole18PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  sgLessonField?: InputMaybe<Scalars['Int']>;
  sgLessonFieldVIP?: InputMaybe<Scalars['Int']>;
  sgLessonIndoor?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreen?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreenVIP?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorVIP?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomHourlyRate?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomMaxHours?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomMaxPlayers?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenHourlyRate?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenMaxMins?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenMaxPlayers?: InputMaybe<Scalars['Int']>;
  viBayHourlyRate?: InputMaybe<Scalars['Int']>;
  viBayHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viBayMaxHours?: InputMaybe<Scalars['Int']>;
  viBayMaxPlayers?: InputMaybe<Scalars['Int']>;
  viBookingCancellationPenalty?: InputMaybe<Scalars['Int']>;
  viBookingLapsedPenalty?: InputMaybe<Scalars['Int']>;
  viHole9MaxHours?: InputMaybe<Scalars['Int']>;
  viHole9MaxPlayers?: InputMaybe<Scalars['Int']>;
  viHole9PerPlayerRate?: InputMaybe<Scalars['Int']>;
  viHole9PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  viHole18MaxHours?: InputMaybe<Scalars['Int']>;
  viHole18MaxPlayers?: InputMaybe<Scalars['Int']>;
  viHole18PerPlayerRate?: InputMaybe<Scalars['Int']>;
  viHole18PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  viLessonField?: InputMaybe<Scalars['Int']>;
  viLessonFieldVIP?: InputMaybe<Scalars['Int']>;
  viLessonIndoor?: InputMaybe<Scalars['Int']>;
  viLessonIndoorPuttingGreen?: InputMaybe<Scalars['Int']>;
  viLessonIndoorPuttingGreenVIP?: InputMaybe<Scalars['Int']>;
  viLessonIndoorVIP?: InputMaybe<Scalars['Int']>;
  viPrivateRoomHourlyRate?: InputMaybe<Scalars['Int']>;
  viPrivateRoomHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viPrivateRoomMaxHours?: InputMaybe<Scalars['Int']>;
  viPrivateRoomMaxPlayers?: InputMaybe<Scalars['Int']>;
  viPuttingGreenHourlyRate?: InputMaybe<Scalars['Int']>;
  viPuttingGreenHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viPuttingGreenMaxMins?: InputMaybe<Scalars['Int']>;
  viPuttingGreenMaxPlayers?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateReservedId = {
  __typename?: 'AdminUpdateReservedId';
  onHoldExpiresAt?: Maybe<Scalars['DateTime']>;
};

export type AdminUpdateReservedIdInput = {
  hold?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateShopDetailsInput = {
  CDN?: InputMaybe<Scalars['String']>;
  accessToken?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  introImage?: InputMaybe<Scalars['String']>;
  isParking?: InputMaybe<Scalars['Boolean']>;
  isShopCloseNextDay?: InputMaybe<Scalars['Boolean']>;
  logoImage?: InputMaybe<Scalars['String']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
  ownerMobilePhone?: InputMaybe<Scalars['String']>;
  ownerMobilePhoneCountry?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  shopCloseTime?: InputMaybe<Scalars['String']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  shopName?: InputMaybe<Scalars['String']>;
  shopOpenTime?: InputMaybe<Scalars['String']>;
  shopPhone?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateShopOptionsDrivingRangeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['String']>;
  difficulty?: InputMaybe<Scalars['Int']>;
  distanceUnit?: InputMaybe<Scalars['Int']>;
  isBallTrajectory?: InputMaybe<Scalars['Boolean']>;
  isFixedCamera?: InputMaybe<Scalars['Boolean']>;
  isSwingVideo?: InputMaybe<Scalars['Boolean']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  teeHeight?: InputMaybe<Scalars['Int']>;
  useSwingPlate?: InputMaybe<Scalars['Int']>;
  windSpeed?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateShopOptionsRealTimeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  drivingRangeTimeLimit?: InputMaybe<Scalars['Int']>;
  gameHoleTypeLimit?: InputMaybe<Scalars['Int']>;
  gameTypeLimit?: InputMaybe<Scalars['Int']>;
  isContentLimit?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<Scalars['Int']>;
  playerCountLimit?: InputMaybe<Scalars['Int']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  usageTime?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateShopOptionsRoundInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  concede?: InputMaybe<Scalars['Int']>;
  distanceUnit?: InputMaybe<Scalars['Int']>;
  greenLocation?: InputMaybe<Scalars['Int']>;
  greenSpeed?: InputMaybe<Scalars['Int']>;
  holeCupLocation?: InputMaybe<Scalars['Int']>;
  isBestVideo?: InputMaybe<Scalars['Boolean']>;
  isCaddyVoice?: InputMaybe<Scalars['Boolean']>;
  isUseObHazardTee?: InputMaybe<Scalars['Boolean']>;
  mulliganCount?: InputMaybe<Scalars['Int']>;
  puttingLine?: InputMaybe<Scalars['Int']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  useSwingPlate?: InputMaybe<Scalars['Int']>;
  windSpeed?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateSidasInsolesInput = {
  memberUuid: Scalars['String'];
  transactionType: AdminUpdateSidasInsolesTransactionType;
};

export enum AdminUpdateSidasInsolesTransactionType {
  Adjustment = 'ADJUSTMENT',
  Complimentary = 'COMPLIMENTARY',
  Redemption = 'REDEMPTION'
}

export type AdminsArgs = {
  after?: InputMaybe<Scalars['String']>;
  countryFilter?: InputMaybe<CountryCode>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  userType?: InputMaybe<UserType>;
};

export type AppData = {
  __typename?: 'AppData';
  androidUrl: Scalars['String'];
  androidVersion: Scalars['String'];
  cancellationConditions: CancellationConditions;
  iosUrl: Scalars['String'];
  iosVersion: Scalars['String'];
  promptMessage: Scalars['String'];
  promptUser: Scalars['Boolean'];
  sidasUrl: Scalars['String'];
  whatsapp: Scalars['String'];
};

export type AppDineMenu = {
  __typename?: 'AppDineMenu';
  foodUri?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  wineUri?: Maybe<Scalars['String']>;
};

export type AppDineMenuArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppMainSlider = {
  __typename?: 'AppMainSlider';
  slides: Array<AppMainSliderSlide>;
};

export type AppMainSliderArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppMainSliderSlide = {
  __typename?: 'AppMainSliderSlide';
  id: Scalars['ID'];
  link?: Maybe<AppMainSliderSlideLink>;
  posterTitle?: Maybe<Scalars['String']>;
  posterUri?: Maybe<Scalars['String']>;
  slidePayload?: Maybe<Scalars['JSON']>;
  slideUri?: Maybe<Scalars['String']>;
};

export type AppMainSliderSlideLink = {
  __typename?: 'AppMainSliderSlideLink';
  posterPayload?: Maybe<Scalars['JSON']>;
  route?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  webViewUrl?: Maybe<Scalars['String']>;
};

export type AppMainSliderSlideV2 = {
  __typename?: 'AppMainSliderSlideV2';
  id: Scalars['ID'];
  isVideo?: Maybe<Scalars['Boolean']>;
  isYoutube?: Maybe<Scalars['Boolean']>;
  link?: Maybe<AppMainSliderSlideLink>;
  order: Scalars['Int'];
  posterTitle?: Maybe<Scalars['String']>;
  posterUri?: Maybe<Scalars['String']>;
  slidePayload?: Maybe<Scalars['JSON']>;
  slideUri?: Maybe<Scalars['String']>;
};

export type AppMainSliderV2 = {
  __typename?: 'AppMainSliderV2';
  slides: Array<AppMainSliderSlideV2>;
};

export type AppMainSliderV2Args = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppManifest = {
  __typename?: 'AppManifest';
  androidUrl: Scalars['String'];
  androidVersion: Scalars['String'];
  bookingVersion: Scalars['String'];
  cancellationConditions: CancellationConditions;
  iosUrl: Scalars['String'];
  iosVersion: Scalars['String'];
  promptMessage: Scalars['String'];
  promptUser: Scalars['Boolean'];
  whatsapp: Scalars['String'];
};

export type AppManifestArgs = {
  temp?: InputMaybe<Scalars['Boolean']>;
};

export type AppManifestV2 = {
  __typename?: 'AppManifestV2';
  aceCoinTopUpPromoBody?: Maybe<Scalars['String']>;
  aceCoinTopUpPromoHeader?: Maybe<Scalars['String']>;
  androidUrl: Scalars['String'];
  androidVersion: Scalars['String'];
  boniqStoreUrl: Scalars['String'];
  cancellationConditions: CancellationConditions;
  concierge: Scalars['String'];
  guestMember: GuestMember;
  iosUrl: Scalars['String'];
  iosVersion: Scalars['String'];
  isRealTimeEnabled: Scalars['Boolean'];
  manualReloadTs?: Maybe<Scalars['DateTime']>;
  promptMessage: Scalars['String'];
  promptUser: Scalars['Boolean'];
  sidasStoreUrl: Scalars['String'];
  translationVersion: Scalars['Int'];
  useWebsiteRates?: Maybe<Scalars['Boolean']>;
  websiteRateUrl?: Maybe<Scalars['String']>;
  whatsapp: Scalars['String'];
};

export type AppMedia = {
  __typename?: 'AppMedia';
  description?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type AppMediaArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppMediaYouTubeVideo = {
  __typename?: 'AppMediaYouTubeVideo';
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AppMediaYouTubeVideoArgs = {
  videoId: Scalars['String'];
};

export enum AppNotificationOperation {
  Account = 'ACCOUNT',
  Acecoins = 'ACECOINS',
  Bookings = 'BOOKINGS',
  CombinedServices = 'COMBINED_SERVICES',
  GameCredit = 'GAME_CREDIT',
  Inbox = 'INBOX',
  LessonVouchers = 'LESSON_VOUCHERS',
  Notification = 'NOTIFICATION',
  Orders = 'ORDERS',
  PractiseCredit = 'PRACTISE_CREDIT',
  Subscriptions = 'SUBSCRIPTIONS'
}

export type AppTelemetry = {
  __typename?: 'AppTelemetry';
  androidVersion?: Maybe<Scalars['String']>;
  iosVersion?: Maybe<Scalars['String']>;
  promptMessage?: Maybe<Scalars['String']>;
  promptUser?: Maybe<Scalars['Boolean']>;
};

export type AppTelemetryInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceManufacturer?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceProductName?: InputMaybe<Scalars['String']>;
  devicePushToken?: InputMaybe<Scalars['String']>;
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  pushNotificationAppEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type AppTelemetryV2Input = {
  appVersion?: InputMaybe<Scalars['String']>;
  biometricAppEnabled?: InputMaybe<Scalars['Boolean']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceManufacturer?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceProductName?: InputMaybe<Scalars['String']>;
  devicePushToken?: InputMaybe<Scalars['String']>;
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  pushNotificationAppEnabled?: InputMaybe<Scalars['Boolean']>;
};

export enum ArchivedBy {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export enum AuditLogOutcome {
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

export type AuthenticatedAdmin = {
  __typename?: 'AuthenticatedAdmin';
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<Scalars['String']>>;
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl: Scalars['String'];
  ud?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: Scalars['String'];
  yourIp: Scalars['String'];
};

export type AuthenticatedMember = {
  __typename?: 'AuthenticatedMember';
  id: Scalars['String'];
  member?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type BasicClubhouseDetails = {
  __typename?: 'BasicClubhouseDetails';
  clubhouseCode: Scalars['String'];
  name: Scalars['String'];
};

export type BaySimulator = {
  __typename?: 'BaySimulator';
  blockedFromBooking: Scalars['Boolean'];
  clientname: Scalars['String'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum BookingStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Lapsed = 'LAPSED',
  Pending = 'PENDING'
}

export enum BookingType {
  Game = 'GAME',
  LessonField = 'LESSON_FIELD',
  LessonIndoor = 'LESSON_INDOOR',
  LessonOutdoor = 'LESSON_OUTDOOR',
  Practise = 'PRACTISE'
}

export type CancellationConditions = {
  __typename?: 'CancellationConditions';
  GAME: Scalars['Int'];
  LESSON_FIELD: Scalars['Int'];
  LESSON_INDOOR: Scalars['Int'];
  LESSON_OUTDOOR: Scalars['Int'];
  PRACTISE: Scalars['Int'];
};

export type CancellationEmailPenaltyLineItem = {
  __typename?: 'CancellationEmailPenaltyLineItem';
  amount: Scalars['String'];
  package?: Maybe<CancellationEmailPenaltyLineItemPackage>;
  type: Scalars['String'];
};

export type CancellationEmailPenaltyLineItemPackage = {
  __typename?: 'CancellationEmailPenaltyLineItemPackage';
  name: Scalars['String'];
  no: Scalars['String'];
};

export enum CancelledBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type ClientStatus = {
  __typename?: 'ClientStatus';
  clients: Scalars['JSON'];
  shopGuid: Scalars['String'];
};

export type ClubhouseOrganization = {
  __typename?: 'ClubhouseOrganization';
  businessName: Scalars['String'];
  id: Scalars['String'];
};

export type ClubhouseOverride = {
  __typename?: 'ClubhouseOverride';
  closureMessage?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type Coach = SystemUser & {
  __typename?: 'Coach';
  baseCountryCode?: Maybe<CountryCode>;
  coachBirthPlace?: Maybe<Scalars['String']>;
  coachBirthdate?: Maybe<Scalars['String']>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLevel?: Maybe<CoachLevel>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAType?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization: AdminOrganization;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status: AdminStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type CoachAccountSettings = {
  __typename?: 'CoachAccountSettings';
  baseCountryCode: CountryCode;
  baseGmtOffset: Scalars['Int'];
  myClubhouses?: Maybe<Array<Maybe<CoachClubhouse>>>;
  slug: Scalars['String'];
};

export type CoachAvailabilityCalendarItems = {
  __typename?: 'CoachAvailabilityCalendarItems';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
  hasIndoorBooking?: Maybe<Scalars['Boolean']>;
  hasOutdoorBooking?: Maybe<Scalars['Boolean']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  isIndoorBookingFull?: Maybe<Scalars['Boolean']>;
};

export type CoachAvailabilityCalendarItemsArgs = {
  currentDate: Scalars['String'];
};

export enum CoachAvailabilityCalendarItemsMode {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR'
}

export type CoachAvailabilityDayItem = {
  __typename?: 'CoachAvailabilityDayItem';
  bi0800?: Maybe<Scalars['String']>;
  bi0900?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  bi2100?: Maybe<Scalars['String']>;
  biOutdoor?: Maybe<Scalars['String']>;
  bs0800?: Maybe<Scalars['String']>;
  bs0900?: Maybe<Scalars['String']>;
  bs1000?: Maybe<Scalars['String']>;
  bs1100?: Maybe<Scalars['String']>;
  bs1200?: Maybe<Scalars['String']>;
  bs1300?: Maybe<Scalars['String']>;
  bs1400?: Maybe<Scalars['String']>;
  bs1500?: Maybe<Scalars['String']>;
  bs1600?: Maybe<Scalars['String']>;
  bs1700?: Maybe<Scalars['String']>;
  bs1800?: Maybe<Scalars['String']>;
  bs1900?: Maybe<Scalars['String']>;
  bs2000?: Maybe<Scalars['String']>;
  bs2100?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  hasOutdoorBooking?: Maybe<Scalars['Boolean']>;
  l0800?: Maybe<Scalars['String']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
  l2100?: Maybe<Scalars['String']>;
};

export type CoachAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export enum CoachAvailabilityDayItemMode {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL'
}

export type CoachAvailabilityDayItemTemplate = {
  __typename?: 'CoachAvailabilityDayItemTemplate';
  id: Scalars['String'];
  l0800?: Maybe<Scalars['String']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
  l2100?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateArgs = {
  id: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateCreate = {
  __typename?: 'CoachAvailabilityDayItemTemplateCreate';
  id: Scalars['String'];
  status: SystemOperationStatus;
};

export type CoachAvailabilityDayItemTemplateCreateInput = {
  l0800?: InputMaybe<Scalars['String']>;
  l0900?: InputMaybe<Scalars['String']>;
  l1000?: InputMaybe<Scalars['String']>;
  l1100?: InputMaybe<Scalars['String']>;
  l1200?: InputMaybe<Scalars['String']>;
  l1300?: InputMaybe<Scalars['String']>;
  l1400?: InputMaybe<Scalars['String']>;
  l1500?: InputMaybe<Scalars['String']>;
  l1600?: InputMaybe<Scalars['String']>;
  l1700?: InputMaybe<Scalars['String']>;
  l1800?: InputMaybe<Scalars['String']>;
  l1900?: InputMaybe<Scalars['String']>;
  l2000?: InputMaybe<Scalars['String']>;
  l2100?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateDeleteInput = {
  id: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateUpdateInput = {
  id: Scalars['String'];
  l0800?: InputMaybe<Scalars['String']>;
  l0900?: InputMaybe<Scalars['String']>;
  l1000?: InputMaybe<Scalars['String']>;
  l1100?: InputMaybe<Scalars['String']>;
  l1200?: InputMaybe<Scalars['String']>;
  l1300?: InputMaybe<Scalars['String']>;
  l1400?: InputMaybe<Scalars['String']>;
  l1500?: InputMaybe<Scalars['String']>;
  l1600?: InputMaybe<Scalars['String']>;
  l1700?: InputMaybe<Scalars['String']>;
  l1800?: InputMaybe<Scalars['String']>;
  l1900?: InputMaybe<Scalars['String']>;
  l2000?: InputMaybe<Scalars['String']>;
  l2100?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CoachAvailabilityDayUpsertInput = {
  coachId?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  l0800?: InputMaybe<Scalars['String']>;
  l0900?: InputMaybe<Scalars['String']>;
  l1000?: InputMaybe<Scalars['String']>;
  l1100?: InputMaybe<Scalars['String']>;
  l1200?: InputMaybe<Scalars['String']>;
  l1300?: InputMaybe<Scalars['String']>;
  l1400?: InputMaybe<Scalars['String']>;
  l1500?: InputMaybe<Scalars['String']>;
  l1600?: InputMaybe<Scalars['String']>;
  l1700?: InputMaybe<Scalars['String']>;
  l1800?: InputMaybe<Scalars['String']>;
  l1900?: InputMaybe<Scalars['String']>;
  l2000?: InputMaybe<Scalars['String']>;
  l2100?: InputMaybe<Scalars['String']>;
};

export type CoachBooking = {
  __typename?: 'CoachBooking';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<CancelledBy>;
  cancelledByAdminName?: Maybe<Scalars['String']>;
  coachId?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  commentByCoach?: Maybe<Scalars['String']>;
  commentByCoachId?: Maybe<Scalars['String']>;
  commentInternal?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dateMonthStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  durationStr?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  endTimeStr?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  groupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  id: Scalars['String'];
  isGroupBooking: Scalars['Boolean'];
  member: Scalars['String'];
  memberIndividualId: Scalars['String'];
  memberUuid: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  noOfPlayers: Scalars['Int'];
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  startTimeStr?: Maybe<Scalars['String']>;
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type CoachBookingArgs = {
  bookingId: Scalars['String'];
};

export type CoachBookingBasic = {
  __typename?: 'CoachBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  coachDisplayName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dateMonthStr?: Maybe<Scalars['String']>;
  dateStr: Scalars['String'];
  dayOfWeekStr?: Maybe<Scalars['String']>;
  durationStr?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  endTimeStr?: Maybe<Scalars['String']>;
  groupBookingId?: Maybe<Scalars['String']>;
  groupBookingIds: Array<Maybe<Scalars['String']>>;
  id: Scalars['String'];
  isGroupBooking: Scalars['Boolean'];
  member: Scalars['String'];
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  startTimeStr?: Maybe<Scalars['String']>;
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type CoachBookingCoach = {
  __typename?: 'CoachBookingCoach';
  baseCountryCode?: Maybe<CountryCode>;
  coachPublished?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type CoachBookingCombinedAvailability = {
  __typename?: 'CoachBookingCombinedAvailability';
  coachId: Scalars['String'];
  coachSlug: Scalars['String'];
  dateObjs: Array<Maybe<CoachBookingCombinedAvailabilityDateObj>>;
  name: Scalars['String'];
};

export type CoachBookingCombinedAvailabilityArgs = {
  currentDate: Scalars['String'];
};

export type CoachBookingCombinedAvailabilityDateObj = {
  __typename?: 'CoachBookingCombinedAvailabilityDateObj';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
  hasIndoorBooking: Scalars['Boolean'];
  hasOutdoorBooking: Scalars['Boolean'];
  isDayBlocked: Scalars['Boolean'];
};

export type CoachBookingCombinedAvailabilityDayItem = {
  __typename?: 'CoachBookingCombinedAvailabilityDayItem';
  bi0800?: Maybe<Scalars['String']>;
  bi0900?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  bi2100?: Maybe<Scalars['String']>;
  biOutdoor?: Maybe<Scalars['String']>;
  bs0800?: Maybe<Scalars['String']>;
  bs0900?: Maybe<Scalars['String']>;
  bs1000?: Maybe<Scalars['String']>;
  bs1100?: Maybe<Scalars['String']>;
  bs1200?: Maybe<Scalars['String']>;
  bs1300?: Maybe<Scalars['String']>;
  bs1400?: Maybe<Scalars['String']>;
  bs1500?: Maybe<Scalars['String']>;
  bs1600?: Maybe<Scalars['String']>;
  bs1700?: Maybe<Scalars['String']>;
  bs1800?: Maybe<Scalars['String']>;
  bs1900?: Maybe<Scalars['String']>;
  bs2000?: Maybe<Scalars['String']>;
  bs2100?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<CoachClubhouse>>;
  date?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  hasOutdoorBooking?: Maybe<Scalars['Boolean']>;
  l0800?: Maybe<Scalars['String']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
  l2100?: Maybe<Scalars['String']>;
};

export type CoachBookingCombinedAvailabilityDayItemArgs = {
  coachId: Scalars['String'];
  dateId: Scalars['String'];
};

export type CoachBookingCommentUpdate = {
  __typename?: 'CoachBookingCommentUpdate';
  commentByCoach?: Maybe<Scalars['String']>;
};

export type CoachBookingCommentUpdateInput = {
  body: Scalars['String'];
  bookingId: Scalars['String'];
  commentId?: InputMaybe<Scalars['String']>;
};

export type CoachBookingEdge = {
  __typename?: 'CoachBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CoachBookingBasic>;
};

export type CoachBookingResponse = {
  __typename?: 'CoachBookingResponse';
  edges?: Maybe<Array<Maybe<CoachBookingEdge>>>;
  firstBookingDate?: Maybe<Scalars['DateTime']>;
  lastBookingDate?: Maybe<Scalars['DateTime']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CoachBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  allBookings?: InputMaybe<Scalars['Boolean']>;
  bookingIdFilter?: InputMaybe<Scalars['String']>;
  bookingTypes: Array<InputMaybe<BookingType>>;
  coachId?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<BookingStatus>;
  venueFilter?: InputMaybe<Scalars['String']>;
};

export type CoachClubhouse = {
  __typename?: 'CoachClubhouse';
  clubhouseCode: Scalars['String'];
  displayName: Scalars['String'];
  tagBgColorCode: Scalars['String'];
  tagText: Scalars['String'];
  tagTextColorCode: Scalars['String'];
};

export type CoachExperience = {
  __typename?: 'CoachExperience';
  details: Scalars['String'];
  period: Scalars['String'];
};

export type CoachGroupBooking = {
  __typename?: 'CoachGroupBooking';
  coachId?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  commentInternal?: Maybe<Scalars['String']>;
  dateMonthStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  durationStr?: Maybe<Scalars['String']>;
  endTimeStr: Scalars['String'];
  facilityType?: Maybe<FacilityType>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<GameCourseType>;
  id: Scalars['String'];
  member: Scalars['String'];
  memberIndividualId: Scalars['String'];
  mobileNumber: Scalars['String'];
  resourceName?: Maybe<Scalars['String']>;
  startTimeStr?: Maybe<Scalars['String']>;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type CoachGroupBookingsArgs = {
  bookingIds: Array<Scalars['String']>;
};

export enum CoachLevel {
  Pro = 'PRO',
  SemiPro = 'SEMI_PRO'
}

export type CoachMember = {
  __typename?: 'CoachMember';
  accountType?: Maybe<AccountType>;
  birthday?: Maybe<Scalars['String']>;
  companyContactPersonEmail?: Maybe<Scalars['String']>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  handed: Handed;
  individualId: Scalars['String'];
  lastName: Scalars['String'];
  memberUuid: Scalars['String'];
  members: Array<Maybe<AdminMemberMember>>;
  membershipType?: Maybe<MembershipTypeBasic>;
  membershipUuid: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  relationshipToMainMember?: Maybe<Relationship>;
  serviceNote?: Maybe<Scalars['String']>;
};

export type CoachMemberArgs = {
  memberUuid: Scalars['String'];
};

export type CoachMemberBasic = {
  __typename?: 'CoachMemberBasic';
  accountType?: Maybe<AccountType>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  individualId: Scalars['String'];
  lastName: Scalars['String'];
  memberName?: Maybe<Scalars['String']>;
  membershipId: Scalars['String'];
  membershipType?: Maybe<MembershipTypeBasic>;
  nextBookingDateStr?: Maybe<Scalars['String']>;
  nextBookingStartTime?: Maybe<Scalars['DateTime']>;
  nextBookingVenue?: Maybe<Scalars['String']>;
  noOfBookings?: Maybe<Scalars['Int']>;
};

export type CoachMemberEdge = {
  __typename?: 'CoachMemberEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CoachMemberBasic>;
};

export type CoachMemberLessonNote = {
  __typename?: 'CoachMemberLessonNote';
  attachments?: Maybe<Array<Scalars['String']>>;
  bookingId?: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  dateStr: Scalars['String'];
  id: Scalars['String'];
  lessonType: Scalars['String'];
  memberIndividualId: Scalars['String'];
  memberName: Scalars['String'];
  memberUuid: Scalars['String'];
  venue?: Maybe<Scalars['String']>;
  venueOther?: Maybe<Scalars['String']>;
};

export type CoachMemberLessonNoteArgs = {
  id: Scalars['String'];
};

export type CoachMemberLessonNoteBasic = {
  __typename?: 'CoachMemberLessonNoteBasic';
  attachments?: Maybe<Array<Scalars['String']>>;
  bookingId?: Maybe<Scalars['String']>;
  dateStr: Scalars['String'];
  id: Scalars['String'];
  lessonType: Scalars['String'];
  venue: Scalars['String'];
};

export type CoachMemberLessonNoteCreateInput = {
  attachments?: InputMaybe<Array<Scalars['String']>>;
  bookingId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  date: Scalars['String'];
  lessonType: Scalars['String'];
  memberUuid: Scalars['String'];
  venue: Scalars['String'];
};

export type CoachMemberLessonNoteDelete = {
  __typename?: 'CoachMemberLessonNoteDelete';
  hasFeedback: Scalars['Boolean'];
};

export type CoachMemberLessonNoteDeleteInput = {
  memberUuid: Scalars['String'];
  noteId: Scalars['String'];
};

export type CoachMemberLessonNoteEdge = {
  __typename?: 'CoachMemberLessonNoteEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CoachMemberLessonNoteBasic>;
};

export type CoachMemberLessonNoteMember = {
  __typename?: 'CoachMemberLessonNoteMember';
  id: Scalars['String'];
  memberIndividualId: Scalars['String'];
  memberName: Scalars['String'];
  noOfLessonNotes?: Maybe<Scalars['Int']>;
};

export type CoachMemberLessonNoteMemberEdge = {
  __typename?: 'CoachMemberLessonNoteMemberEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CoachMemberLessonNoteMember>;
};

export type CoachMemberLessonNoteMemberResponse = {
  __typename?: 'CoachMemberLessonNoteMemberResponse';
  edges?: Maybe<Array<Maybe<CoachMemberLessonNoteMemberEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CoachMemberLessonNoteMembersArgs = {
  nameFilter?: InputMaybe<Scalars['String']>;
};

export type CoachMemberLessonNoteResponse = {
  __typename?: 'CoachMemberLessonNoteResponse';
  edges?: Maybe<Array<Maybe<CoachMemberLessonNoteEdge>>>;
  memberIndividualId: Scalars['String'];
  memberName: Scalars['String'];
  memberUuid: Scalars['String'];
  pageInfo?: Maybe<PageInfo>;
};

export type CoachMemberLessonNoteUpdateInput = {
  attachments?: InputMaybe<Array<Scalars['String']>>;
  comment: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
  lessonType?: InputMaybe<Scalars['String']>;
  noteId: Scalars['String'];
  venue?: InputMaybe<Scalars['String']>;
};

export type CoachMemberLessonNotesArgs = {
  memberUuid: Scalars['String'];
};

export type CoachMemberResponse = {
  __typename?: 'CoachMemberResponse';
  edges?: Maybe<Array<Maybe<CoachMemberEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CoachMembersArgs = {
  nameFilter?: InputMaybe<Scalars['String']>;
  tierFilter?: InputMaybe<Scalars['String']>;
};

export enum CoachSlotStatus {
  Blocked = 'BLOCKED',
  BookedLessonIndoor = 'BOOKED_LESSON_INDOOR',
  BookedLessonIndoorForced = 'BOOKED_LESSON_INDOOR_FORCED',
  BookedLessonOutdoor = 'BOOKED_LESSON_OUTDOOR',
  BookedLessonOutdoorForced = 'BOOKED_LESSON_OUTDOOR_FORCED'
}

export enum CompDailySimulatorUseType {
  Na = 'NA',
  Restricted = 'RESTRICTED',
  Unrestricted = 'UNRESTRICTED'
}

export enum CompDailySimulatorUseTypeOverwrite {
  Na = 'NA',
  Restricted = 'RESTRICTED',
  RestrictedPm = 'RESTRICTED_PM',
  Unrestricted = 'UNRESTRICTED'
}

export enum CountryCode {
  Sg = 'SG',
  Th = 'TH',
  Vn = 'VN',
  Xx = 'XX'
}

export type CourseMapCoordinate = {
  __typename?: 'CourseMapCoordinate';
  downX?: Maybe<Scalars['Float']>;
  downY?: Maybe<Scalars['Float']>;
  holeNumber?: Maybe<Scalars['Int']>;
  rightX?: Maybe<Scalars['Float']>;
  rightY?: Maybe<Scalars['Float']>;
  worldLeftTopX?: Maybe<Scalars['Float']>;
  worldLeftTopY?: Maybe<Scalars['Float']>;
  worldSizeX?: Maybe<Scalars['Float']>;
  worldSizeY?: Maybe<Scalars['Float']>;
};

export type CreateMemberInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry: Scalars['String'];
  addressPostalCode: Scalars['String'];
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1: Scalars['String'];
  addressStreet2?: InputMaybe<Scalars['String']>;
  bankTransferRef?: InputMaybe<Scalars['String']>;
  birthdayDay: Scalars['String'];
  birthdayMonth: Scalars['String'];
  birthdayYear: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  nationality?: InputMaybe<Scalars['String']>;
  partialNricOrFin?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
  relationshipToMainMember?: InputMaybe<Relationship>;
  sameAddressAsMainMember?: InputMaybe<Scalars['Boolean']>;
};

export enum CreatedBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export enum CurrencyCode {
  Sgd = 'SGD',
  Usd = 'USD',
  Vnd = 'VND'
}

export enum DbServiceEnvType {
  Dev = 'DEV',
  Na = 'NA',
  Prod = 'PROD',
  Test = 'TEST'
}

export type DevAceCoinsLedger = {
  __typename?: 'DevAceCoinsLedger';
  aceCoins: Scalars['Float'];
  calculated: Scalars['Float'];
  difference: Scalars['Float'];
  mainMember: Scalars['String'];
  membershipId: Scalars['String'];
  membershipType?: Maybe<MembershipTypeBasic>;
  membershipUuid: Scalars['String'];
  transactions?: Maybe<Array<Maybe<AceCoinLedgerTransaction>>>;
};

export type DevAceCoinsLedgerArgs = {
  membershipUuid: Scalars['String'];
};

export type DevManagementSystemAdminNotificationSendInput = {
  devId: Scalars['String'];
  message: Scalars['String'];
  title: Scalars['String'];
};

export type DevManagementSystemAdminViewportReloadRequestInput = {
  userId: Scalars['String'];
};

export type DevManagementSystemServerEnvironments = {
  __typename?: 'DevManagementSystemServerEnvironments';
  environments: Scalars['JSON'];
};

export type DevManagementSystemServerStatus = {
  __typename?: 'DevManagementSystemServerStatus';
  dbService?: Maybe<DevManagementSystemServerStatusDbService>;
};

export type DevManagementSystemServerStatusDbService = {
  __typename?: 'DevManagementSystemServerStatusDbService';
  envType?: Maybe<DbServiceEnvType>;
  url?: Maybe<Scalars['String']>;
};

export type DevManagementSystemUserTelemetry = {
  __typename?: 'DevManagementSystemUserTelemetry';
  eventId: Scalars['String'];
  pageName: Scalars['String'];
  resourceId?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  resourceType?: Maybe<UserTelemetryResourceType>;
  ts: Scalars['String'];
  userId: Scalars['String'];
  userName: Scalars['String'];
  userProfileImageUrl?: Maybe<Scalars['String']>;
};

export type DevMemberAceCoinIssue = {
  __typename?: 'DevMemberAceCoinIssue';
  aceCoins: Scalars['Float'];
  calculated: Scalars['Float'];
  credits: Scalars['Float'];
  difference: Scalars['Float'];
  errorType: Scalars['String'];
  memberName: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipId: Scalars['String'];
  membershipType: MembershipTypeBasic;
  membershipUuid: Scalars['String'];
};

export enum DeviceType {
  Mobile = 'MOBILE',
  Pc = 'PC',
  Tablet = 'TABLET'
}

export enum Direction {
  Asc = 'asc',
  Desc = 'desc'
}

export enum DurationType {
  Hour = 'HOUR',
  Min = 'MIN'
}

export type EndCoordinates = {
  __typename?: 'EndCoordinates';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type ExpirableCreditBasic = {
  __typename?: 'ExpirableCreditBasic';
  amount: Scalars['Float'];
  expiryDate: Scalars['DateTime'];
  id: Scalars['String'];
};

export type Facility = {
  __typename?: 'Facility';
  clientGuid?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientOrder?: Maybe<Scalars['Int']>;
  facilityCode?: Maybe<Scalars['String']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  id?: Maybe<Scalars['String']>;
};

export type FacilityAvailability = {
  __typename?: 'FacilityAvailability';
  clubhouseCode: Scalars['String'];
  facilityCode: Scalars['String'];
  facilityName: Scalars['String'];
  facilityType: FacilityType;
};

export type FacilityAvailabilityCalendarItems = {
  __typename?: 'FacilityAvailabilityCalendarItems';
  date: Scalars['String'];
  isBlocked?: Maybe<Scalars['Boolean']>;
};

export type FacilityBasic = {
  __typename?: 'FacilityBasic';
  facilityCode: Scalars['String'];
  facilityName: Scalars['String'];
  facilityType: FacilityType;
};

export enum FacilitySlotStatus {
  BookedGame = 'BOOKED_GAME',
  BookedLesson = 'BOOKED_LESSON',
  BookedPractise = 'BOOKED_PRACTISE'
}

export enum FacilityType {
  OpenBay = 'OPEN_BAY',
  PrivateRoom = 'PRIVATE_ROOM',
  PuttingGreen = 'PUTTING_GREEN',
  Studio = 'STUDIO'
}

export enum FacilityUsageDuration {
  Hour_1 = 'HOUR_1',
  Hour_2 = 'HOUR_2',
  Hour_3 = 'HOUR_3',
  Hour_4 = 'HOUR_4',
  Hour_5 = 'HOUR_5',
  HourHalf = 'HOUR_HALF'
}

export type File = {
  name: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
};

export type FileUploadCredentials = {
  __typename?: 'FileUploadCredentials';
  fields: Scalars['JSONObject'];
  signedUrl: Scalars['String'];
};

export type FileUploadObject = {
  __typename?: 'FileUploadObject';
  assetUrl: Scalars['String'];
  clientImageFieldName: Scalars['String'];
  fields: Scalars['JSONObject'];
  index: Scalars['Int'];
  signedUrl: Scalars['String'];
};

export type FormHelperAceCoinType = {
  __typename?: 'FormHelperAceCoinType';
  currencyCode: CurrencyCode;
  price: Scalars['Int'];
};

export type FormHelperAceCoinTypeArgs = {
  countryCode?: InputMaybe<CountryCode>;
  memberUuid?: InputMaybe<Scalars['String']>;
};

export type FormHelperBooking = {
  __typename?: 'FormHelperBooking';
  clubhouses: Array<Maybe<AdminClubhouseBasic>>;
};

export type FormHelperBookingArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type FormHelperNewAdmin = {
  __typename?: 'FormHelperNewAdmin';
  clubhouses: Array<Maybe<AdminClubhouseBasic>>;
};

export type FormHelperNewAdminArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewBlackOut = {
  __typename?: 'FormHelperNewBlackOut';
  clubhouseCode?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  facilities: Array<Maybe<FacilityBasic>>;
  isCreateAllowed: Scalars['Boolean'];
};

export type FormHelperNewBlackOutArgs = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewCoach = {
  __typename?: 'FormHelperNewCoach';
  countries: Array<Maybe<Scalars['String']>>;
};

export type FormHelperNewCoachArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewMembership = {
  __typename?: 'FormHelperNewMembership';
  membershipTypes: Array<Maybe<FormHelperNewMembershipMembershipType>>;
};

export type FormHelperNewMembershipArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewMembershipMembershipType = {
  __typename?: 'FormHelperNewMembershipMembershipType';
  amtAwardMain: Scalars['Int'];
  amtAwardSub: Scalars['Int'];
  amtPurchaseMain: Scalars['Int'];
  amtPurchaseSub: Scalars['Int'];
  baseCountryCode: CountryCode;
  hasReservedIds?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  internalName: Scalars['String'];
  isCorporate: Scalars['Boolean'];
  lessonIndoorCredit: Scalars['Int'];
  lessonOutdoorCredit: Scalars['Int'];
  parentTypeId?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  supplementaryTypePrice: Scalars['Int'];
  supplementaryTypeSlug?: Maybe<Scalars['String']>;
  versionSlug: Scalars['String'];
};

export type FormHelperProductPackage = {
  __typename?: 'FormHelperProductPackage';
  itemCode: Scalars['String'];
  name: Scalars['String'];
};

export type FormHelperProductPackages = {
  __typename?: 'FormHelperProductPackages';
  packages: Array<Maybe<FormHelperProductPackage>>;
};

export type FormHelperProductPackagesArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type GameBookingConditions = {
  __typename?: 'GameBookingConditions';
  maxDays: Scalars['Int'];
  maxPaxBay: Scalars['Int'];
  maxPaxRoom: Scalars['Int'];
  maxPaxStudio: Scalars['Int'];
  timeLimitMinsPerPax9Hole: Scalars['Int'];
  timeLimitMinsPerPax18Hole: Scalars['Int'];
};

export enum GameCourseType {
  Hole_9 = 'HOLE_9',
  Hole_18 = 'HOLE_18'
}

export type GameRound = {
  __typename?: 'GameRound';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<GameRoundScoreCard>>;
};

export type GameRoundCourseInfo = {
  __typename?: 'GameRoundCourseInfo';
  courseInTotalPar: Scalars['Int'];
  courseOutTotalPar: Scalars['Int'];
  coursePar: Array<Scalars['Int']>;
  courseTotalPar: Scalars['Int'];
  intro: Scalars['String'];
  logo: Scalars['String'];
  newPerioHiddenHole: Scalars['String'];
};

export type GameRoundGameInfo = {
  __typename?: 'GameRoundGameInfo';
  clientGuid: Scalars['String'];
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  concede: Scalars['Int'];
  courseInfo: GameRoundCourseInfo;
  courseName: Scalars['String'];
  distanceUnit: Scalars['String'];
  gameEndTime: Scalars['Int'];
  gameHoleType: Scalars['String'];
  gameRoundId: Scalars['Int'];
  gameStartTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  greenLocation: Scalars['String'];
  greenSpeed: Scalars['String'];
  holeCupLocation: Scalars['String'];
  isBestVideo: Scalars['Boolean'];
  isCaddyVoice: Scalars['Boolean'];
  isUseObHazardTee: Scalars['Boolean'];
  mulliganCount: Scalars['Int'];
  playHoleCount: Scalars['Int'];
  puttingLine: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
  tournamentIdx: Scalars['Int'];
  useSwingPlate: Scalars['String'];
  windSpeed: Scalars['String'];
};

export type GameRoundHoleInfo = {
  __typename?: 'GameRoundHoleInfo';
  holeNumber: Scalars['Int'];
  holeOutType: Scalars['Int'];
  isBestVideo: Scalars['Boolean'];
  isConcede: Scalars['Boolean'];
  isLongest: Scalars['Boolean'];
  isMulligan: Scalars['Boolean'];
  isNearpin: Scalars['Boolean'];
  score: Scalars['Int'];
};

export type GameRoundPlayerInfo = {
  __typename?: 'GameRoundPlayerInfo';
  completeHoleCount: Scalars['Int'];
  difficulty: Scalars['Int'];
  handicap: Scalars['Int'];
  holeInfo: Array<GameRoundHoleInfo>;
  inTotalScore: Scalars['Int'];
  nickname: Scalars['String'];
  outTotalScore: Scalars['Int'];
  playerType: Scalars['Int'];
  rank: Scalars['Int'];
  startHole: Scalars['Int'];
  team: Scalars['Int'];
  totalScore: Scalars['String'];
  userGuid: Scalars['String'];
};

export type GameRoundScoreCard = {
  __typename?: 'GameRoundScoreCard';
  gameInfo: GameRoundGameInfo;
  playerInfo: Array<Maybe<GameRoundPlayerInfo>>;
};

export enum GameType {
  Hole_9 = 'HOLE_9',
  Hole_18 = 'HOLE_18'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Undisclosed = 'UNDISCLOSED'
}

export type GenerateLessonAttachmentUploadUrlInput = {
  fileName?: InputMaybe<Scalars['String']>;
  fileType: Scalars['String'];
  lessonLogId: Scalars['String'];
};

export type GenerateLessonAttachmentUploadUrlResponse = {
  __typename?: 'GenerateLessonAttachmentUploadUrlResponse';
  fields: Scalars['JSONObject'];
  fileUrl: Scalars['String'];
  key: Scalars['String'];
  signedUrl: Scalars['String'];
  thumbnailFields?: Maybe<Scalars['JSONObject']>;
  thumbnailFileUrl?: Maybe<Scalars['String']>;
  thumbnailKey?: Maybe<Scalars['String']>;
  thumbnailSignedUrl?: Maybe<Scalars['String']>;
};

export type GroupLessonPartner = {
  facilityCode: Scalars['String'];
  memberUuid: Scalars['String'];
};

export type GroupMember = {
  __typename?: 'GroupMember';
  bookingId: Scalars['String'];
  individualId: Scalars['String'];
  memberUuid: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  playerName?: Maybe<Scalars['String']>;
};

export type GuestMember = {
  __typename?: 'GuestMember';
  guestMemberUuid: Scalars['String'];
  name: Scalars['String'];
};

export enum Handed {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type HitPayPaymentRequest = {
  __typename?: 'HitPayPaymentRequest';
  checkoutUrl?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
};

export enum IndoorLessonType {
  Field = 'FIELD',
  Normal = 'NORMAL',
  Putting = 'PUTTING'
}

export enum InternalAccountType {
  Na = 'NA',
  Staff = 'STAFF',
  Test = 'TEST'
}

export type Invoice = {
  __typename?: 'Invoice';
  additionalDiscount?: Maybe<Scalars['Float']>;
  amount: Scalars['Float'];
  gst?: Maybe<Scalars['Float']>;
  invoiceNo: Scalars['String'];
  lineItems?: Maybe<Array<Maybe<InvoiceLineItem>>>;
  memberDiscount?: Maybe<Scalars['Float']>;
  memberIndividualId?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentMethod: PaymentMethod;
  serviceFee?: Maybe<Scalars['Float']>;
  strDate: Scalars['String'];
  strTime: Scalars['String'];
  subTotal: Scalars['Float'];
  transactionDateTime: Scalars['DateTime'];
  venue?: Maybe<Scalars['String']>;
};

export type InvoiceBasic = {
  __typename?: 'InvoiceBasic';
  account?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  invoiceNo: Scalars['String'];
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentMethod: Scalars['String'];
  transactionDateTime: Scalars['DateTime'];
  venue?: Maybe<Scalars['String']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  name: Scalars['String'];
  qty: Scalars['Float'];
  salesPrice: Scalars['Float'];
};

export type KGolfLoginData = {
  __typename?: 'KGolfLoginData';
  access_token?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['Int']>;
  guid?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type KGolfMemberGet = {
  __typename?: 'KGolfMemberGet';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Int']>;
  isTermsAgreeNotificationSMS?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  mobilePhoneCountry?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type KGolfMemberJoin = {
  __typename?: 'KGolfMemberJoin';
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfUserId?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
};

export type KGolfMemberLogin = {
  __typename?: 'KGolfMemberLogin';
  accessToken?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  ewxpiresIn?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['Int']>;
  guid?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
};

export type KGolfShopLogin = {
  __typename?: 'KGolfShopLogin';
  accessToken?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['Int']>;
  managerId?: Maybe<Scalars['String']>;
  managerIdx?: Maybe<Scalars['Int']>;
  managerName?: Maybe<Scalars['String']>;
  managerType?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  shopGuid?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
};

export type KGolfUpdateMemberInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['Int']>;
  isTermsAgreeNotificationSMS?: InputMaybe<Scalars['Boolean']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  mobilePhoneCountry?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  eMenuId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  itemCode?: Maybe<Scalars['String']>;
  itemName: Scalars['String'];
  mCategoryId?: Maybe<Scalars['Int']>;
  mainCategory?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  qty: Scalars['Float'];
  salesPrice: Scalars['Float'];
  transactionId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export type LineItemInput = {
  __typename?: 'LineItemInput';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  itemCode?: Maybe<Scalars['String']>;
  itemName: Scalars['String'];
  mCategoryId?: Maybe<Scalars['Int']>;
  mainCategory?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  qty: Scalars['Int'];
  salesPrice: Scalars['Float'];
  vendor?: Maybe<Scalars['String']>;
};

export type LoginInfo = {
  __typename?: 'LoginInfo';
  city?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
};

export type ManagementSystem = {
  __typename?: 'ManagementSystem';
  eventId: Scalars['String'];
  evictionFieldNames: Array<Maybe<Scalars['String']>>;
  operation?: Maybe<ManagementSystemPublishOperation>;
  payload?: Maybe<Scalars['JSON']>;
  ref?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userProfileImageUrl?: Maybe<Scalars['String']>;
};

export type ManagementSystemArgs = {
  userId: Scalars['String'];
};

export enum ManagementSystemPublishOperation {
  AdminBookingCreate = 'ADMIN_BOOKING_CREATE',
  AdminBookingUpdate = 'ADMIN_BOOKING_UPDATE',
  AdminMembershipServiceCreate = 'ADMIN_MEMBERSHIP_SERVICE_CREATE',
  AdminMemberCreate = 'ADMIN_MEMBER_CREATE',
  AdminMemberCreditUpdate = 'ADMIN_MEMBER_CREDIT_UPDATE',
  AdminMemberProfileUpdate = 'ADMIN_MEMBER_PROFILE_UPDATE',
  AdminOrganizationUpdate = 'ADMIN_ORGANIZATION_UPDATE',
  CoachAvailabilityDayUpsert = 'COACH_AVAILABILITY_DAY_UPSERT',
  DevAdminNotification = 'DEV_ADMIN_NOTIFICATION',
  DevAdminTelemetryRequest = 'DEV_ADMIN_TELEMETRY_REQUEST',
  DevAdminViewportReloadRequest = 'DEV_ADMIN_VIEWPORT_RELOAD_REQUEST',
  LegacyApiBooingCreate = 'LEGACY_API_BOOING_CREATE',
  MemberBookingCreate = 'MEMBER_BOOKING_CREATE',
  MemberKioskLogin = 'MEMBER_KIOSK_LOGIN',
  PublicApiQuery = 'PUBLIC_API_QUERY',
  Webhook = 'WEBHOOK'
}

export type MemberAccount = {
  __typename?: 'MemberAccount';
  aceCoin: MemberAccountAceCoin;
  benefits: MemberAccountBenefits;
  defaultBaseCountryCode: CountryCode;
  defaultGmtOffset: Scalars['Int'];
  profile: MemberAccountProfile;
  simulator: MemberAccountSimulator;
};

export type MemberAccountAcTransactionEdge = {
  __typename?: 'MemberAccountAcTransactionEdge';
  cursor?: Maybe<Scalars['Int']>;
  node?: Maybe<AceCoinTransaction>;
};

export type MemberAccountAcTransactionResponse = {
  __typename?: 'MemberAccountAcTransactionResponse';
  edges?: Maybe<Array<Maybe<MemberAccountAcTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberAccountAcTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberAccountAceCoin = {
  __typename?: 'MemberAccountAceCoin';
  balance: Scalars['Float'];
  currentSpent: Scalars['Float'];
};

export type MemberAccountArchiveInput = {
  reason: Scalars['String'];
};

export type MemberAccountBenefits = {
  __typename?: 'MemberAccountBenefits';
  gameCredit: Scalars['Int'];
  lessonVoucherField: Scalars['Int'];
  lessonVoucherIndoor: Scalars['Int'];
  practiseCredit: Scalars['Int'];
  sidasInsoles: Scalars['Int'];
  simulatorHasPrivilege?: Maybe<Scalars['Boolean']>;
  simulatorHasPrivilegeHrs?: Maybe<Scalars['Int']>;
  simulatorUsageConditionMonFri?: Maybe<Scalars['String']>;
  simulatorUsageConditionMonSun?: Maybe<Scalars['String']>;
  simulatorUsageConditionSatSun?: Maybe<Scalars['String']>;
  simulatorUsageDateStr?: Maybe<Scalars['String']>;
  simulatorUsageTimeStr?: Maybe<Scalars['String']>;
};

export type MemberAccountBlackDiamondOverview = {
  __typename?: 'MemberAccountBlackDiamondOverview';
  hasSubscription?: Maybe<Scalars['Boolean']>;
  simulatorConditionMonFri?: Maybe<Scalars['String']>;
  simulatorConditionMonFriLocal?: Maybe<Scalars['String']>;
  simulatorConditionMonSun?: Maybe<Scalars['String']>;
  simulatorConditionMonSunLocal?: Maybe<Scalars['String']>;
  simulatorConditionSatSun?: Maybe<Scalars['String']>;
  simulatorConditionSatSunLocal?: Maybe<Scalars['String']>;
  simulatorDescription?: Maybe<Scalars['String']>;
  simulatorDescriptionLocal?: Maybe<Scalars['String']>;
  simulatorIsRedeemed?: Maybe<Scalars['Boolean']>;
  subscriptionDescription?: Maybe<Scalars['String']>;
  subscriptionDescriptionLocal?: Maybe<Scalars['String']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
};

export type MemberAccountCoach = {
  __typename?: 'MemberAccountCoach';
  coachExperiences: Array<CoachExperience>;
  coachExpertise: Array<Scalars['String']>;
  coachLanguages: Array<Scalars['String']>;
  coachLessonField?: Maybe<Scalars['Int']>;
  coachLessonFieldVIP?: Maybe<Scalars['Int']>;
  coachLessonIndoor?: Maybe<Scalars['Int']>;
  coachLessonIndoorVIP?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  isFreelancer: Scalars['Boolean'];
  profileImageUrl: Scalars['String'];
  socialInstagram?: Maybe<Scalars['String']>;
};

export type MemberAccountCoachArgs = {
  coachId: Scalars['String'];
};

export type MemberAccountCoachBasic = {
  __typename?: 'MemberAccountCoachBasic';
  coachExpertise: Array<Scalars['String']>;
  coachPGANo?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  profileImageUrl: Scalars['String'];
  socialInstagram?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type MemberAccountExpirableCredit = {
  __typename?: 'MemberAccountExpirableCredit';
  amount: Scalars['Float'];
  balance: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  creditType: Scalars['String'];
  dateAdded: Scalars['DateTime'];
  dateAddedStr: Scalars['String'];
  expiryDate: Scalars['DateTime'];
  expiryDateStr: Scalars['String'];
  id: Scalars['String'];
};

export type MemberAccountExpirableCreditEdge = {
  __typename?: 'MemberAccountExpirableCreditEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberAccountExpirableCredit>;
};

export type MemberAccountExpirableCreditResponse = {
  __typename?: 'MemberAccountExpirableCreditResponse';
  edges?: Maybe<Array<Maybe<MemberAccountExpirableCreditEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberAccountExpirableCreditsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberAccountFindMember = {
  __typename?: 'MemberAccountFindMember';
  memberFound: Scalars['Boolean'];
  memberName?: Maybe<Scalars['String']>;
};

export type MemberAccountFindMemberArgs = {
  targetMemberCardId: Scalars['String'];
};

export type MemberAccountInvoiceArgs = {
  invoiceNo: Scalars['String'];
};

export type MemberAccountInvoiceBasic = {
  __typename?: 'MemberAccountInvoiceBasic';
  amount: Scalars['Float'];
  invoiceNo: Scalars['String'];
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentMethod: Scalars['String'];
  transactionDateTime: Scalars['DateTime'];
  venue?: Maybe<Scalars['String']>;
};

export type MemberAccountInvoicesArgs = {
  yearMonth?: InputMaybe<Scalars['String']>;
};

export type MemberAccountLessonNote = {
  __typename?: 'MemberAccountLessonNote';
  attachments?: Maybe<Array<Scalars['String']>>;
  bookingId?: Maybe<Scalars['String']>;
  coachDisplayName: Scalars['String'];
  comment: Scalars['String'];
  dateStr: Scalars['String'];
  id: Scalars['String'];
  lessonType: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberAccountLessonNoteArgs = {
  id: Scalars['String'];
};

export type MemberAccountLessonNoteBasic = {
  __typename?: 'MemberAccountLessonNoteBasic';
  attachments?: Maybe<Array<Scalars['String']>>;
  bookingId?: Maybe<Scalars['String']>;
  coachDisplayName: Scalars['String'];
  date: Scalars['DateTime'];
  id: Scalars['String'];
  lessonType: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberAccountLessonNoteEdge = {
  __typename?: 'MemberAccountLessonNoteEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberAccountLessonNoteBasic>;
};

export type MemberAccountLessonNoteResponse = {
  __typename?: 'MemberAccountLessonNoteResponse';
  edges?: Maybe<Array<Maybe<MemberAccountLessonNoteEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberAccountLessonNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  coachIdFilter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberAccountNotificationArgs = {
  notificationOnMemberId: Scalars['String'];
};

export type MemberAccountNotificationBasic = {
  __typename?: 'MemberAccountNotificationBasic';
  createdAt: Scalars['DateTime'];
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isRead?: Maybe<Scalars['Boolean']>;
  isReadDate?: Maybe<Scalars['DateTime']>;
  mode?: Maybe<NotificationMode>;
  notificationOnMemberId?: Maybe<Scalars['String']>;
  preview: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type MemberAccountNotificationDelete = {
  __typename?: 'MemberAccountNotificationDelete';
  newNotificationCount: Scalars['Int'];
};

export type MemberAccountNotificationDeleteInput = {
  notificationId: Scalars['String'];
};

export type MemberAccountNotificationEdge = {
  __typename?: 'MemberAccountNotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberAccountNotificationBasic>;
};

export type MemberAccountNotificationResponse = {
  __typename?: 'MemberAccountNotificationResponse';
  edges?: Maybe<Array<Maybe<MemberAccountNotificationEdge>>>;
  pageInfo?: Maybe<MemberAccountNotificationsPageInfo>;
};

export type MemberAccountNotificationUpdateInput = {
  isDismissed?: InputMaybe<Scalars['Boolean']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  notificationId: Scalars['String'];
};

export type MemberAccountNotificationUpdateV2 = {
  __typename?: 'MemberAccountNotificationUpdateV2';
  newNotificationCount: Scalars['Int'];
};

export type MemberAccountNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberAccountNotificationsPageInfo = {
  __typename?: 'MemberAccountNotificationsPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  newNotificationCount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type MemberAccountPackage = {
  __typename?: 'MemberAccountPackage';
  amount: Scalars['Float'];
  categoryDisplayName?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['DateTime']>;
  dateAddedStr?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  expiryDateStr?: Maybe<Scalars['String']>;
  expiryWarning?: Maybe<Scalars['Boolean']>;
  groupMemberIndividualId: Scalars['String'];
  groupMemberName: Scalars['String'];
  hasSupplementaryRedemption: Scalars['Boolean'];
  isDailyRedeemed: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  packageName: Scalars['String'];
  serviceId: Scalars['String'];
  supplementaryAmount: Scalars['Float'];
  supplementaryUnitName: Scalars['String'];
  transactions: Array<Maybe<ServiceTransactionBasic>>;
  unitType: Scalars['String'];
};

export type MemberAccountPackageArgs = {
  serviceId: Scalars['String'];
};

export type MemberAccountPackageBasic = {
  __typename?: 'MemberAccountPackageBasic';
  amount: Scalars['Float'];
  categoryDisplayName: Scalars['String'];
  dateAdded?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  expiryWarning?: Maybe<Scalars['Boolean']>;
  isDailyRedeemed: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  packageType: Scalars['String'];
  parentServiceId?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  serviceName: Scalars['String'];
  supplementaryAmount: Scalars['Float'];
  supplementaryUnitName: Scalars['String'];
  unitType: Scalars['String'];
};

export type MemberAccountPackageBuyInput = {
  itemCode: Scalars['String'];
};

export type MemberAccountPackageEdge = {
  __typename?: 'MemberAccountPackageEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberAccountPackageBasic>;
};

export type MemberAccountPackageOfferArgs = {
  itemCode: Scalars['String'];
};

export type MemberAccountPackageOffers = {
  __typename?: 'MemberAccountPackageOffers';
  types: Array<Maybe<MemberPackageOfferType>>;
};

export type MemberAccountPackageOverview = {
  __typename?: 'MemberAccountPackageOverview';
  count: Scalars['Int'];
  expiryCreditCount: Scalars['Float'];
  expiryDescription: Scalars['String'];
  expiryDescriptionLocal: Scalars['String'];
};

export type MemberAccountPackageResponse = {
  __typename?: 'MemberAccountPackageResponse';
  edges?: Maybe<Array<Maybe<MemberAccountPackageEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberAccountPackagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  mode: MemberAccountPackagesMode;
  orderBy?: InputMaybe<OrderBy>;
};

export enum MemberAccountPackagesMode {
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

export type MemberAccountProfile = {
  __typename?: 'MemberAccountProfile';
  creditToNextLevel: Scalars['Float'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  lastName: Scalars['String'];
  memberId: Scalars['String'];
  membershipDisplayName: Scalars['String'];
  mobileNumber: Scalars['String'];
  nextLevelDisplayName: Scalars['String'];
  startDate: Scalars['DateTime'];
  subscription: MemberAccountProfileSubscription;
};

export type MemberAccountProfileSubscription = {
  __typename?: 'MemberAccountProfileSubscription';
  daysLeft: Scalars['Int'];
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: SubscriptionStatus;
};

export type MemberAccountPushTokenAddInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  expoProjectId: Scalars['String'];
  pushToken: Scalars['String'];
};

export type MemberAccountPushTokenDeleteInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  pushToken: Scalars['String'];
};

export type MemberAccountRates = {
  __typename?: 'MemberAccountRates';
  currencySymbol: Scalars['String'];
  games: Array<MemberAccountRatesGame>;
  isVip: Scalars['Boolean'];
  lesson?: Maybe<MemberAccountRatesLesson>;
  practice?: Maybe<MemberAccountRatesPractice>;
};

export type MemberAccountRatesGame = {
  __typename?: 'MemberAccountRatesGame';
  rateBay: Scalars['Float'];
  rateBayVip: Scalars['Float'];
  rateRoom: Scalars['Float'];
  rateRoomVip: Scalars['Float'];
  title: Scalars['String'];
  unit: Scalars['String'];
};

export type MemberAccountRatesLesson = {
  __typename?: 'MemberAccountRatesLesson';
  field: MemberAccountRatesLessonField;
  junior: Array<MemberAccountRatesLessonJunior>;
  lesson: Array<MemberAccountRatesLessonLesson>;
};

export type MemberAccountRatesLessonField = {
  __typename?: 'MemberAccountRatesLessonField';
  indoor9Hole: MemberAccountRatesLessonFieldIndoor9Hole;
  indoor18Hole: MemberAccountRatesLessonFieldIndoor18Hole;
  outdoor: MemberAccountRatesLessonFieldOutdoor;
};

export type MemberAccountRatesLessonFieldIndoor9Hole = {
  __typename?: 'MemberAccountRatesLessonFieldIndoor9Hole';
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type MemberAccountRatesLessonFieldIndoor18Hole = {
  __typename?: 'MemberAccountRatesLessonFieldIndoor18Hole';
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type MemberAccountRatesLessonFieldOutdoor = {
  __typename?: 'MemberAccountRatesLessonFieldOutdoor';
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type MemberAccountRatesLessonJunior = {
  __typename?: 'MemberAccountRatesLessonJunior';
  displayName: Scalars['String'];
  period: Scalars['String'];
  rate: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type MemberAccountRatesLessonLesson = {
  __typename?: 'MemberAccountRatesLessonLesson';
  displayName: Scalars['String'];
  period: Scalars['String'];
  rateGroup: Scalars['Float'];
  rateIndividual: Scalars['Float'];
  rateIndividualVip: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type MemberAccountRatesPractice = {
  __typename?: 'MemberAccountRatesPractice';
  elite: Array<MemberAccountRatesPracticeElite>;
  normal: Array<MemberAccountRatesPracticeNormal>;
  premium: Array<MemberAccountRatesPracticePremium>;
};

export type MemberAccountRatesPracticeElite = {
  __typename?: 'MemberAccountRatesPracticeElite';
  categoryListOrder?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  isEarlyBird: Scalars['Boolean'];
  limit: Scalars['String'];
  period: Scalars['String'];
  rate: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type MemberAccountRatesPracticeNormal = {
  __typename?: 'MemberAccountRatesPracticeNormal';
  facilityType: FacilityType;
  rate: Scalars['Float'];
  rateVip: Scalars['Float'];
  title: Scalars['String'];
};

export type MemberAccountRatesPracticePremium = {
  __typename?: 'MemberAccountRatesPracticePremium';
  categoryListOrder?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  isEarlyBird: Scalars['Boolean'];
  period: Scalars['String'];
  rate: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type MemberAccountServiceTransactionEdge = {
  __typename?: 'MemberAccountServiceTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ServiceTransactionBasic>;
};

export type MemberAccountServiceTransactionResponse = {
  __typename?: 'MemberAccountServiceTransactionResponse';
  edges?: Maybe<Array<Maybe<MemberAccountServiceTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberAccountServiceTransactionV2Edge = {
  __typename?: 'MemberAccountServiceTransactionV2Edge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ServiceTransactionBasic>;
};

export type MemberAccountServiceTransactionV2Response = {
  __typename?: 'MemberAccountServiceTransactionV2Response';
  edges?: Maybe<Array<Maybe<MemberAccountServiceTransactionV2Edge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberAccountServiceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberAccountSimulator = {
  __typename?: 'MemberAccountSimulator';
  nickname: Scalars['String'];
  password: Scalars['String'];
  userId: Scalars['String'];
};

export type MemberAccountSubscription = {
  __typename?: 'MemberAccountSubscription';
  amount: Scalars['Float'];
  deductionDate: Scalars['DateTime'];
  deductionDateStr: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
};

export type MemberAccountSubscriptionEdge = {
  __typename?: 'MemberAccountSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberAccountSubscription>;
};

export type MemberAccountSubscriptionResponse = {
  __typename?: 'MemberAccountSubscriptionResponse';
  edges?: Maybe<Array<Maybe<MemberAccountSubscriptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionEndDate?: Maybe<Scalars['DateTime']>;
  subscriptionEndDateStr?: Maybe<Scalars['String']>;
  subscriptionStartDate?: Maybe<Scalars['DateTime']>;
  subscriptionStartDateStr?: Maybe<Scalars['String']>;
};

export type MemberAccountSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberAccountV2 = {
  __typename?: 'MemberAccountV2';
  aceCoins: Scalars['Float'];
  blackDiamondOverview?: Maybe<MemberAccountBlackDiamondOverview>;
  bookingGame: Scalars['Int'];
  bookingLesson: Scalars['Int'];
  bookingPractise: Scalars['Int'];
  creditField: Scalars['Float'];
  creditGame: Scalars['Float'];
  creditIndoor: Scalars['Float'];
  creditPractise: Scalars['Float'];
  defaultBaseCountryCode: CountryCode;
  defaultGmtOffset: Scalars['Int'];
  email: Scalars['String'];
  gender?: Maybe<Gender>;
  handed?: Maybe<Handed>;
  hasFeedback: Scalars['Boolean'];
  hasPackageOffers: Scalars['Boolean'];
  individualId: Scalars['String'];
  memberCardProps: MemberCardProps;
  memberName: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  newNotifications: Scalars['Int'];
  packageOverview?: Maybe<MemberAccountPackageOverview>;
  simulator: MemberAccountSimulator;
  startDate?: Maybe<Scalars['DateTime']>;
  startDateStr?: Maybe<Scalars['String']>;
  tierName: Scalars['String'];
};

export type MemberAddFriendInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  loginId: Scalars['String'];
};

export type MemberApp = {
  __typename?: 'MemberApp';
  eventId?: Maybe<Scalars['String']>;
  evictionFieldNames: Array<Maybe<Scalars['String']>>;
  memberUuid?: Maybe<Scalars['String']>;
};

export type MemberAppArgs = {
  memberUuid: Scalars['String'];
};

export enum MemberAppPublishOperation {
  UpdatedAccount = 'UPDATED_ACCOUNT'
}

export type MemberAuditDataInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  browserName?: InputMaybe<Scalars['String']>;
  browserVersion?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  timezoneOffset?: InputMaybe<Scalars['Int']>;
};

export enum MemberAuditLogEventName {
  BookingCancel = 'BOOKING_CANCEL',
  BookingCreate = 'BOOKING_CREATE',
  KioskLogin = 'KIOSK_LOGIN',
  Login = 'LOGIN',
  LoginBiometric = 'LOGIN_BIOMETRIC'
}

export type MemberAuditLogSaveDataInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  browserName?: InputMaybe<Scalars['String']>;
  browserVersion?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<MemberAuditLogEventName>;
  ipAddress?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  timezoneOffset?: InputMaybe<Scalars['Int']>;
  typeRefId?: InputMaybe<Scalars['String']>;
};

export type MemberAuthResponse = {
  __typename?: 'MemberAuthResponse';
  accessToken: Scalars['String'];
  authenticatedMember: AuthenticatedMember;
  countryCode?: Maybe<CountryCode>;
  isVip?: Maybe<Scalars['Boolean']>;
  refreshToken: Scalars['String'];
};

export type MemberBooking = {
  __typename?: 'MemberBooking';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  coach?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  durationStr: Scalars['String'];
  endTime: Scalars['DateTime'];
  facilityTypeStr?: Maybe<Scalars['String']>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameTypeStr?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  noOfPlayersStr?: Maybe<Scalars['String']>;
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  textCancellationBody: Scalars['String'];
  textCancellationBodyLocal: Scalars['String'];
  textCancellationHeader: Scalars['String'];
  textCancellationHeaderLocal: Scalars['String'];
  type: BookingType;
  typeStr: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberBookingArgs = {
  bookingId: Scalars['String'];
};

export type MemberBookingBasic = {
  __typename?: 'MemberBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  coachDisplayName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  isGroupBooking?: Maybe<Scalars['Boolean']>;
  resourceName?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  type: BookingType;
  venue: Scalars['String'];
};

export type MemberBookingCancelInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  bookingId: Scalars['String'];
};

export type MemberBookingCheckout = {
  __typename?: 'MemberBookingCheckout';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  balanceBefore: Scalars['String'];
  description: Scalars['String'];
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
  textCancellationBody: Scalars['String'];
  textCancellationBodyLocal: Scalars['String'];
  textCancellationHeader: Scalars['String'];
  textCancellationHeaderLocal: Scalars['String'];
  textConfirm: Scalars['String'];
  textConfirmLocal: Scalars['String'];
  textDoubleBookingBody: Scalars['String'];
  textDoubleBookingBodyLocal: Scalars['String'];
  textDoubleBookingHeader: Scalars['String'];
  textDoubleBookingHeaderLocal: Scalars['String'];
  textRights: Scalars['String'];
  textRightsLocal: Scalars['String'];
};

export type MemberBookingCheckoutV2 = {
  __typename?: 'MemberBookingCheckoutV2';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  balanceBefore: Scalars['String'];
  description: Scalars['String'];
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
  textCancellationBody?: Maybe<Scalars['String']>;
  textCancellationBodyLocal?: Maybe<Scalars['String']>;
  textCancellationHeader?: Maybe<Scalars['String']>;
  textCancellationHeaderLocal?: Maybe<Scalars['String']>;
  textConfirm: Scalars['String'];
  textConfirmLocal: Scalars['String'];
  textDoubleBookingBody?: Maybe<Scalars['String']>;
  textDoubleBookingBodyLocal?: Maybe<Scalars['String']>;
  textDoubleBookingHeader?: Maybe<Scalars['String']>;
  textDoubleBookingHeaderLocal?: Maybe<Scalars['String']>;
  textReminderBody?: Maybe<Scalars['String']>;
  textReminderBodyLocal?: Maybe<Scalars['String']>;
  textReminderHeader?: Maybe<Scalars['String']>;
  textReminderHeaderLocal?: Maybe<Scalars['String']>;
  textRights: Scalars['String'];
  textRightsLocal: Scalars['String'];
};

export type MemberBookingClubhouse = {
  __typename?: 'MemberBookingClubhouse';
  clubhouseCode: Scalars['String'];
  displayName: Scalars['String'];
  extendedHourStartsFrom?: Maybe<Scalars['Int']>;
  hasFacilityBay: Scalars['Boolean'];
  hasFacilityPutting: Scalars['Boolean'];
  hasFacilityRoom: Scalars['Boolean'];
  hasFacilityStudio: Scalars['Boolean'];
  tagBgColorCode: Scalars['String'];
  tagText: Scalars['String'];
  tagTextColorCode: Scalars['String'];
};

export type MemberBookingCoach = {
  __typename?: 'MemberBookingCoach';
  coachId?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type MemberBookingCoachAvailabilityCalendarItems = {
  __typename?: 'MemberBookingCoachAvailabilityCalendarItems';
  calendarItems: Array<Maybe<MemberCoachAvailabilityCalendarItems>>;
};

export type MemberBookingCoachAvailabilityCalendarItemsArgs = {
  coachId: Scalars['String'];
  currentDate: Scalars['String'];
  mode: CoachAvailabilityCalendarItemsMode;
};

export type MemberBookingCoachAvailabilityDayItem = {
  __typename?: 'MemberBookingCoachAvailabilityDayItem';
  clubhouseBgCode: Scalars['String'];
  clubhouseCode: Scalars['String'];
  clubhouseName: Scalars['String'];
  date: Scalars['String'];
  dateLong: Scalars['String'];
  time: Scalars['String'];
  timeNum: Scalars['Int'];
  timeStr: Scalars['String'];
  timeStrSpan1hr: Scalars['String'];
  timeStrSpan2hr: Scalars['String'];
  timeStrSpanPutting: Scalars['String'];
};

export type MemberBookingCoachAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export type MemberBookingCoachAvailabilityDayItemV2 = {
  __typename?: 'MemberBookingCoachAvailabilityDayItemV2';
  clubhouseBgCode: Scalars['String'];
  clubhouseCode: Scalars['String'];
  clubhouseName: Scalars['String'];
  date: Scalars['String'];
  dateLong: Scalars['String'];
  time: Scalars['String'];
  timeNum: Scalars['Int'];
  timeStr: Scalars['String'];
  timeStrSpan1hr: Scalars['String'];
  timeStrSpan2hr: Scalars['String'];
  timeStrSpanPutting: Scalars['String'];
  warmUptimeStrSpan: Scalars['String'];
};

export type MemberBookingCoachAvailabilityDayItemV2Args = {
  dateId: Scalars['String'];
  mode: CoachAvailabilityDayItemMode;
};

export type MemberBookingCoachAvailabilitySlotItem = {
  __typename?: 'MemberBookingCoachAvailabilitySlotItem';
  normalHr1Available: Scalars['Boolean'];
  normalHr2Available: Scalars['Boolean'];
  puttingHr1Available: Scalars['Boolean'];
};

export type MemberBookingCoachAvailabilitySlotItemArgs = {
  clubhouseCode: Scalars['String'];
  dateId: Scalars['String'];
  time: Scalars['String'];
};

export enum MemberBookingCoachesMode {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR'
}

export type MemberBookingCoachesV2Args = {
  mode?: InputMaybe<MemberBookingCoachesMode>;
};

export type MemberBookingEdge = {
  __typename?: 'MemberBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberBookingBasic>;
};

export type MemberBookingFacilityAvailabilityCalendarItems = {
  __typename?: 'MemberBookingFacilityAvailabilityCalendarItems';
  calendarItems: Array<Maybe<FacilityAvailabilityCalendarItems>>;
};

export type MemberBookingFacilityAvailabilityCalendarItemsArgs = {
  clubhouseCode: Scalars['String'];
  currentDate: Scalars['String'];
};

export type MemberBookingFacilityAvailabilityDayItem = {
  __typename?: 'MemberBookingFacilityAvailabilityDayItem';
  ampm: Scalars['String'];
  date: Scalars['String'];
  time: Scalars['String'];
  timeNum: Scalars['Int'];
  timeNumEnd?: Maybe<Scalars['Int']>;
  timeStr: Scalars['String'];
  timeStrSpan: Scalars['String'];
};

export type MemberBookingFacilityAvailabilityDayItemArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType?: InputMaybe<GameType>;
  noOfPlayers: Scalars['Int'];
};

export type MemberBookingFacilityAvailabilityDayItems = {
  __typename?: 'MemberBookingFacilityAvailabilityDayItems';
  extended: Array<Maybe<MemberBookingFacilityAvailabilityDayItem>>;
  memberBookingHelperExtendedHour?: Maybe<MemberBookingHelperExtendedHour>;
  normal: Array<Maybe<MemberBookingFacilityAvailabilityDayItem>>;
};

export type MemberBookingGameCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType: GameType;
  noOfPlayers: Scalars['Int'];
};

export type MemberBookingGameCreate = {
  __typename?: 'MemberBookingGameCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingGameCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType: GameType;
  noOfPlayers: Scalars['Int'];
  time: Scalars['String'];
};

export type MemberBookingGroupMember = {
  __typename?: 'MemberBookingGroupMember';
  individualId: Scalars['String'];
  memberName: Scalars['String'];
  memberUuid: Scalars['String'];
  packageId: Scalars['String'];
  selfPackageId: Scalars['String'];
  selfPackageName: Scalars['String'];
};

export type MemberBookingGroupMembers = {
  __typename?: 'MemberBookingGroupMembers';
  members: Array<Maybe<MemberBookingGroupMember>>;
};

export type MemberBookingGroupMembersArgs = {
  packageId?: InputMaybe<Scalars['String']>;
};

export type MemberBookingHelper = {
  __typename?: 'MemberBookingHelper';
  clubhouses: Array<Maybe<MemberBookingClubhouse>>;
  gameBookingConditions: GameBookingConditions;
  practiseBookingConditions: PractiseBookingConditions;
};

export type MemberBookingHelperExtendedHour = {
  __typename?: 'MemberBookingHelperExtendedHour';
  textExtendedHourBody?: Maybe<Scalars['String']>;
  textExtendedHourBodyLocal?: Maybe<Scalars['String']>;
  textExtendedHourHeader?: Maybe<Scalars['String']>;
  textExtendedHourHeaderLocal?: Maybe<Scalars['String']>;
};

export type MemberBookingHelperV2 = {
  __typename?: 'MemberBookingHelperV2';
  clubhouses: Array<Maybe<MemberBookingClubhouse>>;
  gameBookingConditions: GameBookingConditions;
  hasGroupMembers: Scalars['Boolean'];
  memberBookingHelperExtendedHour?: Maybe<MemberBookingHelperExtendedHour>;
  practiseBookingConditions: PractiseBookingConditions;
  preConfirmationCopy?: Maybe<PreConfirmationCopy>;
  premiumPackagePractiseConditionCopy?: Maybe<PremiumPackagePractiseConditionCopy>;
  premiumPackagePractiseExpiryDate?: Maybe<Scalars['DateTime']>;
  teeTimeMax: Scalars['Int'];
  teeTimeMin: Scalars['Int'];
};

export type MemberBookingHelperV2Args = {
  bookingType: BookingType;
};

export type MemberBookingLessonIndoorCheckoutArgs = {
  coachId: Scalars['String'];
  isLessonExtended: Scalars['Boolean'];
  lessonType: IndoorLessonType;
};

export type MemberBookingLessonIndoorCreate = {
  __typename?: 'MemberBookingLessonIndoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingLessonIndoorCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  isLessonExtended: Scalars['Boolean'];
  lessonType: IndoorLessonType;
  time: Scalars['String'];
};

export type MemberBookingLessonIndoorCreateV2Input = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  groupMemberId?: InputMaybe<Scalars['String']>;
  isLessonExtended: Scalars['Boolean'];
  lessonType: IndoorLessonType;
  time: Scalars['String'];
};

export type MemberBookingLessonOutdoorCheckoutArgs = {
  coachId: Scalars['String'];
};

export type MemberBookingLessonOutdoorCreate = {
  __typename?: 'MemberBookingLessonOutdoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingLessonOutdoorCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  details: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberBookingLessonOutdoorCreateV2Input = {
  audit?: InputMaybe<MemberAuditDataInput>;
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  details: Scalars['String'];
  teeTime: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberBookingPractiseCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  noOfPlayers: Scalars['Int'];
};

export type MemberBookingPractiseCreate = {
  __typename?: 'MemberBookingPractiseCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingPractiseCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  noOfPlayers: Scalars['Int'];
  time: Scalars['String'];
};

export type MemberBookingPractiseCreateV2Input = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  noOfPlayers: Scalars['Int'];
  time: Scalars['String'];
};

export type MemberBookingResponse = {
  __typename?: 'MemberBookingResponse';
  edges?: Maybe<Array<Maybe<MemberBookingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberBookingUpdateToGroupInput = {
  bookingId: Scalars['String'];
  partnerMemberUuid: Scalars['String'];
};

export type MemberBookingV2 = {
  __typename?: 'MemberBookingV2';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  coach?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  durationStr: Scalars['String'];
  endTime: Scalars['DateTime'];
  facilityTypeStr?: Maybe<Scalars['String']>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameTypeStr?: Maybe<Scalars['String']>;
  groupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  hasGroupMembers?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isGroupBooking: Scalars['Boolean'];
  noOfPlayersStr?: Maybe<Scalars['String']>;
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  textCancellationBody: Scalars['String'];
  textCancellationBodyLocal: Scalars['String'];
  textCancellationHeader: Scalars['String'];
  textCancellationHeaderLocal: Scalars['String'];
  type: BookingType;
  typeStr: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberBookingsActiveArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<BookingStatus>;
};

export type MemberBookingsCompletedArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  type?: InputMaybe<Scalars['String']>;
};

export type MemberCardProps = {
  __typename?: 'MemberCardProps';
  bgColor: Scalars['String'];
  bgImageName: Scalars['String'];
  textColor: Scalars['String'];
};

export type MemberCoachAvailabilityCalendarItems = {
  __typename?: 'MemberCoachAvailabilityCalendarItems';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
  isFullyBooked?: Maybe<Scalars['Boolean']>;
};

export type MemberDeleteRefreshTokenInput = {
  refreshToken: Scalars['String'];
};

export type MemberFindMember = {
  __typename?: 'MemberFindMember';
  memberFound: Scalars['Boolean'];
  memberName?: Maybe<Scalars['String']>;
};

export type MemberFindMemberInput = {
  targetMemberCardId: Scalars['String'];
};

export type MemberForgotPassword = {
  __typename?: 'MemberForgotPassword';
  email: Scalars['String'];
  resetToken: Scalars['String'];
};

export type MemberForgotPasswordInput = {
  email: Scalars['String'];
};

export type MemberForgotPasswordSubmitInput = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type MemberFriend = {
  __typename?: 'MemberFriend';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type MemberFriendLastTransfer = {
  __typename?: 'MemberFriendLastTransfer';
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  friendName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
};

export type MemberFriendV2 = {
  __typename?: 'MemberFriendV2';
  email?: Maybe<Scalars['String']>;
  friendName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
};

export type MemberFriendsV2 = {
  __typename?: 'MemberFriendsV2';
  friends: Array<Maybe<MemberFriendV2>>;
  lastTransfer?: Maybe<MemberFriendLastTransfer>;
};

export type MemberGameQrCodeLoginInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clientToken?: InputMaybe<Scalars['String']>;
};

export type MemberGameRound = {
  __typename?: 'MemberGameRound';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<MemberGameRoundScoreCard>>;
};

export type MemberGameRoundCourseInfo = {
  __typename?: 'MemberGameRoundCourseInfo';
  courseInTotalPar: Scalars['Int'];
  courseMapCoordinates: Array<Maybe<CourseMapCoordinate>>;
  courseOutTotalPar: Scalars['Int'];
  coursePar: Array<Scalars['Int']>;
  courseTotalPar: Scalars['Int'];
  intro: Scalars['String'];
  logo: Scalars['String'];
  newPerioHiddenHole: Scalars['String'];
};

export type MemberGameRoundGameInfo = {
  __typename?: 'MemberGameRoundGameInfo';
  clientGuid: Scalars['String'];
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  concede: Scalars['Int'];
  courseId?: Maybe<Scalars['String']>;
  courseInfo: MemberGameRoundCourseInfo;
  courseName: Scalars['String'];
  distanceUnit: Scalars['String'];
  gameEndTime: Scalars['Int'];
  gameHoleType: Scalars['String'];
  gameRoundId: Scalars['Int'];
  gameStartTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  greenLocation: Scalars['String'];
  greenSpeed: Scalars['String'];
  holeCupLocation: Scalars['String'];
  isBestVideo: Scalars['Boolean'];
  isCaddyVoice: Scalars['Boolean'];
  isUseObHazardTee: Scalars['Boolean'];
  mulliganCount: Scalars['Int'];
  playHoleCount: Scalars['Int'];
  puttingLine: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
  tournamentIdx: Scalars['Int'];
  useSwingPlate: Scalars['String'];
  windSpeed: Scalars['String'];
};

export type MemberGameRoundPlayerInfo = {
  __typename?: 'MemberGameRoundPlayerInfo';
  completeHoleCount: Scalars['Int'];
  difficulty: Scalars['Int'];
  handicap: Scalars['Int'];
  holes: Array<Maybe<MemberGameRoundPlayerInfoHole>>;
  inTotalScore: Scalars['Int'];
  nickname: Scalars['String'];
  outTotalScore: Scalars['Int'];
  playerType: Scalars['Int'];
  rank: Scalars['Int'];
  startHole: Scalars['Int'];
  team: Scalars['Int'];
  totalScore: Scalars['String'];
  userGuid: Scalars['String'];
};

export type MemberGameRoundPlayerInfoHole = {
  __typename?: 'MemberGameRoundPlayerInfoHole';
  holeNumber: Scalars['Int'];
  holeOutType: Scalars['Int'];
  isBestVideo: Scalars['Boolean'];
  isConcede: Scalars['Boolean'];
  isLongest: Scalars['Boolean'];
  isMulligan: Scalars['Boolean'];
  isNearpin: Scalars['Boolean'];
  score: Scalars['Int'];
  shotCoordinates: Array<Maybe<ShotCoordinate>>;
};

export type MemberGameRoundScoreCard = {
  __typename?: 'MemberGameRoundScoreCard';
  gameRoundInfo: MemberGameRoundGameInfo;
  players: Array<Maybe<MemberGameRoundPlayerInfo>>;
};

export type MemberJwtAccessToken = {
  __typename?: 'MemberJwtAccessToken';
  id?: Maybe<Scalars['String']>;
  member?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type MemberJwtRefreshToken = {
  __typename?: 'MemberJwtRefreshToken';
  family?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  member?: Maybe<Scalars['String']>;
  mode?: Maybe<MemberJwtRefreshTokenMode>;
  username?: Maybe<Scalars['String']>;
};

export enum MemberJwtRefreshTokenMode {
  Lt = 'LT',
  St = 'ST'
}

export type MemberLoginInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  email: Scalars['String'];
  mode: MemberRefreshTokenMode;
  password: Scalars['String'];
};

export type MemberLoginQr = {
  __typename?: 'MemberLoginQR';
  requestId: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type MemberLoginQrArgs = {
  requestId: Scalars['String'];
};

export type MemberLogoutInput = {
  refreshToken: Scalars['String'];
};

export type MemberMember = {
  __typename?: 'MemberMember';
  memberName: Scalars['String'];
};

export type MemberMemberArgs = {
  tergetMemberIndividualId?: InputMaybe<Scalars['String']>;
};

export type MemberNotification = {
  __typename?: 'MemberNotification';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isRead?: Maybe<Scalars['Boolean']>;
  isReadDate?: Maybe<Scalars['DateTime']>;
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MemberNotificationArgs = {
  notificationId: Scalars['String'];
};

export type MemberNotificationBasic = {
  __typename?: 'MemberNotificationBasic';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isRead?: Maybe<Scalars['Boolean']>;
  isReadDate?: Maybe<Scalars['DateTime']>;
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MemberNotificationDeleteInput = {
  notificationId: Scalars['String'];
};

export type MemberNotificationEdge = {
  __typename?: 'MemberNotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberNotificationBasic>;
};

export type MemberNotificationResponse = {
  __typename?: 'MemberNotificationResponse';
  edges?: Maybe<Array<Maybe<MemberNotificationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberOrderArgs = {
  orderNo: Scalars['String'];
};

export type MemberOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type MemberPackageOffer = {
  __typename?: 'MemberPackageOffer';
  categoryDisplayName: Scalars['String'];
  conditions: Array<Maybe<Scalars['String']>>;
  credit?: Maybe<Scalars['String']>;
  details: Array<Maybe<Scalars['String']>>;
  extraUnitPrice: Scalars['String'];
  imageUrl: Scalars['String'];
  itemCode: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Float'];
  priceString: Scalars['String'];
  purchasableByMember: Scalars['Boolean'];
  type: Scalars['String'];
  unitPrice: Scalars['String'];
  validity: Scalars['String'];
};

export type MemberPackageOfferBasic = {
  __typename?: 'MemberPackageOfferBasic';
  credit: Scalars['String'];
  itemCode: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['String'];
  purchasableByMember: Scalars['Boolean'];
  type: Scalars['String'];
  validity: Scalars['String'];
};

export type MemberPackageOfferType = {
  __typename?: 'MemberPackageOfferType';
  categoryDisplayName: Scalars['String'];
  packages: Array<Maybe<MemberPackageOfferBasic>>;
};

export type MemberRefreshAccessTokenInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  mode: MemberRefreshTokenMode;
  refreshToken: Scalars['String'];
};

export enum MemberRefreshTokenMode {
  AppWithoutBiometrics = 'APP_WITHOUT_BIOMETRICS',
  AppWithBiometrics = 'APP_WITH_BIOMETRICS',
  Web = 'WEB'
}

export type MemberRemoveFriendInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  friendUuid: Scalars['String'];
};

export type MemberScoreCard = {
  __typename?: 'MemberScoreCard';
  completeHoleCount?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['Int']>;
  gameRoundId?: Maybe<Scalars['Int']>;
  gameType?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  isTournament?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  practiceType?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  shopName?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Int']>;
};

export type MemberScoreCardArgs = {
  roundIdx: Scalars['Int'];
};

export type MemberScoreCards = {
  __typename?: 'MemberScoreCards';
  cdn: Scalars['String'];
  list: Array<Maybe<MemberScoreCard>>;
  totalCount: Scalars['Int'];
};

export type MemberScoreCardsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type MemberSimulatorPrivilege = {
  __typename?: 'MemberSimulatorPrivilege';
  hasPrivilege: Scalars['Boolean'];
  lastSimulatorUsageDate?: Maybe<Scalars['DateTime']>;
};

export enum MemberStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Lapsed = 'LAPSED',
  Pending = 'PENDING'
}

export type MemberSubscriptionEdge = {
  __typename?: 'MemberSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MembershipSubscription>;
};

export type MemberSubscriptionResponse = {
  __typename?: 'MemberSubscriptionResponse';
  balance?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  daysLeft?: Maybe<Scalars['Int']>;
  edges?: Maybe<Array<Maybe<MemberSubscriptionEdge>>>;
  endDate?: Maybe<Scalars['DateTime']>;
  mainMemberName?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  membershipUuid?: Maybe<Scalars['String']>;
  pageInfo?: Maybe<PageInfo>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SubscriptionStatus>;
};

export type MemberSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberTopUpCreditInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  creditAmount: Scalars['Float'];
};

export type MemberTransferCredit = {
  __typename?: 'MemberTransferCredit';
  canSaveMember: Scalars['Boolean'];
  memberName: Scalars['String'];
};

export type MemberTransferCreditInput = {
  creditAmount: Scalars['Float'];
  targetMemberCardId: Scalars['String'];
};

export type MemberUpdateEmailInput = {
  email: Scalars['String'];
};

export type MemberUpdateGenderInput = {
  gender: Gender;
};

export type MemberUpdateHandedInput = {
  handed: Handed;
};

export type MemberUpdateMobileNumberInput = {
  countryCode: Scalars['String'];
  number: Scalars['String'];
};

export type MemberUpdateNicknameInput = {
  nickname: Scalars['String'];
};

export type MemberUpdatePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type MemberWebsiteLoginQrCodeClaim = {
  __typename?: 'MemberWebsiteLoginQRCodeClaim';
  device: Scalars['String'];
  expiry: Scalars['DateTime'];
  location: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type MemberWebsiteLoginQrCodeClaimInput = {
  token: Scalars['String'];
};

export type MemberWebsiteLoginQrCodeGrantInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  verificationCode: Scalars['String'];
};

export type MemberWebsiteLoginQrCodeRequestInput = {
  device: Scalars['String'];
  ip: Scalars['String'];
  location: Scalars['String'];
};

export enum MembershipActivityType {
  SignUp = 'SIGN_UP',
  TierDowngrade = 'TIER_DOWNGRADE',
  TierUpgrade = 'TIER_UPGRADE'
}

export enum MembershipStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Lapsed = 'LAPSED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export type MembershipSubscription = {
  __typename?: 'MembershipSubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type MembershipTypeBasic = {
  __typename?: 'MembershipTypeBasic';
  baseCountryCode?: Maybe<CountryCode>;
  internalName?: Maybe<Scalars['String']>;
  isCorporate?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  tagBgColorCode?: Maybe<Scalars['String']>;
  tagText?: Maybe<Scalars['String']>;
  tagTextColorCode?: Maybe<Scalars['String']>;
};

export enum MembershipTypeTier {
  Lifestyle = 'LIFESTYLE',
  Premium = 'PREMIUM',
  Vip = 'VIP'
}

export type Mutation = {
  __typename?: 'Mutation';
  adminActivateMembership: SystemOperationStatus;
  adminAdminUpdatePassword: SystemOperationStatus;
  adminBookingBlackoutClubhouseUpdate: AdminBookingBlackoutClubhouse;
  adminBookingBlackoutCoachUpdate: AdminBookingBlackoutCoach;
  adminBookingBlackoutCreate: AdminBookingBlackoutCreate;
  adminBookingBlackoutDelete: SystemOperationStatus;
  adminBookingBookingFacilityUpdate: SystemOperationStatus;
  adminBookingCancel: SystemOperationStatus;
  adminBookingGameCreate: AdminBookingGameCreate;
  adminBookingLessonIndoorCreate: AdminBookingLessonIndoorCreate;
  adminBookingLessonOutdoorCreate: AdminBookingLessonOutdoorCreate;
  adminBookingOptionalPlayerNameUpdate: SystemOperationStatus;
  adminBookingPractiseCreate: AdminBookingPractiseCreate;
  adminBookingSendCancellationNotification: SystemOperationStatus;
  adminBookingUpdate: SystemOperationStatus;
  adminBookingUpdateToGroup: SystemOperationStatus;
  adminClientLoginGuest: SystemOperationStatus;
  adminClientSetup: SystemOperationStatus;
  adminCreateAdmin: NewAdmin;
  adminCreateMembership: AdminNewMembership;
  adminDeleteAdmin: SystemOperationStatus;
  adminDeleteCoach: SystemOperationStatus;
  adminDeleteMembership: SystemOperationStatus;
  adminExtendClientTime: SystemOperationStatus;
  adminForgotPassword: AdminForgotPasswordResponse;
  adminForgotPasswordSubmit: SystemOperationStatus;
  adminLockClient: SystemOperationStatus;
  adminLogin: AdminAuthResponse;
  adminLogout: SystemOperationStatus;
  adminManagementSystemAppMainSliderCreate: AdminManagementSystemAppMainSlider;
  adminManagementSystemAppMainSliderDelete: SystemOperationStatus;
  adminManagementSystemAppMainSliderUpdate: AdminManagementSystemAppMainSlider;
  adminManagementSystemAppMainSliderUpload: AdminManagementSystemAppMainSliderUploadResponse;
  adminManagementSystemReporting: SystemOperationStatus;
  adminManagementSystemSupportTicketCommentAdd: SystemOperationStatus;
  adminManagementSystemSupportTicketCommentDelete: SystemOperationStatus;
  adminManagementSystemSupportTicketCommentUpdate: SystemOperationStatus;
  adminManagementSystemSupportTicketCreate: AdminManagementSystemSupportTicketCreate;
  adminManagementSystemSupportTicketDelete: SystemOperationStatus;
  adminManagementSystemSupportTicketUpdate: SystemOperationStatus;
  adminManagementSystemUserTelemetry: SystemOperationStatus;
  adminMemberBDFAdd: SystemOperationStatus;
  adminMemberCreateKGolfAccount: SystemOperationStatus;
  adminMemberCreditUpdate: SystemOperationStatus;
  adminMemberInvoiceDelete: SystemOperationStatus;
  adminMemberProductPackageDelete: SystemOperationStatus;
  adminMemberProductPackageExtensionUpdate: AdminMemberProductPackageExtension;
  adminMemberProductPackageGroup: SystemOperationStatus;
  adminMemberProductPackageManage: SystemOperationStatus;
  adminMemberProductPackageReActivate: SystemOperationStatus;
  adminMemberProductPackageShare: SystemOperationStatus;
  adminMemberProductPackageTransfer: SystemOperationStatus;
  adminMemberProfileUpdate: AdminMemberProfileUpdate;
  adminMemberReassignMembershipId: SystemOperationStatus;
  adminMemberResendOnboardingEmail: SystemOperationStatus;
  adminMemberSendResetPasswordEmail: SystemOperationStatus;
  adminMemberServiceTransactionDelete: SystemOperationStatus;
  adminMemberServiceTransactionUpdate: ServiceTransactionBasic;
  adminMemberServiceUpdate: SystemOperationStatus;
  adminMemberSimulatorUseUpdate: SystemOperationStatus;
  adminMemberTierUpdate: SystemOperationStatus;
  adminMemberTransferCredit: SystemOperationStatus;
  adminMemberTypeUpdate: SystemOperationStatus;
  adminMemberUpdatePassword: SystemOperationStatus;
  adminMembershipSubscriptionActionDates: SystemOperationStatus;
  adminMembershipSubscriptionPause: SystemOperationStatus;
  adminMembershipSubscriptionStart: SystemOperationStatus;
  adminNotificationCreate: SystemOperationStatus;
  adminNotificationDelete: SystemOperationStatus;
  adminNotificationMemberDelete: SystemOperationStatus;
  adminProductPackageAdd: SystemOperationStatus;
  adminRefreshAccessToken: AdminAuthResponse;
  adminReportAcTransactionDelete: SystemOperationStatus;
  adminResendOnboardingEmail: SystemOperationStatus;
  adminShopGetNotification: AdminShopNotification;
  adminShopSendNotification: SystemOperationStatus;
  adminShopTokens: ShopsTokens;
  adminTerminateMembership: SystemOperationStatus;
  adminUnlockClient: SystemOperationStatus;
  adminUpdateAdmin: UpdatedAdmin;
  adminUpdateClientContentLimit: SystemOperationStatus;
  adminUpdateCoach: UpdatedCoach;
  adminUpdateCoachBookable: AdminUpdateCoachBookable;
  adminUpdateFacility: SystemOperationStatus;
  adminUpdateMembershipType: AdminMembershipType;
  adminUpdateNickname: SystemOperationStatus;
  adminUpdateOrganization: Organization;
  adminUpdatePricing: Pricing;
  adminUpdateReservedId: AdminUpdateReservedId;
  adminUpdateShopDetails: AdminShopDetails;
  adminUpdateShopOptionsDrivingRange: AdminShopOptionsDrivingRange;
  adminUpdateShopOptionsRealTime: AdminShopOptionsRealTime;
  adminUpdateShopOptionsRound: AdminShopOptionsRound;
  adminUpdateSidasInsoles: SystemOperationStatus;
  appTelemetry: AppTelemetry;
  appTelemetryV2: SystemOperationStatus;
  coachAvailabilityDayItemTemplateCreate: CoachAvailabilityDayItemTemplateCreate;
  coachAvailabilityDayItemTemplateDelete: SystemOperationStatus;
  coachAvailabilityDayItemTemplateUpdate: CoachAvailabilityDayItemTemplate;
  coachAvailabilityDayUpsert?: Maybe<CoachAvailabilityDayItem>;
  coachBookingCommentUpdate: CoachBookingCommentUpdate;
  coachMemberLessonNoteCreate: Scalars['String'];
  coachMemberLessonNoteDelete: CoachMemberLessonNoteDelete;
  coachMemberLessonNoteUpdate: Scalars['String'];
  devManagementSystemAdminNotificationSend: SystemOperationStatus;
  devManagementSystemAdminTelemetryRequest: SystemOperationStatus;
  devManagementSystemAdminViewportReloadRequest: SystemOperationStatus;
  devManagementSystemServerStatus: DevManagementSystemServerStatus;
  generateLessonAttachmentUploadUrl: GenerateLessonAttachmentUploadUrlResponse;
  memberAccountArchive: SystemOperationStatus;
  memberAccountNotificationDelete: MemberAccountNotificationDelete;
  memberAccountNotificationUpdate: SystemOperationStatus;
  memberAccountNotificationUpdateV2: MemberAccountNotificationUpdateV2;
  memberAccountPackageBuy: SystemOperationStatus;
  memberAccountPushTokenAdd: SystemOperationStatus;
  memberAccountPushTokenDelete: SystemOperationStatus;
  memberAddFriend: SystemOperationStatus;
  memberBookingCancel: SystemOperationStatus;
  memberBookingGameCreate: MemberBookingGameCreate;
  memberBookingLessonIndoorCreate: MemberBookingLessonIndoorCreate;
  memberBookingLessonIndoorCreateV2: MemberBookingLessonIndoorCreate;
  memberBookingLessonOutdoorCreate: MemberBookingLessonOutdoorCreate;
  memberBookingLessonOutdoorCreateV2: MemberBookingLessonOutdoorCreate;
  memberBookingPractiseCreate: MemberBookingPractiseCreate;
  memberBookingPractiseCreateV2: MemberBookingPractiseCreate;
  memberBookingUpdateToGroup: MemberBookingV2;
  memberDeleteRefreshToken: SystemOperationStatus;
  memberFindMember: MemberFindMember;
  memberForgotPassword: MemberForgotPassword;
  memberForgotPasswordSubmit: SystemOperationStatus;
  memberGameQRCodeLogin: SystemOperationStatus;
  memberLogin: MemberAuthResponse;
  memberLogout: SystemOperationStatus;
  memberNotificationDelete: SystemOperationStatus;
  memberRefreshAccessToken: MemberAuthResponse;
  memberRemoveFriend: SystemOperationStatus;
  memberTopUpCredit: HitPayPaymentRequest;
  memberTransferCredit: SystemOperationStatus;
  memberTransferCreditV2: MemberTransferCredit;
  memberUpdateEmail: SystemOperationStatus;
  memberUpdateGender: SystemOperationStatus;
  memberUpdateHanded: SystemOperationStatus;
  memberUpdateMobileNumber: SystemOperationStatus;
  memberUpdateNickname: SystemOperationStatus;
  memberUpdatePassword: SystemOperationStatus;
  memberWebsiteLoginQRCodeClaim: MemberWebsiteLoginQrCodeClaim;
  memberWebsiteLoginQRCodeGrant: SystemOperationStatus;
  memberWebsiteLoginQRCodeRequest: Scalars['String'];
  publicContactForm: SystemOperationStatus;
  publicNewsletter: SystemOperationStatus;
  selfUpdate: SelfUpdated;
  selfUpdatePassword: SystemOperationStatus;
};


export type MutationAdminActivateMembershipArgs = {
  input?: InputMaybe<AdminActivateMembershipInput>;
};


export type MutationAdminAdminUpdatePasswordArgs = {
  input: AdminAdminUpdatePasswordInput;
};


export type MutationAdminBookingBlackoutClubhouseUpdateArgs = {
  input: AdminBookingBlackoutClubhouseUpdateInput;
};


export type MutationAdminBookingBlackoutCoachUpdateArgs = {
  input: AdminBookingBlackoutCoachUpdateInput;
};


export type MutationAdminBookingBlackoutCreateArgs = {
  input: AdminBookingBlackoutCreateInput;
};


export type MutationAdminBookingBlackoutDeleteArgs = {
  input: AdminBookingBlackoutDeleteInput;
};


export type MutationAdminBookingBookingFacilityUpdateArgs = {
  input: AdminBookingBookingFacilityUpdateInput;
};


export type MutationAdminBookingCancelArgs = {
  input: AdminBookingCancelInput;
};


export type MutationAdminBookingGameCreateArgs = {
  input: AdminBookingGameCreateInput;
};


export type MutationAdminBookingLessonIndoorCreateArgs = {
  input: AdminBookingLessonIndoorCreateInput;
};


export type MutationAdminBookingLessonOutdoorCreateArgs = {
  input: AdminBookingLessonOutdoorCreateInput;
};


export type MutationAdminBookingOptionalPlayerNameUpdateArgs = {
  input: AdminBookingOptionalPlayerNameUpdateInput;
};


export type MutationAdminBookingPractiseCreateArgs = {
  input: AdminBookingPractiseCreateInput;
};


export type MutationAdminBookingSendCancellationNotificationArgs = {
  input: AdminBookingSendCancellationNotificationInput;
};


export type MutationAdminBookingUpdateArgs = {
  input: AdminBookingUpdateInput;
};


export type MutationAdminBookingUpdateToGroupArgs = {
  input: AdminBookingUpdateToGroupInput;
};


export type MutationAdminClientLoginGuestArgs = {
  input: AdminClientLoginGuestInput;
};


export type MutationAdminClientSetupArgs = {
  input: AdminClientSetupInput;
};


export type MutationAdminCreateAdminArgs = {
  input: AdminCreateAdminInput;
};


export type MutationAdminCreateMembershipArgs = {
  input: AdminCreateMembershipInput;
};


export type MutationAdminDeleteAdminArgs = {
  input?: InputMaybe<AdminDeleteAdminInput>;
};


export type MutationAdminDeleteCoachArgs = {
  input?: InputMaybe<AdminDeleteCoachInput>;
};


export type MutationAdminDeleteMembershipArgs = {
  input: AdminDeleteMembershipInput;
};


export type MutationAdminExtendClientTimeArgs = {
  input: AdminExtendClientTimeInput;
};


export type MutationAdminForgotPasswordArgs = {
  input: AdminForgotPasswordInput;
};


export type MutationAdminForgotPasswordSubmitArgs = {
  input: AdminForgotPasswordSubmitInput;
};


export type MutationAdminLockClientArgs = {
  input: AdminLockClientInput;
};


export type MutationAdminLoginArgs = {
  input: AdminLoginInput;
};


export type MutationAdminManagementSystemAppMainSliderCreateArgs = {
  input: AdminManagementSystemAppMainSliderCreateInput;
};


export type MutationAdminManagementSystemAppMainSliderDeleteArgs = {
  input: AdminManagementSystemAppMainSliderDeleteInput;
};


export type MutationAdminManagementSystemAppMainSliderUpdateArgs = {
  input: AdminManagementSystemAppMainSliderUpdateInput;
};


export type MutationAdminManagementSystemAppMainSliderUploadArgs = {
  input: AdminManagementSystemAppMainSliderUploadInput;
};


export type MutationAdminManagementSystemReportingArgs = {
  input: AdminManagementSystemReportingInput;
};


export type MutationAdminManagementSystemSupportTicketCommentAddArgs = {
  input: AdminManagementSystemSupportTicketCommentAddInput;
};


export type MutationAdminManagementSystemSupportTicketCommentDeleteArgs = {
  input: AdminManagementSystemSupportTicketCommentDeleteInput;
};


export type MutationAdminManagementSystemSupportTicketCommentUpdateArgs = {
  input: AdminManagementSystemSupportTicketCommentUpdateInput;
};


export type MutationAdminManagementSystemSupportTicketCreateArgs = {
  input: AdminManagementSystemSupportTicketCreateInput;
};


export type MutationAdminManagementSystemSupportTicketDeleteArgs = {
  input: AdminManagementSystemSupportTicketDeleteInput;
};


export type MutationAdminManagementSystemSupportTicketUpdateArgs = {
  input: AdminManagementSystemSupportTicketUpdateInput;
};


export type MutationAdminManagementSystemUserTelemetryArgs = {
  input: AdminManagementSystemUserTelemetryInput;
};


export type MutationAdminMemberBdfAddArgs = {
  input: AdminMemberBdfAddInput;
};


export type MutationAdminMemberCreateKGolfAccountArgs = {
  input: AdminMemberCreateKGolfAccountInput;
};


export type MutationAdminMemberCreditUpdateArgs = {
  input?: InputMaybe<AdminMemberCreditUpdateInput>;
};


export type MutationAdminMemberInvoiceDeleteArgs = {
  input: AdminMemberInvoiceDeleteInput;
};


export type MutationAdminMemberProductPackageDeleteArgs = {
  input: AdminMemberProductPackageDeleteInput;
};


export type MutationAdminMemberProductPackageExtensionUpdateArgs = {
  input: AdminMemberProductPackageExtensionUpdateInput;
};


export type MutationAdminMemberProductPackageGroupArgs = {
  input: AdminMemberProductPackageGroupInput;
};


export type MutationAdminMemberProductPackageManageArgs = {
  input: AdminMemberProductPackageManageInput;
};


export type MutationAdminMemberProductPackageReActivateArgs = {
  input: AdminMemberProductPackageReActivateInput;
};


export type MutationAdminMemberProductPackageShareArgs = {
  input: AdminMemberProductPackageShareInput;
};


export type MutationAdminMemberProductPackageTransferArgs = {
  input: AdminMemberProductPackageTransferInput;
};


export type MutationAdminMemberProfileUpdateArgs = {
  input: AdminMemberProfileUpdateInput;
};


export type MutationAdminMemberReassignMembershipIdArgs = {
  input: AdminMemberReassignMembershipIdInput;
};


export type MutationAdminMemberResendOnboardingEmailArgs = {
  input: AdminMemberResendOnboardingEmailInput;
};


export type MutationAdminMemberSendResetPasswordEmailArgs = {
  input: AdminMemberSendResetPasswordEmailInput;
};


export type MutationAdminMemberServiceTransactionDeleteArgs = {
  input: AdminMemberServiceTransactionDeleteInput;
};


export type MutationAdminMemberServiceTransactionUpdateArgs = {
  input: AdminMemberServiceTransactionUpdateInput;
};


export type MutationAdminMemberServiceUpdateArgs = {
  input: AdminMemberServiceUpdateInput;
};


export type MutationAdminMemberSimulatorUseUpdateArgs = {
  input: AdminMemberSimulatorUseUpdateInput;
};


export type MutationAdminMemberTierUpdateArgs = {
  input: AdminMemberTierUpdateInput;
};


export type MutationAdminMemberTransferCreditArgs = {
  input: AdminMemberTransferCreditInput;
};


export type MutationAdminMemberTypeUpdateArgs = {
  input: AdminMemberTypeUpdateInput;
};


export type MutationAdminMemberUpdatePasswordArgs = {
  input: AdminMemberUpdatePasswordInput;
};


export type MutationAdminMembershipSubscriptionActionDatesArgs = {
  input: AdminMembershipSubscriptionActionDatesInput;
};


export type MutationAdminMembershipSubscriptionPauseArgs = {
  input: AdminMembershipSubscriptionPauseInput;
};


export type MutationAdminMembershipSubscriptionStartArgs = {
  input: AdminMembershipSubscriptionStartInput;
};


export type MutationAdminNotificationCreateArgs = {
  input: AdminNotificationCreateInput;
};


export type MutationAdminNotificationDeleteArgs = {
  input: AdminNotificationDeleteInput;
};


export type MutationAdminNotificationMemberDeleteArgs = {
  input: AdminNotificationMemberDeleteInput;
};


export type MutationAdminProductPackageAddArgs = {
  input: AdminProductPackageAddInput;
};


export type MutationAdminReportAcTransactionDeleteArgs = {
  input: AdminReportAcTransactionDeleteInput;
};


export type MutationAdminResendOnboardingEmailArgs = {
  input: AdminResendOnboardingEmailInput;
};


export type MutationAdminShopGetNotificationArgs = {
  input: AdminShopGetNotificationInput;
};


export type MutationAdminShopSendNotificationArgs = {
  input: AdminShopSendNotificationInput;
};


export type MutationAdminShopTokensArgs = {
  input?: InputMaybe<AdminShopTokensInput>;
};


export type MutationAdminTerminateMembershipArgs = {
  input: AdminTerminateMembershipInput;
};


export type MutationAdminUnlockClientArgs = {
  input: AdminUnlockClientInput;
};


export type MutationAdminUpdateAdminArgs = {
  args: AdminUpdateAdminArgs;
  input: AdminUpdateAdminInput;
};


export type MutationAdminUpdateClientContentLimitArgs = {
  input: AdminUpdateClientContentLimitInput;
};


export type MutationAdminUpdateCoachArgs = {
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachInput;
};


export type MutationAdminUpdateCoachBookableArgs = {
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachBookableInput;
};


export type MutationAdminUpdateFacilityArgs = {
  input: AdminUpdateFacilityInput;
};


export type MutationAdminUpdateMembershipTypeArgs = {
  input: AdminUpdateMembershipTypeInput;
};


export type MutationAdminUpdateNicknameArgs = {
  input: AdminUpdateNicknameInput;
};


export type MutationAdminUpdateOrganizationArgs = {
  input: AdminUpdateOrganizationInput;
};


export type MutationAdminUpdatePricingArgs = {
  input: AdminUpdatePricingInput;
};


export type MutationAdminUpdateReservedIdArgs = {
  input?: InputMaybe<AdminUpdateReservedIdInput>;
};


export type MutationAdminUpdateShopDetailsArgs = {
  input: AdminUpdateShopDetailsInput;
};


export type MutationAdminUpdateShopOptionsDrivingRangeArgs = {
  input: AdminUpdateShopOptionsDrivingRangeInput;
};


export type MutationAdminUpdateShopOptionsRealTimeArgs = {
  input: AdminUpdateShopOptionsRealTimeInput;
};


export type MutationAdminUpdateShopOptionsRoundArgs = {
  input: AdminUpdateShopOptionsRoundInput;
};


export type MutationAdminUpdateSidasInsolesArgs = {
  input: AdminUpdateSidasInsolesInput;
};


export type MutationAppTelemetryArgs = {
  input: AppTelemetryInput;
};


export type MutationAppTelemetryV2Args = {
  input: AppTelemetryV2Input;
};


export type MutationCoachAvailabilityDayItemTemplateCreateArgs = {
  input: CoachAvailabilityDayItemTemplateCreateInput;
};


export type MutationCoachAvailabilityDayItemTemplateDeleteArgs = {
  input: CoachAvailabilityDayItemTemplateDeleteInput;
};


export type MutationCoachAvailabilityDayItemTemplateUpdateArgs = {
  input: CoachAvailabilityDayItemTemplateUpdateInput;
};


export type MutationCoachAvailabilityDayUpsertArgs = {
  input: CoachAvailabilityDayUpsertInput;
};


export type MutationCoachBookingCommentUpdateArgs = {
  input: CoachBookingCommentUpdateInput;
};


export type MutationCoachMemberLessonNoteCreateArgs = {
  input: CoachMemberLessonNoteCreateInput;
};


export type MutationCoachMemberLessonNoteDeleteArgs = {
  input: CoachMemberLessonNoteDeleteInput;
};


export type MutationCoachMemberLessonNoteUpdateArgs = {
  input: CoachMemberLessonNoteUpdateInput;
};


export type MutationDevManagementSystemAdminNotificationSendArgs = {
  input: DevManagementSystemAdminNotificationSendInput;
};


export type MutationDevManagementSystemAdminViewportReloadRequestArgs = {
  input: DevManagementSystemAdminViewportReloadRequestInput;
};


export type MutationGenerateLessonAttachmentUploadUrlArgs = {
  input: GenerateLessonAttachmentUploadUrlInput;
};


export type MutationMemberAccountArchiveArgs = {
  input: MemberAccountArchiveInput;
};


export type MutationMemberAccountNotificationDeleteArgs = {
  input: MemberAccountNotificationDeleteInput;
};


export type MutationMemberAccountNotificationUpdateArgs = {
  input: MemberAccountNotificationUpdateInput;
};


export type MutationMemberAccountNotificationUpdateV2Args = {
  input: MemberAccountNotificationUpdateInput;
};


export type MutationMemberAccountPackageBuyArgs = {
  input: MemberAccountPackageBuyInput;
};


export type MutationMemberAccountPushTokenAddArgs = {
  input: MemberAccountPushTokenAddInput;
};


export type MutationMemberAccountPushTokenDeleteArgs = {
  input: MemberAccountPushTokenDeleteInput;
};


export type MutationMemberAddFriendArgs = {
  input: MemberAddFriendInput;
};


export type MutationMemberBookingCancelArgs = {
  input: MemberBookingCancelInput;
};


export type MutationMemberBookingGameCreateArgs = {
  input: MemberBookingGameCreateInput;
};


export type MutationMemberBookingLessonIndoorCreateArgs = {
  input: MemberBookingLessonIndoorCreateInput;
};


export type MutationMemberBookingLessonIndoorCreateV2Args = {
  input: MemberBookingLessonIndoorCreateV2Input;
};


export type MutationMemberBookingLessonOutdoorCreateArgs = {
  input: MemberBookingLessonOutdoorCreateInput;
};


export type MutationMemberBookingLessonOutdoorCreateV2Args = {
  input: MemberBookingLessonOutdoorCreateV2Input;
};


export type MutationMemberBookingPractiseCreateArgs = {
  input: MemberBookingPractiseCreateInput;
};


export type MutationMemberBookingPractiseCreateV2Args = {
  input: MemberBookingPractiseCreateV2Input;
};


export type MutationMemberBookingUpdateToGroupArgs = {
  input: MemberBookingUpdateToGroupInput;
};


export type MutationMemberDeleteRefreshTokenArgs = {
  input: MemberDeleteRefreshTokenInput;
};


export type MutationMemberFindMemberArgs = {
  input?: InputMaybe<MemberFindMemberInput>;
};


export type MutationMemberForgotPasswordArgs = {
  input: MemberForgotPasswordInput;
};


export type MutationMemberForgotPasswordSubmitArgs = {
  input: MemberForgotPasswordSubmitInput;
};


export type MutationMemberGameQrCodeLoginArgs = {
  input: MemberGameQrCodeLoginInput;
};


export type MutationMemberLoginArgs = {
  input: MemberLoginInput;
};


export type MutationMemberLogoutArgs = {
  input: MemberLogoutInput;
};


export type MutationMemberNotificationDeleteArgs = {
  input: MemberNotificationDeleteInput;
};


export type MutationMemberRefreshAccessTokenArgs = {
  input: MemberRefreshAccessTokenInput;
};


export type MutationMemberRemoveFriendArgs = {
  input: MemberRemoveFriendInput;
};


export type MutationMemberTopUpCreditArgs = {
  input: MemberTopUpCreditInput;
};


export type MutationMemberTransferCreditArgs = {
  input: MemberTransferCreditInput;
};


export type MutationMemberTransferCreditV2Args = {
  input: MemberTransferCreditInput;
};


export type MutationMemberUpdateEmailArgs = {
  input: MemberUpdateEmailInput;
};


export type MutationMemberUpdateGenderArgs = {
  input: MemberUpdateGenderInput;
};


export type MutationMemberUpdateHandedArgs = {
  input: MemberUpdateHandedInput;
};


export type MutationMemberUpdateMobileNumberArgs = {
  input: MemberUpdateMobileNumberInput;
};


export type MutationMemberUpdateNicknameArgs = {
  input: MemberUpdateNicknameInput;
};


export type MutationMemberUpdatePasswordArgs = {
  input: MemberUpdatePasswordInput;
};


export type MutationMemberWebsiteLoginQrCodeClaimArgs = {
  input: MemberWebsiteLoginQrCodeClaimInput;
};


export type MutationMemberWebsiteLoginQrCodeGrantArgs = {
  input: MemberWebsiteLoginQrCodeGrantInput;
};


export type MutationMemberWebsiteLoginQrCodeRequestArgs = {
  input: MemberWebsiteLoginQrCodeRequestInput;
};


export type MutationPublicContactFormArgs = {
  input: PublicContactFormInput;
};


export type MutationPublicNewsletterArgs = {
  input: PublicNewsletterInput;
};


export type MutationSelfUpdateArgs = {
  input: SelfUpdateInput;
};


export type MutationSelfUpdatePasswordArgs = {
  input: SelfUpdatePasswordInput;
};

export type NewAdmin = {
  __typename?: 'NewAdmin';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  user: Admin;
};

export type NewCoach = {
  __typename?: 'NewCoach';
  coach: Coach;
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
};

export type NonPuttingFacilityDayItem = {
  __typename?: 'NonPuttingFacilityDayItem';
  na0800?: Maybe<Scalars['Boolean']>;
  na0900?: Maybe<Scalars['Boolean']>;
  na1000?: Maybe<Scalars['Boolean']>;
  na1100?: Maybe<Scalars['Boolean']>;
  na1200?: Maybe<Scalars['Boolean']>;
  na1300?: Maybe<Scalars['Boolean']>;
  na1400?: Maybe<Scalars['Boolean']>;
  na1500?: Maybe<Scalars['Boolean']>;
  na1600?: Maybe<Scalars['Boolean']>;
  na1700?: Maybe<Scalars['Boolean']>;
  na1800?: Maybe<Scalars['Boolean']>;
  na1900?: Maybe<Scalars['Boolean']>;
  na2000?: Maybe<Scalars['Boolean']>;
  na2100?: Maybe<Scalars['Boolean']>;
  na2200?: Maybe<Scalars['Boolean']>;
  na2300?: Maybe<Scalars['Boolean']>;
};

export enum NotificationMode {
  Broadcast = 'BROADCAST',
  Single = 'SINGLE'
}

export enum OperationActorType {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type OrderBy = {
  direction?: InputMaybe<Direction>;
  field?: InputMaybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  clubhouses?: Maybe<Array<Maybe<AdminClubhouse>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationNumber?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<Admin>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  firstRecordDateTime?: Maybe<Scalars['DateTime']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export enum PaymentCurrency {
  Sgd = 'SGD',
  Usd = 'USD',
  Vnd = 'VND'
}

export enum PaymentMethod {
  Acecoins = 'ACECOINS',
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  Hitpay = 'HITPAY',
  Nets = 'NETS',
  Nil = 'NIL',
  Paynow = 'PAYNOW',
  Paypal = 'PAYPAL',
  Voucher = 'VOUCHER'
}

export enum PaymentProvider {
  Emenu = 'EMENU',
  Hitpay = 'HITPAY',
  ManagementSystem = 'MANAGEMENT_SYSTEM',
  Nil = 'NIL',
  Unspecified = 'UNSPECIFIED'
}

export type PractiseBookingConditions = {
  __typename?: 'PractiseBookingConditions';
  maxDays: Scalars['Int'];
  maxHrsBay: Scalars['Int'];
  maxHrsRoom: Scalars['Int'];
  maxMinsPutting: Scalars['Int'];
  maxPaxBay: Scalars['Int'];
  maxPaxPutting: Scalars['Int'];
  maxPaxRoom: Scalars['Int'];
};

export type PreConfirmationCopy = {
  __typename?: 'PreConfirmationCopy';
  textCancellationBody?: Maybe<Scalars['String']>;
  textCancellationBodyLocal?: Maybe<Scalars['String']>;
  textCancellationHeader?: Maybe<Scalars['String']>;
  textCancellationHeaderLocal?: Maybe<Scalars['String']>;
  textConfirm?: Maybe<Scalars['String']>;
  textConfirmLocal?: Maybe<Scalars['String']>;
  textDoubleBookingBody?: Maybe<Scalars['String']>;
  textDoubleBookingBodyLocal?: Maybe<Scalars['String']>;
  textDoubleBookingHeader?: Maybe<Scalars['String']>;
  textDoubleBookingHeaderLocal?: Maybe<Scalars['String']>;
  textReminderBody?: Maybe<Scalars['String']>;
  textReminderBodyLocal?: Maybe<Scalars['String']>;
  textReminderHeader?: Maybe<Scalars['String']>;
  textReminderHeaderLocal?: Maybe<Scalars['String']>;
  textRights?: Maybe<Scalars['String']>;
  textRightsLocal?: Maybe<Scalars['String']>;
};

export type PremiumPackagePractiseConditionCopy = {
  __typename?: 'PremiumPackagePractiseConditionCopy';
  textDurationBody?: Maybe<Scalars['String']>;
  textDurationBodyLocal?: Maybe<Scalars['String']>;
  textDurationHeader?: Maybe<Scalars['String']>;
  textDurationHeaderLocal?: Maybe<Scalars['String']>;
  textLocationBody?: Maybe<Scalars['String']>;
  textLocationBodyLocal?: Maybe<Scalars['String']>;
  textLocationHeader?: Maybe<Scalars['String']>;
  textLocationHeaderLocal?: Maybe<Scalars['String']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  sgBayHourlyRate?: Maybe<Scalars['Int']>;
  sgBayHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgBayMaxHours?: Maybe<Scalars['Int']>;
  sgBayMaxPlayers?: Maybe<Scalars['Int']>;
  sgBookingCancellationPenalty?: Maybe<Scalars['Int']>;
  sgBookingLapsedPenalty?: Maybe<Scalars['Int']>;
  sgHole9MaxHours?: Maybe<Scalars['Int']>;
  sgHole9MaxPlayers?: Maybe<Scalars['Int']>;
  sgHole9PerPlayerRate?: Maybe<Scalars['Int']>;
  sgHole9PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  sgHole18MaxHours?: Maybe<Scalars['Int']>;
  sgHole18MaxPlayers?: Maybe<Scalars['Int']>;
  sgHole18PerPlayerRate?: Maybe<Scalars['Int']>;
  sgHole18PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  sgLessonField?: Maybe<Scalars['Int']>;
  sgLessonFieldVIP?: Maybe<Scalars['Int']>;
  sgLessonIndoor?: Maybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  sgLessonIndoorVIP?: Maybe<Scalars['Int']>;
  sgPrivateRoomHourlyRate?: Maybe<Scalars['Int']>;
  sgPrivateRoomHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgPrivateRoomMaxHours?: Maybe<Scalars['Int']>;
  sgPrivateRoomMaxPlayers?: Maybe<Scalars['Int']>;
  sgPuttingGreenHourlyRate?: Maybe<Scalars['Int']>;
  sgPuttingGreenHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgPuttingGreenMaxMins?: Maybe<Scalars['Int']>;
  sgPuttingGreenMaxPlayers?: Maybe<Scalars['Int']>;
  viBayHourlyRate?: Maybe<Scalars['Int']>;
  viBayHourlyRateVIP?: Maybe<Scalars['Int']>;
  viBayMaxHours?: Maybe<Scalars['Int']>;
  viBayMaxPlayers?: Maybe<Scalars['Int']>;
  viBookingCancellationPenalty?: Maybe<Scalars['Int']>;
  viBookingLapsedPenalty?: Maybe<Scalars['Int']>;
  viHole9MaxHours?: Maybe<Scalars['Int']>;
  viHole9MaxPlayers?: Maybe<Scalars['Int']>;
  viHole9PerPlayerRate?: Maybe<Scalars['Int']>;
  viHole9PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  viHole18MaxHours?: Maybe<Scalars['Int']>;
  viHole18MaxPlayers?: Maybe<Scalars['Int']>;
  viHole18PerPlayerRate?: Maybe<Scalars['Int']>;
  viHole18PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  viLessonField?: Maybe<Scalars['Int']>;
  viLessonFieldVIP?: Maybe<Scalars['Int']>;
  viLessonIndoor?: Maybe<Scalars['Int']>;
  viLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  viLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  viLessonIndoorVIP?: Maybe<Scalars['Int']>;
  viPrivateRoomHourlyRate?: Maybe<Scalars['Int']>;
  viPrivateRoomHourlyRateVIP?: Maybe<Scalars['Int']>;
  viPrivateRoomMaxHours?: Maybe<Scalars['Int']>;
  viPrivateRoomMaxPlayers?: Maybe<Scalars['Int']>;
  viPuttingGreenHourlyRate?: Maybe<Scalars['Int']>;
  viPuttingGreenHourlyRateVIP?: Maybe<Scalars['Int']>;
  viPuttingGreenMaxMins?: Maybe<Scalars['Int']>;
  viPuttingGreenMaxPlayers?: Maybe<Scalars['Int']>;
};

export type PrivateRoom = {
  __typename?: 'PrivateRoom';
  blockedFromBooking: Scalars['Boolean'];
  clientname: Scalars['String'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PublicClubhouseArgs = {
  countryCode: CountryCode;
};

export type PublicCoach = {
  __typename?: 'PublicCoach';
  baseCountryCode?: Maybe<CountryCode>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLessonField?: Maybe<Scalars['Int']>;
  coachLessonFieldVIP?: Maybe<Scalars['Int']>;
  coachLessonIndoor?: Maybe<Scalars['Int']>;
  coachLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  coachLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  coachLessonIndoorVIP?: Maybe<Scalars['Int']>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  socialInstagram?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type PublicContactFormInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PublicMembership = {
  __typename?: 'PublicMembership';
  exampleField?: Maybe<Scalars['Int']>;
};

export type PublicNewsletterInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export enum PublishMode {
  Broadcast = 'BROADCAST',
  Single = 'SINGLE'
}

export type PuttingFacilityDayItem = {
  __typename?: 'PuttingFacilityDayItem';
  na0800?: Maybe<Scalars['Boolean']>;
  na0830?: Maybe<Scalars['Boolean']>;
  na0900?: Maybe<Scalars['Boolean']>;
  na0930?: Maybe<Scalars['Boolean']>;
  na1000?: Maybe<Scalars['Boolean']>;
  na1030?: Maybe<Scalars['Boolean']>;
  na1100?: Maybe<Scalars['Boolean']>;
  na1130?: Maybe<Scalars['Boolean']>;
  na1200?: Maybe<Scalars['Boolean']>;
  na1230?: Maybe<Scalars['Boolean']>;
  na1300?: Maybe<Scalars['Boolean']>;
  na1330?: Maybe<Scalars['Boolean']>;
  na1400?: Maybe<Scalars['Boolean']>;
  na1430?: Maybe<Scalars['Boolean']>;
  na1500?: Maybe<Scalars['Boolean']>;
  na1530?: Maybe<Scalars['Boolean']>;
  na1600?: Maybe<Scalars['Boolean']>;
  na1630?: Maybe<Scalars['Boolean']>;
  na1700?: Maybe<Scalars['Boolean']>;
  na1730?: Maybe<Scalars['Boolean']>;
  na1800?: Maybe<Scalars['Boolean']>;
  na1830?: Maybe<Scalars['Boolean']>;
  na1900?: Maybe<Scalars['Boolean']>;
  na1930?: Maybe<Scalars['Boolean']>;
  na2000?: Maybe<Scalars['Boolean']>;
  na2030?: Maybe<Scalars['Boolean']>;
  na2100?: Maybe<Scalars['Boolean']>;
  na2130?: Maybe<Scalars['Boolean']>;
  na2200?: Maybe<Scalars['Boolean']>;
  na2230?: Maybe<Scalars['Boolean']>;
  na2300?: Maybe<Scalars['Boolean']>;
  na2330?: Maybe<Scalars['Boolean']>;
};

export type PuttingGreen = {
  __typename?: 'PuttingGreen';
  blockedFromBooking: Scalars['Boolean'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  admin?: Maybe<Admin>;
  adminBooking?: Maybe<AdminBooking>;
  adminBookingAvailability: Scalars['String'];
  adminBookingBlackoutClubhouse: AdminBookingBlackoutClubhouse;
  adminBookingBlackoutCoach: AdminBookingBlackoutCoach;
  adminBookingBlackouts: Array<Maybe<AdminBookingBlackoutBasic>>;
  adminBookingCoachAvailabilityCalendarItems?: Maybe<AdminBookingCoachAvailabilityCalendarItems>;
  adminBookingCoachAvailabilityDayItem?: Maybe<AdminBookingCoachAvailabilityDayItem>;
  adminBookingCoachAvailabilitySlotItem?: Maybe<AdminBookingCoachAvailabilitySlotItem>;
  adminBookingCoaches: Array<Maybe<AdminBookingCoach>>;
  adminBookingCombinedCoachAvailabilityDayItem?: Maybe<AdminBookingCombinedCoachAvailabilityDayItem>;
  adminBookingFacilityAvailabilityCalendarItems?: Maybe<AdminBookingFacilityAvailabilityCalendarItems>;
  adminBookingFacilityAvailabilityDayItem?: Maybe<AdminBookingFacilityAvailabilityDayItem>;
  adminBookingFacilityAvailabilitySlotItem?: Maybe<AdminBookingFacilityAvailabilitySlotItem>;
  adminBookingGameCheckout: AdminBookingCheckout;
  adminBookingGroupMembers: AdminBookingGroupMembers;
  adminBookingLessonIndoorCheckout: AdminBookingCheckout;
  adminBookingLessonOutdoorCheckout: AdminBookingCheckout;
  adminBookingPractiseCheckout: AdminBookingCheckout;
  adminBookingSettings: AdminBookingSettings;
  adminBookings: AdminBookingResponse;
  adminClientStatus: ClientStatus;
  adminClubhouse: AdminClubhouse;
  adminClubhouseFacilities: Array<Facility>;
  adminClubhouseFacilityAvailability: AdminClubhouseFacilityAvailability;
  adminClubhouses: AdminClubhouseResponse;
  adminCoach: AdminCoach;
  adminCoachAvailabilityCalendarItems: Array<Maybe<CoachAvailabilityCalendarItems>>;
  adminCoachCombinedAvailability: Array<Maybe<AdminCoachCombinedAvailability>>;
  adminCoaches: AdminCoachResponse;
  adminGameHistory: AdminGameHistory;
  adminGroupBookings: Array<AdminGroupBooking>;
  adminKGolfMember: AdminKGolfMember;
  adminManagementSystemAppMainSlider: AdminManagementSystemAppMainSlider;
  adminManagementSystemAppMainSliders: Array<AdminManagementSystemAppMainSlider>;
  adminManagementSystemProps: AdminManagementSystemProps;
  adminManagementSystemSupportTicket: AdminManagementSystemSupportTicket;
  adminManagementSystemSupportTicketComments: Array<Maybe<AdminManagementSystemSupportTicketComment>>;
  adminManagementSystemSupportTicketUsers: Array<AdminManagementSystemSupportTicketUser>;
  adminManagementSystemSupportTickets: AdminManagementSystemSupportTicketResponse;
  adminMember: AdminMember;
  adminMemberAcTransactions: AdminMemberAcTransactionResponse;
  adminMemberInvoices: AdminReportInvoiceResponse;
  adminMemberLessonNoteMembers: AdminMemberLessonNoteMemberResponse;
  adminMemberNotifications: AdminMemberNotificationResponse;
  adminMemberProductGroupPackages: AdminMemberProductGroupPackages;
  adminMemberProductPackage: AdminMemberProductPackage;
  adminMemberProductPackageExtensions: AdminMemberProductPackageExtensions;
  adminMemberServiceTransactions: AdminMemberServiceTransactionResponse;
  adminMemberSubscriptions: AdminMemberSubscriptionResponse;
  adminMembers: AdminMemberResponse;
  adminMembershipServices: AdminMembershipServiceResponse;
  adminMembershipSubscriptions: AdminMembershipSubscriptionResponse;
  adminMembershipType: AdminMembershipType;
  adminMembershipTypes: AdminMembershipTypes;
  adminNotification: AdminNotification;
  adminNotifications: AdminNotificationResponse;
  adminProducts: AdminProductResponse;
  adminReportAcTransactions: AdminReportAcTransactionResponse;
  adminReportHitPayCharge: Invoice;
  adminReportHitPayCharges: AdminReportHitPayChargeResponse;
  adminReportInvoice: Invoice;
  adminReportInvoices: AdminReportInvoiceResponse;
  adminReservedIds?: Maybe<AdminReservedIds>;
  adminScoreCard?: Maybe<Scalars['JSON']>;
  adminShopDetails?: Maybe<AdminShopDetails>;
  adminShopOptionsDrivingRange: AdminShopOptionsDrivingRange;
  adminShopOptionsRealTime: AdminShopOptionsRealTime;
  adminShopOptionsRound: AdminShopOptionsRound;
  adminSimulatorUsage?: Maybe<Scalars['JSON']>;
  adminStaffs: AdminStaffResponse;
  admins: AdminResponse;
  appDineMenu?: Maybe<AppDineMenu>;
  appMainSlider?: Maybe<AppMainSlider>;
  appMainSliderV2?: Maybe<AppMainSliderV2>;
  appManifestV2: AppManifestV2;
  appMedia?: Maybe<Array<Maybe<AppMedia>>>;
  appMediaYouTubeVideo?: Maybe<AppMediaYouTubeVideo>;
  coachAccountSettings: CoachAccountSettings;
  coachAvailabilityCalendarItems: Array<Maybe<CoachAvailabilityCalendarItems>>;
  coachAvailabilityDayItem?: Maybe<CoachAvailabilityDayItem>;
  coachAvailabilityDayItemTemplate: CoachAvailabilityDayItemTemplate;
  coachAvailabilityDayItemTemplates: Array<Maybe<CoachAvailabilityDayItemTemplate>>;
  coachBooking?: Maybe<CoachBooking>;
  coachBookingCoaches: Array<Maybe<CoachBookingCoach>>;
  coachBookingCombinedAvailability: Array<Maybe<CoachBookingCombinedAvailability>>;
  coachBookingCombinedAvailabilityDayItem?: Maybe<CoachBookingCombinedAvailabilityDayItem>;
  coachBookings: CoachBookingResponse;
  coachGroupBookings: Array<CoachGroupBooking>;
  coachMember?: Maybe<CoachMember>;
  coachMemberLessonNote: CoachMemberLessonNote;
  coachMemberLessonNoteMembers: CoachMemberLessonNoteMemberResponse;
  coachMemberLessonNotes: CoachMemberLessonNoteResponse;
  coachMembers: CoachMemberResponse;
  devAceCoinsLedger: DevAceCoinsLedger;
  devManagementSystemServerEnvironments: DevManagementSystemServerEnvironments;
  devMemberAceCoinIssue: Array<Maybe<DevMemberAceCoinIssue>>;
  formHelperAceCoinType?: Maybe<FormHelperAceCoinType>;
  formHelperBooking?: Maybe<FormHelperBooking>;
  formHelperNewAdmin?: Maybe<FormHelperNewAdmin>;
  formHelperNewBlackOut?: Maybe<FormHelperNewBlackOut>;
  formHelperNewCoach?: Maybe<FormHelperNewCoach>;
  formHelperNewMembership?: Maybe<FormHelperNewMembership>;
  formHelperProductPackages?: Maybe<FormHelperProductPackages>;
  memberAccount: MemberAccount;
  memberAccountAcTransactions: MemberAccountAcTransactionResponse;
  memberAccountCoach: MemberAccountCoach;
  memberAccountCoaches: Array<Maybe<MemberAccountCoachBasic>>;
  memberAccountExpirableCredits: MemberAccountExpirableCreditResponse;
  memberAccountFindMember: MemberAccountFindMember;
  memberAccountInvoice: Invoice;
  memberAccountInvoices: Array<Maybe<MemberAccountInvoiceBasic>>;
  memberAccountLessonNote: MemberAccountLessonNote;
  memberAccountLessonNotes: MemberAccountLessonNoteResponse;
  memberAccountNotification: MemberNotification;
  memberAccountNotifications: MemberAccountNotificationResponse;
  memberAccountPackage: MemberAccountPackage;
  memberAccountPackageOffer: MemberPackageOffer;
  memberAccountPackageOffers: MemberAccountPackageOffers;
  memberAccountPackages: MemberAccountPackageResponse;
  memberAccountRates: MemberAccountRates;
  memberAccountServiceTransactions: MemberAccountServiceTransactionResponse;
  memberAccountServiceTransactionsV2: MemberAccountServiceTransactionV2Response;
  memberAccountSubscriptions: MemberAccountSubscriptionResponse;
  memberAccountV2: MemberAccountV2;
  memberBooking: MemberBooking;
  memberBookingCoachAvailabilityCalendarItems?: Maybe<MemberBookingCoachAvailabilityCalendarItems>;
  memberBookingCoachAvailabilityCalendarItemsV2?: Maybe<MemberBookingCoachAvailabilityCalendarItems>;
  memberBookingCoachAvailabilityDayItem: Array<Maybe<MemberBookingCoachAvailabilityDayItem>>;
  memberBookingCoachAvailabilityDayItemV2: Array<Maybe<MemberBookingCoachAvailabilityDayItemV2>>;
  memberBookingCoachAvailabilitySlotItem: MemberBookingCoachAvailabilitySlotItem;
  memberBookingCoaches: Array<Maybe<MemberBookingCoach>>;
  memberBookingCoachesV2: Array<Maybe<MemberBookingCoach>>;
  memberBookingFacilityAvailabilityCalendarItems?: Maybe<MemberBookingFacilityAvailabilityCalendarItems>;
  memberBookingFacilityAvailabilityDayItem: Array<Maybe<MemberBookingFacilityAvailabilityDayItem>>;
  memberBookingFacilityAvailabilityDayItemV2?: Maybe<MemberBookingFacilityAvailabilityDayItems>;
  memberBookingGameCheckout: MemberBookingCheckout;
  memberBookingGameCheckoutV2: MemberBookingCheckoutV2;
  memberBookingGroupMembers: MemberBookingGroupMembers;
  memberBookingHelper: MemberBookingHelper;
  memberBookingHelperV2: MemberBookingHelperV2;
  memberBookingLessonIndoorCheckout: MemberBookingCheckout;
  memberBookingLessonIndoorCheckoutV2: MemberBookingCheckoutV2;
  memberBookingLessonOutdoorCheckout: MemberBookingCheckout;
  memberBookingLessonOutdoorCheckoutV2: MemberBookingCheckoutV2;
  memberBookingPractiseCheckout: MemberBookingCheckout;
  memberBookingPractiseCheckoutV2: MemberBookingCheckoutV2;
  memberBookingV2: MemberBookingV2;
  memberBookings: MemberBookingResponse;
  memberBookingsActive: MemberBookingResponse;
  memberBookingsCompleted: MemberBookingResponse;
  memberBookingsToday: Array<Maybe<MemberBookingBasic>>;
  memberFriends: Array<Maybe<MemberFriend>>;
  memberFriendsV2: MemberFriendsV2;
  memberMember: MemberMember;
  memberNotification: MemberNotification;
  memberNotifications: MemberNotificationResponse;
  memberScoreCard: Scalars['JSON'];
  memberScoreCards: Scalars['JSON'];
  memberSimulatorPrivilege: MemberSimulatorPrivilege;
  memberSubscriptions: MemberSubscriptionResponse;
  organization?: Maybe<Organization>;
  pricing?: Maybe<Pricing>;
  publicClubhouse?: Maybe<Scalars['JSON']>;
  publicCoaches?: Maybe<Array<Maybe<PublicCoach>>>;
  publicMembership: Array<Maybe<PublicMembership>>;
  publicUtilityIpAddress: Scalars['String'];
  self?: Maybe<Self>;
};


export type QueryAdminArgs = {
  args: AdminArgs;
};


export type QueryAdminBookingArgs = {
  args: AdminBookingArgs;
};


export type QueryAdminBookingAvailabilityArgs = {
  args: AdminBookingAvailabilityArgs;
};


export type QueryAdminBookingBlackoutClubhouseArgs = {
  args: AdminBookingBlackoutClubhouseArgs;
};


export type QueryAdminBookingBlackoutCoachArgs = {
  args: AdminBookingBlackoutCoachArgs;
};


export type QueryAdminBookingBlackoutsArgs = {
  args: AdminBookingBlackoutsArgs;
};


export type QueryAdminBookingCoachAvailabilityCalendarItemsArgs = {
  args: AdminBookingCoachAvailabilityCalendarItemsArgs;
};


export type QueryAdminBookingCoachAvailabilityDayItemArgs = {
  args: AdminBookingCoachAvailabilityDayItemArgs;
};


export type QueryAdminBookingCoachAvailabilitySlotItemArgs = {
  args: AdminBookingCoachAvailabilitySlotItemArgs;
};


export type QueryAdminBookingCombinedCoachAvailabilityDayItemArgs = {
  args: AdminBookingCombinedCoachAvailabilityDayItemArgs;
};


export type QueryAdminBookingFacilityAvailabilityCalendarItemsArgs = {
  args: AdminBookingFacilityAvailabilityCalendarItemsArgs;
};


export type QueryAdminBookingFacilityAvailabilityDayItemArgs = {
  args: AdminBookingFacilityAvailabilityDayItemArgs;
};


export type QueryAdminBookingFacilityAvailabilitySlotItemArgs = {
  args: AdminBookingFacilityAvailabilitySlotItemArgs;
};


export type QueryAdminBookingGameCheckoutArgs = {
  args: AdminBookingGameCheckoutArgs;
};


export type QueryAdminBookingGroupMembersArgs = {
  args: AdminBookingGroupMembersArgs;
};


export type QueryAdminBookingLessonIndoorCheckoutArgs = {
  args: AdminBookingLessonIndoorCheckoutArgs;
};


export type QueryAdminBookingLessonOutdoorCheckoutArgs = {
  args: AdminBookingLessonOutdoorCheckoutArgs;
};


export type QueryAdminBookingPractiseCheckoutArgs = {
  args: AdminBookingPractiseCheckoutArgs;
};


export type QueryAdminBookingSettingsArgs = {
  args: AdminBookingSettingsArgs;
};


export type QueryAdminBookingsArgs = {
  args: AdminBookingsArgs;
};


export type QueryAdminClientStatusArgs = {
  args: AdminClientStatusArgs;
};


export type QueryAdminClubhouseArgs = {
  args: AdminClubhouseArgs;
};


export type QueryAdminClubhouseFacilitiesArgs = {
  args: AdminClubhouseFacilitiesArgs;
};


export type QueryAdminClubhouseFacilityAvailabilityArgs = {
  args: AdminClubhouseFacilityAvailabilityArgs;
};


export type QueryAdminClubhousesArgs = {
  args: AdminClubhousesArgs;
};


export type QueryAdminCoachArgs = {
  args: AdminCoachArgs;
};


export type QueryAdminCoachAvailabilityCalendarItemsArgs = {
  args?: InputMaybe<AdminCoachAvailabilityCalendarItemsArgs>;
};


export type QueryAdminCoachCombinedAvailabilityArgs = {
  args: AdminCoachCombinedAvailabilityArgs;
};


export type QueryAdminCoachesArgs = {
  args?: InputMaybe<AdminCoachesArgs>;
};


export type QueryAdminGameHistoryArgs = {
  args: AdminGameHistoryArgs;
};


export type QueryAdminGroupBookingsArgs = {
  args: AdminGroupBookingsArgs;
};


export type QueryAdminKGolfMemberArgs = {
  args?: InputMaybe<AdminKGolfMemberArgs>;
};


export type QueryAdminManagementSystemAppMainSliderArgs = {
  args: AdminManagementSystemAppMainSliderArgs;
};


export type QueryAdminManagementSystemAppMainSlidersArgs = {
  args?: InputMaybe<AdminManagementSystemAppMainSlidersArgs>;
};


export type QueryAdminManagementSystemSupportTicketArgs = {
  args: AdminManagementSystemSupportTicketArgs;
};


export type QueryAdminManagementSystemSupportTicketCommentsArgs = {
  args: AdminManagementSystemSupportTicketCommentsArgs;
};


export type QueryAdminManagementSystemSupportTicketsArgs = {
  args: AdminManagementSystemSupportTicketsArgs;
};


export type QueryAdminMemberArgs = {
  args: AdminMemberArgs;
};


export type QueryAdminMemberAcTransactionsArgs = {
  args: AdminMemberAcTransactionsArgs;
};


export type QueryAdminMemberInvoicesArgs = {
  args: AdminMemberInvoicesArgs;
};


export type QueryAdminMemberLessonNoteMembersArgs = {
  args: AdminMemberLessonNoteMembersArgs;
};


export type QueryAdminMemberNotificationsArgs = {
  args: AdminMemberNotificationsArgs;
};


export type QueryAdminMemberProductGroupPackagesArgs = {
  args: AdminMemberProductGroupPackagesArgs;
};


export type QueryAdminMemberProductPackageArgs = {
  args: AdminMemberProductPackageArgs;
};


export type QueryAdminMemberProductPackageExtensionsArgs = {
  args: AdminMemberProductPackageExtensionsArgs;
};


export type QueryAdminMemberServiceTransactionsArgs = {
  args: AdminMemberServiceTransactionsArgs;
};


export type QueryAdminMemberSubscriptionsArgs = {
  args: AdminMemberSubscriptionsArgs;
};


export type QueryAdminMembersArgs = {
  args: AdminMembersArgs;
};


export type QueryAdminMembershipServicesArgs = {
  args: AdminMembershipServicesArgs;
};


export type QueryAdminMembershipSubscriptionsArgs = {
  args: AdminMembershipSubscriptionsArgs;
};


export type QueryAdminMembershipTypeArgs = {
  args: AdminMembershipTypeArgs;
};


export type QueryAdminMembershipTypesArgs = {
  args: AdminMembershipTypesArgs;
};


export type QueryAdminNotificationArgs = {
  args: AdminNotificationArgs;
};


export type QueryAdminNotificationsArgs = {
  args: AdminNotificationsArgs;
};


export type QueryAdminProductsArgs = {
  args: AdminProductsArgs;
};


export type QueryAdminReportAcTransactionsArgs = {
  args: AdminReportAcTransactionsArgs;
};


export type QueryAdminReportHitPayChargeArgs = {
  args: AdminReportHitPayChargeArgs;
};


export type QueryAdminReportHitPayChargesArgs = {
  args: AdminReportHitPayChargesArgs;
};


export type QueryAdminReportInvoiceArgs = {
  args: AdminReportInvoiceArgs;
};


export type QueryAdminReportInvoicesArgs = {
  args: AdminReportInvoicesArgs;
};


export type QueryAdminReservedIdsArgs = {
  args?: InputMaybe<AdminReservedIdsArgs>;
};


export type QueryAdminScoreCardArgs = {
  args: AdminScoreCardArgs;
};


export type QueryAdminShopDetailsArgs = {
  args: AdminShopDetailsArg;
};


export type QueryAdminShopOptionsDrivingRangeArgs = {
  args: AdminShopOptionsDrivingRangeArgs;
};


export type QueryAdminShopOptionsRealTimeArgs = {
  args: AdminShopOptionsRealTimeArgs;
};


export type QueryAdminShopOptionsRoundArgs = {
  args: AdminShopOptionsRoundArgs;
};


export type QueryAdminSimulatorUsageArgs = {
  args: AdminSimulatorUsageArgs;
};


export type QueryAdminStaffsArgs = {
  args?: InputMaybe<AdminStaffsArgs>;
};


export type QueryAdminsArgs = {
  args: AdminsArgs;
};


export type QueryAppDineMenuArgs = {
  args?: InputMaybe<AppDineMenuArgs>;
};


export type QueryAppMainSliderArgs = {
  args?: InputMaybe<AppMainSliderArgs>;
};


export type QueryAppMainSliderV2Args = {
  args: AppMainSliderV2Args;
};


export type QueryAppMediaArgs = {
  args: AppMediaArgs;
};


export type QueryAppMediaYouTubeVideoArgs = {
  args: AppMediaYouTubeVideoArgs;
};


export type QueryCoachAvailabilityCalendarItemsArgs = {
  args?: InputMaybe<CoachAvailabilityCalendarItemsArgs>;
};


export type QueryCoachAvailabilityDayItemArgs = {
  args: CoachAvailabilityDayItemArgs;
};


export type QueryCoachAvailabilityDayItemTemplateArgs = {
  args: CoachAvailabilityDayItemTemplateArgs;
};


export type QueryCoachBookingArgs = {
  args: CoachBookingArgs;
};


export type QueryCoachBookingCombinedAvailabilityArgs = {
  args: CoachBookingCombinedAvailabilityArgs;
};


export type QueryCoachBookingCombinedAvailabilityDayItemArgs = {
  args: CoachBookingCombinedAvailabilityDayItemArgs;
};


export type QueryCoachBookingsArgs = {
  args: CoachBookingsArgs;
};


export type QueryCoachGroupBookingsArgs = {
  args: CoachGroupBookingsArgs;
};


export type QueryCoachMemberArgs = {
  args: CoachMemberArgs;
};


export type QueryCoachMemberLessonNoteArgs = {
  args: CoachMemberLessonNoteArgs;
};


export type QueryCoachMemberLessonNoteMembersArgs = {
  args: CoachMemberLessonNoteMembersArgs;
};


export type QueryCoachMemberLessonNotesArgs = {
  args: CoachMemberLessonNotesArgs;
};


export type QueryCoachMembersArgs = {
  args: CoachMembersArgs;
};


export type QueryDevAceCoinsLedgerArgs = {
  args?: InputMaybe<DevAceCoinsLedgerArgs>;
};


export type QueryFormHelperAceCoinTypeArgs = {
  args: FormHelperAceCoinTypeArgs;
};


export type QueryFormHelperBookingArgs = {
  args: FormHelperBookingArgs;
};


export type QueryFormHelperNewAdminArgs = {
  args: FormHelperNewAdminArgs;
};


export type QueryFormHelperNewBlackOutArgs = {
  args?: InputMaybe<FormHelperNewBlackOutArgs>;
};


export type QueryFormHelperNewCoachArgs = {
  args: FormHelperNewCoachArgs;
};


export type QueryFormHelperNewMembershipArgs = {
  args: FormHelperNewMembershipArgs;
};


export type QueryFormHelperProductPackagesArgs = {
  args: FormHelperProductPackagesArgs;
};


export type QueryMemberAccountAcTransactionsArgs = {
  args: MemberAccountAcTransactionsArgs;
};


export type QueryMemberAccountCoachArgs = {
  args: MemberAccountCoachArgs;
};


export type QueryMemberAccountExpirableCreditsArgs = {
  args: MemberAccountExpirableCreditsArgs;
};


export type QueryMemberAccountFindMemberArgs = {
  args: MemberAccountFindMemberArgs;
};


export type QueryMemberAccountInvoiceArgs = {
  args: MemberAccountInvoiceArgs;
};


export type QueryMemberAccountInvoicesArgs = {
  args: MemberAccountInvoicesArgs;
};


export type QueryMemberAccountLessonNoteArgs = {
  args: MemberAccountLessonNoteArgs;
};


export type QueryMemberAccountLessonNotesArgs = {
  args: MemberAccountLessonNotesArgs;
};


export type QueryMemberAccountNotificationArgs = {
  args: MemberAccountNotificationArgs;
};


export type QueryMemberAccountNotificationsArgs = {
  args: MemberAccountNotificationsArgs;
};


export type QueryMemberAccountPackageArgs = {
  args: MemberAccountPackageArgs;
};


export type QueryMemberAccountPackageOfferArgs = {
  args: MemberAccountPackageOfferArgs;
};


export type QueryMemberAccountPackagesArgs = {
  args: MemberAccountPackagesArgs;
};


export type QueryMemberAccountServiceTransactionsArgs = {
  args: MemberAccountServiceTransactionsArgs;
};


export type QueryMemberAccountServiceTransactionsV2Args = {
  args: MemberAccountServiceTransactionsArgs;
};


export type QueryMemberAccountSubscriptionsArgs = {
  args: MemberAccountSubscriptionsArgs;
};


export type QueryMemberBookingArgs = {
  args: MemberBookingArgs;
};


export type QueryMemberBookingCoachAvailabilityCalendarItemsArgs = {
  args: MemberBookingCoachAvailabilityCalendarItemsArgs;
};


export type QueryMemberBookingCoachAvailabilityCalendarItemsV2Args = {
  args: MemberBookingCoachAvailabilityCalendarItemsArgs;
};


export type QueryMemberBookingCoachAvailabilityDayItemArgs = {
  args: MemberBookingCoachAvailabilityDayItemArgs;
};


export type QueryMemberBookingCoachAvailabilityDayItemV2Args = {
  args: MemberBookingCoachAvailabilityDayItemV2Args;
};


export type QueryMemberBookingCoachAvailabilitySlotItemArgs = {
  args: MemberBookingCoachAvailabilitySlotItemArgs;
};


export type QueryMemberBookingCoachesV2Args = {
  args?: InputMaybe<MemberBookingCoachesV2Args>;
};


export type QueryMemberBookingFacilityAvailabilityCalendarItemsArgs = {
  args: MemberBookingFacilityAvailabilityCalendarItemsArgs;
};


export type QueryMemberBookingFacilityAvailabilityDayItemArgs = {
  args: MemberBookingFacilityAvailabilityDayItemArgs;
};


export type QueryMemberBookingFacilityAvailabilityDayItemV2Args = {
  args: MemberBookingFacilityAvailabilityDayItemArgs;
};


export type QueryMemberBookingGameCheckoutArgs = {
  args: MemberBookingGameCheckoutArgs;
};


export type QueryMemberBookingGameCheckoutV2Args = {
  args: MemberBookingGameCheckoutArgs;
};


export type QueryMemberBookingGroupMembersArgs = {
  args: MemberBookingGroupMembersArgs;
};


export type QueryMemberBookingHelperV2Args = {
  args: MemberBookingHelperV2Args;
};


export type QueryMemberBookingLessonIndoorCheckoutArgs = {
  args: MemberBookingLessonIndoorCheckoutArgs;
};


export type QueryMemberBookingLessonIndoorCheckoutV2Args = {
  args: MemberBookingLessonIndoorCheckoutArgs;
};


export type QueryMemberBookingLessonOutdoorCheckoutArgs = {
  args: MemberBookingLessonOutdoorCheckoutArgs;
};


export type QueryMemberBookingLessonOutdoorCheckoutV2Args = {
  args: MemberBookingLessonOutdoorCheckoutArgs;
};


export type QueryMemberBookingPractiseCheckoutArgs = {
  args: MemberBookingPractiseCheckoutArgs;
};


export type QueryMemberBookingPractiseCheckoutV2Args = {
  args: MemberBookingPractiseCheckoutArgs;
};


export type QueryMemberBookingV2Args = {
  args: MemberBookingArgs;
};


export type QueryMemberBookingsArgs = {
  args: MemberBookingsArgs;
};


export type QueryMemberBookingsActiveArgs = {
  args: MemberBookingsActiveArgs;
};


export type QueryMemberBookingsCompletedArgs = {
  args: MemberBookingsCompletedArgs;
};


export type QueryMemberMemberArgs = {
  args: MemberMemberArgs;
};


export type QueryMemberNotificationArgs = {
  args: MemberNotificationArgs;
};


export type QueryMemberNotificationsArgs = {
  args: MemberNotificationsArgs;
};


export type QueryMemberScoreCardArgs = {
  args: MemberScoreCardArgs;
};


export type QueryMemberScoreCardsArgs = {
  args: MemberScoreCardsArgs;
};


export type QueryMemberSubscriptionsArgs = {
  args: MemberSubscriptionsArgs;
};


export type QueryPublicClubhouseArgs = {
  args: PublicClubhouseArgs;
};

export enum Relationship {
  Child = 'CHILD',
  Spouse = 'SPOUSE'
}

export enum ReservedIdStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE',
  OnHold = 'ON_HOLD'
}

export enum ReservedMembershipIdStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE',
  OnHold = 'ON_HOLD'
}

export type ScoreCard = {
  __typename?: 'ScoreCard';
  clientName: Scalars['String'];
  courseIntroImage: Scalars['String'];
  courseLogoImage: Scalars['String'];
  courseName: Scalars['String'];
  endTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  roundIdx: Scalars['Int'];
  shopName: Scalars['String'];
  startTime: Scalars['Int'];
  strokeTotalScore: Scalars['Int'];
};

export type Self = {
  __typename?: 'Self';
  baseCountryCode?: Maybe<CountryCode>;
  baseGmtOffset?: Maybe<Scalars['Int']>;
  clubhouses?: Maybe<Array<Maybe<SelfClubhouse>>>;
  countries?: Maybe<Array<Maybe<SelfCountry>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type SelfClubhouse = {
  __typename?: 'SelfClubhouse';
  clubhouseCode: Scalars['String'];
  name: Scalars['String'];
};

export type SelfCountry = {
  __typename?: 'SelfCountry';
  countryCode: CountryCode;
  name: Scalars['String'];
};

export type SelfUpdateInput = {
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
};

export type SelfUpdatePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type SelfUpdated = {
  __typename?: 'SelfUpdated';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  self: Self;
};

export enum SentBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  System = 'SYSTEM'
}

export type ServiceTransactionBasic = {
  __typename?: 'ServiceTransactionBasic';
  amount: Scalars['Float'];
  coach?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  expirableCredit?: Maybe<ExpirableCreditBasic>;
  facilityType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDailyType?: Maybe<Scalars['Boolean']>;
  isShareGroupPaused?: Maybe<Scalars['Boolean']>;
  isSupplementaryRedemption?: Maybe<Scalars['Boolean']>;
  memberName?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  packageType?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  serviceType: Scalars['String'];
  supplementaryUnitName?: Maybe<Scalars['String']>;
  transactionType: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
};

export enum ServiceTransactionDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export enum ServiceTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Purchase = 'PURCHASE',
  Redemption = 'REDEMPTION',
  Transfer = 'TRANSFER'
}

export enum ServiceType {
  Game = 'GAME',
  LessonField = 'LESSON_FIELD',
  LessonIndoor = 'LESSON_INDOOR',
  Practise = 'PRACTISE'
}

export type ShopTokens = {
  __typename?: 'ShopTokens';
  clubhouseCode: Scalars['String'];
  clubhouseName: Scalars['String'];
  kgat: Scalars['String'];
  kgrt: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
};

export type ShopsTokens = {
  __typename?: 'ShopsTokens';
  expires: Scalars['String'];
  shops?: Maybe<Scalars['JSON']>;
  ud?: Maybe<Scalars['DateTime']>;
};

export type ShotCoordinate = {
  __typename?: 'ShotCoordinate';
  endCoordinates?: Maybe<EndCoordinates>;
  gameRoundShotId?: Maybe<Scalars['Int']>;
  shotNumber?: Maybe<Scalars['Int']>;
  startCoordinates?: Maybe<StartCoordinates>;
};

export type SlotItem = {
  __typename?: 'SlotItem';
  bays: Array<Maybe<FacilityAvailability>>;
  puttings: Array<Maybe<FacilityAvailability>>;
  rooms: Array<Maybe<FacilityAvailability>>;
  studios: Array<Maybe<FacilityAvailability>>;
};

export type StartCoordinates = {
  __typename?: 'StartCoordinates';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export enum StringBoolean {
  False = 'FALSE',
  True = 'TRUE'
}

export type Subscription = {
  __typename?: 'Subscription';
  devManagementSystemUserTelemetry?: Maybe<DevManagementSystemUserTelemetry>;
  managementSystem?: Maybe<ManagementSystem>;
  memberApp?: Maybe<MemberApp>;
  memberLoginQR?: Maybe<MemberLoginQr>;
};


export type SubscriptionManagementSystemArgs = {
  args: ManagementSystemArgs;
};


export type SubscriptionMemberAppArgs = {
  args: MemberAppArgs;
};


export type SubscriptionMemberLoginQrArgs = {
  args: MemberLoginQrArgs;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Na = 'NA',
  Paused = 'PAUSED',
  Pending = 'PENDING'
}

export enum SupportTicketCategory {
  BugFix = 'BUG_FIX',
  EnhanceFeature = 'ENHANCE_FEATURE',
  NewFeature = 'NEW_FEATURE',
  Other = 'OTHER',
  Permission = 'PERMISSION'
}

export enum SupportTicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL'
}

export enum SupportTicketStatus {
  AwaitingApproval = 'AWAITING_APPROVAL',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Queued = 'QUEUED'
}

export enum SystemAuditLogEventName {
  AcecoinPurchase = 'ACECOIN_PURCHASE',
  AcecoinTxnDelete = 'ACECOIN_TXN_DELETE',
  AdminLogin = 'ADMIN_LOGIN',
  BlackoutCreate = 'BLACKOUT_CREATE',
  CronJob = 'CRON_JOB',
  DataExport = 'DATA_EXPORT',
  MembershipDelete = 'MEMBERSHIP_DELETE',
  PackagePause = 'PACKAGE_PAUSE',
  PackageResume = 'PACKAGE_RESUME',
  ServiceTxnDelete = 'SERVICE_TXN_DELETE',
  TierDowngrade = 'TIER_DOWNGRADE',
  TierUpgrade = 'TIER_UPGRADE',
  UiReportingClearCache = 'UI_REPORTING_CLEAR_CACHE'
}

export enum SystemOperationStatus {
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  AdminNotFound = 'ADMIN_NOT_FOUND',
  BadRequestException = 'BAD_REQUEST_EXCEPTION',
  BookingNotAllowed = 'BOOKING_NOT_ALLOWED',
  BookingOverlapped = 'BOOKING_OVERLAPPED',
  CannotFindSelf = 'CANNOT_FIND_SELF',
  Fail = 'FAIL',
  IncorrectExistingPassword = 'INCORRECT_EXISTING_PASSWORD',
  InsufficientCredit = 'INSUFFICIENT_CREDIT',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  MemberNotFoundPasswordReset = 'MEMBER_NOT_FOUND_PASSWORD_RESET',
  NoRefreshToken = 'NO_REFRESH_TOKEN',
  PasswordMismatch = 'PASSWORD_MISMATCH',
  ResourceNotAvailable = 'RESOURCE_NOT_AVAILABLE',
  Success = 'SUCCESS',
  SuccessPasswordUpdate = 'SUCCESS_PASSWORD_UPDATE',
  TokenExpired = 'TOKEN_EXPIRED',
  TokenInvalid = 'TOKEN_INVALID',
  UnableToUpdate = 'UNABLE_TO_UPDATE',
  Unauthorized = 'UNAUTHORIZED',
  UniqueConstraintEmail = 'UNIQUE_CONSTRAINT_EMAIL',
  UniqueConstraintViolation = 'UNIQUE_CONSTRAINT_VIOLATION',
  VerificationCodeMismatch = 'VERIFICATION_CODE_MISMATCH',
  VersionMismatch = 'VERSION_MISMATCH'
}

export type SystemUser = {
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins?: Maybe<Array<Maybe<LoginInfo>>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export enum Time {
  Month_2 = 'MONTH_2',
  Month_3 = 'MONTH_3',
  Month_4 = 'MONTH_4',
  Week_1 = 'WEEK_1',
  Week_2 = 'WEEK_2',
  Week_3 = 'WEEK_3',
  Week_4 = 'WEEK_4'
}

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type UpdatedAdmin = {
  __typename?: 'UpdatedAdmin';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  user: Admin;
};

export type UpdatedCoach = {
  __typename?: 'UpdatedCoach';
  coach: AdminCoach;
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
};

export enum UserTelemetryResourceType {
  Booking = 'BOOKING',
  Clubhouse = 'CLUBHOUSE',
  Coach = 'COACH',
  Member = 'MEMBER',
  MyAccount = 'MY_ACCOUNT',
  NotificationMessage = 'NOTIFICATION_MESSAGE',
  Order = 'ORDER',
  OrderAtn = 'ORDER_ATN',
  Organization = 'ORGANIZATION',
  Settings = 'SETTINGS',
  Staff = 'STAFF',
  SystemUser = 'SYSTEM_USER'
}

export enum UserType {
  ClubhouseStaff = 'CLUBHOUSE_STAFF',
  Developer = 'DEVELOPER',
  DeveloperAdmin = 'DEVELOPER_ADMIN',
  ExternalCoach = 'EXTERNAL_COACH',
  MasterCoach = 'MASTER_COACH',
  MasterOwner = 'MASTER_OWNER',
  MasterUser = 'MASTER_USER',
  Owner = 'OWNER',
  User = 'USER'
}

export type WebsiteJuniorGolfProgram = {
  __typename?: 'WebsiteJuniorGolfProgram';
  currencySymbol: Scalars['String'];
  rates: Array<Maybe<WebsiteJuniorGolfProgramRates>>;
};

export type WebsiteJuniorGolfProgramRates = {
  __typename?: 'WebsiteJuniorGolfProgramRates';
  displayName: Scalars['String'];
  period: Scalars['String'];
  rate: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type WebsiteRates = {
  __typename?: 'WebsiteRates';
  currencySymbol: Scalars['String'];
  games: Array<WebsiteRatesGame>;
  lesson?: Maybe<WebsiteRatesLesson>;
  practice?: Maybe<WebsiteRatesPractice>;
};

export type WebsiteRatesGame = {
  __typename?: 'WebsiteRatesGame';
  rateBay: Scalars['Float'];
  rateBayVip: Scalars['Float'];
  rateRoom: Scalars['Float'];
  rateRoomVip: Scalars['Float'];
  title: Scalars['String'];
  unit: Scalars['String'];
};

export type WebsiteRatesLesson = {
  __typename?: 'WebsiteRatesLesson';
  field: WebsiteRatesLessonField;
  junior: Array<WebsiteRatesLessonJunior>;
  lesson: Array<WebsiteRatesLessonLesson>;
};

export type WebsiteRatesLessonField = {
  __typename?: 'WebsiteRatesLessonField';
  indoor9Hole: WebsiteRatesLessonFieldIndoor9Hole;
  indoor18Hole: WebsiteRatesLessonFieldIndoor18Hole;
  outdoor: WebsiteRatesLessonFieldOutdoor;
};

export type WebsiteRatesLessonFieldIndoor9Hole = {
  __typename?: 'WebsiteRatesLessonFieldIndoor9Hole';
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type WebsiteRatesLessonFieldIndoor18Hole = {
  __typename?: 'WebsiteRatesLessonFieldIndoor18Hole';
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type WebsiteRatesLessonFieldOutdoor = {
  __typename?: 'WebsiteRatesLessonFieldOutdoor';
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type WebsiteRatesLessonJunior = {
  __typename?: 'WebsiteRatesLessonJunior';
  displayName: Scalars['String'];
  period: Scalars['String'];
  rate: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type WebsiteRatesLessonLesson = {
  __typename?: 'WebsiteRatesLessonLesson';
  displayName: Scalars['String'];
  period: Scalars['String'];
  rateGroup: Scalars['Float'];
  rateIndividual: Scalars['Float'];
  rateIndividualVip: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type WebsiteRatesPractice = {
  __typename?: 'WebsiteRatesPractice';
  elite: Array<WebsiteRatesPracticeElite>;
  normal: Array<WebsiteRatesPracticeNormal>;
  premium: Array<WebsiteRatesPracticePremium>;
};

export type WebsiteRatesPracticeElite = {
  __typename?: 'WebsiteRatesPracticeElite';
  categoryListOrder?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  isEarlyBird: Scalars['Boolean'];
  limit: Scalars['String'];
  period: Scalars['String'];
  rate: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type WebsiteRatesPracticeNormal = {
  __typename?: 'WebsiteRatesPracticeNormal';
  facilityType: FacilityType;
  rate: Scalars['Float'];
  rateVip: Scalars['Float'];
  title: Scalars['String'];
};

export type WebsiteRatesPracticePremium = {
  __typename?: 'WebsiteRatesPracticePremium';
  categoryListOrder?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  isEarlyBird: Scalars['Boolean'];
  period: Scalars['String'];
  rate: Scalars['Float'];
  tc: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type AdminAdminUpdatePasswordMutationVariables = Exact<{
  input: AdminAdminUpdatePasswordInput;
}>;


export type AdminAdminUpdatePasswordMutation = { __typename?: 'Mutation', adminAdminUpdatePassword: SystemOperationStatus };

export type AdminCreateAdminMutationVariables = Exact<{
  input: AdminCreateAdminInput;
}>;


export type AdminCreateAdminMutation = { __typename?: 'Mutation', adminCreateAdmin: { __typename?: 'NewAdmin', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, user: { __typename?: 'Admin', authorizedClubhouses?: Array<string | null> | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, permissions: Array<string | null>, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string } } };

export type AdminDeleteAdminMutationVariables = Exact<{
  input?: InputMaybe<AdminDeleteAdminInput>;
}>;


export type AdminDeleteAdminMutation = { __typename?: 'Mutation', adminDeleteAdmin: SystemOperationStatus };

export type AdminUpdateAdminMutationVariables = Exact<{
  args: AdminUpdateAdminArgs;
  input: AdminUpdateAdminInput;
}>;


export type AdminUpdateAdminMutation = { __typename?: 'Mutation', adminUpdateAdmin: { __typename?: 'UpdatedAdmin', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, user: { __typename?: 'Admin', authorizedClubhouses?: Array<string | null> | null, baseCountryCode?: CountryCode | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, permissions: Array<string | null>, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins?: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> | null, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } } };

export type AdminResendOnboardingEmailMutationVariables = Exact<{
  input: AdminResendOnboardingEmailInput;
}>;


export type AdminResendOnboardingEmailMutation = { __typename?: 'Mutation', adminResendOnboardingEmail: SystemOperationStatus };

export type FormHelperNewAdminQueryVariables = Exact<{
  args: FormHelperNewAdminArgs;
}>;


export type FormHelperNewAdminQuery = { __typename?: 'Query', formHelperNewAdmin?: { __typename?: 'FormHelperNewAdmin', clubhouses: Array<{ __typename?: 'AdminClubhouseBasic', clubhouseCode: string, clubhouseId: string, name: string } | null> } | null };

export type AdminsQueryVariables = Exact<{
  args: AdminsArgs;
}>;


export type AdminsQuery = { __typename?: 'Query', admins: { __typename?: 'AdminResponse', edges?: Array<{ __typename?: 'AdminEdge', cursor?: string | null, node?: { __typename?: 'AdminBasic', baseCountryCode?: CountryCode | null, createdAt?: any | null, firstName: string, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string, userName: string, userType?: UserType | null, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminQueryVariables = Exact<{
  args: AdminArgs;
}>;


export type AdminQuery = { __typename?: 'Query', admin?: { __typename?: 'Admin', authorizedClubhouses?: Array<string | null> | null, baseCountryCode?: CountryCode | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, permissions: Array<string | null>, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins?: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> | null, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null };

export type AdminBookingCancelMutationVariables = Exact<{
  input: AdminBookingCancelInput;
}>;


export type AdminBookingCancelMutation = { __typename?: 'Mutation', adminBookingCancel: SystemOperationStatus };

export type AdminBookingSendCancellationNotificationMutationVariables = Exact<{
  input: AdminBookingSendCancellationNotificationInput;
}>;


export type AdminBookingSendCancellationNotificationMutation = { __typename?: 'Mutation', adminBookingSendCancellationNotification: SystemOperationStatus };

export type AdminBookingGameCreateMutationVariables = Exact<{
  input: AdminBookingGameCreateInput;
}>;


export type AdminBookingGameCreateMutation = { __typename?: 'Mutation', adminBookingGameCreate: { __typename?: 'AdminBookingGameCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingLessonIndoorCreateMutationVariables = Exact<{
  input: AdminBookingLessonIndoorCreateInput;
}>;


export type AdminBookingLessonIndoorCreateMutation = { __typename?: 'Mutation', adminBookingLessonIndoorCreate: { __typename?: 'AdminBookingLessonIndoorCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingLessonOutdoorCreateMutationVariables = Exact<{
  input: AdminBookingLessonOutdoorCreateInput;
}>;


export type AdminBookingLessonOutdoorCreateMutation = { __typename?: 'Mutation', adminBookingLessonOutdoorCreate: { __typename?: 'AdminBookingLessonOutdoorCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingPractiseCreateMutationVariables = Exact<{
  input: AdminBookingPractiseCreateInput;
}>;


export type AdminBookingPractiseCreateMutation = { __typename?: 'Mutation', adminBookingPractiseCreate: { __typename?: 'AdminBookingPractiseCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingBlackoutCreateMutationVariables = Exact<{
  input: AdminBookingBlackoutCreateInput;
}>;


export type AdminBookingBlackoutCreateMutation = { __typename?: 'Mutation', adminBookingBlackoutCreate: { __typename?: 'AdminBookingBlackoutCreate', errorMessage: string, isCreateAllowed: boolean } };

export type AdminBookingBlackoutClubhouseUpdateMutationVariables = Exact<{
  input: AdminBookingBlackoutClubhouseUpdateInput;
}>;


export type AdminBookingBlackoutClubhouseUpdateMutation = { __typename?: 'Mutation', adminBookingBlackoutClubhouseUpdate: { __typename?: 'AdminBookingBlackoutClubhouse', block08: boolean, block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, block21: boolean, block22: boolean, block23: boolean, clubhouseCode?: string | null, date: string, isDayBlocked: boolean, name: string, facilityObjs: Array<{ __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj', facilityCode: string, facilityName: string, facilityType: FacilityType, availability: { __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability', bi0800?: string | null, bi0830?: string | null, bi0900?: string | null, bi0930?: string | null, bi1000?: string | null, bi1030?: string | null, bi1100?: string | null, bi1130?: string | null, bi1200?: string | null, bi1230?: string | null, bi1300?: string | null, bi1330?: string | null, bi1400?: string | null, bi1430?: string | null, bi1500?: string | null, bi1530?: string | null, bi1600?: string | null, bi1630?: string | null, bi1700?: string | null, bi1730?: string | null, bi1800?: string | null, bi1830?: string | null, bi1900?: string | null, bi1930?: string | null, bi2000?: string | null, bi2030?: string | null, bi2100?: string | null, bi2130?: string | null, bi2200?: string | null, bi2230?: string | null, bi2300?: string | null, bi2330?: string | null } } | null> } };

export type AdminBookingBlackoutCoachUpdateMutationVariables = Exact<{
  input: AdminBookingBlackoutCoachUpdateInput;
}>;


export type AdminBookingBlackoutCoachUpdateMutation = { __typename?: 'Mutation', adminBookingBlackoutCoachUpdate: { __typename?: 'AdminBookingBlackoutCoach', block08: boolean, block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, block21: boolean, coachDisplayName: string, coachSlug: string, date: string, isDayBlocked: boolean } };

export type AdminBookingBlackoutDeleteMutationVariables = Exact<{
  input: AdminBookingBlackoutDeleteInput;
}>;


export type AdminBookingBlackoutDeleteMutation = { __typename?: 'Mutation', adminBookingBlackoutDelete: SystemOperationStatus };

export type AdminBookingUpdateMutationVariables = Exact<{
  input: AdminBookingUpdateInput;
}>;


export type AdminBookingUpdateMutation = { __typename?: 'Mutation', adminBookingUpdate: SystemOperationStatus };

export type AdminBookingUpdateToGroupMutationVariables = Exact<{
  input: AdminBookingUpdateToGroupInput;
}>;


export type AdminBookingUpdateToGroupMutation = { __typename?: 'Mutation', adminBookingUpdateToGroup: SystemOperationStatus };

export type AdminBookingBookingFacilityUpdateMutationVariables = Exact<{
  input: AdminBookingBookingFacilityUpdateInput;
}>;


export type AdminBookingBookingFacilityUpdateMutation = { __typename?: 'Mutation', adminBookingBookingFacilityUpdate: SystemOperationStatus };

export type AdminBookingOptionalPlayerNameUpdateMutationVariables = Exact<{
  input: AdminBookingOptionalPlayerNameUpdateInput;
}>;


export type AdminBookingOptionalPlayerNameUpdateMutation = { __typename?: 'Mutation', adminBookingOptionalPlayerNameUpdate: SystemOperationStatus };

export type CoachBookingCommentUpdateMutationVariables = Exact<{
  input: CoachBookingCommentUpdateInput;
}>;


export type CoachBookingCommentUpdateMutation = { __typename?: 'Mutation', coachBookingCommentUpdate: { __typename?: 'CoachBookingCommentUpdate', commentByCoach?: string | null } };

export type AdminBookingCoachesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminBookingCoachesQuery = { __typename?: 'Query', adminBookingCoaches: Array<{ __typename?: 'AdminBookingCoach', baseCountryCode?: CountryCode | null, coachPublished?: boolean | null, displayName?: string | null, profileImageUrl?: string | null, slug?: string | null, userId?: string | null } | null> };

export type AdminBookingCoachesBasicQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminBookingCoachesBasicQuery = { __typename?: 'Query', adminBookingCoaches: Array<{ __typename?: 'AdminBookingCoach', displayName?: string | null, userId?: string | null } | null> };

export type AdminBookingCoachAvailabilityCalendarItemsQueryVariables = Exact<{
  args: AdminBookingCoachAvailabilityCalendarItemsArgs;
}>;


export type AdminBookingCoachAvailabilityCalendarItemsQuery = { __typename?: 'Query', adminBookingCoachAvailabilityCalendarItems?: { __typename?: 'AdminBookingCoachAvailabilityCalendarItems', calendarItems: Array<{ __typename?: 'CoachAvailabilityCalendarItems', clubhouses: Array<string | null>, date: string, hasIndoorBooking?: boolean | null, hasOutdoorBooking?: boolean | null, isBlocked?: boolean | null, isIndoorBookingFull?: boolean | null } | null>, clubhouses: Array<{ __typename?: 'CoachClubhouse', clubhouseCode: string, displayName: string, tagBgColorCode: string, tagText: string, tagTextColorCode: string } | null> } | null };

export type AdminBookingCoachAvailabilityDayItemQueryVariables = Exact<{
  args: AdminBookingCoachAvailabilityDayItemArgs;
}>;


export type AdminBookingCoachAvailabilityDayItemQuery = { __typename?: 'Query', adminBookingCoachAvailabilityDayItem?: { __typename?: 'AdminBookingCoachAvailabilityDayItem', bi0800?: string | null, bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, bi2100?: string | null, blockedClubhousesDay: Array<string | null>, blockedClubhousesHours: Array<string | null>, bs0800?: string | null, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, bs2100?: string | null, date?: string | null, l0800?: string | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null, l2100?: string | null } | null };

export type AdminBookingCoachAvailabilitySlotItemQueryVariables = Exact<{
  args: AdminBookingCoachAvailabilitySlotItemArgs;
}>;


export type AdminBookingCoachAvailabilitySlotItemQuery = { __typename?: 'Query', adminBookingCoachAvailabilitySlotItem?: { __typename?: 'AdminBookingCoachAvailabilitySlotItem', hr1?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr2?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null } | null };

export type AdminBookingFacilityAvailabilityDayItemQueryVariables = Exact<{
  args: AdminBookingFacilityAvailabilityDayItemArgs;
}>;


export type AdminBookingFacilityAvailabilityDayItemQuery = { __typename?: 'Query', adminBookingFacilityAvailabilityDayItem?: { __typename?: 'AdminBookingFacilityAvailabilityDayItem', nonPutting?: { __typename?: 'NonPuttingFacilityDayItem', na0800?: boolean | null, na0900?: boolean | null, na1000?: boolean | null, na1100?: boolean | null, na1200?: boolean | null, na1300?: boolean | null, na1400?: boolean | null, na1500?: boolean | null, na1600?: boolean | null, na1700?: boolean | null, na1800?: boolean | null, na1900?: boolean | null, na2000?: boolean | null, na2100?: boolean | null, na2200?: boolean | null, na2300?: boolean | null } | null, putting?: { __typename?: 'PuttingFacilityDayItem', na0800?: boolean | null, na0830?: boolean | null, na0900?: boolean | null, na0930?: boolean | null, na1000?: boolean | null, na1030?: boolean | null, na1100?: boolean | null, na1130?: boolean | null, na1200?: boolean | null, na1230?: boolean | null, na1300?: boolean | null, na1330?: boolean | null, na1400?: boolean | null, na1430?: boolean | null, na1500?: boolean | null, na1530?: boolean | null, na1600?: boolean | null, na1630?: boolean | null, na1700?: boolean | null, na1730?: boolean | null, na1800?: boolean | null, na1830?: boolean | null, na1900?: boolean | null, na1930?: boolean | null, na2000?: boolean | null, na2030?: boolean | null, na2100?: boolean | null, na2130?: boolean | null, na2200?: boolean | null, na2230?: boolean | null, na2300?: boolean | null, na2330?: boolean | null } | null } | null };

export type AdminBookingFacilityAvailabilitySlotItemQueryVariables = Exact<{
  args: AdminBookingFacilityAvailabilitySlotItemArgs;
}>;


export type AdminBookingFacilityAvailabilitySlotItemQuery = { __typename?: 'Query', adminBookingFacilityAvailabilitySlotItem?: { __typename?: 'AdminBookingFacilityAvailabilitySlotItem', hr1?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr2?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr3?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr4?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr5?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, putting30?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, putting60?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null } | null };

export type AdminBookingFacilityAvailabilityCalendarItemsQueryVariables = Exact<{
  args: AdminBookingFacilityAvailabilityCalendarItemsArgs;
}>;


export type AdminBookingFacilityAvailabilityCalendarItemsQuery = { __typename?: 'Query', adminBookingFacilityAvailabilityCalendarItems?: { __typename?: 'AdminBookingFacilityAvailabilityCalendarItems', calendarItems: Array<{ __typename?: 'FacilityAvailabilityCalendarItems', date: string, isBlocked?: boolean | null } | null> } | null };

export type AdminCoachCombinedAvailabilityQueryVariables = Exact<{
  args: AdminCoachCombinedAvailabilityArgs;
}>;


export type AdminCoachCombinedAvailabilityQuery = { __typename?: 'Query', adminCoachCombinedAvailability: Array<{ __typename?: 'AdminCoachCombinedAvailability', coachId: string, coachSlug: string, name: string, dateObjs: Array<{ __typename?: 'AdminCoachCombinedAvailabilityDateObj', clubhouses: Array<string | null>, date: string, hasIndoorBooking: boolean, hasOutdoorBooking: boolean, isDayBlocked: boolean } | null> } | null> };

export type AdminClubhouseFacilityAvailabilityQueryVariables = Exact<{
  args: AdminClubhouseFacilityAvailabilityArgs;
}>;


export type AdminClubhouseFacilityAvailabilityQuery = { __typename?: 'Query', adminClubhouseFacilityAvailability: { __typename?: 'AdminClubhouseFacilityAvailability', clubhouseCode: string, date: string, isDayBlocked: boolean, name: string, facilityObjs: Array<{ __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj', facilityCode: string, facilityName: string, facilityType: FacilityType, availability: { __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability', bi0800?: string | null, bi0830?: string | null, bi0900?: string | null, bi0930?: string | null, bi1000?: string | null, bi1030?: string | null, bi1100?: string | null, bi1130?: string | null, bi1200?: string | null, bi1230?: string | null, bi1300?: string | null, bi1330?: string | null, bi1400?: string | null, bi1430?: string | null, bi1500?: string | null, bi1530?: string | null, bi1600?: string | null, bi1630?: string | null, bi1700?: string | null, bi1730?: string | null, bi1800?: string | null, bi1830?: string | null, bi1900?: string | null, bi1930?: string | null, bi2000?: string | null, bi2030?: string | null, bi2100?: string | null, bi2130?: string | null, bi2200?: string | null, bi2230?: string | null, bi2300?: string | null, bi2330?: string | null } } | null> } };

export type AdminBookingBlackoutClubhouseQueryVariables = Exact<{
  args: AdminBookingBlackoutClubhouseArgs;
}>;


export type AdminBookingBlackoutClubhouseQuery = { __typename?: 'Query', adminBookingBlackoutClubhouse: { __typename?: 'AdminBookingBlackoutClubhouse', block08: boolean, block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, block21: boolean, block22: boolean, block23: boolean, clubhouseCode?: string | null, date: string, isDayBlocked: boolean, name: string, facilityObjs: Array<{ __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj', facilityCode: string, facilityName: string, facilityType: FacilityType, availability: { __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability', bi0800?: string | null, bi0830?: string | null, bi0900?: string | null, bi0930?: string | null, bi1000?: string | null, bi1030?: string | null, bi1100?: string | null, bi1130?: string | null, bi1200?: string | null, bi1230?: string | null, bi1300?: string | null, bi1330?: string | null, bi1400?: string | null, bi1430?: string | null, bi1500?: string | null, bi1530?: string | null, bi1600?: string | null, bi1630?: string | null, bi1700?: string | null, bi1730?: string | null, bi1800?: string | null, bi1830?: string | null, bi1900?: string | null, bi1930?: string | null, bi2000?: string | null, bi2030?: string | null, bi2100?: string | null, bi2130?: string | null, bi2200?: string | null, bi2230?: string | null, bi2300?: string | null, bi2330?: string | null } } | null> } };

export type AdminBookingBlackoutCoachQueryVariables = Exact<{
  args: AdminBookingBlackoutCoachArgs;
}>;


export type AdminBookingBlackoutCoachQuery = { __typename?: 'Query', adminBookingBlackoutCoach: { __typename?: 'AdminBookingBlackoutCoach', block08: boolean, block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, block21: boolean, coachDisplayName: string, coachSlug: string, date: string, isDayBlocked: boolean } };

export type AdminBookingBlackoutsQueryVariables = Exact<{
  args: AdminBookingBlackoutsArgs;
}>;


export type AdminBookingBlackoutsQuery = { __typename?: 'Query', adminBookingBlackouts: Array<{ __typename?: 'AdminBookingBlackoutBasic', clubhouseCode?: string | null, clubhouseName?: string | null, coachDisplayName?: string | null, coachSlug?: string | null, countryCode?: CountryCode | null, date: string, type: string } | null> };

export type AdminBookingCombinedCoachAvailabilityDayItemQueryVariables = Exact<{
  args: AdminBookingCombinedCoachAvailabilityDayItemArgs;
}>;


export type AdminBookingCombinedCoachAvailabilityDayItemQuery = { __typename?: 'Query', adminBookingCombinedCoachAvailabilityDayItem?: { __typename?: 'AdminBookingCombinedCoachAvailabilityDayItem', bi0800?: string | null, bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, bi2100?: string | null, biOutdoor?: string | null, bs0800?: string | null, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, bs2100?: string | null, date?: string | null, displayName?: string | null, hasOutdoorBooking?: boolean | null, l0800?: string | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null, l2100?: string | null, clubhouses: Array<{ __typename?: 'CoachClubhouse', clubhouseCode: string, displayName: string, tagBgColorCode: string, tagText: string, tagTextColorCode: string } | null> } | null };

export type FormHelperBookingQueryVariables = Exact<{
  args: FormHelperBookingArgs;
}>;


export type FormHelperBookingQuery = { __typename?: 'Query', formHelperBooking?: { __typename?: 'FormHelperBooking', clubhouses: Array<{ __typename?: 'AdminClubhouseBasic', clubhouseCode: string, clubhouseId: string, name: string } | null> } | null };

export type FormHelperNewBlackOutQueryVariables = Exact<{
  args?: InputMaybe<FormHelperNewBlackOutArgs>;
}>;


export type FormHelperNewBlackOutQuery = { __typename?: 'Query', formHelperNewBlackOut?: { __typename?: 'FormHelperNewBlackOut', clubhouseCode?: string | null, date: string, errorMessage?: string | null, isCreateAllowed: boolean, facilities: Array<{ __typename?: 'FacilityBasic', facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null };

export type AdminBookingAvailabilityQueryVariables = Exact<{
  args: AdminBookingAvailabilityArgs;
}>;


export type AdminBookingAvailabilityQuery = { __typename?: 'Query', adminBookingAvailability: string };

export type AdminBookingQueryVariables = Exact<{
  args: AdminBookingArgs;
}>;


export type AdminBookingQuery = { __typename?: 'Query', adminBooking?: { __typename?: 'AdminBooking', cancellationDateTime?: any | null, cancellationNotificationByAppSent?: boolean | null, cancellationNotificationByEmailSent?: boolean | null, cancellationNotificationBySmsSent?: boolean | null, cancellationNotificationMessage?: string | null, cancellationNotificationSentByAdminName?: string | null, cancellationNotificationSentDateTime?: any | null, cancellationReason?: string | null, cancelledBy?: CancelledBy | null, cancelledByAdminName?: string | null, clubhouseCode?: string | null, coachDateId?: string | null, coachId?: string | null, coachName?: string | null, commentAdminToCoach?: string | null, commentAdminToMember?: string | null, commentByCoach?: string | null, commentByCoachId?: string | null, commentInternal?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminName?: string | null, date: any, dateMonthStr?: string | null, dateStr?: string | null, dayOfWeekStr?: string | null, duration?: number | null, durationStr?: string | null, endTime: any, endTimeStr?: string | null, facilityType?: FacilityType | null, fieldLessonDetails?: string | null, gameCourseType?: GameCourseType | null, groupBookingId?: string | null, id: string, isGroupBooking: boolean, lateCancellationDetails?: any | null, member: string, memberHasGroupMembers: boolean, memberIndividualId: string, membershipUuid: string, memberUuid: string, mobileNumber?: string | null, noOfPlayers: number, playerName?: string | null, resourceName?: string | null, startTime: any, startTimeStr?: string | null, status: BookingStatus, type: BookingType, venue?: string | null, yearStr?: string | null, groupMembers?: Array<{ __typename?: 'GroupMember', bookingId: string, individualId: string, memberUuid: string, mobileNumber?: string | null, name: string, playerName?: string | null } | null> | null } | null };

export type AdminBookingBasicQueryVariables = Exact<{
  args: AdminBookingArgs;
}>;


export type AdminBookingBasicQuery = { __typename?: 'Query', adminBooking?: { __typename?: 'AdminBooking', dateMonthStr?: string | null, dayOfWeekStr?: string | null, durationStr?: string | null, endTimeStr?: string | null, facilityType?: FacilityType | null, id: string, member: string, memberIndividualId: string, resourceName?: string | null, startTimeStr?: string | null, venue?: string | null, yearStr?: string | null } | null };

export type AdminBookingsQueryVariables = Exact<{
  args: AdminBookingsArgs;
}>;


export type AdminBookingsQuery = { __typename?: 'Query', adminBookings: { __typename?: 'AdminBookingResponse', firstBookingDate?: any | null, lastBookingDate?: any | null, edges?: Array<{ __typename?: 'AdminBookingEdge', cursor?: string | null, node?: { __typename?: 'AdminBookingBasic', cancellationDateTime?: any | null, coachDisplayName?: string | null, date: any, dateMonthStr?: string | null, dayOfWeekStr?: string | null, durationStr?: string | null, endTime: any, endTimeStr?: string | null, gameCourseType?: GameCourseType | null, groupBookingId?: string | null, groupBookingIds: Array<string | null>, id: string, isGroupBooking: boolean, lateCancellationDetails?: any | null, member: string, memberUuid: string, playerName?: string | null, resourceName?: string | null, startTime: any, startTimeStr?: string | null, status: BookingStatus, type: BookingType, venue?: string | null, yearStr?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminBookingGameCheckoutQueryVariables = Exact<{
  args: AdminBookingGameCheckoutArgs;
}>;


export type AdminBookingGameCheckoutQuery = { __typename?: 'Query', adminBookingGameCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingLessonIndoorCheckoutQueryVariables = Exact<{
  args: AdminBookingLessonIndoorCheckoutArgs;
}>;


export type AdminBookingLessonIndoorCheckoutQuery = { __typename?: 'Query', adminBookingLessonIndoorCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingLessonOutdoorCheckoutQueryVariables = Exact<{
  args: AdminBookingLessonOutdoorCheckoutArgs;
}>;


export type AdminBookingLessonOutdoorCheckoutQuery = { __typename?: 'Query', adminBookingLessonOutdoorCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingPractiseCheckoutQueryVariables = Exact<{
  args: AdminBookingPractiseCheckoutArgs;
}>;


export type AdminBookingPractiseCheckoutQuery = { __typename?: 'Query', adminBookingPractiseCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingSettingsQueryVariables = Exact<{
  args: AdminBookingSettingsArgs;
}>;


export type AdminBookingSettingsQuery = { __typename?: 'Query', adminBookingSettings: { __typename?: 'AdminBookingSettings', cancellationConditions: { __typename?: 'CancellationConditions', GAME: number, LESSON_FIELD: number, LESSON_INDOOR: number, LESSON_OUTDOOR: number, PRACTISE: number } } };

export type AdminBookingGroupMembersQueryVariables = Exact<{
  args: AdminBookingGroupMembersArgs;
}>;


export type AdminBookingGroupMembersQuery = { __typename?: 'Query', adminBookingGroupMembers: { __typename?: 'AdminBookingGroupMembers', members: Array<{ __typename?: 'AdminBookingGroupMember', individualId: string, memberName: string, memberUuid: string, selfPackageId: string, selfPackageName: string } | null> } };

export type AdminGroupBookingsQueryVariables = Exact<{
  args: AdminGroupBookingsArgs;
}>;


export type AdminGroupBookingsQuery = { __typename?: 'Query', adminGroupBookings: Array<{ __typename?: 'AdminGroupBooking', clubhouseCode?: string | null, coachName?: string | null, commentAdminToCoach?: string | null, commentAdminToMember?: string | null, commentInternal?: string | null, dateMonthStr?: string | null, dateStr?: string | null, dayOfWeekStr?: string | null, durationStr?: string | null, endTimeStr: string, facilityMode?: string | null, facilityStartTime?: string | null, facilityType?: FacilityType | null, fieldLessonDetails?: string | null, gameCourseType?: GameCourseType | null, id: string, member: string, memberIndividualId: string, mobileNumber: string, noOfPlayers: number, resourceName?: string | null, startTimeStr?: string | null, status?: BookingStatus | null, type: BookingType, venue?: string | null, yearStr?: string | null }> };

export type AdminStaffsQueryVariables = Exact<{
  args?: InputMaybe<AdminStaffsArgs>;
}>;


export type AdminStaffsQuery = { __typename?: 'Query', adminStaffs: { __typename?: 'AdminStaffResponse', edges?: Array<{ __typename?: 'AdminStaffEdge', cursor?: string | null, node?: { __typename?: 'AdminStaffBasic', baseCountryCode?: CountryCode | null, createdAt?: any | null, firstName: string, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string, userName: string, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminClientSetupMutationVariables = Exact<{
  input: AdminClientSetupInput;
}>;


export type AdminClientSetupMutation = { __typename?: 'Mutation', adminClientSetup: SystemOperationStatus };

export type AdminUpdateFacilityMutationVariables = Exact<{
  input: AdminUpdateFacilityInput;
}>;


export type AdminUpdateFacilityMutation = { __typename?: 'Mutation', adminUpdateFacility: SystemOperationStatus };

export type AdminClubhousesQueryVariables = Exact<{
  args: AdminClubhousesArgs;
}>;


export type AdminClubhousesQuery = { __typename?: 'Query', adminClubhouses: { __typename?: 'AdminClubhouseResponse', edges?: Array<{ __typename?: 'AdminClubhouseEdge', cursor?: string | null, node?: { __typename?: 'AdminClubhouseBasic', addressCountryIso?: CountryCode | null, clubhouseCode: string, clubhouseId: string, name: string } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminClubhouseQueryVariables = Exact<{
  args: AdminClubhouseArgs;
}>;


export type AdminClubhouseQuery = { __typename?: 'Query', adminClubhouse: { __typename?: 'AdminClubhouse', addressCity?: string | null, addressCountry?: string | null, addressCountryIso?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, clubhouseCode?: string | null, clubhouseId: string, colorCode?: string | null, createdAt?: any | null, email?: string | null, kGolfClientId?: string | null, kGolfClientSecret?: string | null, kGolfPassword?: string | null, kGolfShopGuid?: string | null, kGolfUsername?: string | null, name: string, noOfPrivateRooms?: number | null, noOfPuttingGreen?: number | null, noOfSimulators?: number | null, organizationId: string, phoneNumber?: string | null, updatedAt?: any | null, organization: { __typename?: 'ClubhouseOrganization', businessName: string, id: string } } };

export type AdminClubhouseFacilitiesQueryVariables = Exact<{
  args: AdminClubhouseFacilitiesArgs;
}>;


export type AdminClubhouseFacilitiesQuery = { __typename?: 'Query', adminClubhouseFacilities: Array<{ __typename?: 'Facility', clientGuid?: string | null, clientName?: string | null, clientOrder?: number | null, facilityCode?: string | null, facilityName?: string | null, facilityType?: FacilityType | null, id?: string | null }> };

export type AdminDeleteCoachMutationVariables = Exact<{
  input?: InputMaybe<AdminDeleteCoachInput>;
}>;


export type AdminDeleteCoachMutation = { __typename?: 'Mutation', adminDeleteCoach: SystemOperationStatus };

export type AdminUpdateCoachBookableMutationVariables = Exact<{
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachBookableInput;
}>;


export type AdminUpdateCoachBookableMutation = { __typename?: 'Mutation', adminUpdateCoachBookable: { __typename?: 'AdminUpdateCoachBookable', isBookable: boolean } };

export type AdminUpdateCoachMutationVariables = Exact<{
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachInput;
}>;


export type AdminUpdateCoachMutation = { __typename?: 'Mutation', adminUpdateCoach: { __typename?: 'UpdatedCoach', coach: { __typename?: 'AdminCoach', baseCountryCode?: CountryCode | null, coachBirthdate?: string | null, coachBirthPlace?: string | null, coachExperiences?: any | null, coachExpertise?: Array<string | null> | null, coachLanguages?: Array<string | null> | null, coachLevel?: CoachLevel | null, coachListOrder?: number | null, coachPGANo?: string | null, coachPGAType?: string | null, coachPGAYear?: string | null, coachPublished?: boolean | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, profileImageUrl?: string | null, slug?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType: UserType, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null>, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null }, fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null } };

export type CoachAvailabilityDayUpsertMutationVariables = Exact<{
  input: CoachAvailabilityDayUpsertInput;
}>;


export type CoachAvailabilityDayUpsertMutation = { __typename?: 'Mutation', coachAvailabilityDayUpsert?: { __typename?: 'CoachAvailabilityDayItem', bi0800?: string | null, bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, bi2100?: string | null, bs0800?: string | null, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, bs2100?: string | null, date?: string | null, l0800?: string | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null, l2100?: string | null } | null };

export type FormHelperNewCoachQueryVariables = Exact<{
  args: FormHelperNewCoachArgs;
}>;


export type FormHelperNewCoachQuery = { __typename?: 'Query', formHelperNewCoach?: { __typename?: 'FormHelperNewCoach', countries: Array<string | null> } | null };

export type AdminCoachQueryVariables = Exact<{
  args: AdminCoachArgs;
}>;


export type AdminCoachQuery = { __typename?: 'Query', adminCoach: { __typename?: 'AdminCoach', baseCountryCode?: CountryCode | null, coachBirthdate?: string | null, coachBirthPlace?: string | null, coachExperiences?: any | null, coachExpertise?: Array<string | null> | null, coachLanguages?: Array<string | null> | null, coachLevel?: CoachLevel | null, coachListOrder?: number | null, coachPGANo?: string | null, coachPGAType?: string | null, coachPGAYear?: string | null, coachPublished?: boolean | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, profileImageUrl?: string | null, slug?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType: UserType, clubhouses?: Array<{ __typename?: 'CoachClubhouse', clubhouseCode: string, displayName: string, tagBgColorCode: string, tagText: string, tagTextColorCode: string } | null> | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null>, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } };

export type AdminCoachesQueryVariables = Exact<{
  args?: InputMaybe<AdminCoachesArgs>;
}>;


export type AdminCoachesQuery = { __typename?: 'Query', adminCoaches: { __typename?: 'AdminCoachResponse', edges?: Array<{ __typename?: 'AdminCoachEdge', cursor?: string | null, node?: { __typename?: 'AdminCoachBasic', baseCountryCode?: CountryCode | null, coachPublished?: boolean | null, createdAt?: any | null, displayName?: string | null, firstName: string, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string, userName: string, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminCoachAvailabilityCalendarItemsQueryVariables = Exact<{
  args?: InputMaybe<AdminCoachAvailabilityCalendarItemsArgs>;
}>;


export type AdminCoachAvailabilityCalendarItemsQuery = { __typename?: 'Query', adminCoachAvailabilityCalendarItems: Array<{ __typename?: 'CoachAvailabilityCalendarItems', clubhouses: Array<string | null>, date: string, hasIndoorBooking?: boolean | null, hasOutdoorBooking?: boolean | null, isBlocked?: boolean | null, isIndoorBookingFull?: boolean | null } | null> };

export type CoachAvailabilityDayItemQueryVariables = Exact<{
  args: CoachAvailabilityDayItemArgs;
}>;


export type CoachAvailabilityDayItemQuery = { __typename?: 'Query', coachAvailabilityDayItem?: { __typename?: 'CoachAvailabilityDayItem', bi0800?: string | null, bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, bi2100?: string | null, biOutdoor?: string | null, bs0800?: string | null, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, bs2100?: string | null, date?: string | null, hasOutdoorBooking?: boolean | null, l0800?: string | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null, l2100?: string | null } | null };

export type AdminLoginMutationVariables = Exact<{
  input: AdminLoginInput;
}>;


export type AdminLoginMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'AdminAuthResponse', accessToken: string, authenticatedAdmin: { __typename?: 'AuthenticatedAdmin', clubhouseCode?: string | null, clubhouses: Array<string | null>, firstName: string, lastLoginDate?: any | null, lastName: string, permissions?: Array<string | null> | null, profileImageUrl: string, ud?: any | null, userId: string, userType: string, yourIp: string, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } } };

export type AdminLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminLogoutMutation = { __typename?: 'Mutation', adminLogout: SystemOperationStatus };

export type AdminRefreshAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminRefreshAccessTokenMutation = { __typename?: 'Mutation', adminRefreshAccessToken: { __typename?: 'AdminAuthResponse', accessToken: string, authenticatedAdmin: { __typename?: 'AuthenticatedAdmin', clubhouseCode?: string | null, clubhouses: Array<string | null>, firstName: string, lastLoginDate?: any | null, lastName: string, permissions?: Array<string | null> | null, profileImageUrl: string, ud?: any | null, userId: string, userType: string, yourIp: string, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } } };

export type AdminForgotPasswordMutationVariables = Exact<{
  input: AdminForgotPasswordInput;
}>;


export type AdminForgotPasswordMutation = { __typename?: 'Mutation', adminForgotPassword: { __typename?: 'AdminForgotPasswordResponse', email: string, resetToken: string } };

export type AdminForgotPasswordSubmitMutationVariables = Exact<{
  input: AdminForgotPasswordSubmitInput;
}>;


export type AdminForgotPasswordSubmitMutation = { __typename?: 'Mutation', adminForgotPasswordSubmit: SystemOperationStatus };

export type AdminShopTokensMutationVariables = Exact<{
  input?: InputMaybe<AdminShopTokensInput>;
}>;


export type AdminShopTokensMutation = { __typename?: 'Mutation', adminShopTokens: { __typename?: 'ShopsTokens', expires: string, shops?: any | null, ud?: any | null } };

export type AdminDeleteMembershipMutationVariables = Exact<{
  input: AdminDeleteMembershipInput;
}>;


export type AdminDeleteMembershipMutation = { __typename?: 'Mutation', adminDeleteMembership: SystemOperationStatus };

export type AdminMemberCreditUpdateMutationVariables = Exact<{
  input?: InputMaybe<AdminMemberCreditUpdateInput>;
}>;


export type AdminMemberCreditUpdateMutation = { __typename?: 'Mutation', adminMemberCreditUpdate: SystemOperationStatus };

export type AdminMemberSendResetPasswordEmailMutationVariables = Exact<{
  input: AdminMemberSendResetPasswordEmailInput;
}>;


export type AdminMemberSendResetPasswordEmailMutation = { __typename?: 'Mutation', adminMemberSendResetPasswordEmail: SystemOperationStatus };

export type AdminMemberProfileUpdateMutationVariables = Exact<{
  input: AdminMemberProfileUpdateInput;
}>;


export type AdminMemberProfileUpdateMutation = { __typename?: 'Mutation', adminMemberProfileUpdate: { __typename?: 'AdminMemberProfileUpdate', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, member: { __typename?: 'AdminMember', accountType?: AccountType | null, activationOrderNo: string, activationPrice: number, addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, birthday?: string | null, companyContactPersonEmail?: string | null, companyContactPersonFirstName?: string | null, companyContactPersonLastName?: string | null, companyName?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, credit: number, creditSpent: number, email: string, firstName: string, gameCredit: number, gender?: Gender | null, handed: Handed, hasGroupMembers: boolean, hasSimulatorPrivilege: boolean, hasSubscriptions: boolean, individualId: string, internalAccountType?: InternalAccountType | null, isSimulatorUseRedeemed: boolean, kGolfAccountCreationError?: boolean | null, lastName: string, locker: boolean, membershipStatus: MembershipStatus, membershipUuid: string, memberStatus: MemberStatus, memberUuid: string, mobileNumber?: string | null, nationality?: string | null, nickname?: string | null, partialNricOrFin?: string | null, practiseCredit: number, profileImageUrl?: string | null, pushTokens: Array<string | null>, relationshipToMainMember?: Relationship | null, serviceNote?: string | null, signUpSidasInsoles: number, startDate?: any | null, voucherField: number, voucherIndoor: number, activationLineItems: Array<{ __typename?: 'AdminMemberActivationLineItem', itemName: string, salesPrice: number } | null>, members: Array<{ __typename?: 'AdminMemberMember', accountType?: AccountType | null, firstName?: string | null, id?: string | null, individualId?: string | null, lastName?: string | null } | null>, membershipType?: { __typename?: 'MembershipTypeBasic', baseCountryCode?: CountryCode | null, internalName?: string | null, isCorporate?: boolean | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null } | null } } };

export type AdminMemberTierUpdateMutationVariables = Exact<{
  input: AdminMemberTierUpdateInput;
}>;


export type AdminMemberTierUpdateMutation = { __typename?: 'Mutation', adminMemberTierUpdate: SystemOperationStatus };

export type AdminUpdateSidasInsolesMutationVariables = Exact<{
  input: AdminUpdateSidasInsolesInput;
}>;


export type AdminUpdateSidasInsolesMutation = { __typename?: 'Mutation', adminUpdateSidasInsoles: SystemOperationStatus };

export type AdminUpdateNicknameMutationVariables = Exact<{
  input: AdminUpdateNicknameInput;
}>;


export type AdminUpdateNicknameMutation = { __typename?: 'Mutation', adminUpdateNickname: SystemOperationStatus };

export type AdminMemberResendOnboardingEmailMutationVariables = Exact<{
  input: AdminMemberResendOnboardingEmailInput;
}>;


export type AdminMemberResendOnboardingEmailMutation = { __typename?: 'Mutation', adminMemberResendOnboardingEmail: SystemOperationStatus };

export type AdminMemberUpdatePasswordMutationVariables = Exact<{
  input: AdminMemberUpdatePasswordInput;
}>;


export type AdminMemberUpdatePasswordMutation = { __typename?: 'Mutation', adminMemberUpdatePassword: SystemOperationStatus };

export type AdminMemberReassignMembershipIdMutationVariables = Exact<{
  input: AdminMemberReassignMembershipIdInput;
}>;


export type AdminMemberReassignMembershipIdMutation = { __typename?: 'Mutation', adminMemberReassignMembershipId: SystemOperationStatus };

export type AdminMemberServiceUpdateMutationVariables = Exact<{
  input: AdminMemberServiceUpdateInput;
}>;


export type AdminMemberServiceUpdateMutation = { __typename?: 'Mutation', adminMemberServiceUpdate: SystemOperationStatus };

export type AdminMemberTypeUpdateMutationVariables = Exact<{
  input: AdminMemberTypeUpdateInput;
}>;


export type AdminMemberTypeUpdateMutation = { __typename?: 'Mutation', adminMemberTypeUpdate: SystemOperationStatus };

export type AdminMemberServiceTransactionDeleteMutationVariables = Exact<{
  input: AdminMemberServiceTransactionDeleteInput;
}>;


export type AdminMemberServiceTransactionDeleteMutation = { __typename?: 'Mutation', adminMemberServiceTransactionDelete: SystemOperationStatus };

export type AdminMemberProductPackageDeleteMutationVariables = Exact<{
  input: AdminMemberProductPackageDeleteInput;
}>;


export type AdminMemberProductPackageDeleteMutation = { __typename?: 'Mutation', adminMemberProductPackageDelete: SystemOperationStatus };

export type AdminMemberProductPackageShareMutationVariables = Exact<{
  input: AdminMemberProductPackageShareInput;
}>;


export type AdminMemberProductPackageShareMutation = { __typename?: 'Mutation', adminMemberProductPackageShare: SystemOperationStatus };

export type AdminMemberProductPackageManageMutationVariables = Exact<{
  input: AdminMemberProductPackageManageInput;
}>;


export type AdminMemberProductPackageManageMutation = { __typename?: 'Mutation', adminMemberProductPackageManage: SystemOperationStatus };

export type AdminMemberProductPackageTransferMutationVariables = Exact<{
  input: AdminMemberProductPackageTransferInput;
}>;


export type AdminMemberProductPackageTransferMutation = { __typename?: 'Mutation', adminMemberProductPackageTransfer: SystemOperationStatus };

export type AdminMemberProductPackageGroupMutationVariables = Exact<{
  input: AdminMemberProductPackageGroupInput;
}>;


export type AdminMemberProductPackageGroupMutation = { __typename?: 'Mutation', adminMemberProductPackageGroup: SystemOperationStatus };

export type AdminMemberServiceTransactionUpdateMutationVariables = Exact<{
  input: AdminMemberServiceTransactionUpdateInput;
}>;


export type AdminMemberServiceTransactionUpdateMutation = { __typename?: 'Mutation', adminMemberServiceTransactionUpdate: { __typename?: 'ServiceTransactionBasic', amount: number, coach?: string | null, comment?: string | null, date: any, facilityType?: string | null, id: string, memberName?: string | null, packageName?: string | null, packageType?: string | null, serviceId?: string | null, serviceType: string, transactionType: string, venue?: string | null, expirableCredit?: { __typename?: 'ExpirableCreditBasic', amount: number, expiryDate: any, id: string } | null } };

export type AdminMemberProductPackageExtensionUpdateMutationVariables = Exact<{
  input: AdminMemberProductPackageExtensionUpdateInput;
}>;


export type AdminMemberProductPackageExtensionUpdateMutation = { __typename?: 'Mutation', adminMemberProductPackageExtensionUpdate: { __typename?: 'AdminMemberProductPackageExtension', authorizedAdjusterName?: string | null, comment?: string | null, dateExtended?: any | null, daysAdded?: number | null, id: string, newExpiryDate?: any | null, prevExpiryDate?: any | null } };

export type AdminMemberSimulatorUseUpdateMutationVariables = Exact<{
  input: AdminMemberSimulatorUseUpdateInput;
}>;


export type AdminMemberSimulatorUseUpdateMutation = { __typename?: 'Mutation', adminMemberSimulatorUseUpdate: SystemOperationStatus };

export type AdminMemberInvoiceDeleteMutationVariables = Exact<{
  input: AdminMemberInvoiceDeleteInput;
}>;


export type AdminMemberInvoiceDeleteMutation = { __typename?: 'Mutation', adminMemberInvoiceDelete: SystemOperationStatus };

export type AdminMemberBdfAddMutationVariables = Exact<{
  input: AdminMemberBdfAddInput;
}>;


export type AdminMemberBdfAddMutation = { __typename?: 'Mutation', adminMemberBDFAdd: SystemOperationStatus };

export type AdminMemberProductPackageReActivateMutationVariables = Exact<{
  input: AdminMemberProductPackageReActivateInput;
}>;


export type AdminMemberProductPackageReActivateMutation = { __typename?: 'Mutation', adminMemberProductPackageReActivate: SystemOperationStatus };

export type AdminMemberTransferCreditMutationVariables = Exact<{
  input: AdminMemberTransferCreditInput;
}>;


export type AdminMemberTransferCreditMutation = { __typename?: 'Mutation', adminMemberTransferCredit: SystemOperationStatus };

export type CoachMemberLessonNoteUpdateMutationVariables = Exact<{
  input: CoachMemberLessonNoteUpdateInput;
}>;


export type CoachMemberLessonNoteUpdateMutation = { __typename?: 'Mutation', coachMemberLessonNoteUpdate: string };

export type CoachMemberLessonNoteDeleteMutationVariables = Exact<{
  input: CoachMemberLessonNoteDeleteInput;
}>;


export type CoachMemberLessonNoteDeleteMutation = { __typename?: 'Mutation', coachMemberLessonNoteDelete: { __typename?: 'CoachMemberLessonNoteDelete', hasFeedback: boolean } };

export type GenerateLessonAttachmentUploadUrlMutationVariables = Exact<{
  input: GenerateLessonAttachmentUploadUrlInput;
}>;


export type GenerateLessonAttachmentUploadUrlMutation = { __typename?: 'Mutation', generateLessonAttachmentUploadUrl: { __typename?: 'GenerateLessonAttachmentUploadUrlResponse', fields: any, fileUrl: string, key: string, signedUrl: string } };

export type FormHelperAceCoinTypeQueryVariables = Exact<{
  args: FormHelperAceCoinTypeArgs;
}>;


export type FormHelperAceCoinTypeQuery = { __typename?: 'Query', formHelperAceCoinType?: { __typename?: 'FormHelperAceCoinType', currencyCode: CurrencyCode, price: number } | null };

export type FormHelperProductPackagesQueryVariables = Exact<{
  args: FormHelperProductPackagesArgs;
}>;


export type FormHelperProductPackagesQuery = { __typename?: 'Query', formHelperProductPackages?: { __typename?: 'FormHelperProductPackages', packages: Array<{ __typename?: 'FormHelperProductPackage', itemCode: string, name: string } | null> } | null };

export type AdminMembersQueryVariables = Exact<{
  args: AdminMembersArgs;
}>;


export type AdminMembersQuery = { __typename?: 'Query', adminMembers: { __typename?: 'AdminMemberResponse', edges?: Array<{ __typename?: 'AdminMemberEdge', cursor?: string | null, node?: { __typename?: 'AdminMemberBasic', accountType?: AccountType | null, aceCoins?: number | null, appVersion?: string | null, companyContactPersonFirstName?: string | null, companyContactPersonLastName?: string | null, companyName?: string | null, createdAt?: any | null, credits?: number | null, firstName: string, hasGroupMembers?: boolean | null, id: string, individualId: string, internalAccountType?: InternalAccountType | null, kGolfAccountCreationError?: boolean | null, lastName: string, lessonIndoorCredits?: number | null, memberName?: string | null, membershipId: string, memberStatus?: MemberStatus | null, practiseCredits?: number | null, startDate?: any | null, membershipType?: { __typename?: 'MembershipTypeBasic', baseCountryCode?: CountryCode | null, internalName?: string | null, isCorporate?: boolean | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'AdminMemberResponsePageInfo', endCursor?: string | null, failedKGolfAccounts?: number | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberQueryVariables = Exact<{
  args: AdminMemberArgs;
}>;


export type AdminMemberQuery = { __typename?: 'Query', adminMember: { __typename?: 'AdminMember', accountType?: AccountType | null, activationOrderNo: string, activationPrice: number, addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, birthday?: string | null, companyContactPersonEmail?: string | null, companyContactPersonFirstName?: string | null, companyContactPersonLastName?: string | null, companyName?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, credit: number, creditSpent: number, email: string, firstName: string, gameCredit: number, gender?: Gender | null, handed: Handed, hasGroupMembers: boolean, hasSimulatorPrivilege: boolean, hasSubscriptions: boolean, individualId: string, internalAccountType?: InternalAccountType | null, isSimulatorUseRedeemed: boolean, kGolfAccountCreationError?: boolean | null, lastName: string, locker: boolean, membershipStatus: MembershipStatus, membershipUuid: string, memberStatus: MemberStatus, memberUuid: string, mobileNumber?: string | null, nationality?: string | null, nickname?: string | null, partialNricOrFin?: string | null, practiseCredit: number, profileImageUrl?: string | null, pushTokens: Array<string | null>, relationshipToMainMember?: Relationship | null, serviceNote?: string | null, signUpSidasInsoles: number, startDate?: any | null, termEndDate?: any | null, voucherField: number, voucherIndoor: number, activationLineItems: Array<{ __typename?: 'AdminMemberActivationLineItem', itemName: string, salesPrice: number } | null>, members: Array<{ __typename?: 'AdminMemberMember', accountType?: AccountType | null, firstName?: string | null, id?: string | null, individualId?: string | null, lastName?: string | null } | null>, membershipType?: { __typename?: 'MembershipTypeBasic', baseCountryCode?: CountryCode | null, internalName?: string | null, isCorporate?: boolean | null, price?: number | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null } | null } };

export type AdminKGolfMemberQueryVariables = Exact<{
  args?: InputMaybe<AdminKGolfMemberArgs>;
}>;


export type AdminKGolfMemberQuery = { __typename?: 'Query', adminKGolfMember: { __typename?: 'AdminKGolfMember', address1?: string | null, address2?: string | null, birthday?: string | null, cdn?: string | null, city?: string | null, connectKakao?: boolean | null, connectWechat?: boolean | null, country?: string | null, email?: string | null, gender?: number | null, handed?: number | null, id?: string | null, isTermsAgreeNotificationEmail?: boolean | null, isTermsAgreeNotificationSMS?: boolean | null, mobilePhone?: string | null, mobilePhoneCountry?: string | null, nickname?: string | null, profilePath?: string | null, province?: string | null, zipcode?: string | null } };

export type AdminMembershipSubscriptionsQueryVariables = Exact<{
  args: AdminMembershipSubscriptionsArgs;
}>;


export type AdminMembershipSubscriptionsQuery = { __typename?: 'Query', adminMembershipSubscriptions: { __typename?: 'AdminMembershipSubscriptionResponse', edges?: Array<{ __typename?: 'AdminMembershipSubscriptionEdge', cursor?: string | null, node?: { __typename?: 'AdminMembershipSubscriptionBasic', aceCoins: number, endDate?: any | null, mainMemberMainId: string, mainMemberName: string, membershipUuid: string, memberUuid: string, startDate?: any | null, status: SubscriptionStatus, subscriptionBalance: number } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberSubscriptionsQueryVariables = Exact<{
  args: AdminMemberSubscriptionsArgs;
}>;


export type AdminMemberSubscriptionsQuery = { __typename?: 'Query', adminMemberSubscriptions: { __typename?: 'AdminMemberSubscriptionResponse', status?: SubscriptionStatus | null, subscriptionEndDate?: any | null, subscriptionStartDate?: any | null, edges?: Array<{ __typename?: 'AdminMemberSubscriptionEdge', cursor?: string | null, node?: { __typename?: 'AdminMembershipSubscription', amount?: number | null, creditDeducted?: boolean | null, days?: number | null, description?: string | null, endDate?: any | null, id?: string | null, startDate?: any | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, firstRecordDateTime?: any | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMembershipServicesQueryVariables = Exact<{
  args: AdminMembershipServicesArgs;
}>;


export type AdminMembershipServicesQuery = { __typename?: 'Query', adminMembershipServices: { __typename?: 'AdminMembershipServiceResponse', edges?: Array<{ __typename?: 'AdminMembershipServiceEdge', cursor?: string | null, node?: { __typename?: 'AdminMembershipService', amount: number, countryCode?: CountryCode | null, dateAdded?: any | null, expiryDate?: any | null, expiryWarning?: boolean | null, groupServiceId?: string | null, hasSupplementaryRedemption: boolean, isDaily: boolean, isDailyRedeemed: boolean, isGroup: boolean, isShareGroupPaused: boolean, memberName?: string | null, orderNo?: string | null, packageType: string, parentServiceId?: string | null, serviceId: string, serviceName: string, status?: string | null, supplementaryAmount: number, supplementaryUnitName: string, type?: string | null, unitType: string } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberServiceTransactionsQueryVariables = Exact<{
  args: AdminMemberServiceTransactionsArgs;
}>;


export type AdminMemberServiceTransactionsQuery = { __typename?: 'Query', adminMemberServiceTransactions: { __typename?: 'AdminMemberServiceTransactionResponse', edges?: Array<{ __typename?: 'AdminMemberServiceTransactionEdge', cursor?: string | null, node?: { __typename?: 'ServiceTransactionBasic', amount: number, coach?: string | null, comment?: string | null, date: any, facilityType?: string | null, id: string, isShareGroupPaused?: boolean | null, isSupplementaryRedemption?: boolean | null, memberName?: string | null, packageName?: string | null, packageType?: string | null, serviceId?: string | null, serviceType: string, supplementaryUnitName?: string | null, transactionType: string, type?: string | null, venue?: string | null, expirableCredit?: { __typename?: 'ExpirableCreditBasic', amount: number, expiryDate: any, id: string } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, firstRecordDateTime?: any | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberAcTransactionsQueryVariables = Exact<{
  args: AdminMemberAcTransactionsArgs;
}>;


export type AdminMemberAcTransactionsQuery = { __typename?: 'Query', adminMemberAcTransactions: { __typename?: 'AdminMemberAcTransactionResponse', edges?: Array<{ __typename?: 'AdminMemberAcTransactionEdge', cursor?: number | null, node?: { __typename?: 'AceCoinTransaction', account?: string | null, accountId?: string | null, amount: number, description: string, direction: number, id: number, invoiceNo?: string | null, transactionDateTime: any, transactionId: string, type: AcTransactionType, venue?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, firstRecordDateTime?: any | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberInvoicesQueryVariables = Exact<{
  args: AdminMemberInvoicesArgs;
}>;


export type AdminMemberInvoicesQuery = { __typename?: 'Query', adminMemberInvoices: { __typename?: 'AdminReportInvoiceResponse', edges?: Array<{ __typename?: 'AdminReportInvoiceEdge', cursor?: string | null, node?: { __typename?: 'InvoiceBasic', account?: string | null, accountId?: string | null, amount: number, invoiceNo: string, paymentCurrency?: PaymentCurrency | null, paymentMethod: string, transactionDateTime: any, venue?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, firstRecordDateTime?: any | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberProductPackageQueryVariables = Exact<{
  args: AdminMemberProductPackageArgs;
}>;


export type AdminMemberProductPackageQuery = { __typename?: 'Query', adminMemberProductPackage: { __typename?: 'AdminMemberProductPackage', amount: number, comment?: string | null, dateAdded?: any | null, expiryDate?: any | null, expiryDateStr: string, expiryWarning?: boolean | null, forfeitureAmount: number, forfeitureDate?: any | null, forfeitureDateStr?: string | null, groupId?: string | null, hasSupplementaryRedemption: boolean, individualId?: string | null, isDaily: boolean, isDailyRedeemed: boolean, isGroup: boolean, isReActivateable: boolean, isShareGroupPaused: boolean, memberName?: string | null, membershipUuid: string, memberUuid: string, packageName: string, packageType: string, parentServiceId?: string | null, pausedAt?: any | null, serviceId: string, status?: string | null, supplementaryAmount: number, supplementaryUnitName: string, type?: string | null, unitType: string, extensions: Array<{ __typename?: 'AdminMemberProductPackageExtension', authorizedAdjusterName?: string | null, comment?: string | null, dateExtended?: any | null, daysAdded?: number | null, id: string, newExpiryDate?: any | null, prevExpiryDate?: any | null } | null>, groupServices?: Array<{ __typename?: 'AdminMemberProductGroupPackage', amount: number, individualId: string, isShareGroupPaused: boolean, memberName: string, packageName: string, serviceId: string } | null> | null, pauseHistory?: Array<{ __typename?: 'AdminMemberProductPackagePause', action: string, authorizedAdjusterName?: string | null, comment?: string | null, dateChanged: any, newExpiryDate?: any | null, prevExpiryDate?: any | null }> | null, subServices?: Array<{ __typename?: 'AdminMemberProductPackageSubService', amount: number, dateAdded: any, individualId: string, memberName: string, memberUuid: string, parentServiceId: string, serviceId: string, status?: string | null } | null> | null, transactions: Array<{ __typename?: 'ServiceTransactionBasic', amount: number, coach?: string | null, comment?: string | null, date: any, facilityType?: string | null, id: string, memberName?: string | null, packageName?: string | null, packageType?: string | null, serviceId?: string | null, serviceType: string, transactionType: string, venue?: string | null } | null> } };

export type AdminMemberProductPackageExtensionsQueryVariables = Exact<{
  args: AdminMemberProductPackageExtensionsArgs;
}>;


export type AdminMemberProductPackageExtensionsQuery = { __typename?: 'Query', adminMemberProductPackageExtensions: { __typename?: 'AdminMemberProductPackageExtensions', extensions?: Array<{ __typename?: 'AdminMemberProductPackageExtension', authorizedAdjusterName?: string | null, comment?: string | null, dateExtended?: any | null, daysAdded?: number | null, newExpiryDate?: any | null, prevExpiryDate?: any | null } | null> | null } };

export type AdminMemberProductGroupPackagesQueryVariables = Exact<{
  args: AdminMemberProductGroupPackagesArgs;
}>;


export type AdminMemberProductGroupPackagesQuery = { __typename?: 'Query', adminMemberProductGroupPackages: { __typename?: 'AdminMemberProductGroupPackages', packages?: Array<{ __typename?: 'AdminMemberProductGroupPackage', amount: number, individualId: string, isShareGroupPaused: boolean, memberName: string, packageName: string, serviceId: string } | null> | null } };

export type AdminMemberLessonNoteMembersQueryVariables = Exact<{
  args: AdminMemberLessonNoteMembersArgs;
}>;


export type AdminMemberLessonNoteMembersQuery = { __typename?: 'Query', adminMemberLessonNoteMembers: { __typename?: 'AdminMemberLessonNoteMemberResponse', edges?: Array<{ __typename?: 'AdminMemberLessonNoteMemberEdge', cursor?: string | null, node?: { __typename?: 'AdminMemberLessonNoteMember', id: string, memberIndividualId: string, memberName: string, noOfLessonNotes?: number | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, firstRecordDateTime?: any | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type CoachMemberLessonNotesQueryVariables = Exact<{
  args: CoachMemberLessonNotesArgs;
}>;


export type CoachMemberLessonNotesQuery = { __typename?: 'Query', coachMemberLessonNotes: { __typename?: 'CoachMemberLessonNoteResponse', memberIndividualId: string, memberName: string, memberUuid: string, edges?: Array<{ __typename?: 'CoachMemberLessonNoteEdge', cursor?: string | null, node?: { __typename?: 'CoachMemberLessonNoteBasic', attachments?: Array<string> | null, bookingId?: string | null, dateStr: string, id: string, lessonType: string, venue: string } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, firstRecordDateTime?: any | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type CoachMemberLessonNoteQueryVariables = Exact<{
  args: CoachMemberLessonNoteArgs;
}>;


export type CoachMemberLessonNoteQuery = { __typename?: 'Query', coachMemberLessonNote: { __typename?: 'CoachMemberLessonNote', attachments?: Array<string> | null, bookingId?: string | null, comment: string, dateStr: string, id: string, lessonType: string, memberIndividualId: string, memberName: string, memberUuid: string, venue?: string | null, venueOther?: string | null } };

export type AdminUpdateMembershipTypeMutationVariables = Exact<{
  input: AdminUpdateMembershipTypeInput;
}>;


export type AdminUpdateMembershipTypeMutation = { __typename?: 'Mutation', adminUpdateMembershipType: { __typename?: 'AdminMembershipType', baseCountryCode?: CountryCode | null, compDailySimulatorUse?: number | null, compDailySimulatorUseType?: CompDailySimulatorUseType | null, compFieldLessons?: number | null, compIndoorLessons?: number | null, compLocker?: boolean | null, designatedPrivateRoom?: boolean | null, discount?: number | null, id?: string | null, imageUrl?: string | null, initialCredits?: number | null, internalName?: string | null, isCorporate?: boolean | null, isEnabled?: boolean | null, lineItemCode?: string | null, loungeAccess?: boolean | null, mainTypeSlug?: string | null, monthlySub?: number | null, price?: number | null, publicName?: string | null, signupProductSidasInsoles?: boolean | null, subscriptionlineItemCode?: string | null, supplementaryTypeSlug?: string | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } };

export type AdminMembershipTypesQueryVariables = Exact<{
  args: AdminMembershipTypesArgs;
}>;


export type AdminMembershipTypesQuery = { __typename?: 'Query', adminMembershipTypes: { __typename?: 'AdminMembershipTypes', numberOfTypes?: number | null, lifestyle?: Array<{ __typename?: 'AdminMembershipTypeBasic', baseCountryCode?: CountryCode | null, id?: string | null, internalName?: string | null, price?: number | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } | null> | null, premium?: Array<{ __typename?: 'AdminMembershipTypeBasic', baseCountryCode?: CountryCode | null, id?: string | null, internalName?: string | null, price?: number | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } | null> | null, vip?: Array<{ __typename?: 'AdminMembershipTypeBasic', baseCountryCode?: CountryCode | null, id?: string | null, internalName?: string | null, price?: number | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } | null> | null } };

export type AdminMembershipTypeQueryVariables = Exact<{
  args: AdminMembershipTypeArgs;
}>;


export type AdminMembershipTypeQuery = { __typename?: 'Query', adminMembershipType: { __typename?: 'AdminMembershipType', baseCountryCode?: CountryCode | null, compDailySimulatorUse?: number | null, compDailySimulatorUseType?: CompDailySimulatorUseType | null, compFieldLessons?: number | null, compIndoorLessons?: number | null, compLocker?: boolean | null, designatedPrivateRoom?: boolean | null, discount?: number | null, id?: string | null, imageUrl?: string | null, initialCredits?: number | null, internalName?: string | null, isCorporate?: boolean | null, isEnabled?: boolean | null, lineItemCode?: string | null, loungeAccess?: boolean | null, mainTypeSlug?: string | null, monthlySub?: number | null, price?: number | null, publicName?: string | null, signupProductSidasInsoles?: boolean | null, subscriptionlineItemCode?: string | null, supplementaryTypeSlug?: string | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } };

export type AdminActivateMembershipMutationVariables = Exact<{
  input?: InputMaybe<AdminActivateMembershipInput>;
}>;


export type AdminActivateMembershipMutation = { __typename?: 'Mutation', adminActivateMembership: SystemOperationStatus };

export type AdminCreateMembershipMutationVariables = Exact<{
  input: AdminCreateMembershipInput;
}>;


export type AdminCreateMembershipMutation = { __typename?: 'Mutation', adminCreateMembership: { __typename?: 'AdminNewMembership', memberUuid?: string | null, fileUploadCredentials?: { __typename?: 'AdminNewMembershipFileUploadCredentials', mainMembers?: Array<{ __typename?: 'FileUploadObject', assetUrl: string, clientImageFieldName: string, fields: any, index: number, signedUrl: string } | null> | null, subMembers?: Array<{ __typename?: 'FileUploadObject', assetUrl: string, clientImageFieldName: string, fields: any, index: number, signedUrl: string } | null> | null } | null, payment?: { __typename?: 'HitPayPaymentRequest', checkoutUrl?: string | null, requestId?: string | null } | null } };

export type AdminUpdateReservedIdMutationVariables = Exact<{
  input?: InputMaybe<AdminUpdateReservedIdInput>;
}>;


export type AdminUpdateReservedIdMutation = { __typename?: 'Mutation', adminUpdateReservedId: { __typename?: 'AdminUpdateReservedId', onHoldExpiresAt?: any | null } };

export type AdminMembershipSubscriptionPauseMutationVariables = Exact<{
  input: AdminMembershipSubscriptionPauseInput;
}>;


export type AdminMembershipSubscriptionPauseMutation = { __typename?: 'Mutation', adminMembershipSubscriptionPause: SystemOperationStatus };

export type AdminMembershipSubscriptionStartMutationVariables = Exact<{
  input: AdminMembershipSubscriptionStartInput;
}>;


export type AdminMembershipSubscriptionStartMutation = { __typename?: 'Mutation', adminMembershipSubscriptionStart: SystemOperationStatus };

export type AdminMembershipSubscriptionActionDatesMutationVariables = Exact<{
  input: AdminMembershipSubscriptionActionDatesInput;
}>;


export type AdminMembershipSubscriptionActionDatesMutation = { __typename?: 'Mutation', adminMembershipSubscriptionActionDates: SystemOperationStatus };

export type FormHelperNewMembershipQueryVariables = Exact<{
  args: FormHelperNewMembershipArgs;
}>;


export type FormHelperNewMembershipQuery = { __typename?: 'Query', formHelperNewMembership?: { __typename?: 'FormHelperNewMembership', membershipTypes: Array<{ __typename?: 'FormHelperNewMembershipMembershipType', amtAwardMain: number, amtAwardSub: number, amtPurchaseMain: number, amtPurchaseSub: number, baseCountryCode: CountryCode, hasReservedIds?: boolean | null, id: string, internalName: string, isCorporate: boolean, lessonIndoorCredit: number, lessonOutdoorCredit: number, parentTypeId?: string | null, price: number, supplementaryTypePrice: number, supplementaryTypeSlug?: string | null, versionSlug: string } | null> } | null };

export type AdminReservedIdsQueryVariables = Exact<{
  args?: InputMaybe<AdminReservedIdsArgs>;
}>;


export type AdminReservedIdsQuery = { __typename?: 'Query', adminReservedIds?: { __typename?: 'AdminReservedIds', idOnHold?: string | null, idOnHoldExpiresAt?: any | null, reservedIds?: Array<{ __typename?: 'AdminReservedId', id?: number | null, membershipId?: string | null, onHoldExpiresAt?: any | null, onHoldFor?: string | null, status?: ReservedIdStatus | null, updatedAt?: any | null } | null> | null } | null };

export type SelfUpdateMutationVariables = Exact<{
  input: SelfUpdateInput;
}>;


export type SelfUpdateMutation = { __typename?: 'Mutation', selfUpdate: { __typename?: 'SelfUpdated', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, self: { __typename?: 'Self', createdAt?: any | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, organizationId: string, organizationName: string, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> } } };

export type SelfUpdatePasswordMutationVariables = Exact<{
  input: SelfUpdatePasswordInput;
}>;


export type SelfUpdatePasswordMutation = { __typename?: 'Mutation', selfUpdatePassword: SystemOperationStatus };

export type SelfQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfQuery = { __typename?: 'Query', self?: { __typename?: 'Self', baseCountryCode?: CountryCode | null, createdAt?: any | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, organizationId: string, organizationName: string, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> } | null };

export type SelfBasicQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfBasicQuery = { __typename?: 'Query', self?: { __typename?: 'Self', baseCountryCode?: CountryCode | null, baseGmtOffset?: number | null, clubhouses?: Array<{ __typename?: 'SelfClubhouse', clubhouseCode: string, name: string } | null> | null, countries?: Array<{ __typename?: 'SelfCountry', countryCode: CountryCode, name: string } | null> | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } | null };

export type AdminNotificationCreateMutationVariables = Exact<{
  input: AdminNotificationCreateInput;
}>;


export type AdminNotificationCreateMutation = { __typename?: 'Mutation', adminNotificationCreate: SystemOperationStatus };

export type AdminNotificationDeleteMutationVariables = Exact<{
  input: AdminNotificationDeleteInput;
}>;


export type AdminNotificationDeleteMutation = { __typename?: 'Mutation', adminNotificationDelete: SystemOperationStatus };

export type AdminNotificationMemberDeleteMutationVariables = Exact<{
  input: AdminNotificationMemberDeleteInput;
}>;


export type AdminNotificationMemberDeleteMutation = { __typename?: 'Mutation', adminNotificationMemberDelete: SystemOperationStatus };

export type AdminMemberNotificationsQueryVariables = Exact<{
  args: AdminMemberNotificationsArgs;
}>;


export type AdminMemberNotificationsQuery = { __typename?: 'Query', adminMemberNotifications: { __typename?: 'AdminMemberNotificationResponse', edges?: Array<{ __typename?: 'AdminMemberNotificationEdge', cursor?: string | null, node?: { __typename?: 'AdminNotificationBasic', createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, expiry?: boolean | null, expiryDate?: any | null, id: string, message: string, mode?: NotificationMode | null, title?: string | null, updatedAt?: any | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminNotificationQueryVariables = Exact<{
  args: AdminNotificationArgs;
}>;


export type AdminNotificationQuery = { __typename?: 'Query', adminNotification: { __typename?: 'AdminNotification', createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, expiry?: boolean | null, expiryDate?: any | null, id: string, message: string, mode?: NotificationMode | null, title?: string | null, updatedAt?: any | null } };

export type AdminNotificationsQueryVariables = Exact<{
  args: AdminNotificationsArgs;
}>;


export type AdminNotificationsQuery = { __typename?: 'Query', adminNotifications: { __typename?: 'AdminNotificationResponse', edges?: Array<{ __typename?: 'AdminNotificationEdge', cursor?: string | null, node?: { __typename?: 'AdminNotificationBasic', createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, expiry?: boolean | null, expiryDate?: any | null, id: string, message: string, title?: string | null, updatedAt?: any | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminUpdateOrganizationMutationVariables = Exact<{
  input: AdminUpdateOrganizationInput;
}>;


export type AdminUpdateOrganizationMutation = { __typename?: 'Mutation', adminUpdateOrganization: { __typename?: 'Organization', addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, businessName?: string | null, createdAt?: any | null, email?: string | null, id: string, organizationNumber?: number | null, phoneNumber?: string | null, updatedAt?: any | null } };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, businessName?: string | null, createdAt?: any | null, email?: string | null, id: string, organizationNumber?: number | null, phoneNumber?: string | null, updatedAt?: any | null } | null };

export type AdminProductPackageAddMutationVariables = Exact<{
  input: AdminProductPackageAddInput;
}>;


export type AdminProductPackageAddMutation = { __typename?: 'Mutation', adminProductPackageAdd: SystemOperationStatus };

export type AdminProductsQueryVariables = Exact<{
  args: AdminProductsArgs;
}>;


export type AdminProductsQuery = { __typename?: 'Query', adminProducts: { __typename?: 'AdminProductResponse', edges?: Array<{ __typename?: 'AdminProductEdge', cursor?: string | null, node?: { __typename?: 'AdminProductBasic', baseCountryCode: CountryCode, itemCode: string, name: string, packageType: string, price?: number | null, priceAceCoins?: number | null, priceCurrency?: string | null, validity?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminReportAcTransactionDeleteMutationVariables = Exact<{
  input: AdminReportAcTransactionDeleteInput;
}>;


export type AdminReportAcTransactionDeleteMutation = { __typename?: 'Mutation', adminReportAcTransactionDelete: SystemOperationStatus };

export type AdminReportAcTransactionsQueryVariables = Exact<{
  args: AdminReportAcTransactionsArgs;
}>;


export type AdminReportAcTransactionsQuery = { __typename?: 'Query', adminReportAcTransactions: { __typename?: 'AdminReportAcTransactionResponse', edges?: Array<{ __typename?: 'AdminReportAcTransactionEdge', cursor?: number | null, node?: { __typename?: 'AceCoinTransaction', account?: string | null, accountId?: string | null, amount: number, description: string, direction: number, id: number, invoiceNo?: string | null, transactionDateTime: any, transactionId: string, type: AcTransactionType, venue?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminReportInvoiceQueryVariables = Exact<{
  args: AdminReportInvoiceArgs;
}>;


export type AdminReportInvoiceQuery = { __typename?: 'Query', adminReportInvoice: { __typename?: 'Invoice', additionalDiscount?: number | null, amount: number, gst?: number | null, invoiceNo: string, memberDiscount?: number | null, memberIndividualId?: string | null, memberName?: string | null, memberUuid?: string | null, paymentCurrency?: PaymentCurrency | null, paymentMethod: PaymentMethod, serviceFee?: number | null, strDate: string, strTime: string, subTotal: number, transactionDateTime: any, venue?: string | null, lineItems?: Array<{ __typename?: 'InvoiceLineItem', name: string, qty: number, salesPrice: number } | null> | null } };

export type AdminReportInvoicesQueryVariables = Exact<{
  args: AdminReportInvoicesArgs;
}>;


export type AdminReportInvoicesQuery = { __typename?: 'Query', adminReportInvoices: { __typename?: 'AdminReportInvoiceResponse', edges?: Array<{ __typename?: 'AdminReportInvoiceEdge', cursor?: string | null, node?: { __typename?: 'InvoiceBasic', account?: string | null, accountId?: string | null, amount: number, invoiceNo: string, paymentCurrency?: PaymentCurrency | null, paymentMethod: string, transactionDateTime: any, venue?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminSimulatorUsageQueryVariables = Exact<{
  args: AdminSimulatorUsageArgs;
}>;


export type AdminSimulatorUsageQuery = { __typename?: 'Query', adminSimulatorUsage?: any | null };

export type AdminReportHitPayChargesQueryVariables = Exact<{
  args: AdminReportHitPayChargesArgs;
}>;


export type AdminReportHitPayChargesQuery = { __typename?: 'Query', adminReportHitPayCharges: { __typename?: 'AdminReportHitPayChargeResponse', edges?: Array<{ __typename?: 'AdminReportHitPayChargeEdge', cursor?: string | null, node?: { __typename?: 'AdminReportHitPayCharge', amount?: string | null, buyer_email?: string | null, buyer_name: string, buyer_phone?: string | null, created_at?: string | null, currency?: string | null, fees?: string | null, id: string, payment_method?: string | null, payment_type?: string | null, quantity: number, refunded_amount?: string | null, status: string, updated_at?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminReportHitPayChargeQueryVariables = Exact<{
  args: AdminReportHitPayChargeArgs;
}>;


export type AdminReportHitPayChargeQuery = { __typename?: 'Query', adminReportHitPayCharge: { __typename?: 'Invoice', additionalDiscount?: number | null, amount: number, gst?: number | null, invoiceNo: string, memberDiscount?: number | null, memberIndividualId?: string | null, memberName?: string | null, memberUuid?: string | null, paymentCurrency?: PaymentCurrency | null, paymentMethod: PaymentMethod, serviceFee?: number | null, strDate: string, strTime: string, subTotal: number, transactionDateTime: any, venue?: string | null, lineItems?: Array<{ __typename?: 'InvoiceLineItem', name: string, qty: number, salesPrice: number } | null> | null } };

export type AdminClientLoginGuestMutationVariables = Exact<{
  input: AdminClientLoginGuestInput;
}>;


export type AdminClientLoginGuestMutation = { __typename?: 'Mutation', adminClientLoginGuest: SystemOperationStatus };

export type AdminExtendClientTimeMutationVariables = Exact<{
  input: AdminExtendClientTimeInput;
}>;


export type AdminExtendClientTimeMutation = { __typename?: 'Mutation', adminExtendClientTime: SystemOperationStatus };

export type AdminLockClientMutationVariables = Exact<{
  input: AdminLockClientInput;
}>;


export type AdminLockClientMutation = { __typename?: 'Mutation', adminLockClient: SystemOperationStatus };

export type AdminShopSendNotificationMutationVariables = Exact<{
  input: AdminShopSendNotificationInput;
}>;


export type AdminShopSendNotificationMutation = { __typename?: 'Mutation', adminShopSendNotification: SystemOperationStatus };

export type AdminUnlockClientMutationVariables = Exact<{
  input: AdminUnlockClientInput;
}>;


export type AdminUnlockClientMutation = { __typename?: 'Mutation', adminUnlockClient: SystemOperationStatus };

export type AdminUpdateClientContentLimitMutationVariables = Exact<{
  input: AdminUpdateClientContentLimitInput;
}>;


export type AdminUpdateClientContentLimitMutation = { __typename?: 'Mutation', adminUpdateClientContentLimit: SystemOperationStatus };

export type AdminUpdateShopDetailsMutationVariables = Exact<{
  input: AdminUpdateShopDetailsInput;
}>;


export type AdminUpdateShopDetailsMutation = { __typename?: 'Mutation', adminUpdateShopDetails: { __typename?: 'AdminShopDetails', address1?: string | null, address2?: string | null, CDN?: string | null, country?: string | null, currency?: string | null, isEquipmentStorage?: boolean | null, isLeftHanded?: boolean | null, isParking?: boolean | null, isProLesson?: boolean | null, isShopCloseNextDay?: boolean | null, isSwingplate?: boolean | null, ownerEmail?: string | null, ownerMobilePhone?: string | null, ownerMobilePhoneCountry?: string | null, ownerName?: string | null, shopCloseTime?: string | null, shopGuid?: string | null, shopName?: string | null, shopOpenTime?: string | null, shopPhone?: string | null, zipcode?: string | null, clientType?: { __typename?: 'AdminShopDetailsClientType', lesson?: boolean | null, practice?: boolean | null, screen?: boolean | null } | null } };

export type AdminUpdateShopOptionsDrivingRangeMutationVariables = Exact<{
  input: AdminUpdateShopOptionsDrivingRangeInput;
}>;


export type AdminUpdateShopOptionsDrivingRangeMutation = { __typename?: 'Mutation', adminUpdateShopOptionsDrivingRange: { __typename?: 'AdminShopOptionsDrivingRange', courseId?: string | null, difficulty?: number | null, distanceUnit?: number | null, isBallTrajectory?: boolean | null, isFixedCamera?: boolean | null, isSwingVideo?: boolean | null, teeHeight?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type AdminUpdateShopOptionsRealTimeMutationVariables = Exact<{
  input: AdminUpdateShopOptionsRealTimeInput;
}>;


export type AdminUpdateShopOptionsRealTimeMutation = { __typename?: 'Mutation', adminUpdateShopOptionsRealTime: { __typename?: 'AdminShopOptionsRealTime', drivingRangeTimeLimit?: number | null, gameHoleTypeLimit?: number | null, gameTypeLimit?: number | null, isContentLimit?: boolean | null, paymentType?: number | null, playerCountLimit?: number | null, usageTime?: number | null } };

export type AdminUpdateShopOptionsRoundMutationVariables = Exact<{
  input: AdminUpdateShopOptionsRoundInput;
}>;


export type AdminUpdateShopOptionsRoundMutation = { __typename?: 'Mutation', adminUpdateShopOptionsRound: { __typename?: 'AdminShopOptionsRound', concede?: number | null, distanceUnit?: number | null, greenLocation?: number | null, greenSpeed?: number | null, holeCupLocation?: number | null, isBestVideo?: boolean | null, isCaddyVoice?: boolean | null, isUseObHazardTee?: boolean | null, mulliganCount?: number | null, puttingLine?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type AdminShopGetNotificationMutationVariables = Exact<{
  input: AdminShopGetNotificationInput;
}>;


export type AdminShopGetNotificationMutation = { __typename?: 'Mutation', adminShopGetNotification: { __typename?: 'AdminShopNotification', message: string } };

export type AdminGameHistoryQueryVariables = Exact<{
  args: AdminGameHistoryArgs;
}>;


export type AdminGameHistoryQuery = { __typename?: 'Query', adminGameHistory: { __typename?: 'AdminGameHistory', currentPage: number, maxPage: number, totalCount: number, list: Array<{ __typename?: 'AdminGameHistoryListItem', clientName: string, completeHoleCount: number, endTime?: number | null, gameRoundId: number, gameType: string, gameTypeCode: number, playerCount: number, startTime: number } | null> } };

export type AdminClientStatusQueryVariables = Exact<{
  args: AdminClientStatusArgs;
}>;


export type AdminClientStatusQuery = { __typename?: 'Query', adminClientStatus: { __typename?: 'ClientStatus', clients: any, shopGuid: string } };

export type AdminScoreCardQueryVariables = Exact<{
  args: AdminScoreCardArgs;
}>;


export type AdminScoreCardQuery = { __typename?: 'Query', adminScoreCard?: any | null };

export type AdminShopDetailsQueryVariables = Exact<{
  args: AdminShopDetailsArg;
}>;


export type AdminShopDetailsQuery = { __typename?: 'Query', adminShopDetails?: { __typename?: 'AdminShopDetails', address1?: string | null, address2?: string | null, CDN?: string | null, country?: string | null, currency?: string | null, isEquipmentStorage?: boolean | null, isLeftHanded?: boolean | null, isParking?: boolean | null, isProLesson?: boolean | null, isShopCloseNextDay?: boolean | null, isSwingplate?: boolean | null, ownerEmail?: string | null, ownerMobilePhone?: string | null, ownerMobilePhoneCountry?: string | null, ownerName?: string | null, shopCloseTime?: string | null, shopGuid?: string | null, shopName?: string | null, shopOpenTime?: string | null, shopPhone?: string | null, zipcode?: string | null, clientType?: { __typename?: 'AdminShopDetailsClientType', lesson?: boolean | null, practice?: boolean | null, screen?: boolean | null } | null } | null };

export type AdminShopOptionsDrivingRangeQueryVariables = Exact<{
  args: AdminShopOptionsDrivingRangeArgs;
}>;


export type AdminShopOptionsDrivingRangeQuery = { __typename?: 'Query', adminShopOptionsDrivingRange: { __typename?: 'AdminShopOptionsDrivingRange', courseId?: string | null, difficulty?: number | null, distanceUnit?: number | null, isBallTrajectory?: boolean | null, isFixedCamera?: boolean | null, isSwingVideo?: boolean | null, teeHeight?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type AdminShopOptionsRealTimeQueryVariables = Exact<{
  args: AdminShopOptionsRealTimeArgs;
}>;


export type AdminShopOptionsRealTimeQuery = { __typename?: 'Query', adminShopOptionsRealTime: { __typename?: 'AdminShopOptionsRealTime', drivingRangeTimeLimit?: number | null, gameHoleTypeLimit?: number | null, gameTypeLimit?: number | null, isContentLimit?: boolean | null, paymentType?: number | null, playerCountLimit?: number | null, usageTime?: number | null } };

export type AdminShopOptionsRoundQueryVariables = Exact<{
  args: AdminShopOptionsRoundArgs;
}>;


export type AdminShopOptionsRoundQuery = { __typename?: 'Query', adminShopOptionsRound: { __typename?: 'AdminShopOptionsRound', concede?: number | null, distanceUnit?: number | null, greenLocation?: number | null, greenSpeed?: number | null, holeCupLocation?: number | null, isBestVideo?: boolean | null, isCaddyVoice?: boolean | null, isUseObHazardTee?: boolean | null, mulliganCount?: number | null, puttingLine?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type AdminManagementSystemUserTelemetryMutationVariables = Exact<{
  input: AdminManagementSystemUserTelemetryInput;
}>;


export type AdminManagementSystemUserTelemetryMutation = { __typename?: 'Mutation', adminManagementSystemUserTelemetry: SystemOperationStatus };

export type AdminManagementSystemSupportTicketCreateMutationVariables = Exact<{
  input: AdminManagementSystemSupportTicketCreateInput;
}>;


export type AdminManagementSystemSupportTicketCreateMutation = { __typename?: 'Mutation', adminManagementSystemSupportTicketCreate: { __typename?: 'AdminManagementSystemSupportTicketCreate', id: string } };

export type AdminManagementSystemSupportTicketCommentAddMutationVariables = Exact<{
  input: AdminManagementSystemSupportTicketCommentAddInput;
}>;


export type AdminManagementSystemSupportTicketCommentAddMutation = { __typename?: 'Mutation', adminManagementSystemSupportTicketCommentAdd: SystemOperationStatus };

export type AdminManagementSystemSupportTicketCommentUpdateMutationVariables = Exact<{
  input: AdminManagementSystemSupportTicketCommentUpdateInput;
}>;


export type AdminManagementSystemSupportTicketCommentUpdateMutation = { __typename?: 'Mutation', adminManagementSystemSupportTicketCommentUpdate: SystemOperationStatus };

export type AdminManagementSystemSupportTicketCommentDeleteMutationVariables = Exact<{
  input: AdminManagementSystemSupportTicketCommentDeleteInput;
}>;


export type AdminManagementSystemSupportTicketCommentDeleteMutation = { __typename?: 'Mutation', adminManagementSystemSupportTicketCommentDelete: SystemOperationStatus };

export type AdminManagementSystemSupportTicketDeleteMutationVariables = Exact<{
  input: AdminManagementSystemSupportTicketDeleteInput;
}>;


export type AdminManagementSystemSupportTicketDeleteMutation = { __typename?: 'Mutation', adminManagementSystemSupportTicketDelete: SystemOperationStatus };

export type AdminManagementSystemSupportTicketUpdateMutationVariables = Exact<{
  input: AdminManagementSystemSupportTicketUpdateInput;
}>;


export type AdminManagementSystemSupportTicketUpdateMutation = { __typename?: 'Mutation', adminManagementSystemSupportTicketUpdate: SystemOperationStatus };

export type AdminManagementSystemReportingMutationVariables = Exact<{
  input: AdminManagementSystemReportingInput;
}>;


export type AdminManagementSystemReportingMutation = { __typename?: 'Mutation', adminManagementSystemReporting: SystemOperationStatus };

export type AdminManagementSystemAppMainSliderCreateMutationVariables = Exact<{
  input: AdminManagementSystemAppMainSliderCreateInput;
}>;


export type AdminManagementSystemAppMainSliderCreateMutation = { __typename?: 'Mutation', adminManagementSystemAppMainSliderCreate: { __typename?: 'AdminManagementSystemAppMainSlider', id: string } };

export type AdminManagementSystemAppMainSliderUpdateMutationVariables = Exact<{
  input: AdminManagementSystemAppMainSliderUpdateInput;
}>;


export type AdminManagementSystemAppMainSliderUpdateMutation = { __typename?: 'Mutation', adminManagementSystemAppMainSliderUpdate: { __typename?: 'AdminManagementSystemAppMainSlider', id: string } };

export type AdminManagementSystemAppMainSliderDeleteMutationVariables = Exact<{
  input: AdminManagementSystemAppMainSliderDeleteInput;
}>;


export type AdminManagementSystemAppMainSliderDeleteMutation = { __typename?: 'Mutation', adminManagementSystemAppMainSliderDelete: SystemOperationStatus };

export type AdminManagementSystemAppMainSliderUploadMutationVariables = Exact<{
  input: AdminManagementSystemAppMainSliderUploadInput;
}>;


export type AdminManagementSystemAppMainSliderUploadMutation = { __typename?: 'Mutation', adminManagementSystemAppMainSliderUpload: { __typename?: 'AdminManagementSystemAppMainSliderUploadResponse', fields: any, fileUrl: string, isVideo: boolean, key: string, signedUrl: string } };

export type AdminManagementSystemPropsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminManagementSystemPropsQuery = { __typename?: 'Query', adminManagementSystemProps: { __typename?: 'AdminManagementSystemProps', currentAppVersion: string } };

export type AdminManagementSystemSupportTicketsQueryVariables = Exact<{
  args: AdminManagementSystemSupportTicketsArgs;
}>;


export type AdminManagementSystemSupportTicketsQuery = { __typename?: 'Query', adminManagementSystemSupportTickets: { __typename?: 'AdminManagementSystemSupportTicketResponse', firstTicketDate?: any | null, lastTicketDate?: any | null, edges?: Array<{ __typename?: 'AdminManagementSystemSupportTicketEdge', cursor?: string | null, node?: { __typename?: 'AdminManagementSystemSupportTicketBasic', dateClosed?: any | null, dateOpened?: any | null, id?: string | null, initiatorId?: string | null, initiatorName?: string | null, priority?: SupportTicketPriority | null, status?: SupportTicketStatus | null, title?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, firstRecordDateTime?: any | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminManagementSystemSupportTicketQueryVariables = Exact<{
  args: AdminManagementSystemSupportTicketArgs;
}>;


export type AdminManagementSystemSupportTicketQuery = { __typename?: 'Query', adminManagementSystemSupportTicket: { __typename?: 'AdminManagementSystemSupportTicket', approvedBy?: string | null, body: string, bodyUpdatedAt?: any | null, category?: SupportTicketCategory | null, dateClosed?: any | null, dateOpened?: any | null, id?: string | null, manHoursRequired: number, openedBy: string, priority?: SupportTicketPriority | null, startDate?: any | null, status?: SupportTicketStatus | null, title: string, updatedAt?: any | null, userId: string, userProfileImageUrl?: string | null } };

export type AdminManagementSystemSupportTicketCommentsQueryVariables = Exact<{
  args: AdminManagementSystemSupportTicketCommentsArgs;
}>;


export type AdminManagementSystemSupportTicketCommentsQuery = { __typename?: 'Query', adminManagementSystemSupportTicketComments: Array<{ __typename?: 'AdminManagementSystemSupportTicketComment', editedOn?: any | null, id: string, message: string, postedOn: any, userId: string, userName: string, userProfileImageUrl?: string | null } | null> };

export type AdminManagementSystemSupportTicketUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminManagementSystemSupportTicketUsersQuery = { __typename?: 'Query', adminManagementSystemSupportTicketUsers: Array<{ __typename?: 'AdminManagementSystemSupportTicketUser', userId: string, userName: string }> };

export type AdminManagementSystemAppMainSlidersQueryVariables = Exact<{
  args?: InputMaybe<AdminManagementSystemAppMainSlidersArgs>;
}>;


export type AdminManagementSystemAppMainSlidersQuery = { __typename?: 'Query', adminManagementSystemAppMainSliders: Array<{ __typename?: 'AdminManagementSystemAppMainSlider', baseCountryCode: CountryCode, expiryDate?: any | null, id: string, isVideo?: boolean | null, isYoutube?: boolean | null, linkRoute?: string | null, linkTitle?: string | null, linkUrl?: string | null, order?: number | null, posterPayload?: any | null, posterTitle?: string | null, posterUri?: string | null, publish?: boolean | null, slidePayload?: any | null, slideUri?: string | null, webViewUrl?: string | null }> };

export type AdminManagementSystemAppMainSliderQueryVariables = Exact<{
  args: AdminManagementSystemAppMainSliderArgs;
}>;


export type AdminManagementSystemAppMainSliderQuery = { __typename?: 'Query', adminManagementSystemAppMainSlider: { __typename?: 'AdminManagementSystemAppMainSlider', baseCountryCode: CountryCode, expiryDate?: any | null, id: string, isVideo?: boolean | null, isYoutube?: boolean | null, linkRoute?: string | null, linkTitle?: string | null, linkUrl?: string | null, order?: number | null, posterPayload?: any | null, posterTitle?: string | null, posterUri?: string | null, publish?: boolean | null, slidePayload?: any | null, slideUri?: string | null, webViewUrl?: string | null } };

export type ManagementSystemSubscriptionVariables = Exact<{
  args: ManagementSystemArgs;
}>;


export type ManagementSystemSubscription = { __typename?: 'Subscription', managementSystem?: { __typename?: 'ManagementSystem', eventId: string, evictionFieldNames: Array<string | null>, operation?: ManagementSystemPublishOperation | null, payload?: any | null, ref?: string | null, userId?: string | null, userName?: string | null, userProfileImageUrl?: string | null } | null };


export const AdminAdminUpdatePasswordDocument = gql`
    mutation AdminAdminUpdatePassword($input: AdminAdminUpdatePasswordInput!) {
  adminAdminUpdatePassword(input: $input)
}
    `;
export type AdminAdminUpdatePasswordMutationFn = Apollo.MutationFunction<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>;

/**
 * __useAdminAdminUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAdminAdminUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAdminUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAdminUpdatePasswordMutation, { data, loading, error }] = useAdminAdminUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAdminUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>(AdminAdminUpdatePasswordDocument, options);
      }
export type AdminAdminUpdatePasswordMutationHookResult = ReturnType<typeof useAdminAdminUpdatePasswordMutation>;
export type AdminAdminUpdatePasswordMutationResult = Apollo.MutationResult<AdminAdminUpdatePasswordMutation>;
export type AdminAdminUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>;
export const AdminCreateAdminDocument = gql`
    mutation AdminCreateAdmin($input: AdminCreateAdminInput!) {
  adminCreateAdmin(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    user {
      authorizedClubhouses
      email
      firstName
      lastName
      mobileNumber
      permissions
      profileImageUrl
      status
      userId
    }
  }
}
    `;
export type AdminCreateAdminMutationFn = Apollo.MutationFunction<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>;

/**
 * __useAdminCreateAdminMutation__
 *
 * To run a mutation, you first call `useAdminCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAdminMutation, { data, loading, error }] = useAdminCreateAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>(AdminCreateAdminDocument, options);
      }
export type AdminCreateAdminMutationHookResult = ReturnType<typeof useAdminCreateAdminMutation>;
export type AdminCreateAdminMutationResult = Apollo.MutationResult<AdminCreateAdminMutation>;
export type AdminCreateAdminMutationOptions = Apollo.BaseMutationOptions<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>;
export const AdminDeleteAdminDocument = gql`
    mutation AdminDeleteAdmin($input: AdminDeleteAdminInput) {
  adminDeleteAdmin(input: $input)
}
    `;
export type AdminDeleteAdminMutationFn = Apollo.MutationFunction<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>;

/**
 * __useAdminDeleteAdminMutation__
 *
 * To run a mutation, you first call `useAdminDeleteAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteAdminMutation, { data, loading, error }] = useAdminDeleteAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteAdminMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>(AdminDeleteAdminDocument, options);
      }
export type AdminDeleteAdminMutationHookResult = ReturnType<typeof useAdminDeleteAdminMutation>;
export type AdminDeleteAdminMutationResult = Apollo.MutationResult<AdminDeleteAdminMutation>;
export type AdminDeleteAdminMutationOptions = Apollo.BaseMutationOptions<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>;
export const AdminUpdateAdminDocument = gql`
    mutation AdminUpdateAdmin($args: AdminUpdateAdminArgs!, $input: AdminUpdateAdminInput!) {
  adminUpdateAdmin(args: $args, input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    user {
      authorizedClubhouses
      baseCountryCode
      createdAt
      displayName
      email
      firstName
      gender
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      logins {
        city
        ipAddress
        time
      }
      mobileNumber
      organization {
        businessName
        clubhouses {
          clubhouseCode
          name
        }
        id
      }
      permissions
      profileImageUrl
      status
      updatedAt
      userId
      userType
    }
  }
}
    `;
export type AdminUpdateAdminMutationFn = Apollo.MutationFunction<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>;

/**
 * __useAdminUpdateAdminMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAdminMutation, { data, loading, error }] = useAdminUpdateAdminMutation({
 *   variables: {
 *      args: // value for 'args'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateAdminMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>(AdminUpdateAdminDocument, options);
      }
export type AdminUpdateAdminMutationHookResult = ReturnType<typeof useAdminUpdateAdminMutation>;
export type AdminUpdateAdminMutationResult = Apollo.MutationResult<AdminUpdateAdminMutation>;
export type AdminUpdateAdminMutationOptions = Apollo.BaseMutationOptions<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>;
export const AdminResendOnboardingEmailDocument = gql`
    mutation AdminResendOnboardingEmail($input: AdminResendOnboardingEmailInput!) {
  adminResendOnboardingEmail(input: $input)
}
    `;
export type AdminResendOnboardingEmailMutationFn = Apollo.MutationFunction<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>;

/**
 * __useAdminResendOnboardingEmailMutation__
 *
 * To run a mutation, you first call `useAdminResendOnboardingEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResendOnboardingEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResendOnboardingEmailMutation, { data, loading, error }] = useAdminResendOnboardingEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminResendOnboardingEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>(AdminResendOnboardingEmailDocument, options);
      }
export type AdminResendOnboardingEmailMutationHookResult = ReturnType<typeof useAdminResendOnboardingEmailMutation>;
export type AdminResendOnboardingEmailMutationResult = Apollo.MutationResult<AdminResendOnboardingEmailMutation>;
export type AdminResendOnboardingEmailMutationOptions = Apollo.BaseMutationOptions<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>;
export const FormHelperNewAdminDocument = gql`
    query FormHelperNewAdmin($args: FormHelperNewAdminArgs!) {
  formHelperNewAdmin(args: $args) {
    clubhouses {
      clubhouseCode
      clubhouseId
      name
    }
  }
}
    `;

/**
 * __useFormHelperNewAdminQuery__
 *
 * To run a query within a React component, call `useFormHelperNewAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewAdminQuery(baseOptions: Apollo.QueryHookOptions<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>(FormHelperNewAdminDocument, options);
      }
export function useFormHelperNewAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>(FormHelperNewAdminDocument, options);
        }
export type FormHelperNewAdminQueryHookResult = ReturnType<typeof useFormHelperNewAdminQuery>;
export type FormHelperNewAdminLazyQueryHookResult = ReturnType<typeof useFormHelperNewAdminLazyQuery>;
export type FormHelperNewAdminQueryResult = Apollo.QueryResult<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>;
export const AdminsDocument = gql`
    query Admins($args: AdminsArgs!) {
  admins(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        createdAt
        firstName
        lastAccessTokenDate
        lastLoginDate
        lastName
        organization {
          businessName
          clubhouses {
            clubhouseCode
            name
          }
          id
        }
        profileImageUrl
        status
        userId
        userName
        userType
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminsQuery__
 *
 * To run a query within a React component, call `useAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminsQuery(baseOptions: Apollo.QueryHookOptions<AdminsQuery, AdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminsQuery, AdminsQueryVariables>(AdminsDocument, options);
      }
export function useAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminsQuery, AdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminsQuery, AdminsQueryVariables>(AdminsDocument, options);
        }
export type AdminsQueryHookResult = ReturnType<typeof useAdminsQuery>;
export type AdminsLazyQueryHookResult = ReturnType<typeof useAdminsLazyQuery>;
export type AdminsQueryResult = Apollo.QueryResult<AdminsQuery, AdminsQueryVariables>;
export const AdminDocument = gql`
    query Admin($args: AdminArgs!) {
  admin(args: $args) {
    authorizedClubhouses
    baseCountryCode
    createdAt
    displayName
    email
    firstName
    gender
    lastAccessTokenDate
    lastLogin {
      city
      ipAddress
      time
    }
    lastLoginDate
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organization {
      businessName
      clubhouses {
        clubhouseCode
        name
      }
      id
    }
    permissions
    profileImageUrl
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useAdminQuery__
 *
 * To run a query within a React component, call `useAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminQuery(baseOptions: Apollo.QueryHookOptions<AdminQuery, AdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuery, AdminQueryVariables>(AdminDocument, options);
      }
export function useAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuery, AdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuery, AdminQueryVariables>(AdminDocument, options);
        }
export type AdminQueryHookResult = ReturnType<typeof useAdminQuery>;
export type AdminLazyQueryHookResult = ReturnType<typeof useAdminLazyQuery>;
export type AdminQueryResult = Apollo.QueryResult<AdminQuery, AdminQueryVariables>;
export const AdminBookingCancelDocument = gql`
    mutation AdminBookingCancel($input: AdminBookingCancelInput!) {
  adminBookingCancel(input: $input)
}
    `;
export type AdminBookingCancelMutationFn = Apollo.MutationFunction<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>;

/**
 * __useAdminBookingCancelMutation__
 *
 * To run a mutation, you first call `useAdminBookingCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingCancelMutation, { data, loading, error }] = useAdminBookingCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingCancelMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>(AdminBookingCancelDocument, options);
      }
export type AdminBookingCancelMutationHookResult = ReturnType<typeof useAdminBookingCancelMutation>;
export type AdminBookingCancelMutationResult = Apollo.MutationResult<AdminBookingCancelMutation>;
export type AdminBookingCancelMutationOptions = Apollo.BaseMutationOptions<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>;
export const AdminBookingSendCancellationNotificationDocument = gql`
    mutation AdminBookingSendCancellationNotification($input: AdminBookingSendCancellationNotificationInput!) {
  adminBookingSendCancellationNotification(input: $input)
}
    `;
export type AdminBookingSendCancellationNotificationMutationFn = Apollo.MutationFunction<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>;

/**
 * __useAdminBookingSendCancellationNotificationMutation__
 *
 * To run a mutation, you first call `useAdminBookingSendCancellationNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingSendCancellationNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingSendCancellationNotificationMutation, { data, loading, error }] = useAdminBookingSendCancellationNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingSendCancellationNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>(AdminBookingSendCancellationNotificationDocument, options);
      }
export type AdminBookingSendCancellationNotificationMutationHookResult = ReturnType<typeof useAdminBookingSendCancellationNotificationMutation>;
export type AdminBookingSendCancellationNotificationMutationResult = Apollo.MutationResult<AdminBookingSendCancellationNotificationMutation>;
export type AdminBookingSendCancellationNotificationMutationOptions = Apollo.BaseMutationOptions<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>;
export const AdminBookingGameCreateDocument = gql`
    mutation AdminBookingGameCreate($input: AdminBookingGameCreateInput!) {
  adminBookingGameCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingGameCreateMutationFn = Apollo.MutationFunction<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>;

/**
 * __useAdminBookingGameCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingGameCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingGameCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingGameCreateMutation, { data, loading, error }] = useAdminBookingGameCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingGameCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>(AdminBookingGameCreateDocument, options);
      }
export type AdminBookingGameCreateMutationHookResult = ReturnType<typeof useAdminBookingGameCreateMutation>;
export type AdminBookingGameCreateMutationResult = Apollo.MutationResult<AdminBookingGameCreateMutation>;
export type AdminBookingGameCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>;
export const AdminBookingLessonIndoorCreateDocument = gql`
    mutation AdminBookingLessonIndoorCreate($input: AdminBookingLessonIndoorCreateInput!) {
  adminBookingLessonIndoorCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingLessonIndoorCreateMutationFn = Apollo.MutationFunction<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>;

/**
 * __useAdminBookingLessonIndoorCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingLessonIndoorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonIndoorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingLessonIndoorCreateMutation, { data, loading, error }] = useAdminBookingLessonIndoorCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingLessonIndoorCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>(AdminBookingLessonIndoorCreateDocument, options);
      }
export type AdminBookingLessonIndoorCreateMutationHookResult = ReturnType<typeof useAdminBookingLessonIndoorCreateMutation>;
export type AdminBookingLessonIndoorCreateMutationResult = Apollo.MutationResult<AdminBookingLessonIndoorCreateMutation>;
export type AdminBookingLessonIndoorCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>;
export const AdminBookingLessonOutdoorCreateDocument = gql`
    mutation AdminBookingLessonOutdoorCreate($input: AdminBookingLessonOutdoorCreateInput!) {
  adminBookingLessonOutdoorCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingLessonOutdoorCreateMutationFn = Apollo.MutationFunction<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>;

/**
 * __useAdminBookingLessonOutdoorCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingLessonOutdoorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonOutdoorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingLessonOutdoorCreateMutation, { data, loading, error }] = useAdminBookingLessonOutdoorCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingLessonOutdoorCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>(AdminBookingLessonOutdoorCreateDocument, options);
      }
export type AdminBookingLessonOutdoorCreateMutationHookResult = ReturnType<typeof useAdminBookingLessonOutdoorCreateMutation>;
export type AdminBookingLessonOutdoorCreateMutationResult = Apollo.MutationResult<AdminBookingLessonOutdoorCreateMutation>;
export type AdminBookingLessonOutdoorCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>;
export const AdminBookingPractiseCreateDocument = gql`
    mutation AdminBookingPractiseCreate($input: AdminBookingPractiseCreateInput!) {
  adminBookingPractiseCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingPractiseCreateMutationFn = Apollo.MutationFunction<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>;

/**
 * __useAdminBookingPractiseCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingPractiseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingPractiseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingPractiseCreateMutation, { data, loading, error }] = useAdminBookingPractiseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingPractiseCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>(AdminBookingPractiseCreateDocument, options);
      }
export type AdminBookingPractiseCreateMutationHookResult = ReturnType<typeof useAdminBookingPractiseCreateMutation>;
export type AdminBookingPractiseCreateMutationResult = Apollo.MutationResult<AdminBookingPractiseCreateMutation>;
export type AdminBookingPractiseCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>;
export const AdminBookingBlackoutCreateDocument = gql`
    mutation AdminBookingBlackoutCreate($input: AdminBookingBlackoutCreateInput!) {
  adminBookingBlackoutCreate(input: $input) {
    errorMessage
    isCreateAllowed
  }
}
    `;
export type AdminBookingBlackoutCreateMutationFn = Apollo.MutationFunction<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>;

/**
 * __useAdminBookingBlackoutCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutCreateMutation, { data, loading, error }] = useAdminBookingBlackoutCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>(AdminBookingBlackoutCreateDocument, options);
      }
export type AdminBookingBlackoutCreateMutationHookResult = ReturnType<typeof useAdminBookingBlackoutCreateMutation>;
export type AdminBookingBlackoutCreateMutationResult = Apollo.MutationResult<AdminBookingBlackoutCreateMutation>;
export type AdminBookingBlackoutCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>;
export const AdminBookingBlackoutClubhouseUpdateDocument = gql`
    mutation AdminBookingBlackoutClubhouseUpdate($input: AdminBookingBlackoutClubhouseUpdateInput!) {
  adminBookingBlackoutClubhouseUpdate(input: $input) {
    block08
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    block21
    block22
    block23
    clubhouseCode
    date
    facilityObjs {
      availability {
        bi0800
        bi0830
        bi0900
        bi0930
        bi1000
        bi1030
        bi1100
        bi1130
        bi1200
        bi1230
        bi1300
        bi1330
        bi1400
        bi1430
        bi1500
        bi1530
        bi1600
        bi1630
        bi1700
        bi1730
        bi1800
        bi1830
        bi1900
        bi1930
        bi2000
        bi2030
        bi2100
        bi2130
        bi2200
        bi2230
        bi2300
        bi2330
      }
      facilityCode
      facilityName
      facilityType
    }
    isDayBlocked
    name
  }
}
    `;
export type AdminBookingBlackoutClubhouseUpdateMutationFn = Apollo.MutationFunction<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>;

/**
 * __useAdminBookingBlackoutClubhouseUpdateMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutClubhouseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutClubhouseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutClubhouseUpdateMutation, { data, loading, error }] = useAdminBookingBlackoutClubhouseUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutClubhouseUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>(AdminBookingBlackoutClubhouseUpdateDocument, options);
      }
export type AdminBookingBlackoutClubhouseUpdateMutationHookResult = ReturnType<typeof useAdminBookingBlackoutClubhouseUpdateMutation>;
export type AdminBookingBlackoutClubhouseUpdateMutationResult = Apollo.MutationResult<AdminBookingBlackoutClubhouseUpdateMutation>;
export type AdminBookingBlackoutClubhouseUpdateMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>;
export const AdminBookingBlackoutCoachUpdateDocument = gql`
    mutation AdminBookingBlackoutCoachUpdate($input: AdminBookingBlackoutCoachUpdateInput!) {
  adminBookingBlackoutCoachUpdate(input: $input) {
    block08
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    block21
    coachDisplayName
    coachSlug
    date
    isDayBlocked
  }
}
    `;
export type AdminBookingBlackoutCoachUpdateMutationFn = Apollo.MutationFunction<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>;

/**
 * __useAdminBookingBlackoutCoachUpdateMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutCoachUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutCoachUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutCoachUpdateMutation, { data, loading, error }] = useAdminBookingBlackoutCoachUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutCoachUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>(AdminBookingBlackoutCoachUpdateDocument, options);
      }
export type AdminBookingBlackoutCoachUpdateMutationHookResult = ReturnType<typeof useAdminBookingBlackoutCoachUpdateMutation>;
export type AdminBookingBlackoutCoachUpdateMutationResult = Apollo.MutationResult<AdminBookingBlackoutCoachUpdateMutation>;
export type AdminBookingBlackoutCoachUpdateMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>;
export const AdminBookingBlackoutDeleteDocument = gql`
    mutation AdminBookingBlackoutDelete($input: AdminBookingBlackoutDeleteInput!) {
  adminBookingBlackoutDelete(input: $input)
}
    `;
export type AdminBookingBlackoutDeleteMutationFn = Apollo.MutationFunction<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>;

/**
 * __useAdminBookingBlackoutDeleteMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutDeleteMutation, { data, loading, error }] = useAdminBookingBlackoutDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>(AdminBookingBlackoutDeleteDocument, options);
      }
export type AdminBookingBlackoutDeleteMutationHookResult = ReturnType<typeof useAdminBookingBlackoutDeleteMutation>;
export type AdminBookingBlackoutDeleteMutationResult = Apollo.MutationResult<AdminBookingBlackoutDeleteMutation>;
export type AdminBookingBlackoutDeleteMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>;
export const AdminBookingUpdateDocument = gql`
    mutation AdminBookingUpdate($input: AdminBookingUpdateInput!) {
  adminBookingUpdate(input: $input)
}
    `;
export type AdminBookingUpdateMutationFn = Apollo.MutationFunction<AdminBookingUpdateMutation, AdminBookingUpdateMutationVariables>;

/**
 * __useAdminBookingUpdateMutation__
 *
 * To run a mutation, you first call `useAdminBookingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingUpdateMutation, { data, loading, error }] = useAdminBookingUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingUpdateMutation, AdminBookingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingUpdateMutation, AdminBookingUpdateMutationVariables>(AdminBookingUpdateDocument, options);
      }
export type AdminBookingUpdateMutationHookResult = ReturnType<typeof useAdminBookingUpdateMutation>;
export type AdminBookingUpdateMutationResult = Apollo.MutationResult<AdminBookingUpdateMutation>;
export type AdminBookingUpdateMutationOptions = Apollo.BaseMutationOptions<AdminBookingUpdateMutation, AdminBookingUpdateMutationVariables>;
export const AdminBookingUpdateToGroupDocument = gql`
    mutation AdminBookingUpdateToGroup($input: AdminBookingUpdateToGroupInput!) {
  adminBookingUpdateToGroup(input: $input)
}
    `;
export type AdminBookingUpdateToGroupMutationFn = Apollo.MutationFunction<AdminBookingUpdateToGroupMutation, AdminBookingUpdateToGroupMutationVariables>;

/**
 * __useAdminBookingUpdateToGroupMutation__
 *
 * To run a mutation, you first call `useAdminBookingUpdateToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingUpdateToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingUpdateToGroupMutation, { data, loading, error }] = useAdminBookingUpdateToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingUpdateToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingUpdateToGroupMutation, AdminBookingUpdateToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingUpdateToGroupMutation, AdminBookingUpdateToGroupMutationVariables>(AdminBookingUpdateToGroupDocument, options);
      }
export type AdminBookingUpdateToGroupMutationHookResult = ReturnType<typeof useAdminBookingUpdateToGroupMutation>;
export type AdminBookingUpdateToGroupMutationResult = Apollo.MutationResult<AdminBookingUpdateToGroupMutation>;
export type AdminBookingUpdateToGroupMutationOptions = Apollo.BaseMutationOptions<AdminBookingUpdateToGroupMutation, AdminBookingUpdateToGroupMutationVariables>;
export const AdminBookingBookingFacilityUpdateDocument = gql`
    mutation AdminBookingBookingFacilityUpdate($input: AdminBookingBookingFacilityUpdateInput!) {
  adminBookingBookingFacilityUpdate(input: $input)
}
    `;
export type AdminBookingBookingFacilityUpdateMutationFn = Apollo.MutationFunction<AdminBookingBookingFacilityUpdateMutation, AdminBookingBookingFacilityUpdateMutationVariables>;

/**
 * __useAdminBookingBookingFacilityUpdateMutation__
 *
 * To run a mutation, you first call `useAdminBookingBookingFacilityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBookingFacilityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBookingFacilityUpdateMutation, { data, loading, error }] = useAdminBookingBookingFacilityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBookingFacilityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBookingFacilityUpdateMutation, AdminBookingBookingFacilityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBookingFacilityUpdateMutation, AdminBookingBookingFacilityUpdateMutationVariables>(AdminBookingBookingFacilityUpdateDocument, options);
      }
export type AdminBookingBookingFacilityUpdateMutationHookResult = ReturnType<typeof useAdminBookingBookingFacilityUpdateMutation>;
export type AdminBookingBookingFacilityUpdateMutationResult = Apollo.MutationResult<AdminBookingBookingFacilityUpdateMutation>;
export type AdminBookingBookingFacilityUpdateMutationOptions = Apollo.BaseMutationOptions<AdminBookingBookingFacilityUpdateMutation, AdminBookingBookingFacilityUpdateMutationVariables>;
export const AdminBookingOptionalPlayerNameUpdateDocument = gql`
    mutation AdminBookingOptionalPlayerNameUpdate($input: AdminBookingOptionalPlayerNameUpdateInput!) {
  adminBookingOptionalPlayerNameUpdate(input: $input)
}
    `;
export type AdminBookingOptionalPlayerNameUpdateMutationFn = Apollo.MutationFunction<AdminBookingOptionalPlayerNameUpdateMutation, AdminBookingOptionalPlayerNameUpdateMutationVariables>;

/**
 * __useAdminBookingOptionalPlayerNameUpdateMutation__
 *
 * To run a mutation, you first call `useAdminBookingOptionalPlayerNameUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingOptionalPlayerNameUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingOptionalPlayerNameUpdateMutation, { data, loading, error }] = useAdminBookingOptionalPlayerNameUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingOptionalPlayerNameUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingOptionalPlayerNameUpdateMutation, AdminBookingOptionalPlayerNameUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingOptionalPlayerNameUpdateMutation, AdminBookingOptionalPlayerNameUpdateMutationVariables>(AdminBookingOptionalPlayerNameUpdateDocument, options);
      }
export type AdminBookingOptionalPlayerNameUpdateMutationHookResult = ReturnType<typeof useAdminBookingOptionalPlayerNameUpdateMutation>;
export type AdminBookingOptionalPlayerNameUpdateMutationResult = Apollo.MutationResult<AdminBookingOptionalPlayerNameUpdateMutation>;
export type AdminBookingOptionalPlayerNameUpdateMutationOptions = Apollo.BaseMutationOptions<AdminBookingOptionalPlayerNameUpdateMutation, AdminBookingOptionalPlayerNameUpdateMutationVariables>;
export const CoachBookingCommentUpdateDocument = gql`
    mutation CoachBookingCommentUpdate($input: CoachBookingCommentUpdateInput!) {
  coachBookingCommentUpdate(input: $input) {
    commentByCoach
  }
}
    `;
export type CoachBookingCommentUpdateMutationFn = Apollo.MutationFunction<CoachBookingCommentUpdateMutation, CoachBookingCommentUpdateMutationVariables>;

/**
 * __useCoachBookingCommentUpdateMutation__
 *
 * To run a mutation, you first call `useCoachBookingCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachBookingCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachBookingCommentUpdateMutation, { data, loading, error }] = useCoachBookingCommentUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachBookingCommentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CoachBookingCommentUpdateMutation, CoachBookingCommentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoachBookingCommentUpdateMutation, CoachBookingCommentUpdateMutationVariables>(CoachBookingCommentUpdateDocument, options);
      }
export type CoachBookingCommentUpdateMutationHookResult = ReturnType<typeof useCoachBookingCommentUpdateMutation>;
export type CoachBookingCommentUpdateMutationResult = Apollo.MutationResult<CoachBookingCommentUpdateMutation>;
export type CoachBookingCommentUpdateMutationOptions = Apollo.BaseMutationOptions<CoachBookingCommentUpdateMutation, CoachBookingCommentUpdateMutationVariables>;
export const AdminBookingCoachesDocument = gql`
    query AdminBookingCoaches {
  adminBookingCoaches {
    baseCountryCode
    coachPublished
    displayName
    profileImageUrl
    slug
    userId
  }
}
    `;

/**
 * __useAdminBookingCoachesQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminBookingCoachesQuery(baseOptions?: Apollo.QueryHookOptions<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>(AdminBookingCoachesDocument, options);
      }
export function useAdminBookingCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>(AdminBookingCoachesDocument, options);
        }
export type AdminBookingCoachesQueryHookResult = ReturnType<typeof useAdminBookingCoachesQuery>;
export type AdminBookingCoachesLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachesLazyQuery>;
export type AdminBookingCoachesQueryResult = Apollo.QueryResult<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>;
export const AdminBookingCoachesBasicDocument = gql`
    query AdminBookingCoachesBasic {
  adminBookingCoaches {
    displayName
    userId
  }
}
    `;

/**
 * __useAdminBookingCoachesBasicQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachesBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachesBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachesBasicQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminBookingCoachesBasicQuery(baseOptions?: Apollo.QueryHookOptions<AdminBookingCoachesBasicQuery, AdminBookingCoachesBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachesBasicQuery, AdminBookingCoachesBasicQueryVariables>(AdminBookingCoachesBasicDocument, options);
      }
export function useAdminBookingCoachesBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachesBasicQuery, AdminBookingCoachesBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachesBasicQuery, AdminBookingCoachesBasicQueryVariables>(AdminBookingCoachesBasicDocument, options);
        }
export type AdminBookingCoachesBasicQueryHookResult = ReturnType<typeof useAdminBookingCoachesBasicQuery>;
export type AdminBookingCoachesBasicLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachesBasicLazyQuery>;
export type AdminBookingCoachesBasicQueryResult = Apollo.QueryResult<AdminBookingCoachesBasicQuery, AdminBookingCoachesBasicQueryVariables>;
export const AdminBookingCoachAvailabilityCalendarItemsDocument = gql`
    query AdminBookingCoachAvailabilityCalendarItems($args: AdminBookingCoachAvailabilityCalendarItemsArgs!) {
  adminBookingCoachAvailabilityCalendarItems(args: $args) {
    calendarItems {
      clubhouses
      date
      hasIndoorBooking
      hasOutdoorBooking
      isBlocked
      isIndoorBookingFull
    }
    clubhouses {
      clubhouseCode
      displayName
      tagBgColorCode
      tagText
      tagTextColorCode
    }
  }
}
    `;

/**
 * __useAdminBookingCoachAvailabilityCalendarItemsQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachAvailabilityCalendarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachAvailabilityCalendarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachAvailabilityCalendarItemsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCoachAvailabilityCalendarItemsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>(AdminBookingCoachAvailabilityCalendarItemsDocument, options);
      }
export function useAdminBookingCoachAvailabilityCalendarItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>(AdminBookingCoachAvailabilityCalendarItemsDocument, options);
        }
export type AdminBookingCoachAvailabilityCalendarItemsQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityCalendarItemsQuery>;
export type AdminBookingCoachAvailabilityCalendarItemsLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityCalendarItemsLazyQuery>;
export type AdminBookingCoachAvailabilityCalendarItemsQueryResult = Apollo.QueryResult<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>;
export const AdminBookingCoachAvailabilityDayItemDocument = gql`
    query AdminBookingCoachAvailabilityDayItem($args: AdminBookingCoachAvailabilityDayItemArgs!) {
  adminBookingCoachAvailabilityDayItem(args: $args) {
    bi0800
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    bi2100
    blockedClubhousesDay
    blockedClubhousesHours
    bs0800
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    bs2100
    date
    l0800
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
    l2100
  }
}
    `;

/**
 * __useAdminBookingCoachAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCoachAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>(AdminBookingCoachAvailabilityDayItemDocument, options);
      }
export function useAdminBookingCoachAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>(AdminBookingCoachAvailabilityDayItemDocument, options);
        }
export type AdminBookingCoachAvailabilityDayItemQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityDayItemQuery>;
export type AdminBookingCoachAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityDayItemLazyQuery>;
export type AdminBookingCoachAvailabilityDayItemQueryResult = Apollo.QueryResult<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>;
export const AdminBookingCoachAvailabilitySlotItemDocument = gql`
    query AdminBookingCoachAvailabilitySlotItem($args: AdminBookingCoachAvailabilitySlotItemArgs!) {
  adminBookingCoachAvailabilitySlotItem(args: $args) {
    hr1 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr2 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
  }
}
    `;

/**
 * __useAdminBookingCoachAvailabilitySlotItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachAvailabilitySlotItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachAvailabilitySlotItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachAvailabilitySlotItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCoachAvailabilitySlotItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>(AdminBookingCoachAvailabilitySlotItemDocument, options);
      }
export function useAdminBookingCoachAvailabilitySlotItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>(AdminBookingCoachAvailabilitySlotItemDocument, options);
        }
export type AdminBookingCoachAvailabilitySlotItemQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilitySlotItemQuery>;
export type AdminBookingCoachAvailabilitySlotItemLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilitySlotItemLazyQuery>;
export type AdminBookingCoachAvailabilitySlotItemQueryResult = Apollo.QueryResult<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>;
export const AdminBookingFacilityAvailabilityDayItemDocument = gql`
    query AdminBookingFacilityAvailabilityDayItem($args: AdminBookingFacilityAvailabilityDayItemArgs!) {
  adminBookingFacilityAvailabilityDayItem(args: $args) {
    nonPutting {
      na0800
      na0900
      na1000
      na1100
      na1200
      na1300
      na1400
      na1500
      na1600
      na1700
      na1800
      na1900
      na2000
      na2100
      na2200
      na2300
    }
    putting {
      na0800
      na0830
      na0900
      na0930
      na1000
      na1030
      na1100
      na1130
      na1200
      na1230
      na1300
      na1330
      na1400
      na1430
      na1500
      na1530
      na1600
      na1630
      na1700
      na1730
      na1800
      na1830
      na1900
      na1930
      na2000
      na2030
      na2100
      na2130
      na2200
      na2230
      na2300
      na2330
    }
  }
}
    `;

/**
 * __useAdminBookingFacilityAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingFacilityAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingFacilityAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingFacilityAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingFacilityAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>(AdminBookingFacilityAvailabilityDayItemDocument, options);
      }
export function useAdminBookingFacilityAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>(AdminBookingFacilityAvailabilityDayItemDocument, options);
        }
export type AdminBookingFacilityAvailabilityDayItemQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityDayItemQuery>;
export type AdminBookingFacilityAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityDayItemLazyQuery>;
export type AdminBookingFacilityAvailabilityDayItemQueryResult = Apollo.QueryResult<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>;
export const AdminBookingFacilityAvailabilitySlotItemDocument = gql`
    query AdminBookingFacilityAvailabilitySlotItem($args: AdminBookingFacilityAvailabilitySlotItemArgs!) {
  adminBookingFacilityAvailabilitySlotItem(args: $args) {
    hr1 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr2 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr3 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr4 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr5 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    putting30 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    putting60 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
  }
}
    `;

/**
 * __useAdminBookingFacilityAvailabilitySlotItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingFacilityAvailabilitySlotItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingFacilityAvailabilitySlotItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingFacilityAvailabilitySlotItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingFacilityAvailabilitySlotItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>(AdminBookingFacilityAvailabilitySlotItemDocument, options);
      }
export function useAdminBookingFacilityAvailabilitySlotItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>(AdminBookingFacilityAvailabilitySlotItemDocument, options);
        }
export type AdminBookingFacilityAvailabilitySlotItemQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilitySlotItemQuery>;
export type AdminBookingFacilityAvailabilitySlotItemLazyQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilitySlotItemLazyQuery>;
export type AdminBookingFacilityAvailabilitySlotItemQueryResult = Apollo.QueryResult<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>;
export const AdminBookingFacilityAvailabilityCalendarItemsDocument = gql`
    query AdminBookingFacilityAvailabilityCalendarItems($args: AdminBookingFacilityAvailabilityCalendarItemsArgs!) {
  adminBookingFacilityAvailabilityCalendarItems(args: $args) {
    calendarItems {
      date
      isBlocked
    }
  }
}
    `;

/**
 * __useAdminBookingFacilityAvailabilityCalendarItemsQuery__
 *
 * To run a query within a React component, call `useAdminBookingFacilityAvailabilityCalendarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingFacilityAvailabilityCalendarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingFacilityAvailabilityCalendarItemsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingFacilityAvailabilityCalendarItemsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>(AdminBookingFacilityAvailabilityCalendarItemsDocument, options);
      }
export function useAdminBookingFacilityAvailabilityCalendarItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>(AdminBookingFacilityAvailabilityCalendarItemsDocument, options);
        }
export type AdminBookingFacilityAvailabilityCalendarItemsQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityCalendarItemsQuery>;
export type AdminBookingFacilityAvailabilityCalendarItemsLazyQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityCalendarItemsLazyQuery>;
export type AdminBookingFacilityAvailabilityCalendarItemsQueryResult = Apollo.QueryResult<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>;
export const AdminCoachCombinedAvailabilityDocument = gql`
    query AdminCoachCombinedAvailability($args: AdminCoachCombinedAvailabilityArgs!) {
  adminCoachCombinedAvailability(args: $args) {
    coachId
    coachSlug
    dateObjs {
      clubhouses
      date
      hasIndoorBooking
      hasOutdoorBooking
      isDayBlocked
    }
    name
  }
}
    `;

/**
 * __useAdminCoachCombinedAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdminCoachCombinedAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachCombinedAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachCombinedAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachCombinedAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>(AdminCoachCombinedAvailabilityDocument, options);
      }
export function useAdminCoachCombinedAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>(AdminCoachCombinedAvailabilityDocument, options);
        }
export type AdminCoachCombinedAvailabilityQueryHookResult = ReturnType<typeof useAdminCoachCombinedAvailabilityQuery>;
export type AdminCoachCombinedAvailabilityLazyQueryHookResult = ReturnType<typeof useAdminCoachCombinedAvailabilityLazyQuery>;
export type AdminCoachCombinedAvailabilityQueryResult = Apollo.QueryResult<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>;
export const AdminClubhouseFacilityAvailabilityDocument = gql`
    query AdminClubhouseFacilityAvailability($args: AdminClubhouseFacilityAvailabilityArgs!) {
  adminClubhouseFacilityAvailability(args: $args) {
    clubhouseCode
    date
    facilityObjs {
      availability {
        bi0800
        bi0830
        bi0900
        bi0930
        bi1000
        bi1030
        bi1100
        bi1130
        bi1200
        bi1230
        bi1300
        bi1330
        bi1400
        bi1430
        bi1500
        bi1530
        bi1600
        bi1630
        bi1700
        bi1730
        bi1800
        bi1830
        bi1900
        bi1930
        bi2000
        bi2030
        bi2100
        bi2130
        bi2200
        bi2230
        bi2300
        bi2330
      }
      facilityCode
      facilityName
      facilityType
    }
    isDayBlocked
    name
  }
}
    `;

/**
 * __useAdminClubhouseFacilityAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdminClubhouseFacilityAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhouseFacilityAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhouseFacilityAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhouseFacilityAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>(AdminClubhouseFacilityAvailabilityDocument, options);
      }
export function useAdminClubhouseFacilityAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>(AdminClubhouseFacilityAvailabilityDocument, options);
        }
export type AdminClubhouseFacilityAvailabilityQueryHookResult = ReturnType<typeof useAdminClubhouseFacilityAvailabilityQuery>;
export type AdminClubhouseFacilityAvailabilityLazyQueryHookResult = ReturnType<typeof useAdminClubhouseFacilityAvailabilityLazyQuery>;
export type AdminClubhouseFacilityAvailabilityQueryResult = Apollo.QueryResult<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>;
export const AdminBookingBlackoutClubhouseDocument = gql`
    query AdminBookingBlackoutClubhouse($args: AdminBookingBlackoutClubhouseArgs!) {
  adminBookingBlackoutClubhouse(args: $args) {
    block08
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    block21
    block22
    block23
    clubhouseCode
    date
    facilityObjs {
      availability {
        bi0800
        bi0830
        bi0900
        bi0930
        bi1000
        bi1030
        bi1100
        bi1130
        bi1200
        bi1230
        bi1300
        bi1330
        bi1400
        bi1430
        bi1500
        bi1530
        bi1600
        bi1630
        bi1700
        bi1730
        bi1800
        bi1830
        bi1900
        bi1930
        bi2000
        bi2030
        bi2100
        bi2130
        bi2200
        bi2230
        bi2300
        bi2330
      }
      facilityCode
      facilityName
      facilityType
    }
    isDayBlocked
    name
  }
}
    `;

/**
 * __useAdminBookingBlackoutClubhouseQuery__
 *
 * To run a query within a React component, call `useAdminBookingBlackoutClubhouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutClubhouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBlackoutClubhouseQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBlackoutClubhouseQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>(AdminBookingBlackoutClubhouseDocument, options);
      }
export function useAdminBookingBlackoutClubhouseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>(AdminBookingBlackoutClubhouseDocument, options);
        }
export type AdminBookingBlackoutClubhouseQueryHookResult = ReturnType<typeof useAdminBookingBlackoutClubhouseQuery>;
export type AdminBookingBlackoutClubhouseLazyQueryHookResult = ReturnType<typeof useAdminBookingBlackoutClubhouseLazyQuery>;
export type AdminBookingBlackoutClubhouseQueryResult = Apollo.QueryResult<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>;
export const AdminBookingBlackoutCoachDocument = gql`
    query AdminBookingBlackoutCoach($args: AdminBookingBlackoutCoachArgs!) {
  adminBookingBlackoutCoach(args: $args) {
    block08
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    block21
    coachDisplayName
    coachSlug
    date
    isDayBlocked
  }
}
    `;

/**
 * __useAdminBookingBlackoutCoachQuery__
 *
 * To run a query within a React component, call `useAdminBookingBlackoutCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBlackoutCoachQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBlackoutCoachQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>(AdminBookingBlackoutCoachDocument, options);
      }
export function useAdminBookingBlackoutCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>(AdminBookingBlackoutCoachDocument, options);
        }
export type AdminBookingBlackoutCoachQueryHookResult = ReturnType<typeof useAdminBookingBlackoutCoachQuery>;
export type AdminBookingBlackoutCoachLazyQueryHookResult = ReturnType<typeof useAdminBookingBlackoutCoachLazyQuery>;
export type AdminBookingBlackoutCoachQueryResult = Apollo.QueryResult<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>;
export const AdminBookingBlackoutsDocument = gql`
    query AdminBookingBlackouts($args: AdminBookingBlackoutsArgs!) {
  adminBookingBlackouts(args: $args) {
    clubhouseCode
    clubhouseName
    coachDisplayName
    coachSlug
    countryCode
    date
    type
  }
}
    `;

/**
 * __useAdminBookingBlackoutsQuery__
 *
 * To run a query within a React component, call `useAdminBookingBlackoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBlackoutsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBlackoutsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>(AdminBookingBlackoutsDocument, options);
      }
export function useAdminBookingBlackoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>(AdminBookingBlackoutsDocument, options);
        }
export type AdminBookingBlackoutsQueryHookResult = ReturnType<typeof useAdminBookingBlackoutsQuery>;
export type AdminBookingBlackoutsLazyQueryHookResult = ReturnType<typeof useAdminBookingBlackoutsLazyQuery>;
export type AdminBookingBlackoutsQueryResult = Apollo.QueryResult<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>;
export const AdminBookingCombinedCoachAvailabilityDayItemDocument = gql`
    query AdminBookingCombinedCoachAvailabilityDayItem($args: AdminBookingCombinedCoachAvailabilityDayItemArgs!) {
  adminBookingCombinedCoachAvailabilityDayItem(args: $args) {
    bi0800
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    bi2100
    biOutdoor
    bs0800
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    bs2100
    clubhouses {
      clubhouseCode
      displayName
      tagBgColorCode
      tagText
      tagTextColorCode
    }
    date
    displayName
    hasOutdoorBooking
    l0800
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
    l2100
  }
}
    `;

/**
 * __useAdminBookingCombinedCoachAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingCombinedCoachAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCombinedCoachAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCombinedCoachAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCombinedCoachAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>(AdminBookingCombinedCoachAvailabilityDayItemDocument, options);
      }
export function useAdminBookingCombinedCoachAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>(AdminBookingCombinedCoachAvailabilityDayItemDocument, options);
        }
export type AdminBookingCombinedCoachAvailabilityDayItemQueryHookResult = ReturnType<typeof useAdminBookingCombinedCoachAvailabilityDayItemQuery>;
export type AdminBookingCombinedCoachAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useAdminBookingCombinedCoachAvailabilityDayItemLazyQuery>;
export type AdminBookingCombinedCoachAvailabilityDayItemQueryResult = Apollo.QueryResult<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>;
export const FormHelperBookingDocument = gql`
    query FormHelperBooking($args: FormHelperBookingArgs!) {
  formHelperBooking(args: $args) {
    clubhouses {
      clubhouseCode
      clubhouseId
      name
    }
  }
}
    `;

/**
 * __useFormHelperBookingQuery__
 *
 * To run a query within a React component, call `useFormHelperBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperBookingQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperBookingQuery(baseOptions: Apollo.QueryHookOptions<FormHelperBookingQuery, FormHelperBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperBookingQuery, FormHelperBookingQueryVariables>(FormHelperBookingDocument, options);
      }
export function useFormHelperBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperBookingQuery, FormHelperBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperBookingQuery, FormHelperBookingQueryVariables>(FormHelperBookingDocument, options);
        }
export type FormHelperBookingQueryHookResult = ReturnType<typeof useFormHelperBookingQuery>;
export type FormHelperBookingLazyQueryHookResult = ReturnType<typeof useFormHelperBookingLazyQuery>;
export type FormHelperBookingQueryResult = Apollo.QueryResult<FormHelperBookingQuery, FormHelperBookingQueryVariables>;
export const FormHelperNewBlackOutDocument = gql`
    query FormHelperNewBlackOut($args: FormHelperNewBlackOutArgs) {
  formHelperNewBlackOut(args: $args) {
    clubhouseCode
    date
    errorMessage
    facilities {
      facilityCode
      facilityName
      facilityType
    }
    isCreateAllowed
  }
}
    `;

/**
 * __useFormHelperNewBlackOutQuery__
 *
 * To run a query within a React component, call `useFormHelperNewBlackOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewBlackOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewBlackOutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewBlackOutQuery(baseOptions?: Apollo.QueryHookOptions<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>(FormHelperNewBlackOutDocument, options);
      }
export function useFormHelperNewBlackOutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>(FormHelperNewBlackOutDocument, options);
        }
export type FormHelperNewBlackOutQueryHookResult = ReturnType<typeof useFormHelperNewBlackOutQuery>;
export type FormHelperNewBlackOutLazyQueryHookResult = ReturnType<typeof useFormHelperNewBlackOutLazyQuery>;
export type FormHelperNewBlackOutQueryResult = Apollo.QueryResult<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>;
export const AdminBookingAvailabilityDocument = gql`
    query AdminBookingAvailability($args: AdminBookingAvailabilityArgs!) {
  adminBookingAvailability(args: $args)
}
    `;

/**
 * __useAdminBookingAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdminBookingAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>(AdminBookingAvailabilityDocument, options);
      }
export function useAdminBookingAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>(AdminBookingAvailabilityDocument, options);
        }
export type AdminBookingAvailabilityQueryHookResult = ReturnType<typeof useAdminBookingAvailabilityQuery>;
export type AdminBookingAvailabilityLazyQueryHookResult = ReturnType<typeof useAdminBookingAvailabilityLazyQuery>;
export type AdminBookingAvailabilityQueryResult = Apollo.QueryResult<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>;
export const AdminBookingDocument = gql`
    query AdminBooking($args: AdminBookingArgs!) {
  adminBooking(args: $args) {
    cancellationDateTime
    cancellationNotificationByAppSent
    cancellationNotificationByEmailSent
    cancellationNotificationBySmsSent
    cancellationNotificationMessage
    cancellationNotificationSentByAdminName
    cancellationNotificationSentDateTime
    cancellationReason
    cancelledBy
    cancelledByAdminName
    clubhouseCode
    coachDateId
    coachId
    coachName
    commentAdminToCoach
    commentAdminToMember
    commentByCoach
    commentByCoachId
    commentInternal
    createdAt
    createdBy
    createdByAdminName
    date
    dateMonthStr
    dateStr
    dayOfWeekStr
    duration
    durationStr
    endTime
    endTimeStr
    facilityType
    fieldLessonDetails
    gameCourseType
    groupBookingId
    groupMembers {
      bookingId
      individualId
      memberUuid
      mobileNumber
      name
      playerName
    }
    id
    isGroupBooking
    lateCancellationDetails
    member
    memberHasGroupMembers
    memberIndividualId
    membershipUuid
    memberUuid
    mobileNumber
    noOfPlayers
    playerName
    resourceName
    startTime
    startTimeStr
    status
    type
    venue
    yearStr
  }
}
    `;

/**
 * __useAdminBookingQuery__
 *
 * To run a query within a React component, call `useAdminBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingQuery, AdminBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingQuery, AdminBookingQueryVariables>(AdminBookingDocument, options);
      }
export function useAdminBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingQuery, AdminBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingQuery, AdminBookingQueryVariables>(AdminBookingDocument, options);
        }
export type AdminBookingQueryHookResult = ReturnType<typeof useAdminBookingQuery>;
export type AdminBookingLazyQueryHookResult = ReturnType<typeof useAdminBookingLazyQuery>;
export type AdminBookingQueryResult = Apollo.QueryResult<AdminBookingQuery, AdminBookingQueryVariables>;
export const AdminBookingBasicDocument = gql`
    query AdminBookingBasic($args: AdminBookingArgs!) {
  adminBooking(args: $args) {
    dateMonthStr
    dayOfWeekStr
    durationStr
    endTimeStr
    facilityType
    id
    member
    memberIndividualId
    resourceName
    startTimeStr
    venue
    yearStr
  }
}
    `;

/**
 * __useAdminBookingBasicQuery__
 *
 * To run a query within a React component, call `useAdminBookingBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBasicQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBasicQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>(AdminBookingBasicDocument, options);
      }
export function useAdminBookingBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>(AdminBookingBasicDocument, options);
        }
export type AdminBookingBasicQueryHookResult = ReturnType<typeof useAdminBookingBasicQuery>;
export type AdminBookingBasicLazyQueryHookResult = ReturnType<typeof useAdminBookingBasicLazyQuery>;
export type AdminBookingBasicQueryResult = Apollo.QueryResult<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>;
export const AdminBookingsDocument = gql`
    query AdminBookings($args: AdminBookingsArgs!) {
  adminBookings(args: $args) {
    edges {
      cursor
      node {
        cancellationDateTime
        coachDisplayName
        date
        dateMonthStr
        dayOfWeekStr
        durationStr
        endTime
        endTimeStr
        gameCourseType
        groupBookingId
        groupBookingIds
        id
        isGroupBooking
        lateCancellationDetails
        member
        memberUuid
        playerName
        resourceName
        startTime
        startTimeStr
        status
        type
        venue
        yearStr
      }
    }
    firstBookingDate
    lastBookingDate
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminBookingsQuery__
 *
 * To run a query within a React component, call `useAdminBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingsQuery, AdminBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingsQuery, AdminBookingsQueryVariables>(AdminBookingsDocument, options);
      }
export function useAdminBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingsQuery, AdminBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingsQuery, AdminBookingsQueryVariables>(AdminBookingsDocument, options);
        }
export type AdminBookingsQueryHookResult = ReturnType<typeof useAdminBookingsQuery>;
export type AdminBookingsLazyQueryHookResult = ReturnType<typeof useAdminBookingsLazyQuery>;
export type AdminBookingsQueryResult = Apollo.QueryResult<AdminBookingsQuery, AdminBookingsQueryVariables>;
export const AdminBookingGameCheckoutDocument = gql`
    query AdminBookingGameCheckout($args: AdminBookingGameCheckoutArgs!) {
  adminBookingGameCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingGameCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingGameCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingGameCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingGameCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingGameCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>(AdminBookingGameCheckoutDocument, options);
      }
export function useAdminBookingGameCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>(AdminBookingGameCheckoutDocument, options);
        }
export type AdminBookingGameCheckoutQueryHookResult = ReturnType<typeof useAdminBookingGameCheckoutQuery>;
export type AdminBookingGameCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingGameCheckoutLazyQuery>;
export type AdminBookingGameCheckoutQueryResult = Apollo.QueryResult<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>;
export const AdminBookingLessonIndoorCheckoutDocument = gql`
    query AdminBookingLessonIndoorCheckout($args: AdminBookingLessonIndoorCheckoutArgs!) {
  adminBookingLessonIndoorCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingLessonIndoorCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingLessonIndoorCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonIndoorCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingLessonIndoorCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingLessonIndoorCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>(AdminBookingLessonIndoorCheckoutDocument, options);
      }
export function useAdminBookingLessonIndoorCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>(AdminBookingLessonIndoorCheckoutDocument, options);
        }
export type AdminBookingLessonIndoorCheckoutQueryHookResult = ReturnType<typeof useAdminBookingLessonIndoorCheckoutQuery>;
export type AdminBookingLessonIndoorCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingLessonIndoorCheckoutLazyQuery>;
export type AdminBookingLessonIndoorCheckoutQueryResult = Apollo.QueryResult<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>;
export const AdminBookingLessonOutdoorCheckoutDocument = gql`
    query AdminBookingLessonOutdoorCheckout($args: AdminBookingLessonOutdoorCheckoutArgs!) {
  adminBookingLessonOutdoorCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingLessonOutdoorCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingLessonOutdoorCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonOutdoorCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingLessonOutdoorCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingLessonOutdoorCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>(AdminBookingLessonOutdoorCheckoutDocument, options);
      }
export function useAdminBookingLessonOutdoorCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>(AdminBookingLessonOutdoorCheckoutDocument, options);
        }
export type AdminBookingLessonOutdoorCheckoutQueryHookResult = ReturnType<typeof useAdminBookingLessonOutdoorCheckoutQuery>;
export type AdminBookingLessonOutdoorCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingLessonOutdoorCheckoutLazyQuery>;
export type AdminBookingLessonOutdoorCheckoutQueryResult = Apollo.QueryResult<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>;
export const AdminBookingPractiseCheckoutDocument = gql`
    query AdminBookingPractiseCheckout($args: AdminBookingPractiseCheckoutArgs!) {
  adminBookingPractiseCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingPractiseCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingPractiseCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingPractiseCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingPractiseCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingPractiseCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>(AdminBookingPractiseCheckoutDocument, options);
      }
export function useAdminBookingPractiseCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>(AdminBookingPractiseCheckoutDocument, options);
        }
export type AdminBookingPractiseCheckoutQueryHookResult = ReturnType<typeof useAdminBookingPractiseCheckoutQuery>;
export type AdminBookingPractiseCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingPractiseCheckoutLazyQuery>;
export type AdminBookingPractiseCheckoutQueryResult = Apollo.QueryResult<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>;
export const AdminBookingSettingsDocument = gql`
    query AdminBookingSettings($args: AdminBookingSettingsArgs!) {
  adminBookingSettings(args: $args) {
    cancellationConditions {
      GAME
      LESSON_FIELD
      LESSON_INDOOR
      LESSON_OUTDOOR
      PRACTISE
    }
  }
}
    `;

/**
 * __useAdminBookingSettingsQuery__
 *
 * To run a query within a React component, call `useAdminBookingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingSettingsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingSettingsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>(AdminBookingSettingsDocument, options);
      }
export function useAdminBookingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>(AdminBookingSettingsDocument, options);
        }
export type AdminBookingSettingsQueryHookResult = ReturnType<typeof useAdminBookingSettingsQuery>;
export type AdminBookingSettingsLazyQueryHookResult = ReturnType<typeof useAdminBookingSettingsLazyQuery>;
export type AdminBookingSettingsQueryResult = Apollo.QueryResult<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>;
export const AdminBookingGroupMembersDocument = gql`
    query AdminBookingGroupMembers($args: AdminBookingGroupMembersArgs!) {
  adminBookingGroupMembers(args: $args) {
    members {
      individualId
      memberName
      memberUuid
      selfPackageId
      selfPackageName
    }
  }
}
    `;

/**
 * __useAdminBookingGroupMembersQuery__
 *
 * To run a query within a React component, call `useAdminBookingGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingGroupMembersQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingGroupMembersQuery, AdminBookingGroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingGroupMembersQuery, AdminBookingGroupMembersQueryVariables>(AdminBookingGroupMembersDocument, options);
      }
export function useAdminBookingGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingGroupMembersQuery, AdminBookingGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingGroupMembersQuery, AdminBookingGroupMembersQueryVariables>(AdminBookingGroupMembersDocument, options);
        }
export type AdminBookingGroupMembersQueryHookResult = ReturnType<typeof useAdminBookingGroupMembersQuery>;
export type AdminBookingGroupMembersLazyQueryHookResult = ReturnType<typeof useAdminBookingGroupMembersLazyQuery>;
export type AdminBookingGroupMembersQueryResult = Apollo.QueryResult<AdminBookingGroupMembersQuery, AdminBookingGroupMembersQueryVariables>;
export const AdminGroupBookingsDocument = gql`
    query AdminGroupBookings($args: AdminGroupBookingsArgs!) {
  adminGroupBookings(args: $args) {
    clubhouseCode
    coachName
    commentAdminToCoach
    commentAdminToMember
    commentInternal
    dateMonthStr
    dateStr
    dayOfWeekStr
    durationStr
    endTimeStr
    facilityMode
    facilityStartTime
    facilityType
    fieldLessonDetails
    gameCourseType
    id
    member
    memberIndividualId
    mobileNumber
    noOfPlayers
    resourceName
    startTimeStr
    status
    type
    venue
    yearStr
  }
}
    `;

/**
 * __useAdminGroupBookingsQuery__
 *
 * To run a query within a React component, call `useAdminGroupBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGroupBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGroupBookingsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminGroupBookingsQuery(baseOptions: Apollo.QueryHookOptions<AdminGroupBookingsQuery, AdminGroupBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGroupBookingsQuery, AdminGroupBookingsQueryVariables>(AdminGroupBookingsDocument, options);
      }
export function useAdminGroupBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGroupBookingsQuery, AdminGroupBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGroupBookingsQuery, AdminGroupBookingsQueryVariables>(AdminGroupBookingsDocument, options);
        }
export type AdminGroupBookingsQueryHookResult = ReturnType<typeof useAdminGroupBookingsQuery>;
export type AdminGroupBookingsLazyQueryHookResult = ReturnType<typeof useAdminGroupBookingsLazyQuery>;
export type AdminGroupBookingsQueryResult = Apollo.QueryResult<AdminGroupBookingsQuery, AdminGroupBookingsQueryVariables>;
export const AdminStaffsDocument = gql`
    query AdminStaffs($args: AdminStaffsArgs) {
  adminStaffs(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        createdAt
        firstName
        lastAccessTokenDate
        lastLoginDate
        lastName
        organization {
          businessName
          clubhouses {
            clubhouseCode
            name
          }
          id
        }
        profileImageUrl
        status
        userId
        userName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminStaffsQuery__
 *
 * To run a query within a React component, call `useAdminStaffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStaffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStaffsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminStaffsQuery(baseOptions?: Apollo.QueryHookOptions<AdminStaffsQuery, AdminStaffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStaffsQuery, AdminStaffsQueryVariables>(AdminStaffsDocument, options);
      }
export function useAdminStaffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStaffsQuery, AdminStaffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStaffsQuery, AdminStaffsQueryVariables>(AdminStaffsDocument, options);
        }
export type AdminStaffsQueryHookResult = ReturnType<typeof useAdminStaffsQuery>;
export type AdminStaffsLazyQueryHookResult = ReturnType<typeof useAdminStaffsLazyQuery>;
export type AdminStaffsQueryResult = Apollo.QueryResult<AdminStaffsQuery, AdminStaffsQueryVariables>;
export const AdminClientSetupDocument = gql`
    mutation AdminClientSetup($input: AdminClientSetupInput!) {
  adminClientSetup(input: $input)
}
    `;
export type AdminClientSetupMutationFn = Apollo.MutationFunction<AdminClientSetupMutation, AdminClientSetupMutationVariables>;

/**
 * __useAdminClientSetupMutation__
 *
 * To run a mutation, you first call `useAdminClientSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminClientSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminClientSetupMutation, { data, loading, error }] = useAdminClientSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminClientSetupMutation(baseOptions?: Apollo.MutationHookOptions<AdminClientSetupMutation, AdminClientSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminClientSetupMutation, AdminClientSetupMutationVariables>(AdminClientSetupDocument, options);
      }
export type AdminClientSetupMutationHookResult = ReturnType<typeof useAdminClientSetupMutation>;
export type AdminClientSetupMutationResult = Apollo.MutationResult<AdminClientSetupMutation>;
export type AdminClientSetupMutationOptions = Apollo.BaseMutationOptions<AdminClientSetupMutation, AdminClientSetupMutationVariables>;
export const AdminUpdateFacilityDocument = gql`
    mutation AdminUpdateFacility($input: AdminUpdateFacilityInput!) {
  adminUpdateFacility(input: $input)
}
    `;
export type AdminUpdateFacilityMutationFn = Apollo.MutationFunction<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>;

/**
 * __useAdminUpdateFacilityMutation__
 *
 * To run a mutation, you first call `useAdminUpdateFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateFacilityMutation, { data, loading, error }] = useAdminUpdateFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateFacilityMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>(AdminUpdateFacilityDocument, options);
      }
export type AdminUpdateFacilityMutationHookResult = ReturnType<typeof useAdminUpdateFacilityMutation>;
export type AdminUpdateFacilityMutationResult = Apollo.MutationResult<AdminUpdateFacilityMutation>;
export type AdminUpdateFacilityMutationOptions = Apollo.BaseMutationOptions<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>;
export const AdminClubhousesDocument = gql`
    query AdminClubhouses($args: AdminClubhousesArgs!) {
  adminClubhouses(args: $args) {
    edges {
      cursor
      node {
        addressCountryIso
        clubhouseCode
        clubhouseId
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminClubhousesQuery__
 *
 * To run a query within a React component, call `useAdminClubhousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhousesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhousesQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhousesQuery, AdminClubhousesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhousesQuery, AdminClubhousesQueryVariables>(AdminClubhousesDocument, options);
      }
export function useAdminClubhousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhousesQuery, AdminClubhousesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhousesQuery, AdminClubhousesQueryVariables>(AdminClubhousesDocument, options);
        }
export type AdminClubhousesQueryHookResult = ReturnType<typeof useAdminClubhousesQuery>;
export type AdminClubhousesLazyQueryHookResult = ReturnType<typeof useAdminClubhousesLazyQuery>;
export type AdminClubhousesQueryResult = Apollo.QueryResult<AdminClubhousesQuery, AdminClubhousesQueryVariables>;
export const AdminClubhouseDocument = gql`
    query AdminClubhouse($args: AdminClubhouseArgs!) {
  adminClubhouse(args: $args) {
    addressCity
    addressCountry
    addressCountryIso
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    clubhouseCode
    clubhouseId
    colorCode
    createdAt
    email
    kGolfClientId
    kGolfClientSecret
    kGolfPassword
    kGolfShopGuid
    kGolfUsername
    name
    noOfPrivateRooms
    noOfPuttingGreen
    noOfSimulators
    organization {
      businessName
      id
    }
    organizationId
    phoneNumber
    updatedAt
  }
}
    `;

/**
 * __useAdminClubhouseQuery__
 *
 * To run a query within a React component, call `useAdminClubhouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhouseQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhouseQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhouseQuery, AdminClubhouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhouseQuery, AdminClubhouseQueryVariables>(AdminClubhouseDocument, options);
      }
export function useAdminClubhouseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhouseQuery, AdminClubhouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhouseQuery, AdminClubhouseQueryVariables>(AdminClubhouseDocument, options);
        }
export type AdminClubhouseQueryHookResult = ReturnType<typeof useAdminClubhouseQuery>;
export type AdminClubhouseLazyQueryHookResult = ReturnType<typeof useAdminClubhouseLazyQuery>;
export type AdminClubhouseQueryResult = Apollo.QueryResult<AdminClubhouseQuery, AdminClubhouseQueryVariables>;
export const AdminClubhouseFacilitiesDocument = gql`
    query AdminClubhouseFacilities($args: AdminClubhouseFacilitiesArgs!) {
  adminClubhouseFacilities(args: $args) {
    clientGuid
    clientName
    clientOrder
    facilityCode
    facilityName
    facilityType
    id
  }
}
    `;

/**
 * __useAdminClubhouseFacilitiesQuery__
 *
 * To run a query within a React component, call `useAdminClubhouseFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhouseFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhouseFacilitiesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhouseFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>(AdminClubhouseFacilitiesDocument, options);
      }
export function useAdminClubhouseFacilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>(AdminClubhouseFacilitiesDocument, options);
        }
export type AdminClubhouseFacilitiesQueryHookResult = ReturnType<typeof useAdminClubhouseFacilitiesQuery>;
export type AdminClubhouseFacilitiesLazyQueryHookResult = ReturnType<typeof useAdminClubhouseFacilitiesLazyQuery>;
export type AdminClubhouseFacilitiesQueryResult = Apollo.QueryResult<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>;
export const AdminDeleteCoachDocument = gql`
    mutation AdminDeleteCoach($input: AdminDeleteCoachInput) {
  adminDeleteCoach(input: $input)
}
    `;
export type AdminDeleteCoachMutationFn = Apollo.MutationFunction<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>;

/**
 * __useAdminDeleteCoachMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCoachMutation, { data, loading, error }] = useAdminDeleteCoachMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteCoachMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>(AdminDeleteCoachDocument, options);
      }
export type AdminDeleteCoachMutationHookResult = ReturnType<typeof useAdminDeleteCoachMutation>;
export type AdminDeleteCoachMutationResult = Apollo.MutationResult<AdminDeleteCoachMutation>;
export type AdminDeleteCoachMutationOptions = Apollo.BaseMutationOptions<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>;
export const AdminUpdateCoachBookableDocument = gql`
    mutation AdminUpdateCoachBookable($args: AdminUpdateCoachArgs!, $input: AdminUpdateCoachBookableInput!) {
  adminUpdateCoachBookable(args: $args, input: $input) {
    isBookable
  }
}
    `;
export type AdminUpdateCoachBookableMutationFn = Apollo.MutationFunction<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>;

/**
 * __useAdminUpdateCoachBookableMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCoachBookableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCoachBookableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCoachBookableMutation, { data, loading, error }] = useAdminUpdateCoachBookableMutation({
 *   variables: {
 *      args: // value for 'args'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCoachBookableMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>(AdminUpdateCoachBookableDocument, options);
      }
export type AdminUpdateCoachBookableMutationHookResult = ReturnType<typeof useAdminUpdateCoachBookableMutation>;
export type AdminUpdateCoachBookableMutationResult = Apollo.MutationResult<AdminUpdateCoachBookableMutation>;
export type AdminUpdateCoachBookableMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>;
export const AdminUpdateCoachDocument = gql`
    mutation AdminUpdateCoach($args: AdminUpdateCoachArgs!, $input: AdminUpdateCoachInput!) {
  adminUpdateCoach(args: $args, input: $input) {
    coach {
      baseCountryCode
      coachBirthdate
      coachBirthPlace
      coachExperiences
      coachExpertise
      coachLanguages
      coachLevel
      coachListOrder
      coachPGANo
      coachPGAType
      coachPGAYear
      coachPublished
      createdAt
      displayName
      email
      firstName
      gender
      lastAccessTokenDate
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      logins {
        city
        ipAddress
        time
      }
      mobileNumber
      organization {
        businessName
        clubhouses {
          clubhouseCode
          name
        }
        id
      }
      profileImageUrl
      slug
      status
      updatedAt
      userId
      userType
    }
    fileUploadCredentials {
      fields
      signedUrl
    }
  }
}
    `;
export type AdminUpdateCoachMutationFn = Apollo.MutationFunction<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>;

/**
 * __useAdminUpdateCoachMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCoachMutation, { data, loading, error }] = useAdminUpdateCoachMutation({
 *   variables: {
 *      args: // value for 'args'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCoachMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>(AdminUpdateCoachDocument, options);
      }
export type AdminUpdateCoachMutationHookResult = ReturnType<typeof useAdminUpdateCoachMutation>;
export type AdminUpdateCoachMutationResult = Apollo.MutationResult<AdminUpdateCoachMutation>;
export type AdminUpdateCoachMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>;
export const CoachAvailabilityDayUpsertDocument = gql`
    mutation CoachAvailabilityDayUpsert($input: CoachAvailabilityDayUpsertInput!) {
  coachAvailabilityDayUpsert(input: $input) {
    bi0800
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    bi2100
    bs0800
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    bs2100
    date
    l0800
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
    l2100
  }
}
    `;
export type CoachAvailabilityDayUpsertMutationFn = Apollo.MutationFunction<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>;

/**
 * __useCoachAvailabilityDayUpsertMutation__
 *
 * To run a mutation, you first call `useCoachAvailabilityDayUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachAvailabilityDayUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachAvailabilityDayUpsertMutation, { data, loading, error }] = useCoachAvailabilityDayUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachAvailabilityDayUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>(CoachAvailabilityDayUpsertDocument, options);
      }
export type CoachAvailabilityDayUpsertMutationHookResult = ReturnType<typeof useCoachAvailabilityDayUpsertMutation>;
export type CoachAvailabilityDayUpsertMutationResult = Apollo.MutationResult<CoachAvailabilityDayUpsertMutation>;
export type CoachAvailabilityDayUpsertMutationOptions = Apollo.BaseMutationOptions<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>;
export const FormHelperNewCoachDocument = gql`
    query FormHelperNewCoach($args: FormHelperNewCoachArgs!) {
  formHelperNewCoach(args: $args) {
    countries
  }
}
    `;

/**
 * __useFormHelperNewCoachQuery__
 *
 * To run a query within a React component, call `useFormHelperNewCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewCoachQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewCoachQuery(baseOptions: Apollo.QueryHookOptions<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>(FormHelperNewCoachDocument, options);
      }
export function useFormHelperNewCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>(FormHelperNewCoachDocument, options);
        }
export type FormHelperNewCoachQueryHookResult = ReturnType<typeof useFormHelperNewCoachQuery>;
export type FormHelperNewCoachLazyQueryHookResult = ReturnType<typeof useFormHelperNewCoachLazyQuery>;
export type FormHelperNewCoachQueryResult = Apollo.QueryResult<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>;
export const AdminCoachDocument = gql`
    query AdminCoach($args: AdminCoachArgs!) {
  adminCoach(args: $args) {
    baseCountryCode
    clubhouses {
      clubhouseCode
      displayName
      tagBgColorCode
      tagText
      tagTextColorCode
    }
    coachBirthdate
    coachBirthPlace
    coachExperiences
    coachExpertise
    coachLanguages
    coachLevel
    coachListOrder
    coachPGANo
    coachPGAType
    coachPGAYear
    coachPublished
    createdAt
    displayName
    email
    firstName
    gender
    lastAccessTokenDate
    lastLogin {
      city
      ipAddress
      time
    }
    lastLoginDate
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organization {
      businessName
      clubhouses {
        clubhouseCode
        name
      }
      id
    }
    profileImageUrl
    slug
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useAdminCoachQuery__
 *
 * To run a query within a React component, call `useAdminCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachQuery(baseOptions: Apollo.QueryHookOptions<AdminCoachQuery, AdminCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachQuery, AdminCoachQueryVariables>(AdminCoachDocument, options);
      }
export function useAdminCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachQuery, AdminCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachQuery, AdminCoachQueryVariables>(AdminCoachDocument, options);
        }
export type AdminCoachQueryHookResult = ReturnType<typeof useAdminCoachQuery>;
export type AdminCoachLazyQueryHookResult = ReturnType<typeof useAdminCoachLazyQuery>;
export type AdminCoachQueryResult = Apollo.QueryResult<AdminCoachQuery, AdminCoachQueryVariables>;
export const AdminCoachesDocument = gql`
    query AdminCoaches($args: AdminCoachesArgs) {
  adminCoaches(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        coachPublished
        createdAt
        displayName
        firstName
        lastAccessTokenDate
        lastLoginDate
        lastName
        organization {
          businessName
          clubhouses {
            clubhouseCode
            name
          }
          id
        }
        profileImageUrl
        status
        userId
        userName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminCoachesQuery__
 *
 * To run a query within a React component, call `useAdminCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachesQuery(baseOptions?: Apollo.QueryHookOptions<AdminCoachesQuery, AdminCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachesQuery, AdminCoachesQueryVariables>(AdminCoachesDocument, options);
      }
export function useAdminCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachesQuery, AdminCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachesQuery, AdminCoachesQueryVariables>(AdminCoachesDocument, options);
        }
export type AdminCoachesQueryHookResult = ReturnType<typeof useAdminCoachesQuery>;
export type AdminCoachesLazyQueryHookResult = ReturnType<typeof useAdminCoachesLazyQuery>;
export type AdminCoachesQueryResult = Apollo.QueryResult<AdminCoachesQuery, AdminCoachesQueryVariables>;
export const AdminCoachAvailabilityCalendarItemsDocument = gql`
    query AdminCoachAvailabilityCalendarItems($args: AdminCoachAvailabilityCalendarItemsArgs) {
  adminCoachAvailabilityCalendarItems(args: $args) {
    clubhouses
    date
    hasIndoorBooking
    hasOutdoorBooking
    isBlocked
    isIndoorBookingFull
  }
}
    `;

/**
 * __useAdminCoachAvailabilityCalendarItemsQuery__
 *
 * To run a query within a React component, call `useAdminCoachAvailabilityCalendarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachAvailabilityCalendarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachAvailabilityCalendarItemsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachAvailabilityCalendarItemsQuery(baseOptions?: Apollo.QueryHookOptions<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>(AdminCoachAvailabilityCalendarItemsDocument, options);
      }
export function useAdminCoachAvailabilityCalendarItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>(AdminCoachAvailabilityCalendarItemsDocument, options);
        }
export type AdminCoachAvailabilityCalendarItemsQueryHookResult = ReturnType<typeof useAdminCoachAvailabilityCalendarItemsQuery>;
export type AdminCoachAvailabilityCalendarItemsLazyQueryHookResult = ReturnType<typeof useAdminCoachAvailabilityCalendarItemsLazyQuery>;
export type AdminCoachAvailabilityCalendarItemsQueryResult = Apollo.QueryResult<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>;
export const CoachAvailabilityDayItemDocument = gql`
    query CoachAvailabilityDayItem($args: CoachAvailabilityDayItemArgs!) {
  coachAvailabilityDayItem(args: $args) {
    bi0800
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    bi2100
    biOutdoor
    bs0800
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    bs2100
    date
    hasOutdoorBooking
    l0800
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
    l2100
  }
}
    `;

/**
 * __useCoachAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useCoachAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCoachAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>(CoachAvailabilityDayItemDocument, options);
      }
export function useCoachAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>(CoachAvailabilityDayItemDocument, options);
        }
export type CoachAvailabilityDayItemQueryHookResult = ReturnType<typeof useCoachAvailabilityDayItemQuery>;
export type CoachAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useCoachAvailabilityDayItemLazyQuery>;
export type CoachAvailabilityDayItemQueryResult = Apollo.QueryResult<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>;
export const AdminLoginDocument = gql`
    mutation AdminLogin($input: AdminLoginInput!) {
  adminLogin(input: $input) {
    accessToken
    authenticatedAdmin {
      clubhouseCode
      clubhouses
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      permissions
      profileImageUrl
      ud
      userId
      userType
      yourIp
    }
  }
}
    `;
export type AdminLoginMutationFn = Apollo.MutationFunction<AdminLoginMutation, AdminLoginMutationVariables>;

/**
 * __useAdminLoginMutation__
 *
 * To run a mutation, you first call `useAdminLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLoginMutation, { data, loading, error }] = useAdminLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminLoginMutation(baseOptions?: Apollo.MutationHookOptions<AdminLoginMutation, AdminLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLoginMutation, AdminLoginMutationVariables>(AdminLoginDocument, options);
      }
export type AdminLoginMutationHookResult = ReturnType<typeof useAdminLoginMutation>;
export type AdminLoginMutationResult = Apollo.MutationResult<AdminLoginMutation>;
export type AdminLoginMutationOptions = Apollo.BaseMutationOptions<AdminLoginMutation, AdminLoginMutationVariables>;
export const AdminLogoutDocument = gql`
    mutation AdminLogout {
  adminLogout
}
    `;
export type AdminLogoutMutationFn = Apollo.MutationFunction<AdminLogoutMutation, AdminLogoutMutationVariables>;

/**
 * __useAdminLogoutMutation__
 *
 * To run a mutation, you first call `useAdminLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLogoutMutation, { data, loading, error }] = useAdminLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AdminLogoutMutation, AdminLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLogoutMutation, AdminLogoutMutationVariables>(AdminLogoutDocument, options);
      }
export type AdminLogoutMutationHookResult = ReturnType<typeof useAdminLogoutMutation>;
export type AdminLogoutMutationResult = Apollo.MutationResult<AdminLogoutMutation>;
export type AdminLogoutMutationOptions = Apollo.BaseMutationOptions<AdminLogoutMutation, AdminLogoutMutationVariables>;
export const AdminRefreshAccessTokenDocument = gql`
    mutation AdminRefreshAccessToken {
  adminRefreshAccessToken {
    accessToken
    authenticatedAdmin {
      clubhouseCode
      clubhouses
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      permissions
      profileImageUrl
      ud
      userId
      userType
      yourIp
    }
  }
}
    `;
export type AdminRefreshAccessTokenMutationFn = Apollo.MutationFunction<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>;

/**
 * __useAdminRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useAdminRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRefreshAccessTokenMutation, { data, loading, error }] = useAdminRefreshAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminRefreshAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>(AdminRefreshAccessTokenDocument, options);
      }
export type AdminRefreshAccessTokenMutationHookResult = ReturnType<typeof useAdminRefreshAccessTokenMutation>;
export type AdminRefreshAccessTokenMutationResult = Apollo.MutationResult<AdminRefreshAccessTokenMutation>;
export type AdminRefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>;
export const AdminForgotPasswordDocument = gql`
    mutation AdminForgotPassword($input: AdminForgotPasswordInput!) {
  adminForgotPassword(input: $input) {
    email
    resetToken
  }
}
    `;
export type AdminForgotPasswordMutationFn = Apollo.MutationFunction<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>;

/**
 * __useAdminForgotPasswordMutation__
 *
 * To run a mutation, you first call `useAdminForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForgotPasswordMutation, { data, loading, error }] = useAdminForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>(AdminForgotPasswordDocument, options);
      }
export type AdminForgotPasswordMutationHookResult = ReturnType<typeof useAdminForgotPasswordMutation>;
export type AdminForgotPasswordMutationResult = Apollo.MutationResult<AdminForgotPasswordMutation>;
export type AdminForgotPasswordMutationOptions = Apollo.BaseMutationOptions<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>;
export const AdminForgotPasswordSubmitDocument = gql`
    mutation AdminForgotPasswordSubmit($input: AdminForgotPasswordSubmitInput!) {
  adminForgotPasswordSubmit(input: $input)
}
    `;
export type AdminForgotPasswordSubmitMutationFn = Apollo.MutationFunction<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>;

/**
 * __useAdminForgotPasswordSubmitMutation__
 *
 * To run a mutation, you first call `useAdminForgotPasswordSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForgotPasswordSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForgotPasswordSubmitMutation, { data, loading, error }] = useAdminForgotPasswordSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminForgotPasswordSubmitMutation(baseOptions?: Apollo.MutationHookOptions<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>(AdminForgotPasswordSubmitDocument, options);
      }
export type AdminForgotPasswordSubmitMutationHookResult = ReturnType<typeof useAdminForgotPasswordSubmitMutation>;
export type AdminForgotPasswordSubmitMutationResult = Apollo.MutationResult<AdminForgotPasswordSubmitMutation>;
export type AdminForgotPasswordSubmitMutationOptions = Apollo.BaseMutationOptions<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>;
export const AdminShopTokensDocument = gql`
    mutation AdminShopTokens($input: AdminShopTokensInput) {
  adminShopTokens(input: $input) {
    expires
    shops
    ud
  }
}
    `;
export type AdminShopTokensMutationFn = Apollo.MutationFunction<AdminShopTokensMutation, AdminShopTokensMutationVariables>;

/**
 * __useAdminShopTokensMutation__
 *
 * To run a mutation, you first call `useAdminShopTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShopTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShopTokensMutation, { data, loading, error }] = useAdminShopTokensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminShopTokensMutation(baseOptions?: Apollo.MutationHookOptions<AdminShopTokensMutation, AdminShopTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminShopTokensMutation, AdminShopTokensMutationVariables>(AdminShopTokensDocument, options);
      }
export type AdminShopTokensMutationHookResult = ReturnType<typeof useAdminShopTokensMutation>;
export type AdminShopTokensMutationResult = Apollo.MutationResult<AdminShopTokensMutation>;
export type AdminShopTokensMutationOptions = Apollo.BaseMutationOptions<AdminShopTokensMutation, AdminShopTokensMutationVariables>;
export const AdminDeleteMembershipDocument = gql`
    mutation AdminDeleteMembership($input: AdminDeleteMembershipInput!) {
  adminDeleteMembership(input: $input)
}
    `;
export type AdminDeleteMembershipMutationFn = Apollo.MutationFunction<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>;

/**
 * __useAdminDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMembershipMutation, { data, loading, error }] = useAdminDeleteMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>(AdminDeleteMembershipDocument, options);
      }
export type AdminDeleteMembershipMutationHookResult = ReturnType<typeof useAdminDeleteMembershipMutation>;
export type AdminDeleteMembershipMutationResult = Apollo.MutationResult<AdminDeleteMembershipMutation>;
export type AdminDeleteMembershipMutationOptions = Apollo.BaseMutationOptions<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>;
export const AdminMemberCreditUpdateDocument = gql`
    mutation AdminMemberCreditUpdate($input: AdminMemberCreditUpdateInput) {
  adminMemberCreditUpdate(input: $input)
}
    `;
export type AdminMemberCreditUpdateMutationFn = Apollo.MutationFunction<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>;

/**
 * __useAdminMemberCreditUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberCreditUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberCreditUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberCreditUpdateMutation, { data, loading, error }] = useAdminMemberCreditUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberCreditUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>(AdminMemberCreditUpdateDocument, options);
      }
export type AdminMemberCreditUpdateMutationHookResult = ReturnType<typeof useAdminMemberCreditUpdateMutation>;
export type AdminMemberCreditUpdateMutationResult = Apollo.MutationResult<AdminMemberCreditUpdateMutation>;
export type AdminMemberCreditUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>;
export const AdminMemberSendResetPasswordEmailDocument = gql`
    mutation AdminMemberSendResetPasswordEmail($input: AdminMemberSendResetPasswordEmailInput!) {
  adminMemberSendResetPasswordEmail(input: $input)
}
    `;
export type AdminMemberSendResetPasswordEmailMutationFn = Apollo.MutationFunction<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>;

/**
 * __useAdminMemberSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useAdminMemberSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberSendResetPasswordEmailMutation, { data, loading, error }] = useAdminMemberSendResetPasswordEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>(AdminMemberSendResetPasswordEmailDocument, options);
      }
export type AdminMemberSendResetPasswordEmailMutationHookResult = ReturnType<typeof useAdminMemberSendResetPasswordEmailMutation>;
export type AdminMemberSendResetPasswordEmailMutationResult = Apollo.MutationResult<AdminMemberSendResetPasswordEmailMutation>;
export type AdminMemberSendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>;
export const AdminMemberProfileUpdateDocument = gql`
    mutation AdminMemberProfileUpdate($input: AdminMemberProfileUpdateInput!) {
  adminMemberProfileUpdate(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    member {
      accountType
      activationLineItems {
        itemName
        salesPrice
      }
      activationOrderNo
      activationPrice
      addressCity
      addressCountry
      addressPostalCode
      addressState
      addressStreet1
      addressStreet2
      birthday
      companyContactPersonEmail
      companyContactPersonFirstName
      companyContactPersonLastName
      companyName
      createdAt
      createdBy
      createdByAdminId
      createdByAdminName
      credit
      creditSpent
      email
      firstName
      gameCredit
      gender
      handed
      hasGroupMembers
      hasSimulatorPrivilege
      hasSubscriptions
      individualId
      internalAccountType
      isSimulatorUseRedeemed
      kGolfAccountCreationError
      lastName
      locker
      members {
        accountType
        firstName
        id
        individualId
        lastName
      }
      membershipStatus
      membershipType {
        baseCountryCode
        internalName
        isCorporate
        tagBgColorCode
        tagText
        tagTextColorCode
      }
      membershipUuid
      memberStatus
      memberUuid
      mobileNumber
      nationality
      nickname
      partialNricOrFin
      practiseCredit
      profileImageUrl
      pushTokens
      relationshipToMainMember
      serviceNote
      signUpSidasInsoles
      startDate
      voucherField
      voucherIndoor
    }
  }
}
    `;
export type AdminMemberProfileUpdateMutationFn = Apollo.MutationFunction<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>;

/**
 * __useAdminMemberProfileUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProfileUpdateMutation, { data, loading, error }] = useAdminMemberProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>(AdminMemberProfileUpdateDocument, options);
      }
export type AdminMemberProfileUpdateMutationHookResult = ReturnType<typeof useAdminMemberProfileUpdateMutation>;
export type AdminMemberProfileUpdateMutationResult = Apollo.MutationResult<AdminMemberProfileUpdateMutation>;
export type AdminMemberProfileUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>;
export const AdminMemberTierUpdateDocument = gql`
    mutation AdminMemberTierUpdate($input: AdminMemberTierUpdateInput!) {
  adminMemberTierUpdate(input: $input)
}
    `;
export type AdminMemberTierUpdateMutationFn = Apollo.MutationFunction<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>;

/**
 * __useAdminMemberTierUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberTierUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberTierUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberTierUpdateMutation, { data, loading, error }] = useAdminMemberTierUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberTierUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>(AdminMemberTierUpdateDocument, options);
      }
export type AdminMemberTierUpdateMutationHookResult = ReturnType<typeof useAdminMemberTierUpdateMutation>;
export type AdminMemberTierUpdateMutationResult = Apollo.MutationResult<AdminMemberTierUpdateMutation>;
export type AdminMemberTierUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>;
export const AdminUpdateSidasInsolesDocument = gql`
    mutation AdminUpdateSidasInsoles($input: AdminUpdateSidasInsolesInput!) {
  adminUpdateSidasInsoles(input: $input)
}
    `;
export type AdminUpdateSidasInsolesMutationFn = Apollo.MutationFunction<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>;

/**
 * __useAdminUpdateSidasInsolesMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSidasInsolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSidasInsolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSidasInsolesMutation, { data, loading, error }] = useAdminUpdateSidasInsolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateSidasInsolesMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>(AdminUpdateSidasInsolesDocument, options);
      }
export type AdminUpdateSidasInsolesMutationHookResult = ReturnType<typeof useAdminUpdateSidasInsolesMutation>;
export type AdminUpdateSidasInsolesMutationResult = Apollo.MutationResult<AdminUpdateSidasInsolesMutation>;
export type AdminUpdateSidasInsolesMutationOptions = Apollo.BaseMutationOptions<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>;
export const AdminUpdateNicknameDocument = gql`
    mutation AdminUpdateNickname($input: AdminUpdateNicknameInput!) {
  adminUpdateNickname(input: $input)
}
    `;
export type AdminUpdateNicknameMutationFn = Apollo.MutationFunction<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>;

/**
 * __useAdminUpdateNicknameMutation__
 *
 * To run a mutation, you first call `useAdminUpdateNicknameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateNicknameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateNicknameMutation, { data, loading, error }] = useAdminUpdateNicknameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateNicknameMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>(AdminUpdateNicknameDocument, options);
      }
export type AdminUpdateNicknameMutationHookResult = ReturnType<typeof useAdminUpdateNicknameMutation>;
export type AdminUpdateNicknameMutationResult = Apollo.MutationResult<AdminUpdateNicknameMutation>;
export type AdminUpdateNicknameMutationOptions = Apollo.BaseMutationOptions<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>;
export const AdminMemberResendOnboardingEmailDocument = gql`
    mutation AdminMemberResendOnboardingEmail($input: AdminMemberResendOnboardingEmailInput!) {
  adminMemberResendOnboardingEmail(input: $input)
}
    `;
export type AdminMemberResendOnboardingEmailMutationFn = Apollo.MutationFunction<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>;

/**
 * __useAdminMemberResendOnboardingEmailMutation__
 *
 * To run a mutation, you first call `useAdminMemberResendOnboardingEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberResendOnboardingEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberResendOnboardingEmailMutation, { data, loading, error }] = useAdminMemberResendOnboardingEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberResendOnboardingEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>(AdminMemberResendOnboardingEmailDocument, options);
      }
export type AdminMemberResendOnboardingEmailMutationHookResult = ReturnType<typeof useAdminMemberResendOnboardingEmailMutation>;
export type AdminMemberResendOnboardingEmailMutationResult = Apollo.MutationResult<AdminMemberResendOnboardingEmailMutation>;
export type AdminMemberResendOnboardingEmailMutationOptions = Apollo.BaseMutationOptions<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>;
export const AdminMemberUpdatePasswordDocument = gql`
    mutation AdminMemberUpdatePassword($input: AdminMemberUpdatePasswordInput!) {
  adminMemberUpdatePassword(input: $input)
}
    `;
export type AdminMemberUpdatePasswordMutationFn = Apollo.MutationFunction<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>;

/**
 * __useAdminMemberUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAdminMemberUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberUpdatePasswordMutation, { data, loading, error }] = useAdminMemberUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>(AdminMemberUpdatePasswordDocument, options);
      }
export type AdminMemberUpdatePasswordMutationHookResult = ReturnType<typeof useAdminMemberUpdatePasswordMutation>;
export type AdminMemberUpdatePasswordMutationResult = Apollo.MutationResult<AdminMemberUpdatePasswordMutation>;
export type AdminMemberUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>;
export const AdminMemberReassignMembershipIdDocument = gql`
    mutation AdminMemberReassignMembershipId($input: AdminMemberReassignMembershipIdInput!) {
  adminMemberReassignMembershipId(input: $input)
}
    `;
export type AdminMemberReassignMembershipIdMutationFn = Apollo.MutationFunction<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>;

/**
 * __useAdminMemberReassignMembershipIdMutation__
 *
 * To run a mutation, you first call `useAdminMemberReassignMembershipIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberReassignMembershipIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberReassignMembershipIdMutation, { data, loading, error }] = useAdminMemberReassignMembershipIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberReassignMembershipIdMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>(AdminMemberReassignMembershipIdDocument, options);
      }
export type AdminMemberReassignMembershipIdMutationHookResult = ReturnType<typeof useAdminMemberReassignMembershipIdMutation>;
export type AdminMemberReassignMembershipIdMutationResult = Apollo.MutationResult<AdminMemberReassignMembershipIdMutation>;
export type AdminMemberReassignMembershipIdMutationOptions = Apollo.BaseMutationOptions<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>;
export const AdminMemberServiceUpdateDocument = gql`
    mutation AdminMemberServiceUpdate($input: AdminMemberServiceUpdateInput!) {
  adminMemberServiceUpdate(input: $input)
}
    `;
export type AdminMemberServiceUpdateMutationFn = Apollo.MutationFunction<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>;

/**
 * __useAdminMemberServiceUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberServiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberServiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberServiceUpdateMutation, { data, loading, error }] = useAdminMemberServiceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberServiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>(AdminMemberServiceUpdateDocument, options);
      }
export type AdminMemberServiceUpdateMutationHookResult = ReturnType<typeof useAdminMemberServiceUpdateMutation>;
export type AdminMemberServiceUpdateMutationResult = Apollo.MutationResult<AdminMemberServiceUpdateMutation>;
export type AdminMemberServiceUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>;
export const AdminMemberTypeUpdateDocument = gql`
    mutation AdminMemberTypeUpdate($input: AdminMemberTypeUpdateInput!) {
  adminMemberTypeUpdate(input: $input)
}
    `;
export type AdminMemberTypeUpdateMutationFn = Apollo.MutationFunction<AdminMemberTypeUpdateMutation, AdminMemberTypeUpdateMutationVariables>;

/**
 * __useAdminMemberTypeUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberTypeUpdateMutation, { data, loading, error }] = useAdminMemberTypeUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberTypeUpdateMutation, AdminMemberTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberTypeUpdateMutation, AdminMemberTypeUpdateMutationVariables>(AdminMemberTypeUpdateDocument, options);
      }
export type AdminMemberTypeUpdateMutationHookResult = ReturnType<typeof useAdminMemberTypeUpdateMutation>;
export type AdminMemberTypeUpdateMutationResult = Apollo.MutationResult<AdminMemberTypeUpdateMutation>;
export type AdminMemberTypeUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberTypeUpdateMutation, AdminMemberTypeUpdateMutationVariables>;
export const AdminMemberServiceTransactionDeleteDocument = gql`
    mutation AdminMemberServiceTransactionDelete($input: AdminMemberServiceTransactionDeleteInput!) {
  adminMemberServiceTransactionDelete(input: $input)
}
    `;
export type AdminMemberServiceTransactionDeleteMutationFn = Apollo.MutationFunction<AdminMemberServiceTransactionDeleteMutation, AdminMemberServiceTransactionDeleteMutationVariables>;

/**
 * __useAdminMemberServiceTransactionDeleteMutation__
 *
 * To run a mutation, you first call `useAdminMemberServiceTransactionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberServiceTransactionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberServiceTransactionDeleteMutation, { data, loading, error }] = useAdminMemberServiceTransactionDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberServiceTransactionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberServiceTransactionDeleteMutation, AdminMemberServiceTransactionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberServiceTransactionDeleteMutation, AdminMemberServiceTransactionDeleteMutationVariables>(AdminMemberServiceTransactionDeleteDocument, options);
      }
export type AdminMemberServiceTransactionDeleteMutationHookResult = ReturnType<typeof useAdminMemberServiceTransactionDeleteMutation>;
export type AdminMemberServiceTransactionDeleteMutationResult = Apollo.MutationResult<AdminMemberServiceTransactionDeleteMutation>;
export type AdminMemberServiceTransactionDeleteMutationOptions = Apollo.BaseMutationOptions<AdminMemberServiceTransactionDeleteMutation, AdminMemberServiceTransactionDeleteMutationVariables>;
export const AdminMemberProductPackageDeleteDocument = gql`
    mutation AdminMemberProductPackageDelete($input: AdminMemberProductPackageDeleteInput!) {
  adminMemberProductPackageDelete(input: $input)
}
    `;
export type AdminMemberProductPackageDeleteMutationFn = Apollo.MutationFunction<AdminMemberProductPackageDeleteMutation, AdminMemberProductPackageDeleteMutationVariables>;

/**
 * __useAdminMemberProductPackageDeleteMutation__
 *
 * To run a mutation, you first call `useAdminMemberProductPackageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProductPackageDeleteMutation, { data, loading, error }] = useAdminMemberProductPackageDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProductPackageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProductPackageDeleteMutation, AdminMemberProductPackageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProductPackageDeleteMutation, AdminMemberProductPackageDeleteMutationVariables>(AdminMemberProductPackageDeleteDocument, options);
      }
export type AdminMemberProductPackageDeleteMutationHookResult = ReturnType<typeof useAdminMemberProductPackageDeleteMutation>;
export type AdminMemberProductPackageDeleteMutationResult = Apollo.MutationResult<AdminMemberProductPackageDeleteMutation>;
export type AdminMemberProductPackageDeleteMutationOptions = Apollo.BaseMutationOptions<AdminMemberProductPackageDeleteMutation, AdminMemberProductPackageDeleteMutationVariables>;
export const AdminMemberProductPackageShareDocument = gql`
    mutation AdminMemberProductPackageShare($input: AdminMemberProductPackageShareInput!) {
  adminMemberProductPackageShare(input: $input)
}
    `;
export type AdminMemberProductPackageShareMutationFn = Apollo.MutationFunction<AdminMemberProductPackageShareMutation, AdminMemberProductPackageShareMutationVariables>;

/**
 * __useAdminMemberProductPackageShareMutation__
 *
 * To run a mutation, you first call `useAdminMemberProductPackageShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProductPackageShareMutation, { data, loading, error }] = useAdminMemberProductPackageShareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProductPackageShareMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProductPackageShareMutation, AdminMemberProductPackageShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProductPackageShareMutation, AdminMemberProductPackageShareMutationVariables>(AdminMemberProductPackageShareDocument, options);
      }
export type AdminMemberProductPackageShareMutationHookResult = ReturnType<typeof useAdminMemberProductPackageShareMutation>;
export type AdminMemberProductPackageShareMutationResult = Apollo.MutationResult<AdminMemberProductPackageShareMutation>;
export type AdminMemberProductPackageShareMutationOptions = Apollo.BaseMutationOptions<AdminMemberProductPackageShareMutation, AdminMemberProductPackageShareMutationVariables>;
export const AdminMemberProductPackageManageDocument = gql`
    mutation AdminMemberProductPackageManage($input: AdminMemberProductPackageManageInput!) {
  adminMemberProductPackageManage(input: $input)
}
    `;
export type AdminMemberProductPackageManageMutationFn = Apollo.MutationFunction<AdminMemberProductPackageManageMutation, AdminMemberProductPackageManageMutationVariables>;

/**
 * __useAdminMemberProductPackageManageMutation__
 *
 * To run a mutation, you first call `useAdminMemberProductPackageManageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageManageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProductPackageManageMutation, { data, loading, error }] = useAdminMemberProductPackageManageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProductPackageManageMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProductPackageManageMutation, AdminMemberProductPackageManageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProductPackageManageMutation, AdminMemberProductPackageManageMutationVariables>(AdminMemberProductPackageManageDocument, options);
      }
export type AdminMemberProductPackageManageMutationHookResult = ReturnType<typeof useAdminMemberProductPackageManageMutation>;
export type AdminMemberProductPackageManageMutationResult = Apollo.MutationResult<AdminMemberProductPackageManageMutation>;
export type AdminMemberProductPackageManageMutationOptions = Apollo.BaseMutationOptions<AdminMemberProductPackageManageMutation, AdminMemberProductPackageManageMutationVariables>;
export const AdminMemberProductPackageTransferDocument = gql`
    mutation AdminMemberProductPackageTransfer($input: AdminMemberProductPackageTransferInput!) {
  adminMemberProductPackageTransfer(input: $input)
}
    `;
export type AdminMemberProductPackageTransferMutationFn = Apollo.MutationFunction<AdminMemberProductPackageTransferMutation, AdminMemberProductPackageTransferMutationVariables>;

/**
 * __useAdminMemberProductPackageTransferMutation__
 *
 * To run a mutation, you first call `useAdminMemberProductPackageTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProductPackageTransferMutation, { data, loading, error }] = useAdminMemberProductPackageTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProductPackageTransferMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProductPackageTransferMutation, AdminMemberProductPackageTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProductPackageTransferMutation, AdminMemberProductPackageTransferMutationVariables>(AdminMemberProductPackageTransferDocument, options);
      }
export type AdminMemberProductPackageTransferMutationHookResult = ReturnType<typeof useAdminMemberProductPackageTransferMutation>;
export type AdminMemberProductPackageTransferMutationResult = Apollo.MutationResult<AdminMemberProductPackageTransferMutation>;
export type AdminMemberProductPackageTransferMutationOptions = Apollo.BaseMutationOptions<AdminMemberProductPackageTransferMutation, AdminMemberProductPackageTransferMutationVariables>;
export const AdminMemberProductPackageGroupDocument = gql`
    mutation AdminMemberProductPackageGroup($input: AdminMemberProductPackageGroupInput!) {
  adminMemberProductPackageGroup(input: $input)
}
    `;
export type AdminMemberProductPackageGroupMutationFn = Apollo.MutationFunction<AdminMemberProductPackageGroupMutation, AdminMemberProductPackageGroupMutationVariables>;

/**
 * __useAdminMemberProductPackageGroupMutation__
 *
 * To run a mutation, you first call `useAdminMemberProductPackageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProductPackageGroupMutation, { data, loading, error }] = useAdminMemberProductPackageGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProductPackageGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProductPackageGroupMutation, AdminMemberProductPackageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProductPackageGroupMutation, AdminMemberProductPackageGroupMutationVariables>(AdminMemberProductPackageGroupDocument, options);
      }
export type AdminMemberProductPackageGroupMutationHookResult = ReturnType<typeof useAdminMemberProductPackageGroupMutation>;
export type AdminMemberProductPackageGroupMutationResult = Apollo.MutationResult<AdminMemberProductPackageGroupMutation>;
export type AdminMemberProductPackageGroupMutationOptions = Apollo.BaseMutationOptions<AdminMemberProductPackageGroupMutation, AdminMemberProductPackageGroupMutationVariables>;
export const AdminMemberServiceTransactionUpdateDocument = gql`
    mutation AdminMemberServiceTransactionUpdate($input: AdminMemberServiceTransactionUpdateInput!) {
  adminMemberServiceTransactionUpdate(input: $input) {
    amount
    coach
    comment
    date
    expirableCredit {
      amount
      expiryDate
      id
    }
    facilityType
    id
    memberName
    packageName
    packageType
    serviceId
    serviceType
    transactionType
    venue
  }
}
    `;
export type AdminMemberServiceTransactionUpdateMutationFn = Apollo.MutationFunction<AdminMemberServiceTransactionUpdateMutation, AdminMemberServiceTransactionUpdateMutationVariables>;

/**
 * __useAdminMemberServiceTransactionUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberServiceTransactionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberServiceTransactionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberServiceTransactionUpdateMutation, { data, loading, error }] = useAdminMemberServiceTransactionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberServiceTransactionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberServiceTransactionUpdateMutation, AdminMemberServiceTransactionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberServiceTransactionUpdateMutation, AdminMemberServiceTransactionUpdateMutationVariables>(AdminMemberServiceTransactionUpdateDocument, options);
      }
export type AdminMemberServiceTransactionUpdateMutationHookResult = ReturnType<typeof useAdminMemberServiceTransactionUpdateMutation>;
export type AdminMemberServiceTransactionUpdateMutationResult = Apollo.MutationResult<AdminMemberServiceTransactionUpdateMutation>;
export type AdminMemberServiceTransactionUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberServiceTransactionUpdateMutation, AdminMemberServiceTransactionUpdateMutationVariables>;
export const AdminMemberProductPackageExtensionUpdateDocument = gql`
    mutation AdminMemberProductPackageExtensionUpdate($input: AdminMemberProductPackageExtensionUpdateInput!) {
  adminMemberProductPackageExtensionUpdate(input: $input) {
    authorizedAdjusterName
    comment
    dateExtended
    daysAdded
    id
    newExpiryDate
    prevExpiryDate
  }
}
    `;
export type AdminMemberProductPackageExtensionUpdateMutationFn = Apollo.MutationFunction<AdminMemberProductPackageExtensionUpdateMutation, AdminMemberProductPackageExtensionUpdateMutationVariables>;

/**
 * __useAdminMemberProductPackageExtensionUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberProductPackageExtensionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageExtensionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProductPackageExtensionUpdateMutation, { data, loading, error }] = useAdminMemberProductPackageExtensionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProductPackageExtensionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProductPackageExtensionUpdateMutation, AdminMemberProductPackageExtensionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProductPackageExtensionUpdateMutation, AdminMemberProductPackageExtensionUpdateMutationVariables>(AdminMemberProductPackageExtensionUpdateDocument, options);
      }
export type AdminMemberProductPackageExtensionUpdateMutationHookResult = ReturnType<typeof useAdminMemberProductPackageExtensionUpdateMutation>;
export type AdminMemberProductPackageExtensionUpdateMutationResult = Apollo.MutationResult<AdminMemberProductPackageExtensionUpdateMutation>;
export type AdminMemberProductPackageExtensionUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberProductPackageExtensionUpdateMutation, AdminMemberProductPackageExtensionUpdateMutationVariables>;
export const AdminMemberSimulatorUseUpdateDocument = gql`
    mutation AdminMemberSimulatorUseUpdate($input: AdminMemberSimulatorUseUpdateInput!) {
  adminMemberSimulatorUseUpdate(input: $input)
}
    `;
export type AdminMemberSimulatorUseUpdateMutationFn = Apollo.MutationFunction<AdminMemberSimulatorUseUpdateMutation, AdminMemberSimulatorUseUpdateMutationVariables>;

/**
 * __useAdminMemberSimulatorUseUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberSimulatorUseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberSimulatorUseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberSimulatorUseUpdateMutation, { data, loading, error }] = useAdminMemberSimulatorUseUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberSimulatorUseUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberSimulatorUseUpdateMutation, AdminMemberSimulatorUseUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberSimulatorUseUpdateMutation, AdminMemberSimulatorUseUpdateMutationVariables>(AdminMemberSimulatorUseUpdateDocument, options);
      }
export type AdminMemberSimulatorUseUpdateMutationHookResult = ReturnType<typeof useAdminMemberSimulatorUseUpdateMutation>;
export type AdminMemberSimulatorUseUpdateMutationResult = Apollo.MutationResult<AdminMemberSimulatorUseUpdateMutation>;
export type AdminMemberSimulatorUseUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberSimulatorUseUpdateMutation, AdminMemberSimulatorUseUpdateMutationVariables>;
export const AdminMemberInvoiceDeleteDocument = gql`
    mutation AdminMemberInvoiceDelete($input: AdminMemberInvoiceDeleteInput!) {
  adminMemberInvoiceDelete(input: $input)
}
    `;
export type AdminMemberInvoiceDeleteMutationFn = Apollo.MutationFunction<AdminMemberInvoiceDeleteMutation, AdminMemberInvoiceDeleteMutationVariables>;

/**
 * __useAdminMemberInvoiceDeleteMutation__
 *
 * To run a mutation, you first call `useAdminMemberInvoiceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberInvoiceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberInvoiceDeleteMutation, { data, loading, error }] = useAdminMemberInvoiceDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberInvoiceDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberInvoiceDeleteMutation, AdminMemberInvoiceDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberInvoiceDeleteMutation, AdminMemberInvoiceDeleteMutationVariables>(AdminMemberInvoiceDeleteDocument, options);
      }
export type AdminMemberInvoiceDeleteMutationHookResult = ReturnType<typeof useAdminMemberInvoiceDeleteMutation>;
export type AdminMemberInvoiceDeleteMutationResult = Apollo.MutationResult<AdminMemberInvoiceDeleteMutation>;
export type AdminMemberInvoiceDeleteMutationOptions = Apollo.BaseMutationOptions<AdminMemberInvoiceDeleteMutation, AdminMemberInvoiceDeleteMutationVariables>;
export const AdminMemberBdfAddDocument = gql`
    mutation AdminMemberBDFAdd($input: AdminMemberBDFAddInput!) {
  adminMemberBDFAdd(input: $input)
}
    `;
export type AdminMemberBdfAddMutationFn = Apollo.MutationFunction<AdminMemberBdfAddMutation, AdminMemberBdfAddMutationVariables>;

/**
 * __useAdminMemberBdfAddMutation__
 *
 * To run a mutation, you first call `useAdminMemberBdfAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberBdfAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberBdfAddMutation, { data, loading, error }] = useAdminMemberBdfAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberBdfAddMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberBdfAddMutation, AdminMemberBdfAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberBdfAddMutation, AdminMemberBdfAddMutationVariables>(AdminMemberBdfAddDocument, options);
      }
export type AdminMemberBdfAddMutationHookResult = ReturnType<typeof useAdminMemberBdfAddMutation>;
export type AdminMemberBdfAddMutationResult = Apollo.MutationResult<AdminMemberBdfAddMutation>;
export type AdminMemberBdfAddMutationOptions = Apollo.BaseMutationOptions<AdminMemberBdfAddMutation, AdminMemberBdfAddMutationVariables>;
export const AdminMemberProductPackageReActivateDocument = gql`
    mutation AdminMemberProductPackageReActivate($input: AdminMemberProductPackageReActivateInput!) {
  adminMemberProductPackageReActivate(input: $input)
}
    `;
export type AdminMemberProductPackageReActivateMutationFn = Apollo.MutationFunction<AdminMemberProductPackageReActivateMutation, AdminMemberProductPackageReActivateMutationVariables>;

/**
 * __useAdminMemberProductPackageReActivateMutation__
 *
 * To run a mutation, you first call `useAdminMemberProductPackageReActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageReActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProductPackageReActivateMutation, { data, loading, error }] = useAdminMemberProductPackageReActivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProductPackageReActivateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProductPackageReActivateMutation, AdminMemberProductPackageReActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProductPackageReActivateMutation, AdminMemberProductPackageReActivateMutationVariables>(AdminMemberProductPackageReActivateDocument, options);
      }
export type AdminMemberProductPackageReActivateMutationHookResult = ReturnType<typeof useAdminMemberProductPackageReActivateMutation>;
export type AdminMemberProductPackageReActivateMutationResult = Apollo.MutationResult<AdminMemberProductPackageReActivateMutation>;
export type AdminMemberProductPackageReActivateMutationOptions = Apollo.BaseMutationOptions<AdminMemberProductPackageReActivateMutation, AdminMemberProductPackageReActivateMutationVariables>;
export const AdminMemberTransferCreditDocument = gql`
    mutation AdminMemberTransferCredit($input: AdminMemberTransferCreditInput!) {
  adminMemberTransferCredit(input: $input)
}
    `;
export type AdminMemberTransferCreditMutationFn = Apollo.MutationFunction<AdminMemberTransferCreditMutation, AdminMemberTransferCreditMutationVariables>;

/**
 * __useAdminMemberTransferCreditMutation__
 *
 * To run a mutation, you first call `useAdminMemberTransferCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberTransferCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberTransferCreditMutation, { data, loading, error }] = useAdminMemberTransferCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberTransferCreditMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberTransferCreditMutation, AdminMemberTransferCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberTransferCreditMutation, AdminMemberTransferCreditMutationVariables>(AdminMemberTransferCreditDocument, options);
      }
export type AdminMemberTransferCreditMutationHookResult = ReturnType<typeof useAdminMemberTransferCreditMutation>;
export type AdminMemberTransferCreditMutationResult = Apollo.MutationResult<AdminMemberTransferCreditMutation>;
export type AdminMemberTransferCreditMutationOptions = Apollo.BaseMutationOptions<AdminMemberTransferCreditMutation, AdminMemberTransferCreditMutationVariables>;
export const CoachMemberLessonNoteUpdateDocument = gql`
    mutation CoachMemberLessonNoteUpdate($input: CoachMemberLessonNoteUpdateInput!) {
  coachMemberLessonNoteUpdate(input: $input)
}
    `;
export type CoachMemberLessonNoteUpdateMutationFn = Apollo.MutationFunction<CoachMemberLessonNoteUpdateMutation, CoachMemberLessonNoteUpdateMutationVariables>;

/**
 * __useCoachMemberLessonNoteUpdateMutation__
 *
 * To run a mutation, you first call `useCoachMemberLessonNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachMemberLessonNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachMemberLessonNoteUpdateMutation, { data, loading, error }] = useCoachMemberLessonNoteUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachMemberLessonNoteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CoachMemberLessonNoteUpdateMutation, CoachMemberLessonNoteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoachMemberLessonNoteUpdateMutation, CoachMemberLessonNoteUpdateMutationVariables>(CoachMemberLessonNoteUpdateDocument, options);
      }
export type CoachMemberLessonNoteUpdateMutationHookResult = ReturnType<typeof useCoachMemberLessonNoteUpdateMutation>;
export type CoachMemberLessonNoteUpdateMutationResult = Apollo.MutationResult<CoachMemberLessonNoteUpdateMutation>;
export type CoachMemberLessonNoteUpdateMutationOptions = Apollo.BaseMutationOptions<CoachMemberLessonNoteUpdateMutation, CoachMemberLessonNoteUpdateMutationVariables>;
export const CoachMemberLessonNoteDeleteDocument = gql`
    mutation CoachMemberLessonNoteDelete($input: CoachMemberLessonNoteDeleteInput!) {
  coachMemberLessonNoteDelete(input: $input) {
    hasFeedback
  }
}
    `;
export type CoachMemberLessonNoteDeleteMutationFn = Apollo.MutationFunction<CoachMemberLessonNoteDeleteMutation, CoachMemberLessonNoteDeleteMutationVariables>;

/**
 * __useCoachMemberLessonNoteDeleteMutation__
 *
 * To run a mutation, you first call `useCoachMemberLessonNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachMemberLessonNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachMemberLessonNoteDeleteMutation, { data, loading, error }] = useCoachMemberLessonNoteDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachMemberLessonNoteDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CoachMemberLessonNoteDeleteMutation, CoachMemberLessonNoteDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoachMemberLessonNoteDeleteMutation, CoachMemberLessonNoteDeleteMutationVariables>(CoachMemberLessonNoteDeleteDocument, options);
      }
export type CoachMemberLessonNoteDeleteMutationHookResult = ReturnType<typeof useCoachMemberLessonNoteDeleteMutation>;
export type CoachMemberLessonNoteDeleteMutationResult = Apollo.MutationResult<CoachMemberLessonNoteDeleteMutation>;
export type CoachMemberLessonNoteDeleteMutationOptions = Apollo.BaseMutationOptions<CoachMemberLessonNoteDeleteMutation, CoachMemberLessonNoteDeleteMutationVariables>;
export const GenerateLessonAttachmentUploadUrlDocument = gql`
    mutation GenerateLessonAttachmentUploadUrl($input: GenerateLessonAttachmentUploadUrlInput!) {
  generateLessonAttachmentUploadUrl(input: $input) {
    fields
    fileUrl
    key
    signedUrl
  }
}
    `;
export type GenerateLessonAttachmentUploadUrlMutationFn = Apollo.MutationFunction<GenerateLessonAttachmentUploadUrlMutation, GenerateLessonAttachmentUploadUrlMutationVariables>;

/**
 * __useGenerateLessonAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateLessonAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLessonAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLessonAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateLessonAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLessonAttachmentUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateLessonAttachmentUploadUrlMutation, GenerateLessonAttachmentUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateLessonAttachmentUploadUrlMutation, GenerateLessonAttachmentUploadUrlMutationVariables>(GenerateLessonAttachmentUploadUrlDocument, options);
      }
export type GenerateLessonAttachmentUploadUrlMutationHookResult = ReturnType<typeof useGenerateLessonAttachmentUploadUrlMutation>;
export type GenerateLessonAttachmentUploadUrlMutationResult = Apollo.MutationResult<GenerateLessonAttachmentUploadUrlMutation>;
export type GenerateLessonAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateLessonAttachmentUploadUrlMutation, GenerateLessonAttachmentUploadUrlMutationVariables>;
export const FormHelperAceCoinTypeDocument = gql`
    query FormHelperAceCoinType($args: FormHelperAceCoinTypeArgs!) {
  formHelperAceCoinType(args: $args) {
    currencyCode
    price
  }
}
    `;

/**
 * __useFormHelperAceCoinTypeQuery__
 *
 * To run a query within a React component, call `useFormHelperAceCoinTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperAceCoinTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperAceCoinTypeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperAceCoinTypeQuery(baseOptions: Apollo.QueryHookOptions<FormHelperAceCoinTypeQuery, FormHelperAceCoinTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperAceCoinTypeQuery, FormHelperAceCoinTypeQueryVariables>(FormHelperAceCoinTypeDocument, options);
      }
export function useFormHelperAceCoinTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperAceCoinTypeQuery, FormHelperAceCoinTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperAceCoinTypeQuery, FormHelperAceCoinTypeQueryVariables>(FormHelperAceCoinTypeDocument, options);
        }
export type FormHelperAceCoinTypeQueryHookResult = ReturnType<typeof useFormHelperAceCoinTypeQuery>;
export type FormHelperAceCoinTypeLazyQueryHookResult = ReturnType<typeof useFormHelperAceCoinTypeLazyQuery>;
export type FormHelperAceCoinTypeQueryResult = Apollo.QueryResult<FormHelperAceCoinTypeQuery, FormHelperAceCoinTypeQueryVariables>;
export const FormHelperProductPackagesDocument = gql`
    query FormHelperProductPackages($args: FormHelperProductPackagesArgs!) {
  formHelperProductPackages(args: $args) {
    packages {
      itemCode
      name
    }
  }
}
    `;

/**
 * __useFormHelperProductPackagesQuery__
 *
 * To run a query within a React component, call `useFormHelperProductPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperProductPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperProductPackagesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperProductPackagesQuery(baseOptions: Apollo.QueryHookOptions<FormHelperProductPackagesQuery, FormHelperProductPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperProductPackagesQuery, FormHelperProductPackagesQueryVariables>(FormHelperProductPackagesDocument, options);
      }
export function useFormHelperProductPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperProductPackagesQuery, FormHelperProductPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperProductPackagesQuery, FormHelperProductPackagesQueryVariables>(FormHelperProductPackagesDocument, options);
        }
export type FormHelperProductPackagesQueryHookResult = ReturnType<typeof useFormHelperProductPackagesQuery>;
export type FormHelperProductPackagesLazyQueryHookResult = ReturnType<typeof useFormHelperProductPackagesLazyQuery>;
export type FormHelperProductPackagesQueryResult = Apollo.QueryResult<FormHelperProductPackagesQuery, FormHelperProductPackagesQueryVariables>;
export const AdminMembersDocument = gql`
    query AdminMembers($args: AdminMembersArgs!) {
  adminMembers(args: $args) {
    edges {
      cursor
      node {
        accountType
        aceCoins
        appVersion
        companyContactPersonFirstName
        companyContactPersonLastName
        companyName
        createdAt
        credits
        firstName
        hasGroupMembers
        id
        individualId
        internalAccountType
        kGolfAccountCreationError
        lastName
        lessonIndoorCredits
        memberName
        membershipId
        membershipType {
          baseCountryCode
          internalName
          isCorporate
          tagBgColorCode
          tagText
          tagTextColorCode
        }
        memberStatus
        practiseCredits
        startDate
      }
    }
    pageInfo {
      endCursor
      failedKGolfAccounts
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMembersQuery__
 *
 * To run a query within a React component, call `useAdminMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembersQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembersQuery(baseOptions: Apollo.QueryHookOptions<AdminMembersQuery, AdminMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembersQuery, AdminMembersQueryVariables>(AdminMembersDocument, options);
      }
export function useAdminMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembersQuery, AdminMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembersQuery, AdminMembersQueryVariables>(AdminMembersDocument, options);
        }
export type AdminMembersQueryHookResult = ReturnType<typeof useAdminMembersQuery>;
export type AdminMembersLazyQueryHookResult = ReturnType<typeof useAdminMembersLazyQuery>;
export type AdminMembersQueryResult = Apollo.QueryResult<AdminMembersQuery, AdminMembersQueryVariables>;
export const AdminMemberDocument = gql`
    query AdminMember($args: AdminMemberArgs!) {
  adminMember(args: $args) {
    accountType
    activationLineItems {
      itemName
      salesPrice
    }
    activationOrderNo
    activationPrice
    addressCity
    addressCountry
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    birthday
    companyContactPersonEmail
    companyContactPersonFirstName
    companyContactPersonLastName
    companyName
    createdAt
    createdBy
    createdByAdminId
    createdByAdminName
    credit
    creditSpent
    email
    firstName
    gameCredit
    gender
    handed
    hasGroupMembers
    hasSimulatorPrivilege
    hasSubscriptions
    individualId
    internalAccountType
    isSimulatorUseRedeemed
    kGolfAccountCreationError
    lastName
    locker
    members {
      accountType
      firstName
      id
      individualId
      lastName
    }
    membershipStatus
    membershipType {
      baseCountryCode
      internalName
      isCorporate
      price
      tagBgColorCode
      tagText
      tagTextColorCode
    }
    membershipUuid
    memberStatus
    memberUuid
    mobileNumber
    nationality
    nickname
    partialNricOrFin
    practiseCredit
    profileImageUrl
    pushTokens
    relationshipToMainMember
    serviceNote
    signUpSidasInsoles
    startDate
    termEndDate
    voucherField
    voucherIndoor
  }
}
    `;

/**
 * __useAdminMemberQuery__
 *
 * To run a query within a React component, call `useAdminMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberQuery, AdminMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberQuery, AdminMemberQueryVariables>(AdminMemberDocument, options);
      }
export function useAdminMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberQuery, AdminMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberQuery, AdminMemberQueryVariables>(AdminMemberDocument, options);
        }
export type AdminMemberQueryHookResult = ReturnType<typeof useAdminMemberQuery>;
export type AdminMemberLazyQueryHookResult = ReturnType<typeof useAdminMemberLazyQuery>;
export type AdminMemberQueryResult = Apollo.QueryResult<AdminMemberQuery, AdminMemberQueryVariables>;
export const AdminKGolfMemberDocument = gql`
    query AdminKGolfMember($args: AdminKGolfMemberArgs) {
  adminKGolfMember(args: $args) {
    address1
    address2
    birthday
    cdn
    city
    connectKakao
    connectWechat
    country
    email
    gender
    handed
    id
    isTermsAgreeNotificationEmail
    isTermsAgreeNotificationSMS
    mobilePhone
    mobilePhoneCountry
    nickname
    profilePath
    province
    zipcode
  }
}
    `;

/**
 * __useAdminKGolfMemberQuery__
 *
 * To run a query within a React component, call `useAdminKGolfMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminKGolfMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminKGolfMemberQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminKGolfMemberQuery(baseOptions?: Apollo.QueryHookOptions<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>(AdminKGolfMemberDocument, options);
      }
export function useAdminKGolfMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>(AdminKGolfMemberDocument, options);
        }
export type AdminKGolfMemberQueryHookResult = ReturnType<typeof useAdminKGolfMemberQuery>;
export type AdminKGolfMemberLazyQueryHookResult = ReturnType<typeof useAdminKGolfMemberLazyQuery>;
export type AdminKGolfMemberQueryResult = Apollo.QueryResult<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>;
export const AdminMembershipSubscriptionsDocument = gql`
    query AdminMembershipSubscriptions($args: AdminMembershipSubscriptionsArgs!) {
  adminMembershipSubscriptions(args: $args) {
    edges {
      cursor
      node {
        aceCoins
        endDate
        mainMemberMainId
        mainMemberName
        membershipUuid
        memberUuid
        startDate
        status
        subscriptionBalance
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMembershipSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAdminMembershipSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipSubscriptionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>(AdminMembershipSubscriptionsDocument, options);
      }
export function useAdminMembershipSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>(AdminMembershipSubscriptionsDocument, options);
        }
export type AdminMembershipSubscriptionsQueryHookResult = ReturnType<typeof useAdminMembershipSubscriptionsQuery>;
export type AdminMembershipSubscriptionsLazyQueryHookResult = ReturnType<typeof useAdminMembershipSubscriptionsLazyQuery>;
export type AdminMembershipSubscriptionsQueryResult = Apollo.QueryResult<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>;
export const AdminMemberSubscriptionsDocument = gql`
    query AdminMemberSubscriptions($args: AdminMemberSubscriptionsArgs!) {
  adminMemberSubscriptions(args: $args) {
    edges {
      cursor
      node {
        amount
        creditDeducted
        days
        description
        endDate
        id
        startDate
      }
    }
    pageInfo {
      endCursor
      firstRecordDateTime
      hasNextPage
      total
    }
    status
    subscriptionEndDate
    subscriptionStartDate
  }
}
    `;

/**
 * __useAdminMemberSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAdminMemberSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberSubscriptionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>(AdminMemberSubscriptionsDocument, options);
      }
export function useAdminMemberSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>(AdminMemberSubscriptionsDocument, options);
        }
export type AdminMemberSubscriptionsQueryHookResult = ReturnType<typeof useAdminMemberSubscriptionsQuery>;
export type AdminMemberSubscriptionsLazyQueryHookResult = ReturnType<typeof useAdminMemberSubscriptionsLazyQuery>;
export type AdminMemberSubscriptionsQueryResult = Apollo.QueryResult<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>;
export const AdminMembershipServicesDocument = gql`
    query AdminMembershipServices($args: AdminMembershipServicesArgs!) {
  adminMembershipServices(args: $args) {
    edges {
      cursor
      node {
        amount
        countryCode
        dateAdded
        expiryDate
        expiryWarning
        groupServiceId
        hasSupplementaryRedemption
        isDaily
        isDailyRedeemed
        isGroup
        isShareGroupPaused
        memberName
        orderNo
        packageType
        parentServiceId
        serviceId
        serviceName
        status
        supplementaryAmount
        supplementaryUnitName
        type
        unitType
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMembershipServicesQuery__
 *
 * To run a query within a React component, call `useAdminMembershipServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipServicesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipServicesQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>(AdminMembershipServicesDocument, options);
      }
export function useAdminMembershipServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>(AdminMembershipServicesDocument, options);
        }
export type AdminMembershipServicesQueryHookResult = ReturnType<typeof useAdminMembershipServicesQuery>;
export type AdminMembershipServicesLazyQueryHookResult = ReturnType<typeof useAdminMembershipServicesLazyQuery>;
export type AdminMembershipServicesQueryResult = Apollo.QueryResult<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>;
export const AdminMemberServiceTransactionsDocument = gql`
    query AdminMemberServiceTransactions($args: AdminMemberServiceTransactionsArgs!) {
  adminMemberServiceTransactions(args: $args) {
    edges {
      cursor
      node {
        amount
        coach
        comment
        date
        expirableCredit {
          amount
          expiryDate
          id
        }
        facilityType
        id
        isShareGroupPaused
        isSupplementaryRedemption
        memberName
        packageName
        packageType
        serviceId
        serviceType
        supplementaryUnitName
        transactionType
        type
        venue
      }
    }
    pageInfo {
      endCursor
      firstRecordDateTime
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMemberServiceTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminMemberServiceTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberServiceTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberServiceTransactionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberServiceTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>(AdminMemberServiceTransactionsDocument, options);
      }
export function useAdminMemberServiceTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>(AdminMemberServiceTransactionsDocument, options);
        }
export type AdminMemberServiceTransactionsQueryHookResult = ReturnType<typeof useAdminMemberServiceTransactionsQuery>;
export type AdminMemberServiceTransactionsLazyQueryHookResult = ReturnType<typeof useAdminMemberServiceTransactionsLazyQuery>;
export type AdminMemberServiceTransactionsQueryResult = Apollo.QueryResult<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>;
export const AdminMemberAcTransactionsDocument = gql`
    query AdminMemberAcTransactions($args: AdminMemberAcTransactionsArgs!) {
  adminMemberAcTransactions(args: $args) {
    edges {
      cursor
      node {
        account
        accountId
        amount
        description
        direction
        id
        invoiceNo
        transactionDateTime
        transactionId
        type
        venue
      }
    }
    pageInfo {
      endCursor
      firstRecordDateTime
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMemberAcTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminMemberAcTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberAcTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberAcTransactionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberAcTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberAcTransactionsQuery, AdminMemberAcTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberAcTransactionsQuery, AdminMemberAcTransactionsQueryVariables>(AdminMemberAcTransactionsDocument, options);
      }
export function useAdminMemberAcTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberAcTransactionsQuery, AdminMemberAcTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberAcTransactionsQuery, AdminMemberAcTransactionsQueryVariables>(AdminMemberAcTransactionsDocument, options);
        }
export type AdminMemberAcTransactionsQueryHookResult = ReturnType<typeof useAdminMemberAcTransactionsQuery>;
export type AdminMemberAcTransactionsLazyQueryHookResult = ReturnType<typeof useAdminMemberAcTransactionsLazyQuery>;
export type AdminMemberAcTransactionsQueryResult = Apollo.QueryResult<AdminMemberAcTransactionsQuery, AdminMemberAcTransactionsQueryVariables>;
export const AdminMemberInvoicesDocument = gql`
    query AdminMemberInvoices($args: AdminMemberInvoicesArgs!) {
  adminMemberInvoices(args: $args) {
    edges {
      cursor
      node {
        account
        accountId
        amount
        invoiceNo
        paymentCurrency
        paymentMethod
        transactionDateTime
        venue
      }
    }
    pageInfo {
      endCursor
      firstRecordDateTime
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMemberInvoicesQuery__
 *
 * To run a query within a React component, call `useAdminMemberInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberInvoicesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberInvoicesQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberInvoicesQuery, AdminMemberInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberInvoicesQuery, AdminMemberInvoicesQueryVariables>(AdminMemberInvoicesDocument, options);
      }
export function useAdminMemberInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberInvoicesQuery, AdminMemberInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberInvoicesQuery, AdminMemberInvoicesQueryVariables>(AdminMemberInvoicesDocument, options);
        }
export type AdminMemberInvoicesQueryHookResult = ReturnType<typeof useAdminMemberInvoicesQuery>;
export type AdminMemberInvoicesLazyQueryHookResult = ReturnType<typeof useAdminMemberInvoicesLazyQuery>;
export type AdminMemberInvoicesQueryResult = Apollo.QueryResult<AdminMemberInvoicesQuery, AdminMemberInvoicesQueryVariables>;
export const AdminMemberProductPackageDocument = gql`
    query AdminMemberProductPackage($args: AdminMemberProductPackageArgs!) {
  adminMemberProductPackage(args: $args) {
    amount
    comment
    dateAdded
    expiryDate
    expiryDateStr
    expiryWarning
    extensions {
      authorizedAdjusterName
      comment
      dateExtended
      daysAdded
      id
      newExpiryDate
      prevExpiryDate
    }
    forfeitureAmount
    forfeitureDate
    forfeitureDateStr
    groupId
    groupServices {
      amount
      individualId
      isShareGroupPaused
      memberName
      packageName
      serviceId
    }
    hasSupplementaryRedemption
    individualId
    isDaily
    isDailyRedeemed
    isGroup
    isReActivateable
    isShareGroupPaused
    memberName
    membershipUuid
    memberUuid
    packageName
    packageType
    parentServiceId
    pausedAt
    pauseHistory {
      action
      authorizedAdjusterName
      comment
      dateChanged
      newExpiryDate
      prevExpiryDate
    }
    serviceId
    status
    subServices {
      amount
      dateAdded
      individualId
      memberName
      memberUuid
      parentServiceId
      serviceId
      status
    }
    supplementaryAmount
    supplementaryUnitName
    transactions {
      amount
      coach
      comment
      date
      facilityType
      id
      memberName
      packageName
      packageType
      serviceId
      serviceType
      transactionType
      venue
    }
    type
    unitType
  }
}
    `;

/**
 * __useAdminMemberProductPackageQuery__
 *
 * To run a query within a React component, call `useAdminMemberProductPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberProductPackageQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberProductPackageQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberProductPackageQuery, AdminMemberProductPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberProductPackageQuery, AdminMemberProductPackageQueryVariables>(AdminMemberProductPackageDocument, options);
      }
export function useAdminMemberProductPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberProductPackageQuery, AdminMemberProductPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberProductPackageQuery, AdminMemberProductPackageQueryVariables>(AdminMemberProductPackageDocument, options);
        }
export type AdminMemberProductPackageQueryHookResult = ReturnType<typeof useAdminMemberProductPackageQuery>;
export type AdminMemberProductPackageLazyQueryHookResult = ReturnType<typeof useAdminMemberProductPackageLazyQuery>;
export type AdminMemberProductPackageQueryResult = Apollo.QueryResult<AdminMemberProductPackageQuery, AdminMemberProductPackageQueryVariables>;
export const AdminMemberProductPackageExtensionsDocument = gql`
    query AdminMemberProductPackageExtensions($args: AdminMemberProductPackageExtensionsArgs!) {
  adminMemberProductPackageExtensions(args: $args) {
    extensions {
      authorizedAdjusterName
      comment
      dateExtended
      daysAdded
      newExpiryDate
      prevExpiryDate
    }
  }
}
    `;

/**
 * __useAdminMemberProductPackageExtensionsQuery__
 *
 * To run a query within a React component, call `useAdminMemberProductPackageExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductPackageExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberProductPackageExtensionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberProductPackageExtensionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberProductPackageExtensionsQuery, AdminMemberProductPackageExtensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberProductPackageExtensionsQuery, AdminMemberProductPackageExtensionsQueryVariables>(AdminMemberProductPackageExtensionsDocument, options);
      }
export function useAdminMemberProductPackageExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberProductPackageExtensionsQuery, AdminMemberProductPackageExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberProductPackageExtensionsQuery, AdminMemberProductPackageExtensionsQueryVariables>(AdminMemberProductPackageExtensionsDocument, options);
        }
export type AdminMemberProductPackageExtensionsQueryHookResult = ReturnType<typeof useAdminMemberProductPackageExtensionsQuery>;
export type AdminMemberProductPackageExtensionsLazyQueryHookResult = ReturnType<typeof useAdminMemberProductPackageExtensionsLazyQuery>;
export type AdminMemberProductPackageExtensionsQueryResult = Apollo.QueryResult<AdminMemberProductPackageExtensionsQuery, AdminMemberProductPackageExtensionsQueryVariables>;
export const AdminMemberProductGroupPackagesDocument = gql`
    query AdminMemberProductGroupPackages($args: AdminMemberProductGroupPackagesArgs!) {
  adminMemberProductGroupPackages(args: $args) {
    packages {
      amount
      individualId
      isShareGroupPaused
      memberName
      packageName
      serviceId
    }
  }
}
    `;

/**
 * __useAdminMemberProductGroupPackagesQuery__
 *
 * To run a query within a React component, call `useAdminMemberProductGroupPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProductGroupPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberProductGroupPackagesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberProductGroupPackagesQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberProductGroupPackagesQuery, AdminMemberProductGroupPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberProductGroupPackagesQuery, AdminMemberProductGroupPackagesQueryVariables>(AdminMemberProductGroupPackagesDocument, options);
      }
export function useAdminMemberProductGroupPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberProductGroupPackagesQuery, AdminMemberProductGroupPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberProductGroupPackagesQuery, AdminMemberProductGroupPackagesQueryVariables>(AdminMemberProductGroupPackagesDocument, options);
        }
export type AdminMemberProductGroupPackagesQueryHookResult = ReturnType<typeof useAdminMemberProductGroupPackagesQuery>;
export type AdminMemberProductGroupPackagesLazyQueryHookResult = ReturnType<typeof useAdminMemberProductGroupPackagesLazyQuery>;
export type AdminMemberProductGroupPackagesQueryResult = Apollo.QueryResult<AdminMemberProductGroupPackagesQuery, AdminMemberProductGroupPackagesQueryVariables>;
export const AdminMemberLessonNoteMembersDocument = gql`
    query AdminMemberLessonNoteMembers($args: AdminMemberLessonNoteMembersArgs!) {
  adminMemberLessonNoteMembers(args: $args) {
    edges {
      cursor
      node {
        id
        memberIndividualId
        memberName
        noOfLessonNotes
      }
    }
    pageInfo {
      endCursor
      firstRecordDateTime
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMemberLessonNoteMembersQuery__
 *
 * To run a query within a React component, call `useAdminMemberLessonNoteMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberLessonNoteMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberLessonNoteMembersQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberLessonNoteMembersQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberLessonNoteMembersQuery, AdminMemberLessonNoteMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberLessonNoteMembersQuery, AdminMemberLessonNoteMembersQueryVariables>(AdminMemberLessonNoteMembersDocument, options);
      }
export function useAdminMemberLessonNoteMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberLessonNoteMembersQuery, AdminMemberLessonNoteMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberLessonNoteMembersQuery, AdminMemberLessonNoteMembersQueryVariables>(AdminMemberLessonNoteMembersDocument, options);
        }
export type AdminMemberLessonNoteMembersQueryHookResult = ReturnType<typeof useAdminMemberLessonNoteMembersQuery>;
export type AdminMemberLessonNoteMembersLazyQueryHookResult = ReturnType<typeof useAdminMemberLessonNoteMembersLazyQuery>;
export type AdminMemberLessonNoteMembersQueryResult = Apollo.QueryResult<AdminMemberLessonNoteMembersQuery, AdminMemberLessonNoteMembersQueryVariables>;
export const CoachMemberLessonNotesDocument = gql`
    query CoachMemberLessonNotes($args: CoachMemberLessonNotesArgs!) {
  coachMemberLessonNotes(args: $args) {
    edges {
      cursor
      node {
        attachments
        bookingId
        dateStr
        id
        lessonType
        venue
      }
    }
    memberIndividualId
    memberName
    memberUuid
    pageInfo {
      endCursor
      firstRecordDateTime
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useCoachMemberLessonNotesQuery__
 *
 * To run a query within a React component, call `useCoachMemberLessonNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachMemberLessonNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachMemberLessonNotesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCoachMemberLessonNotesQuery(baseOptions: Apollo.QueryHookOptions<CoachMemberLessonNotesQuery, CoachMemberLessonNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachMemberLessonNotesQuery, CoachMemberLessonNotesQueryVariables>(CoachMemberLessonNotesDocument, options);
      }
export function useCoachMemberLessonNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachMemberLessonNotesQuery, CoachMemberLessonNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachMemberLessonNotesQuery, CoachMemberLessonNotesQueryVariables>(CoachMemberLessonNotesDocument, options);
        }
export type CoachMemberLessonNotesQueryHookResult = ReturnType<typeof useCoachMemberLessonNotesQuery>;
export type CoachMemberLessonNotesLazyQueryHookResult = ReturnType<typeof useCoachMemberLessonNotesLazyQuery>;
export type CoachMemberLessonNotesQueryResult = Apollo.QueryResult<CoachMemberLessonNotesQuery, CoachMemberLessonNotesQueryVariables>;
export const CoachMemberLessonNoteDocument = gql`
    query CoachMemberLessonNote($args: CoachMemberLessonNoteArgs!) {
  coachMemberLessonNote(args: $args) {
    attachments
    bookingId
    comment
    dateStr
    id
    lessonType
    memberIndividualId
    memberName
    memberUuid
    venue
    venueOther
  }
}
    `;

/**
 * __useCoachMemberLessonNoteQuery__
 *
 * To run a query within a React component, call `useCoachMemberLessonNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachMemberLessonNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachMemberLessonNoteQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCoachMemberLessonNoteQuery(baseOptions: Apollo.QueryHookOptions<CoachMemberLessonNoteQuery, CoachMemberLessonNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachMemberLessonNoteQuery, CoachMemberLessonNoteQueryVariables>(CoachMemberLessonNoteDocument, options);
      }
export function useCoachMemberLessonNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachMemberLessonNoteQuery, CoachMemberLessonNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachMemberLessonNoteQuery, CoachMemberLessonNoteQueryVariables>(CoachMemberLessonNoteDocument, options);
        }
export type CoachMemberLessonNoteQueryHookResult = ReturnType<typeof useCoachMemberLessonNoteQuery>;
export type CoachMemberLessonNoteLazyQueryHookResult = ReturnType<typeof useCoachMemberLessonNoteLazyQuery>;
export type CoachMemberLessonNoteQueryResult = Apollo.QueryResult<CoachMemberLessonNoteQuery, CoachMemberLessonNoteQueryVariables>;
export const AdminUpdateMembershipTypeDocument = gql`
    mutation AdminUpdateMembershipType($input: AdminUpdateMembershipTypeInput!) {
  adminUpdateMembershipType(input: $input) {
    baseCountryCode
    compDailySimulatorUse
    compDailySimulatorUseType
    compFieldLessons
    compIndoorLessons
    compLocker
    designatedPrivateRoom
    discount
    id
    imageUrl
    initialCredits
    internalName
    isCorporate
    isEnabled
    lineItemCode
    loungeAccess
    mainTypeSlug
    monthlySub
    price
    publicName
    signupProductSidasInsoles
    subscriptionlineItemCode
    supplementaryTypeSlug
    tagBgColorCode
    tagText
    tagTextColorCode
    tier
    versionSlug
  }
}
    `;
export type AdminUpdateMembershipTypeMutationFn = Apollo.MutationFunction<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>;

/**
 * __useAdminUpdateMembershipTypeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMembershipTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMembershipTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMembershipTypeMutation, { data, loading, error }] = useAdminUpdateMembershipTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateMembershipTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>(AdminUpdateMembershipTypeDocument, options);
      }
export type AdminUpdateMembershipTypeMutationHookResult = ReturnType<typeof useAdminUpdateMembershipTypeMutation>;
export type AdminUpdateMembershipTypeMutationResult = Apollo.MutationResult<AdminUpdateMembershipTypeMutation>;
export type AdminUpdateMembershipTypeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>;
export const AdminMembershipTypesDocument = gql`
    query AdminMembershipTypes($args: AdminMembershipTypesArgs!) {
  adminMembershipTypes(args: $args) {
    lifestyle {
      baseCountryCode
      id
      internalName
      price
      tier
      versionSlug
    }
    numberOfTypes
    premium {
      baseCountryCode
      id
      internalName
      price
      tier
      versionSlug
    }
    vip {
      baseCountryCode
      id
      internalName
      price
      tier
      versionSlug
    }
  }
}
    `;

/**
 * __useAdminMembershipTypesQuery__
 *
 * To run a query within a React component, call `useAdminMembershipTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipTypesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipTypesQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>(AdminMembershipTypesDocument, options);
      }
export function useAdminMembershipTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>(AdminMembershipTypesDocument, options);
        }
export type AdminMembershipTypesQueryHookResult = ReturnType<typeof useAdminMembershipTypesQuery>;
export type AdminMembershipTypesLazyQueryHookResult = ReturnType<typeof useAdminMembershipTypesLazyQuery>;
export type AdminMembershipTypesQueryResult = Apollo.QueryResult<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>;
export const AdminMembershipTypeDocument = gql`
    query AdminMembershipType($args: AdminMembershipTypeArgs!) {
  adminMembershipType(args: $args) {
    baseCountryCode
    compDailySimulatorUse
    compDailySimulatorUseType
    compFieldLessons
    compIndoorLessons
    compLocker
    designatedPrivateRoom
    discount
    id
    imageUrl
    initialCredits
    internalName
    isCorporate
    isEnabled
    lineItemCode
    loungeAccess
    mainTypeSlug
    monthlySub
    price
    publicName
    signupProductSidasInsoles
    subscriptionlineItemCode
    supplementaryTypeSlug
    tagBgColorCode
    tagText
    tagTextColorCode
    tier
    versionSlug
  }
}
    `;

/**
 * __useAdminMembershipTypeQuery__
 *
 * To run a query within a React component, call `useAdminMembershipTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipTypeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipTypeQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>(AdminMembershipTypeDocument, options);
      }
export function useAdminMembershipTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>(AdminMembershipTypeDocument, options);
        }
export type AdminMembershipTypeQueryHookResult = ReturnType<typeof useAdminMembershipTypeQuery>;
export type AdminMembershipTypeLazyQueryHookResult = ReturnType<typeof useAdminMembershipTypeLazyQuery>;
export type AdminMembershipTypeQueryResult = Apollo.QueryResult<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>;
export const AdminActivateMembershipDocument = gql`
    mutation AdminActivateMembership($input: AdminActivateMembershipInput) {
  adminActivateMembership(input: $input)
}
    `;
export type AdminActivateMembershipMutationFn = Apollo.MutationFunction<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>;

/**
 * __useAdminActivateMembershipMutation__
 *
 * To run a mutation, you first call `useAdminActivateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminActivateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminActivateMembershipMutation, { data, loading, error }] = useAdminActivateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminActivateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>(AdminActivateMembershipDocument, options);
      }
export type AdminActivateMembershipMutationHookResult = ReturnType<typeof useAdminActivateMembershipMutation>;
export type AdminActivateMembershipMutationResult = Apollo.MutationResult<AdminActivateMembershipMutation>;
export type AdminActivateMembershipMutationOptions = Apollo.BaseMutationOptions<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>;
export const AdminCreateMembershipDocument = gql`
    mutation AdminCreateMembership($input: AdminCreateMembershipInput!) {
  adminCreateMembership(input: $input) {
    fileUploadCredentials {
      mainMembers {
        assetUrl
        clientImageFieldName
        fields
        index
        signedUrl
      }
      subMembers {
        assetUrl
        clientImageFieldName
        fields
        index
        signedUrl
      }
    }
    memberUuid
    payment {
      checkoutUrl
      requestId
    }
  }
}
    `;
export type AdminCreateMembershipMutationFn = Apollo.MutationFunction<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>;

/**
 * __useAdminCreateMembershipMutation__
 *
 * To run a mutation, you first call `useAdminCreateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMembershipMutation, { data, loading, error }] = useAdminCreateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>(AdminCreateMembershipDocument, options);
      }
export type AdminCreateMembershipMutationHookResult = ReturnType<typeof useAdminCreateMembershipMutation>;
export type AdminCreateMembershipMutationResult = Apollo.MutationResult<AdminCreateMembershipMutation>;
export type AdminCreateMembershipMutationOptions = Apollo.BaseMutationOptions<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>;
export const AdminUpdateReservedIdDocument = gql`
    mutation AdminUpdateReservedId($input: AdminUpdateReservedIdInput) {
  adminUpdateReservedId(input: $input) {
    onHoldExpiresAt
  }
}
    `;
export type AdminUpdateReservedIdMutationFn = Apollo.MutationFunction<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>;

/**
 * __useAdminUpdateReservedIdMutation__
 *
 * To run a mutation, you first call `useAdminUpdateReservedIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateReservedIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateReservedIdMutation, { data, loading, error }] = useAdminUpdateReservedIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateReservedIdMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>(AdminUpdateReservedIdDocument, options);
      }
export type AdminUpdateReservedIdMutationHookResult = ReturnType<typeof useAdminUpdateReservedIdMutation>;
export type AdminUpdateReservedIdMutationResult = Apollo.MutationResult<AdminUpdateReservedIdMutation>;
export type AdminUpdateReservedIdMutationOptions = Apollo.BaseMutationOptions<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>;
export const AdminMembershipSubscriptionPauseDocument = gql`
    mutation AdminMembershipSubscriptionPause($input: AdminMembershipSubscriptionPauseInput!) {
  adminMembershipSubscriptionPause(input: $input)
}
    `;
export type AdminMembershipSubscriptionPauseMutationFn = Apollo.MutationFunction<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>;

/**
 * __useAdminMembershipSubscriptionPauseMutation__
 *
 * To run a mutation, you first call `useAdminMembershipSubscriptionPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMembershipSubscriptionPauseMutation, { data, loading, error }] = useAdminMembershipSubscriptionPauseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionPauseMutation(baseOptions?: Apollo.MutationHookOptions<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>(AdminMembershipSubscriptionPauseDocument, options);
      }
export type AdminMembershipSubscriptionPauseMutationHookResult = ReturnType<typeof useAdminMembershipSubscriptionPauseMutation>;
export type AdminMembershipSubscriptionPauseMutationResult = Apollo.MutationResult<AdminMembershipSubscriptionPauseMutation>;
export type AdminMembershipSubscriptionPauseMutationOptions = Apollo.BaseMutationOptions<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>;
export const AdminMembershipSubscriptionStartDocument = gql`
    mutation AdminMembershipSubscriptionStart($input: AdminMembershipSubscriptionStartInput!) {
  adminMembershipSubscriptionStart(input: $input)
}
    `;
export type AdminMembershipSubscriptionStartMutationFn = Apollo.MutationFunction<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>;

/**
 * __useAdminMembershipSubscriptionStartMutation__
 *
 * To run a mutation, you first call `useAdminMembershipSubscriptionStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMembershipSubscriptionStartMutation, { data, loading, error }] = useAdminMembershipSubscriptionStartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionStartMutation(baseOptions?: Apollo.MutationHookOptions<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>(AdminMembershipSubscriptionStartDocument, options);
      }
export type AdminMembershipSubscriptionStartMutationHookResult = ReturnType<typeof useAdminMembershipSubscriptionStartMutation>;
export type AdminMembershipSubscriptionStartMutationResult = Apollo.MutationResult<AdminMembershipSubscriptionStartMutation>;
export type AdminMembershipSubscriptionStartMutationOptions = Apollo.BaseMutationOptions<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>;
export const AdminMembershipSubscriptionActionDatesDocument = gql`
    mutation AdminMembershipSubscriptionActionDates($input: AdminMembershipSubscriptionActionDatesInput!) {
  adminMembershipSubscriptionActionDates(input: $input)
}
    `;
export type AdminMembershipSubscriptionActionDatesMutationFn = Apollo.MutationFunction<AdminMembershipSubscriptionActionDatesMutation, AdminMembershipSubscriptionActionDatesMutationVariables>;

/**
 * __useAdminMembershipSubscriptionActionDatesMutation__
 *
 * To run a mutation, you first call `useAdminMembershipSubscriptionActionDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionActionDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMembershipSubscriptionActionDatesMutation, { data, loading, error }] = useAdminMembershipSubscriptionActionDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionActionDatesMutation(baseOptions?: Apollo.MutationHookOptions<AdminMembershipSubscriptionActionDatesMutation, AdminMembershipSubscriptionActionDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMembershipSubscriptionActionDatesMutation, AdminMembershipSubscriptionActionDatesMutationVariables>(AdminMembershipSubscriptionActionDatesDocument, options);
      }
export type AdminMembershipSubscriptionActionDatesMutationHookResult = ReturnType<typeof useAdminMembershipSubscriptionActionDatesMutation>;
export type AdminMembershipSubscriptionActionDatesMutationResult = Apollo.MutationResult<AdminMembershipSubscriptionActionDatesMutation>;
export type AdminMembershipSubscriptionActionDatesMutationOptions = Apollo.BaseMutationOptions<AdminMembershipSubscriptionActionDatesMutation, AdminMembershipSubscriptionActionDatesMutationVariables>;
export const FormHelperNewMembershipDocument = gql`
    query FormHelperNewMembership($args: FormHelperNewMembershipArgs!) {
  formHelperNewMembership(args: $args) {
    membershipTypes {
      amtAwardMain
      amtAwardSub
      amtPurchaseMain
      amtPurchaseSub
      baseCountryCode
      hasReservedIds
      id
      internalName
      isCorporate
      lessonIndoorCredit
      lessonOutdoorCredit
      parentTypeId
      price
      supplementaryTypePrice
      supplementaryTypeSlug
      versionSlug
    }
  }
}
    `;

/**
 * __useFormHelperNewMembershipQuery__
 *
 * To run a query within a React component, call `useFormHelperNewMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewMembershipQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewMembershipQuery(baseOptions: Apollo.QueryHookOptions<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>(FormHelperNewMembershipDocument, options);
      }
export function useFormHelperNewMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>(FormHelperNewMembershipDocument, options);
        }
export type FormHelperNewMembershipQueryHookResult = ReturnType<typeof useFormHelperNewMembershipQuery>;
export type FormHelperNewMembershipLazyQueryHookResult = ReturnType<typeof useFormHelperNewMembershipLazyQuery>;
export type FormHelperNewMembershipQueryResult = Apollo.QueryResult<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>;
export const AdminReservedIdsDocument = gql`
    query AdminReservedIds($args: AdminReservedIdsArgs) {
  adminReservedIds(args: $args) {
    idOnHold
    idOnHoldExpiresAt
    reservedIds {
      id
      membershipId
      onHoldExpiresAt
      onHoldFor
      status
      updatedAt
    }
  }
}
    `;

/**
 * __useAdminReservedIdsQuery__
 *
 * To run a query within a React component, call `useAdminReservedIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReservedIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReservedIdsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReservedIdsQuery(baseOptions?: Apollo.QueryHookOptions<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>(AdminReservedIdsDocument, options);
      }
export function useAdminReservedIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>(AdminReservedIdsDocument, options);
        }
export type AdminReservedIdsQueryHookResult = ReturnType<typeof useAdminReservedIdsQuery>;
export type AdminReservedIdsLazyQueryHookResult = ReturnType<typeof useAdminReservedIdsLazyQuery>;
export type AdminReservedIdsQueryResult = Apollo.QueryResult<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>;
export const SelfUpdateDocument = gql`
    mutation SelfUpdate($input: SelfUpdateInput!) {
  selfUpdate(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    self {
      createdAt
      email
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastName
      logins {
        city
        ipAddress
        time
      }
      mobileNumber
      organizationId
      organizationName
      profileImageUrl
      status
      updatedAt
      userId
      userType
    }
  }
}
    `;
export type SelfUpdateMutationFn = Apollo.MutationFunction<SelfUpdateMutation, SelfUpdateMutationVariables>;

/**
 * __useSelfUpdateMutation__
 *
 * To run a mutation, you first call `useSelfUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfUpdateMutation, { data, loading, error }] = useSelfUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SelfUpdateMutation, SelfUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfUpdateMutation, SelfUpdateMutationVariables>(SelfUpdateDocument, options);
      }
export type SelfUpdateMutationHookResult = ReturnType<typeof useSelfUpdateMutation>;
export type SelfUpdateMutationResult = Apollo.MutationResult<SelfUpdateMutation>;
export type SelfUpdateMutationOptions = Apollo.BaseMutationOptions<SelfUpdateMutation, SelfUpdateMutationVariables>;
export const SelfUpdatePasswordDocument = gql`
    mutation SelfUpdatePassword($input: SelfUpdatePasswordInput!) {
  selfUpdatePassword(input: $input)
}
    `;
export type SelfUpdatePasswordMutationFn = Apollo.MutationFunction<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>;

/**
 * __useSelfUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useSelfUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfUpdatePasswordMutation, { data, loading, error }] = useSelfUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>(SelfUpdatePasswordDocument, options);
      }
export type SelfUpdatePasswordMutationHookResult = ReturnType<typeof useSelfUpdatePasswordMutation>;
export type SelfUpdatePasswordMutationResult = Apollo.MutationResult<SelfUpdatePasswordMutation>;
export type SelfUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>;
export const SelfDocument = gql`
    query Self {
  self {
    baseCountryCode
    createdAt
    email
    firstName
    lastLogin {
      city
      ipAddress
      time
    }
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organizationId
    organizationName
    profileImageUrl
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useSelfQuery__
 *
 * To run a query within a React component, call `useSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfQuery(baseOptions?: Apollo.QueryHookOptions<SelfQuery, SelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
      }
export function useSelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfQuery, SelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
        }
export type SelfQueryHookResult = ReturnType<typeof useSelfQuery>;
export type SelfLazyQueryHookResult = ReturnType<typeof useSelfLazyQuery>;
export type SelfQueryResult = Apollo.QueryResult<SelfQuery, SelfQueryVariables>;
export const SelfBasicDocument = gql`
    query SelfBasic {
  self {
    baseCountryCode
    baseGmtOffset
    clubhouses {
      clubhouseCode
      name
    }
    countries {
      countryCode
      name
    }
    lastLogin {
      city
      ipAddress
      time
    }
  }
}
    `;

/**
 * __useSelfBasicQuery__
 *
 * To run a query within a React component, call `useSelfBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfBasicQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfBasicQuery(baseOptions?: Apollo.QueryHookOptions<SelfBasicQuery, SelfBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfBasicQuery, SelfBasicQueryVariables>(SelfBasicDocument, options);
      }
export function useSelfBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfBasicQuery, SelfBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfBasicQuery, SelfBasicQueryVariables>(SelfBasicDocument, options);
        }
export type SelfBasicQueryHookResult = ReturnType<typeof useSelfBasicQuery>;
export type SelfBasicLazyQueryHookResult = ReturnType<typeof useSelfBasicLazyQuery>;
export type SelfBasicQueryResult = Apollo.QueryResult<SelfBasicQuery, SelfBasicQueryVariables>;
export const AdminNotificationCreateDocument = gql`
    mutation AdminNotificationCreate($input: AdminNotificationCreateInput!) {
  adminNotificationCreate(input: $input)
}
    `;
export type AdminNotificationCreateMutationFn = Apollo.MutationFunction<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>;

/**
 * __useAdminNotificationCreateMutation__
 *
 * To run a mutation, you first call `useAdminNotificationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNotificationCreateMutation, { data, loading, error }] = useAdminNotificationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminNotificationCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>(AdminNotificationCreateDocument, options);
      }
export type AdminNotificationCreateMutationHookResult = ReturnType<typeof useAdminNotificationCreateMutation>;
export type AdminNotificationCreateMutationResult = Apollo.MutationResult<AdminNotificationCreateMutation>;
export type AdminNotificationCreateMutationOptions = Apollo.BaseMutationOptions<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>;
export const AdminNotificationDeleteDocument = gql`
    mutation AdminNotificationDelete($input: AdminNotificationDeleteInput!) {
  adminNotificationDelete(input: $input)
}
    `;
export type AdminNotificationDeleteMutationFn = Apollo.MutationFunction<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>;

/**
 * __useAdminNotificationDeleteMutation__
 *
 * To run a mutation, you first call `useAdminNotificationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNotificationDeleteMutation, { data, loading, error }] = useAdminNotificationDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminNotificationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>(AdminNotificationDeleteDocument, options);
      }
export type AdminNotificationDeleteMutationHookResult = ReturnType<typeof useAdminNotificationDeleteMutation>;
export type AdminNotificationDeleteMutationResult = Apollo.MutationResult<AdminNotificationDeleteMutation>;
export type AdminNotificationDeleteMutationOptions = Apollo.BaseMutationOptions<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>;
export const AdminNotificationMemberDeleteDocument = gql`
    mutation AdminNotificationMemberDelete($input: AdminNotificationMemberDeleteInput!) {
  adminNotificationMemberDelete(input: $input)
}
    `;
export type AdminNotificationMemberDeleteMutationFn = Apollo.MutationFunction<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>;

/**
 * __useAdminNotificationMemberDeleteMutation__
 *
 * To run a mutation, you first call `useAdminNotificationMemberDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationMemberDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNotificationMemberDeleteMutation, { data, loading, error }] = useAdminNotificationMemberDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminNotificationMemberDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>(AdminNotificationMemberDeleteDocument, options);
      }
export type AdminNotificationMemberDeleteMutationHookResult = ReturnType<typeof useAdminNotificationMemberDeleteMutation>;
export type AdminNotificationMemberDeleteMutationResult = Apollo.MutationResult<AdminNotificationMemberDeleteMutation>;
export type AdminNotificationMemberDeleteMutationOptions = Apollo.BaseMutationOptions<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>;
export const AdminMemberNotificationsDocument = gql`
    query AdminMemberNotifications($args: AdminMemberNotificationsArgs!) {
  adminMemberNotifications(args: $args) {
    edges {
      cursor
      node {
        createdAt
        createdBy
        createdByAdminId
        createdByAdminName
        expiry
        expiryDate
        id
        message
        mode
        title
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMemberNotificationsQuery__
 *
 * To run a query within a React component, call `useAdminMemberNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberNotificationsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberNotificationsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>(AdminMemberNotificationsDocument, options);
      }
export function useAdminMemberNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>(AdminMemberNotificationsDocument, options);
        }
export type AdminMemberNotificationsQueryHookResult = ReturnType<typeof useAdminMemberNotificationsQuery>;
export type AdminMemberNotificationsLazyQueryHookResult = ReturnType<typeof useAdminMemberNotificationsLazyQuery>;
export type AdminMemberNotificationsQueryResult = Apollo.QueryResult<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>;
export const AdminNotificationDocument = gql`
    query AdminNotification($args: AdminNotificationArgs!) {
  adminNotification(args: $args) {
    createdAt
    createdBy
    createdByAdminId
    createdByAdminName
    expiry
    expiryDate
    id
    message
    mode
    title
    updatedAt
  }
}
    `;

/**
 * __useAdminNotificationQuery__
 *
 * To run a query within a React component, call `useAdminNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNotificationQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminNotificationQuery(baseOptions: Apollo.QueryHookOptions<AdminNotificationQuery, AdminNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNotificationQuery, AdminNotificationQueryVariables>(AdminNotificationDocument, options);
      }
export function useAdminNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNotificationQuery, AdminNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNotificationQuery, AdminNotificationQueryVariables>(AdminNotificationDocument, options);
        }
export type AdminNotificationQueryHookResult = ReturnType<typeof useAdminNotificationQuery>;
export type AdminNotificationLazyQueryHookResult = ReturnType<typeof useAdminNotificationLazyQuery>;
export type AdminNotificationQueryResult = Apollo.QueryResult<AdminNotificationQuery, AdminNotificationQueryVariables>;
export const AdminNotificationsDocument = gql`
    query AdminNotifications($args: AdminNotificationsArgs!) {
  adminNotifications(args: $args) {
    edges {
      cursor
      node {
        createdAt
        createdBy
        createdByAdminId
        createdByAdminName
        expiry
        expiryDate
        id
        message
        title
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminNotificationsQuery__
 *
 * To run a query within a React component, call `useAdminNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNotificationsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminNotificationsQuery(baseOptions: Apollo.QueryHookOptions<AdminNotificationsQuery, AdminNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNotificationsQuery, AdminNotificationsQueryVariables>(AdminNotificationsDocument, options);
      }
export function useAdminNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNotificationsQuery, AdminNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNotificationsQuery, AdminNotificationsQueryVariables>(AdminNotificationsDocument, options);
        }
export type AdminNotificationsQueryHookResult = ReturnType<typeof useAdminNotificationsQuery>;
export type AdminNotificationsLazyQueryHookResult = ReturnType<typeof useAdminNotificationsLazyQuery>;
export type AdminNotificationsQueryResult = Apollo.QueryResult<AdminNotificationsQuery, AdminNotificationsQueryVariables>;
export const AdminUpdateOrganizationDocument = gql`
    mutation AdminUpdateOrganization($input: AdminUpdateOrganizationInput!) {
  adminUpdateOrganization(input: $input) {
    addressCity
    addressCountry
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    businessName
    createdAt
    email
    id
    organizationNumber
    phoneNumber
    updatedAt
  }
}
    `;
export type AdminUpdateOrganizationMutationFn = Apollo.MutationFunction<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;

/**
 * __useAdminUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrganizationMutation, { data, loading, error }] = useAdminUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>(AdminUpdateOrganizationDocument, options);
      }
export type AdminUpdateOrganizationMutationHookResult = ReturnType<typeof useAdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationResult = Apollo.MutationResult<AdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;
export const OrganizationDocument = gql`
    query Organization {
  organization {
    addressCity
    addressCountry
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    businessName
    createdAt
    email
    id
    organizationNumber
    phoneNumber
    updatedAt
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const AdminProductPackageAddDocument = gql`
    mutation AdminProductPackageAdd($input: AdminProductPackageAddInput!) {
  adminProductPackageAdd(input: $input)
}
    `;
export type AdminProductPackageAddMutationFn = Apollo.MutationFunction<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>;

/**
 * __useAdminProductPackageAddMutation__
 *
 * To run a mutation, you first call `useAdminProductPackageAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductPackageAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductPackageAddMutation, { data, loading, error }] = useAdminProductPackageAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminProductPackageAddMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>(AdminProductPackageAddDocument, options);
      }
export type AdminProductPackageAddMutationHookResult = ReturnType<typeof useAdminProductPackageAddMutation>;
export type AdminProductPackageAddMutationResult = Apollo.MutationResult<AdminProductPackageAddMutation>;
export type AdminProductPackageAddMutationOptions = Apollo.BaseMutationOptions<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>;
export const AdminProductsDocument = gql`
    query AdminProducts($args: AdminProductsArgs!) {
  adminProducts(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        itemCode
        name
        packageType
        packageType
        price
        priceAceCoins
        priceCurrency
        validity
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminProductsQuery__
 *
 * To run a query within a React component, call `useAdminProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminProductsQuery(baseOptions: Apollo.QueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
      }
export function useAdminProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
        }
export type AdminProductsQueryHookResult = ReturnType<typeof useAdminProductsQuery>;
export type AdminProductsLazyQueryHookResult = ReturnType<typeof useAdminProductsLazyQuery>;
export type AdminProductsQueryResult = Apollo.QueryResult<AdminProductsQuery, AdminProductsQueryVariables>;
export const AdminReportAcTransactionDeleteDocument = gql`
    mutation AdminReportAcTransactionDelete($input: AdminReportAcTransactionDeleteInput!) {
  adminReportAcTransactionDelete(input: $input)
}
    `;
export type AdminReportAcTransactionDeleteMutationFn = Apollo.MutationFunction<AdminReportAcTransactionDeleteMutation, AdminReportAcTransactionDeleteMutationVariables>;

/**
 * __useAdminReportAcTransactionDeleteMutation__
 *
 * To run a mutation, you first call `useAdminReportAcTransactionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReportAcTransactionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReportAcTransactionDeleteMutation, { data, loading, error }] = useAdminReportAcTransactionDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminReportAcTransactionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminReportAcTransactionDeleteMutation, AdminReportAcTransactionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminReportAcTransactionDeleteMutation, AdminReportAcTransactionDeleteMutationVariables>(AdminReportAcTransactionDeleteDocument, options);
      }
export type AdminReportAcTransactionDeleteMutationHookResult = ReturnType<typeof useAdminReportAcTransactionDeleteMutation>;
export type AdminReportAcTransactionDeleteMutationResult = Apollo.MutationResult<AdminReportAcTransactionDeleteMutation>;
export type AdminReportAcTransactionDeleteMutationOptions = Apollo.BaseMutationOptions<AdminReportAcTransactionDeleteMutation, AdminReportAcTransactionDeleteMutationVariables>;
export const AdminReportAcTransactionsDocument = gql`
    query AdminReportAcTransactions($args: AdminReportAcTransactionsArgs!) {
  adminReportAcTransactions(args: $args) {
    edges {
      cursor
      node {
        account
        accountId
        amount
        description
        direction
        id
        invoiceNo
        transactionDateTime
        transactionId
        type
        venue
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminReportAcTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminReportAcTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportAcTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportAcTransactionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportAcTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminReportAcTransactionsQuery, AdminReportAcTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportAcTransactionsQuery, AdminReportAcTransactionsQueryVariables>(AdminReportAcTransactionsDocument, options);
      }
export function useAdminReportAcTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportAcTransactionsQuery, AdminReportAcTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportAcTransactionsQuery, AdminReportAcTransactionsQueryVariables>(AdminReportAcTransactionsDocument, options);
        }
export type AdminReportAcTransactionsQueryHookResult = ReturnType<typeof useAdminReportAcTransactionsQuery>;
export type AdminReportAcTransactionsLazyQueryHookResult = ReturnType<typeof useAdminReportAcTransactionsLazyQuery>;
export type AdminReportAcTransactionsQueryResult = Apollo.QueryResult<AdminReportAcTransactionsQuery, AdminReportAcTransactionsQueryVariables>;
export const AdminReportInvoiceDocument = gql`
    query AdminReportInvoice($args: AdminReportInvoiceArgs!) {
  adminReportInvoice(args: $args) {
    additionalDiscount
    amount
    gst
    invoiceNo
    lineItems {
      name
      qty
      salesPrice
    }
    memberDiscount
    memberIndividualId
    memberName
    memberUuid
    paymentCurrency
    paymentMethod
    serviceFee
    strDate
    strTime
    subTotal
    transactionDateTime
    venue
  }
}
    `;

/**
 * __useAdminReportInvoiceQuery__
 *
 * To run a query within a React component, call `useAdminReportInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportInvoiceQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportInvoiceQuery(baseOptions: Apollo.QueryHookOptions<AdminReportInvoiceQuery, AdminReportInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportInvoiceQuery, AdminReportInvoiceQueryVariables>(AdminReportInvoiceDocument, options);
      }
export function useAdminReportInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportInvoiceQuery, AdminReportInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportInvoiceQuery, AdminReportInvoiceQueryVariables>(AdminReportInvoiceDocument, options);
        }
export type AdminReportInvoiceQueryHookResult = ReturnType<typeof useAdminReportInvoiceQuery>;
export type AdminReportInvoiceLazyQueryHookResult = ReturnType<typeof useAdminReportInvoiceLazyQuery>;
export type AdminReportInvoiceQueryResult = Apollo.QueryResult<AdminReportInvoiceQuery, AdminReportInvoiceQueryVariables>;
export const AdminReportInvoicesDocument = gql`
    query AdminReportInvoices($args: AdminReportInvoicesArgs!) {
  adminReportInvoices(args: $args) {
    edges {
      cursor
      node {
        account
        accountId
        amount
        invoiceNo
        paymentCurrency
        paymentMethod
        transactionDateTime
        venue
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminReportInvoicesQuery__
 *
 * To run a query within a React component, call `useAdminReportInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportInvoicesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportInvoicesQuery(baseOptions: Apollo.QueryHookOptions<AdminReportInvoicesQuery, AdminReportInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportInvoicesQuery, AdminReportInvoicesQueryVariables>(AdminReportInvoicesDocument, options);
      }
export function useAdminReportInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportInvoicesQuery, AdminReportInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportInvoicesQuery, AdminReportInvoicesQueryVariables>(AdminReportInvoicesDocument, options);
        }
export type AdminReportInvoicesQueryHookResult = ReturnType<typeof useAdminReportInvoicesQuery>;
export type AdminReportInvoicesLazyQueryHookResult = ReturnType<typeof useAdminReportInvoicesLazyQuery>;
export type AdminReportInvoicesQueryResult = Apollo.QueryResult<AdminReportInvoicesQuery, AdminReportInvoicesQueryVariables>;
export const AdminSimulatorUsageDocument = gql`
    query AdminSimulatorUsage($args: AdminSimulatorUsageArgs!) {
  adminSimulatorUsage(args: $args)
}
    `;

/**
 * __useAdminSimulatorUsageQuery__
 *
 * To run a query within a React component, call `useAdminSimulatorUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSimulatorUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSimulatorUsageQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminSimulatorUsageQuery(baseOptions: Apollo.QueryHookOptions<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>(AdminSimulatorUsageDocument, options);
      }
export function useAdminSimulatorUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>(AdminSimulatorUsageDocument, options);
        }
export type AdminSimulatorUsageQueryHookResult = ReturnType<typeof useAdminSimulatorUsageQuery>;
export type AdminSimulatorUsageLazyQueryHookResult = ReturnType<typeof useAdminSimulatorUsageLazyQuery>;
export type AdminSimulatorUsageQueryResult = Apollo.QueryResult<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>;
export const AdminReportHitPayChargesDocument = gql`
    query AdminReportHitPayCharges($args: AdminReportHitPayChargesArgs!) {
  adminReportHitPayCharges(args: $args) {
    edges {
      cursor
      node {
        amount
        buyer_email
        buyer_name
        buyer_phone
        created_at
        currency
        fees
        id
        payment_method
        payment_type
        quantity
        refunded_amount
        status
        updated_at
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminReportHitPayChargesQuery__
 *
 * To run a query within a React component, call `useAdminReportHitPayChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportHitPayChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportHitPayChargesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportHitPayChargesQuery(baseOptions: Apollo.QueryHookOptions<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>(AdminReportHitPayChargesDocument, options);
      }
export function useAdminReportHitPayChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>(AdminReportHitPayChargesDocument, options);
        }
export type AdminReportHitPayChargesQueryHookResult = ReturnType<typeof useAdminReportHitPayChargesQuery>;
export type AdminReportHitPayChargesLazyQueryHookResult = ReturnType<typeof useAdminReportHitPayChargesLazyQuery>;
export type AdminReportHitPayChargesQueryResult = Apollo.QueryResult<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>;
export const AdminReportHitPayChargeDocument = gql`
    query AdminReportHitPayCharge($args: AdminReportHitPayChargeArgs!) {
  adminReportHitPayCharge(args: $args) {
    additionalDiscount
    amount
    gst
    invoiceNo
    lineItems {
      name
      qty
      salesPrice
    }
    memberDiscount
    memberIndividualId
    memberName
    memberUuid
    paymentCurrency
    paymentMethod
    serviceFee
    strDate
    strTime
    subTotal
    transactionDateTime
    venue
  }
}
    `;

/**
 * __useAdminReportHitPayChargeQuery__
 *
 * To run a query within a React component, call `useAdminReportHitPayChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportHitPayChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportHitPayChargeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportHitPayChargeQuery(baseOptions: Apollo.QueryHookOptions<AdminReportHitPayChargeQuery, AdminReportHitPayChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportHitPayChargeQuery, AdminReportHitPayChargeQueryVariables>(AdminReportHitPayChargeDocument, options);
      }
export function useAdminReportHitPayChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportHitPayChargeQuery, AdminReportHitPayChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportHitPayChargeQuery, AdminReportHitPayChargeQueryVariables>(AdminReportHitPayChargeDocument, options);
        }
export type AdminReportHitPayChargeQueryHookResult = ReturnType<typeof useAdminReportHitPayChargeQuery>;
export type AdminReportHitPayChargeLazyQueryHookResult = ReturnType<typeof useAdminReportHitPayChargeLazyQuery>;
export type AdminReportHitPayChargeQueryResult = Apollo.QueryResult<AdminReportHitPayChargeQuery, AdminReportHitPayChargeQueryVariables>;
export const AdminClientLoginGuestDocument = gql`
    mutation AdminClientLoginGuest($input: AdminClientLoginGuestInput!) {
  adminClientLoginGuest(input: $input)
}
    `;
export type AdminClientLoginGuestMutationFn = Apollo.MutationFunction<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>;

/**
 * __useAdminClientLoginGuestMutation__
 *
 * To run a mutation, you first call `useAdminClientLoginGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminClientLoginGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminClientLoginGuestMutation, { data, loading, error }] = useAdminClientLoginGuestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminClientLoginGuestMutation(baseOptions?: Apollo.MutationHookOptions<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>(AdminClientLoginGuestDocument, options);
      }
export type AdminClientLoginGuestMutationHookResult = ReturnType<typeof useAdminClientLoginGuestMutation>;
export type AdminClientLoginGuestMutationResult = Apollo.MutationResult<AdminClientLoginGuestMutation>;
export type AdminClientLoginGuestMutationOptions = Apollo.BaseMutationOptions<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>;
export const AdminExtendClientTimeDocument = gql`
    mutation AdminExtendClientTime($input: AdminExtendClientTimeInput!) {
  adminExtendClientTime(input: $input)
}
    `;
export type AdminExtendClientTimeMutationFn = Apollo.MutationFunction<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>;

/**
 * __useAdminExtendClientTimeMutation__
 *
 * To run a mutation, you first call `useAdminExtendClientTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminExtendClientTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminExtendClientTimeMutation, { data, loading, error }] = useAdminExtendClientTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminExtendClientTimeMutation(baseOptions?: Apollo.MutationHookOptions<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>(AdminExtendClientTimeDocument, options);
      }
export type AdminExtendClientTimeMutationHookResult = ReturnType<typeof useAdminExtendClientTimeMutation>;
export type AdminExtendClientTimeMutationResult = Apollo.MutationResult<AdminExtendClientTimeMutation>;
export type AdminExtendClientTimeMutationOptions = Apollo.BaseMutationOptions<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>;
export const AdminLockClientDocument = gql`
    mutation AdminLockClient($input: AdminLockClientInput!) {
  adminLockClient(input: $input)
}
    `;
export type AdminLockClientMutationFn = Apollo.MutationFunction<AdminLockClientMutation, AdminLockClientMutationVariables>;

/**
 * __useAdminLockClientMutation__
 *
 * To run a mutation, you first call `useAdminLockClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLockClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLockClientMutation, { data, loading, error }] = useAdminLockClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminLockClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminLockClientMutation, AdminLockClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLockClientMutation, AdminLockClientMutationVariables>(AdminLockClientDocument, options);
      }
export type AdminLockClientMutationHookResult = ReturnType<typeof useAdminLockClientMutation>;
export type AdminLockClientMutationResult = Apollo.MutationResult<AdminLockClientMutation>;
export type AdminLockClientMutationOptions = Apollo.BaseMutationOptions<AdminLockClientMutation, AdminLockClientMutationVariables>;
export const AdminShopSendNotificationDocument = gql`
    mutation AdminShopSendNotification($input: AdminShopSendNotificationInput!) {
  adminShopSendNotification(input: $input)
}
    `;
export type AdminShopSendNotificationMutationFn = Apollo.MutationFunction<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>;

/**
 * __useAdminShopSendNotificationMutation__
 *
 * To run a mutation, you first call `useAdminShopSendNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShopSendNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShopSendNotificationMutation, { data, loading, error }] = useAdminShopSendNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminShopSendNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>(AdminShopSendNotificationDocument, options);
      }
export type AdminShopSendNotificationMutationHookResult = ReturnType<typeof useAdminShopSendNotificationMutation>;
export type AdminShopSendNotificationMutationResult = Apollo.MutationResult<AdminShopSendNotificationMutation>;
export type AdminShopSendNotificationMutationOptions = Apollo.BaseMutationOptions<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>;
export const AdminUnlockClientDocument = gql`
    mutation AdminUnlockClient($input: AdminUnlockClientInput!) {
  adminUnlockClient(input: $input)
}
    `;
export type AdminUnlockClientMutationFn = Apollo.MutationFunction<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>;

/**
 * __useAdminUnlockClientMutation__
 *
 * To run a mutation, you first call `useAdminUnlockClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnlockClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnlockClientMutation, { data, loading, error }] = useAdminUnlockClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUnlockClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>(AdminUnlockClientDocument, options);
      }
export type AdminUnlockClientMutationHookResult = ReturnType<typeof useAdminUnlockClientMutation>;
export type AdminUnlockClientMutationResult = Apollo.MutationResult<AdminUnlockClientMutation>;
export type AdminUnlockClientMutationOptions = Apollo.BaseMutationOptions<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>;
export const AdminUpdateClientContentLimitDocument = gql`
    mutation AdminUpdateClientContentLimit($input: AdminUpdateClientContentLimitInput!) {
  adminUpdateClientContentLimit(input: $input)
}
    `;
export type AdminUpdateClientContentLimitMutationFn = Apollo.MutationFunction<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>;

/**
 * __useAdminUpdateClientContentLimitMutation__
 *
 * To run a mutation, you first call `useAdminUpdateClientContentLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateClientContentLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateClientContentLimitMutation, { data, loading, error }] = useAdminUpdateClientContentLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateClientContentLimitMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>(AdminUpdateClientContentLimitDocument, options);
      }
export type AdminUpdateClientContentLimitMutationHookResult = ReturnType<typeof useAdminUpdateClientContentLimitMutation>;
export type AdminUpdateClientContentLimitMutationResult = Apollo.MutationResult<AdminUpdateClientContentLimitMutation>;
export type AdminUpdateClientContentLimitMutationOptions = Apollo.BaseMutationOptions<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>;
export const AdminUpdateShopDetailsDocument = gql`
    mutation AdminUpdateShopDetails($input: AdminUpdateShopDetailsInput!) {
  adminUpdateShopDetails(input: $input) {
    address1
    address2
    CDN
    clientType {
      lesson
      practice
      screen
    }
    country
    currency
    isEquipmentStorage
    isLeftHanded
    isParking
    isProLesson
    isShopCloseNextDay
    isSwingplate
    ownerEmail
    ownerMobilePhone
    ownerMobilePhoneCountry
    ownerName
    shopCloseTime
    shopGuid
    shopName
    shopOpenTime
    shopPhone
    zipcode
  }
}
    `;
export type AdminUpdateShopDetailsMutationFn = Apollo.MutationFunction<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>;

/**
 * __useAdminUpdateShopDetailsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopDetailsMutation, { data, loading, error }] = useAdminUpdateShopDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>(AdminUpdateShopDetailsDocument, options);
      }
export type AdminUpdateShopDetailsMutationHookResult = ReturnType<typeof useAdminUpdateShopDetailsMutation>;
export type AdminUpdateShopDetailsMutationResult = Apollo.MutationResult<AdminUpdateShopDetailsMutation>;
export type AdminUpdateShopDetailsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>;
export const AdminUpdateShopOptionsDrivingRangeDocument = gql`
    mutation AdminUpdateShopOptionsDrivingRange($input: AdminUpdateShopOptionsDrivingRangeInput!) {
  adminUpdateShopOptionsDrivingRange(input: $input) {
    courseId
    difficulty
    distanceUnit
    isBallTrajectory
    isFixedCamera
    isSwingVideo
    teeHeight
    useSwingPlate
    windSpeed
  }
}
    `;
export type AdminUpdateShopOptionsDrivingRangeMutationFn = Apollo.MutationFunction<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>;

/**
 * __useAdminUpdateShopOptionsDrivingRangeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopOptionsDrivingRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopOptionsDrivingRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopOptionsDrivingRangeMutation, { data, loading, error }] = useAdminUpdateShopOptionsDrivingRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopOptionsDrivingRangeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>(AdminUpdateShopOptionsDrivingRangeDocument, options);
      }
export type AdminUpdateShopOptionsDrivingRangeMutationHookResult = ReturnType<typeof useAdminUpdateShopOptionsDrivingRangeMutation>;
export type AdminUpdateShopOptionsDrivingRangeMutationResult = Apollo.MutationResult<AdminUpdateShopOptionsDrivingRangeMutation>;
export type AdminUpdateShopOptionsDrivingRangeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>;
export const AdminUpdateShopOptionsRealTimeDocument = gql`
    mutation AdminUpdateShopOptionsRealTime($input: AdminUpdateShopOptionsRealTimeInput!) {
  adminUpdateShopOptionsRealTime(input: $input) {
    drivingRangeTimeLimit
    gameHoleTypeLimit
    gameTypeLimit
    isContentLimit
    paymentType
    playerCountLimit
    usageTime
  }
}
    `;
export type AdminUpdateShopOptionsRealTimeMutationFn = Apollo.MutationFunction<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>;

/**
 * __useAdminUpdateShopOptionsRealTimeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopOptionsRealTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopOptionsRealTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopOptionsRealTimeMutation, { data, loading, error }] = useAdminUpdateShopOptionsRealTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopOptionsRealTimeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>(AdminUpdateShopOptionsRealTimeDocument, options);
      }
export type AdminUpdateShopOptionsRealTimeMutationHookResult = ReturnType<typeof useAdminUpdateShopOptionsRealTimeMutation>;
export type AdminUpdateShopOptionsRealTimeMutationResult = Apollo.MutationResult<AdminUpdateShopOptionsRealTimeMutation>;
export type AdminUpdateShopOptionsRealTimeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>;
export const AdminUpdateShopOptionsRoundDocument = gql`
    mutation AdminUpdateShopOptionsRound($input: AdminUpdateShopOptionsRoundInput!) {
  adminUpdateShopOptionsRound(input: $input) {
    concede
    distanceUnit
    greenLocation
    greenSpeed
    holeCupLocation
    isBestVideo
    isCaddyVoice
    isUseObHazardTee
    mulliganCount
    puttingLine
    useSwingPlate
    windSpeed
  }
}
    `;
export type AdminUpdateShopOptionsRoundMutationFn = Apollo.MutationFunction<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>;

/**
 * __useAdminUpdateShopOptionsRoundMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopOptionsRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopOptionsRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopOptionsRoundMutation, { data, loading, error }] = useAdminUpdateShopOptionsRoundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopOptionsRoundMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>(AdminUpdateShopOptionsRoundDocument, options);
      }
export type AdminUpdateShopOptionsRoundMutationHookResult = ReturnType<typeof useAdminUpdateShopOptionsRoundMutation>;
export type AdminUpdateShopOptionsRoundMutationResult = Apollo.MutationResult<AdminUpdateShopOptionsRoundMutation>;
export type AdminUpdateShopOptionsRoundMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>;
export const AdminShopGetNotificationDocument = gql`
    mutation AdminShopGetNotification($input: AdminShopGetNotificationInput!) {
  adminShopGetNotification(input: $input) {
    message
  }
}
    `;
export type AdminShopGetNotificationMutationFn = Apollo.MutationFunction<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>;

/**
 * __useAdminShopGetNotificationMutation__
 *
 * To run a mutation, you first call `useAdminShopGetNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShopGetNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShopGetNotificationMutation, { data, loading, error }] = useAdminShopGetNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminShopGetNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>(AdminShopGetNotificationDocument, options);
      }
export type AdminShopGetNotificationMutationHookResult = ReturnType<typeof useAdminShopGetNotificationMutation>;
export type AdminShopGetNotificationMutationResult = Apollo.MutationResult<AdminShopGetNotificationMutation>;
export type AdminShopGetNotificationMutationOptions = Apollo.BaseMutationOptions<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>;
export const AdminGameHistoryDocument = gql`
    query AdminGameHistory($args: AdminGameHistoryArgs!) {
  adminGameHistory(args: $args) {
    currentPage
    list {
      clientName
      completeHoleCount
      endTime
      gameRoundId
      gameType
      gameTypeCode
      playerCount
      startTime
    }
    maxPage
    totalCount
  }
}
    `;

/**
 * __useAdminGameHistoryQuery__
 *
 * To run a query within a React component, call `useAdminGameHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGameHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGameHistoryQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminGameHistoryQuery(baseOptions: Apollo.QueryHookOptions<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>(AdminGameHistoryDocument, options);
      }
export function useAdminGameHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>(AdminGameHistoryDocument, options);
        }
export type AdminGameHistoryQueryHookResult = ReturnType<typeof useAdminGameHistoryQuery>;
export type AdminGameHistoryLazyQueryHookResult = ReturnType<typeof useAdminGameHistoryLazyQuery>;
export type AdminGameHistoryQueryResult = Apollo.QueryResult<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>;
export const AdminClientStatusDocument = gql`
    query AdminClientStatus($args: AdminClientStatusArgs!) {
  adminClientStatus(args: $args) {
    clients
    shopGuid
  }
}
    `;

/**
 * __useAdminClientStatusQuery__
 *
 * To run a query within a React component, call `useAdminClientStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClientStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClientStatusQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClientStatusQuery(baseOptions: Apollo.QueryHookOptions<AdminClientStatusQuery, AdminClientStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClientStatusQuery, AdminClientStatusQueryVariables>(AdminClientStatusDocument, options);
      }
export function useAdminClientStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClientStatusQuery, AdminClientStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClientStatusQuery, AdminClientStatusQueryVariables>(AdminClientStatusDocument, options);
        }
export type AdminClientStatusQueryHookResult = ReturnType<typeof useAdminClientStatusQuery>;
export type AdminClientStatusLazyQueryHookResult = ReturnType<typeof useAdminClientStatusLazyQuery>;
export type AdminClientStatusQueryResult = Apollo.QueryResult<AdminClientStatusQuery, AdminClientStatusQueryVariables>;
export const AdminScoreCardDocument = gql`
    query AdminScoreCard($args: AdminScoreCardArgs!) {
  adminScoreCard(args: $args)
}
    `;

/**
 * __useAdminScoreCardQuery__
 *
 * To run a query within a React component, call `useAdminScoreCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminScoreCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminScoreCardQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminScoreCardQuery(baseOptions: Apollo.QueryHookOptions<AdminScoreCardQuery, AdminScoreCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminScoreCardQuery, AdminScoreCardQueryVariables>(AdminScoreCardDocument, options);
      }
export function useAdminScoreCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminScoreCardQuery, AdminScoreCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminScoreCardQuery, AdminScoreCardQueryVariables>(AdminScoreCardDocument, options);
        }
export type AdminScoreCardQueryHookResult = ReturnType<typeof useAdminScoreCardQuery>;
export type AdminScoreCardLazyQueryHookResult = ReturnType<typeof useAdminScoreCardLazyQuery>;
export type AdminScoreCardQueryResult = Apollo.QueryResult<AdminScoreCardQuery, AdminScoreCardQueryVariables>;
export const AdminShopDetailsDocument = gql`
    query AdminShopDetails($args: AdminShopDetailsArg!) {
  adminShopDetails(args: $args) {
    address1
    address2
    CDN
    clientType {
      lesson
      practice
      screen
    }
    country
    currency
    isEquipmentStorage
    isLeftHanded
    isParking
    isProLesson
    isShopCloseNextDay
    isSwingplate
    ownerEmail
    ownerMobilePhone
    ownerMobilePhoneCountry
    ownerName
    shopCloseTime
    shopGuid
    shopName
    shopOpenTime
    shopPhone
    zipcode
  }
}
    `;

/**
 * __useAdminShopDetailsQuery__
 *
 * To run a query within a React component, call `useAdminShopDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopDetailsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>(AdminShopDetailsDocument, options);
      }
export function useAdminShopDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>(AdminShopDetailsDocument, options);
        }
export type AdminShopDetailsQueryHookResult = ReturnType<typeof useAdminShopDetailsQuery>;
export type AdminShopDetailsLazyQueryHookResult = ReturnType<typeof useAdminShopDetailsLazyQuery>;
export type AdminShopDetailsQueryResult = Apollo.QueryResult<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>;
export const AdminShopOptionsDrivingRangeDocument = gql`
    query AdminShopOptionsDrivingRange($args: AdminShopOptionsDrivingRangeArgs!) {
  adminShopOptionsDrivingRange(args: $args) {
    courseId
    difficulty
    distanceUnit
    isBallTrajectory
    isFixedCamera
    isSwingVideo
    teeHeight
    useSwingPlate
    windSpeed
  }
}
    `;

/**
 * __useAdminShopOptionsDrivingRangeQuery__
 *
 * To run a query within a React component, call `useAdminShopOptionsDrivingRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopOptionsDrivingRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopOptionsDrivingRangeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopOptionsDrivingRangeQuery(baseOptions: Apollo.QueryHookOptions<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>(AdminShopOptionsDrivingRangeDocument, options);
      }
export function useAdminShopOptionsDrivingRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>(AdminShopOptionsDrivingRangeDocument, options);
        }
export type AdminShopOptionsDrivingRangeQueryHookResult = ReturnType<typeof useAdminShopOptionsDrivingRangeQuery>;
export type AdminShopOptionsDrivingRangeLazyQueryHookResult = ReturnType<typeof useAdminShopOptionsDrivingRangeLazyQuery>;
export type AdminShopOptionsDrivingRangeQueryResult = Apollo.QueryResult<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>;
export const AdminShopOptionsRealTimeDocument = gql`
    query AdminShopOptionsRealTime($args: AdminShopOptionsRealTimeArgs!) {
  adminShopOptionsRealTime(args: $args) {
    drivingRangeTimeLimit
    gameHoleTypeLimit
    gameTypeLimit
    isContentLimit
    paymentType
    playerCountLimit
    usageTime
  }
}
    `;

/**
 * __useAdminShopOptionsRealTimeQuery__
 *
 * To run a query within a React component, call `useAdminShopOptionsRealTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopOptionsRealTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopOptionsRealTimeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopOptionsRealTimeQuery(baseOptions: Apollo.QueryHookOptions<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>(AdminShopOptionsRealTimeDocument, options);
      }
export function useAdminShopOptionsRealTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>(AdminShopOptionsRealTimeDocument, options);
        }
export type AdminShopOptionsRealTimeQueryHookResult = ReturnType<typeof useAdminShopOptionsRealTimeQuery>;
export type AdminShopOptionsRealTimeLazyQueryHookResult = ReturnType<typeof useAdminShopOptionsRealTimeLazyQuery>;
export type AdminShopOptionsRealTimeQueryResult = Apollo.QueryResult<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>;
export const AdminShopOptionsRoundDocument = gql`
    query AdminShopOptionsRound($args: AdminShopOptionsRoundArgs!) {
  adminShopOptionsRound(args: $args) {
    concede
    distanceUnit
    greenLocation
    greenSpeed
    holeCupLocation
    isBestVideo
    isCaddyVoice
    isUseObHazardTee
    mulliganCount
    puttingLine
    useSwingPlate
    windSpeed
  }
}
    `;

/**
 * __useAdminShopOptionsRoundQuery__
 *
 * To run a query within a React component, call `useAdminShopOptionsRoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopOptionsRoundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopOptionsRoundQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopOptionsRoundQuery(baseOptions: Apollo.QueryHookOptions<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>(AdminShopOptionsRoundDocument, options);
      }
export function useAdminShopOptionsRoundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>(AdminShopOptionsRoundDocument, options);
        }
export type AdminShopOptionsRoundQueryHookResult = ReturnType<typeof useAdminShopOptionsRoundQuery>;
export type AdminShopOptionsRoundLazyQueryHookResult = ReturnType<typeof useAdminShopOptionsRoundLazyQuery>;
export type AdminShopOptionsRoundQueryResult = Apollo.QueryResult<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>;
export const AdminManagementSystemUserTelemetryDocument = gql`
    mutation AdminManagementSystemUserTelemetry($input: AdminManagementSystemUserTelemetryInput!) {
  adminManagementSystemUserTelemetry(input: $input)
}
    `;
export type AdminManagementSystemUserTelemetryMutationFn = Apollo.MutationFunction<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>;

/**
 * __useAdminManagementSystemUserTelemetryMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemUserTelemetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemUserTelemetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemUserTelemetryMutation, { data, loading, error }] = useAdminManagementSystemUserTelemetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemUserTelemetryMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>(AdminManagementSystemUserTelemetryDocument, options);
      }
export type AdminManagementSystemUserTelemetryMutationHookResult = ReturnType<typeof useAdminManagementSystemUserTelemetryMutation>;
export type AdminManagementSystemUserTelemetryMutationResult = Apollo.MutationResult<AdminManagementSystemUserTelemetryMutation>;
export type AdminManagementSystemUserTelemetryMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>;
export const AdminManagementSystemSupportTicketCreateDocument = gql`
    mutation AdminManagementSystemSupportTicketCreate($input: AdminManagementSystemSupportTicketCreateInput!) {
  adminManagementSystemSupportTicketCreate(input: $input) {
    id
  }
}
    `;
export type AdminManagementSystemSupportTicketCreateMutationFn = Apollo.MutationFunction<AdminManagementSystemSupportTicketCreateMutation, AdminManagementSystemSupportTicketCreateMutationVariables>;

/**
 * __useAdminManagementSystemSupportTicketCreateMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemSupportTicketCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemSupportTicketCreateMutation, { data, loading, error }] = useAdminManagementSystemSupportTicketCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemSupportTicketCreateMutation, AdminManagementSystemSupportTicketCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemSupportTicketCreateMutation, AdminManagementSystemSupportTicketCreateMutationVariables>(AdminManagementSystemSupportTicketCreateDocument, options);
      }
export type AdminManagementSystemSupportTicketCreateMutationHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketCreateMutation>;
export type AdminManagementSystemSupportTicketCreateMutationResult = Apollo.MutationResult<AdminManagementSystemSupportTicketCreateMutation>;
export type AdminManagementSystemSupportTicketCreateMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemSupportTicketCreateMutation, AdminManagementSystemSupportTicketCreateMutationVariables>;
export const AdminManagementSystemSupportTicketCommentAddDocument = gql`
    mutation AdminManagementSystemSupportTicketCommentAdd($input: AdminManagementSystemSupportTicketCommentAddInput!) {
  adminManagementSystemSupportTicketCommentAdd(input: $input)
}
    `;
export type AdminManagementSystemSupportTicketCommentAddMutationFn = Apollo.MutationFunction<AdminManagementSystemSupportTicketCommentAddMutation, AdminManagementSystemSupportTicketCommentAddMutationVariables>;

/**
 * __useAdminManagementSystemSupportTicketCommentAddMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemSupportTicketCommentAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketCommentAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemSupportTicketCommentAddMutation, { data, loading, error }] = useAdminManagementSystemSupportTicketCommentAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketCommentAddMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemSupportTicketCommentAddMutation, AdminManagementSystemSupportTicketCommentAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemSupportTicketCommentAddMutation, AdminManagementSystemSupportTicketCommentAddMutationVariables>(AdminManagementSystemSupportTicketCommentAddDocument, options);
      }
export type AdminManagementSystemSupportTicketCommentAddMutationHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketCommentAddMutation>;
export type AdminManagementSystemSupportTicketCommentAddMutationResult = Apollo.MutationResult<AdminManagementSystemSupportTicketCommentAddMutation>;
export type AdminManagementSystemSupportTicketCommentAddMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemSupportTicketCommentAddMutation, AdminManagementSystemSupportTicketCommentAddMutationVariables>;
export const AdminManagementSystemSupportTicketCommentUpdateDocument = gql`
    mutation AdminManagementSystemSupportTicketCommentUpdate($input: AdminManagementSystemSupportTicketCommentUpdateInput!) {
  adminManagementSystemSupportTicketCommentUpdate(input: $input)
}
    `;
export type AdminManagementSystemSupportTicketCommentUpdateMutationFn = Apollo.MutationFunction<AdminManagementSystemSupportTicketCommentUpdateMutation, AdminManagementSystemSupportTicketCommentUpdateMutationVariables>;

/**
 * __useAdminManagementSystemSupportTicketCommentUpdateMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemSupportTicketCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemSupportTicketCommentUpdateMutation, { data, loading, error }] = useAdminManagementSystemSupportTicketCommentUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketCommentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemSupportTicketCommentUpdateMutation, AdminManagementSystemSupportTicketCommentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemSupportTicketCommentUpdateMutation, AdminManagementSystemSupportTicketCommentUpdateMutationVariables>(AdminManagementSystemSupportTicketCommentUpdateDocument, options);
      }
export type AdminManagementSystemSupportTicketCommentUpdateMutationHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketCommentUpdateMutation>;
export type AdminManagementSystemSupportTicketCommentUpdateMutationResult = Apollo.MutationResult<AdminManagementSystemSupportTicketCommentUpdateMutation>;
export type AdminManagementSystemSupportTicketCommentUpdateMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemSupportTicketCommentUpdateMutation, AdminManagementSystemSupportTicketCommentUpdateMutationVariables>;
export const AdminManagementSystemSupportTicketCommentDeleteDocument = gql`
    mutation AdminManagementSystemSupportTicketCommentDelete($input: AdminManagementSystemSupportTicketCommentDeleteInput!) {
  adminManagementSystemSupportTicketCommentDelete(input: $input)
}
    `;
export type AdminManagementSystemSupportTicketCommentDeleteMutationFn = Apollo.MutationFunction<AdminManagementSystemSupportTicketCommentDeleteMutation, AdminManagementSystemSupportTicketCommentDeleteMutationVariables>;

/**
 * __useAdminManagementSystemSupportTicketCommentDeleteMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemSupportTicketCommentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketCommentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemSupportTicketCommentDeleteMutation, { data, loading, error }] = useAdminManagementSystemSupportTicketCommentDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketCommentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemSupportTicketCommentDeleteMutation, AdminManagementSystemSupportTicketCommentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemSupportTicketCommentDeleteMutation, AdminManagementSystemSupportTicketCommentDeleteMutationVariables>(AdminManagementSystemSupportTicketCommentDeleteDocument, options);
      }
export type AdminManagementSystemSupportTicketCommentDeleteMutationHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketCommentDeleteMutation>;
export type AdminManagementSystemSupportTicketCommentDeleteMutationResult = Apollo.MutationResult<AdminManagementSystemSupportTicketCommentDeleteMutation>;
export type AdminManagementSystemSupportTicketCommentDeleteMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemSupportTicketCommentDeleteMutation, AdminManagementSystemSupportTicketCommentDeleteMutationVariables>;
export const AdminManagementSystemSupportTicketDeleteDocument = gql`
    mutation AdminManagementSystemSupportTicketDelete($input: AdminManagementSystemSupportTicketDeleteInput!) {
  adminManagementSystemSupportTicketDelete(input: $input)
}
    `;
export type AdminManagementSystemSupportTicketDeleteMutationFn = Apollo.MutationFunction<AdminManagementSystemSupportTicketDeleteMutation, AdminManagementSystemSupportTicketDeleteMutationVariables>;

/**
 * __useAdminManagementSystemSupportTicketDeleteMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemSupportTicketDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemSupportTicketDeleteMutation, { data, loading, error }] = useAdminManagementSystemSupportTicketDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemSupportTicketDeleteMutation, AdminManagementSystemSupportTicketDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemSupportTicketDeleteMutation, AdminManagementSystemSupportTicketDeleteMutationVariables>(AdminManagementSystemSupportTicketDeleteDocument, options);
      }
export type AdminManagementSystemSupportTicketDeleteMutationHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketDeleteMutation>;
export type AdminManagementSystemSupportTicketDeleteMutationResult = Apollo.MutationResult<AdminManagementSystemSupportTicketDeleteMutation>;
export type AdminManagementSystemSupportTicketDeleteMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemSupportTicketDeleteMutation, AdminManagementSystemSupportTicketDeleteMutationVariables>;
export const AdminManagementSystemSupportTicketUpdateDocument = gql`
    mutation AdminManagementSystemSupportTicketUpdate($input: AdminManagementSystemSupportTicketUpdateInput!) {
  adminManagementSystemSupportTicketUpdate(input: $input)
}
    `;
export type AdminManagementSystemSupportTicketUpdateMutationFn = Apollo.MutationFunction<AdminManagementSystemSupportTicketUpdateMutation, AdminManagementSystemSupportTicketUpdateMutationVariables>;

/**
 * __useAdminManagementSystemSupportTicketUpdateMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemSupportTicketUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemSupportTicketUpdateMutation, { data, loading, error }] = useAdminManagementSystemSupportTicketUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemSupportTicketUpdateMutation, AdminManagementSystemSupportTicketUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemSupportTicketUpdateMutation, AdminManagementSystemSupportTicketUpdateMutationVariables>(AdminManagementSystemSupportTicketUpdateDocument, options);
      }
export type AdminManagementSystemSupportTicketUpdateMutationHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketUpdateMutation>;
export type AdminManagementSystemSupportTicketUpdateMutationResult = Apollo.MutationResult<AdminManagementSystemSupportTicketUpdateMutation>;
export type AdminManagementSystemSupportTicketUpdateMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemSupportTicketUpdateMutation, AdminManagementSystemSupportTicketUpdateMutationVariables>;
export const AdminManagementSystemReportingDocument = gql`
    mutation AdminManagementSystemReporting($input: AdminManagementSystemReportingInput!) {
  adminManagementSystemReporting(input: $input)
}
    `;
export type AdminManagementSystemReportingMutationFn = Apollo.MutationFunction<AdminManagementSystemReportingMutation, AdminManagementSystemReportingMutationVariables>;

/**
 * __useAdminManagementSystemReportingMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemReportingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemReportingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemReportingMutation, { data, loading, error }] = useAdminManagementSystemReportingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemReportingMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemReportingMutation, AdminManagementSystemReportingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemReportingMutation, AdminManagementSystemReportingMutationVariables>(AdminManagementSystemReportingDocument, options);
      }
export type AdminManagementSystemReportingMutationHookResult = ReturnType<typeof useAdminManagementSystemReportingMutation>;
export type AdminManagementSystemReportingMutationResult = Apollo.MutationResult<AdminManagementSystemReportingMutation>;
export type AdminManagementSystemReportingMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemReportingMutation, AdminManagementSystemReportingMutationVariables>;
export const AdminManagementSystemAppMainSliderCreateDocument = gql`
    mutation AdminManagementSystemAppMainSliderCreate($input: AdminManagementSystemAppMainSliderCreateInput!) {
  adminManagementSystemAppMainSliderCreate(input: $input) {
    id
  }
}
    `;
export type AdminManagementSystemAppMainSliderCreateMutationFn = Apollo.MutationFunction<AdminManagementSystemAppMainSliderCreateMutation, AdminManagementSystemAppMainSliderCreateMutationVariables>;

/**
 * __useAdminManagementSystemAppMainSliderCreateMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemAppMainSliderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemAppMainSliderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemAppMainSliderCreateMutation, { data, loading, error }] = useAdminManagementSystemAppMainSliderCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemAppMainSliderCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemAppMainSliderCreateMutation, AdminManagementSystemAppMainSliderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemAppMainSliderCreateMutation, AdminManagementSystemAppMainSliderCreateMutationVariables>(AdminManagementSystemAppMainSliderCreateDocument, options);
      }
export type AdminManagementSystemAppMainSliderCreateMutationHookResult = ReturnType<typeof useAdminManagementSystemAppMainSliderCreateMutation>;
export type AdminManagementSystemAppMainSliderCreateMutationResult = Apollo.MutationResult<AdminManagementSystemAppMainSliderCreateMutation>;
export type AdminManagementSystemAppMainSliderCreateMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemAppMainSliderCreateMutation, AdminManagementSystemAppMainSliderCreateMutationVariables>;
export const AdminManagementSystemAppMainSliderUpdateDocument = gql`
    mutation AdminManagementSystemAppMainSliderUpdate($input: AdminManagementSystemAppMainSliderUpdateInput!) {
  adminManagementSystemAppMainSliderUpdate(input: $input) {
    id
  }
}
    `;
export type AdminManagementSystemAppMainSliderUpdateMutationFn = Apollo.MutationFunction<AdminManagementSystemAppMainSliderUpdateMutation, AdminManagementSystemAppMainSliderUpdateMutationVariables>;

/**
 * __useAdminManagementSystemAppMainSliderUpdateMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemAppMainSliderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemAppMainSliderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemAppMainSliderUpdateMutation, { data, loading, error }] = useAdminManagementSystemAppMainSliderUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemAppMainSliderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemAppMainSliderUpdateMutation, AdminManagementSystemAppMainSliderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemAppMainSliderUpdateMutation, AdminManagementSystemAppMainSliderUpdateMutationVariables>(AdminManagementSystemAppMainSliderUpdateDocument, options);
      }
export type AdminManagementSystemAppMainSliderUpdateMutationHookResult = ReturnType<typeof useAdminManagementSystemAppMainSliderUpdateMutation>;
export type AdminManagementSystemAppMainSliderUpdateMutationResult = Apollo.MutationResult<AdminManagementSystemAppMainSliderUpdateMutation>;
export type AdminManagementSystemAppMainSliderUpdateMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemAppMainSliderUpdateMutation, AdminManagementSystemAppMainSliderUpdateMutationVariables>;
export const AdminManagementSystemAppMainSliderDeleteDocument = gql`
    mutation AdminManagementSystemAppMainSliderDelete($input: AdminManagementSystemAppMainSliderDeleteInput!) {
  adminManagementSystemAppMainSliderDelete(input: $input)
}
    `;
export type AdminManagementSystemAppMainSliderDeleteMutationFn = Apollo.MutationFunction<AdminManagementSystemAppMainSliderDeleteMutation, AdminManagementSystemAppMainSliderDeleteMutationVariables>;

/**
 * __useAdminManagementSystemAppMainSliderDeleteMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemAppMainSliderDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemAppMainSliderDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemAppMainSliderDeleteMutation, { data, loading, error }] = useAdminManagementSystemAppMainSliderDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemAppMainSliderDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemAppMainSliderDeleteMutation, AdminManagementSystemAppMainSliderDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemAppMainSliderDeleteMutation, AdminManagementSystemAppMainSliderDeleteMutationVariables>(AdminManagementSystemAppMainSliderDeleteDocument, options);
      }
export type AdminManagementSystemAppMainSliderDeleteMutationHookResult = ReturnType<typeof useAdminManagementSystemAppMainSliderDeleteMutation>;
export type AdminManagementSystemAppMainSliderDeleteMutationResult = Apollo.MutationResult<AdminManagementSystemAppMainSliderDeleteMutation>;
export type AdminManagementSystemAppMainSliderDeleteMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemAppMainSliderDeleteMutation, AdminManagementSystemAppMainSliderDeleteMutationVariables>;
export const AdminManagementSystemAppMainSliderUploadDocument = gql`
    mutation AdminManagementSystemAppMainSliderUpload($input: AdminManagementSystemAppMainSliderUploadInput!) {
  adminManagementSystemAppMainSliderUpload(input: $input) {
    fields
    fileUrl
    isVideo
    key
    signedUrl
  }
}
    `;
export type AdminManagementSystemAppMainSliderUploadMutationFn = Apollo.MutationFunction<AdminManagementSystemAppMainSliderUploadMutation, AdminManagementSystemAppMainSliderUploadMutationVariables>;

/**
 * __useAdminManagementSystemAppMainSliderUploadMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemAppMainSliderUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemAppMainSliderUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemAppMainSliderUploadMutation, { data, loading, error }] = useAdminManagementSystemAppMainSliderUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemAppMainSliderUploadMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemAppMainSliderUploadMutation, AdminManagementSystemAppMainSliderUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemAppMainSliderUploadMutation, AdminManagementSystemAppMainSliderUploadMutationVariables>(AdminManagementSystemAppMainSliderUploadDocument, options);
      }
export type AdminManagementSystemAppMainSliderUploadMutationHookResult = ReturnType<typeof useAdminManagementSystemAppMainSliderUploadMutation>;
export type AdminManagementSystemAppMainSliderUploadMutationResult = Apollo.MutationResult<AdminManagementSystemAppMainSliderUploadMutation>;
export type AdminManagementSystemAppMainSliderUploadMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemAppMainSliderUploadMutation, AdminManagementSystemAppMainSliderUploadMutationVariables>;
export const AdminManagementSystemPropsDocument = gql`
    query AdminManagementSystemProps {
  adminManagementSystemProps {
    currentAppVersion
  }
}
    `;

/**
 * __useAdminManagementSystemPropsQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemPropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemPropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemPropsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminManagementSystemPropsQuery(baseOptions?: Apollo.QueryHookOptions<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>(AdminManagementSystemPropsDocument, options);
      }
export function useAdminManagementSystemPropsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>(AdminManagementSystemPropsDocument, options);
        }
export type AdminManagementSystemPropsQueryHookResult = ReturnType<typeof useAdminManagementSystemPropsQuery>;
export type AdminManagementSystemPropsLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemPropsLazyQuery>;
export type AdminManagementSystemPropsQueryResult = Apollo.QueryResult<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>;
export const AdminManagementSystemSupportTicketsDocument = gql`
    query AdminManagementSystemSupportTickets($args: AdminManagementSystemSupportTicketsArgs!) {
  adminManagementSystemSupportTickets(args: $args) {
    edges {
      cursor
      node {
        dateClosed
        dateOpened
        id
        initiatorId
        initiatorName
        priority
        status
        title
      }
    }
    firstTicketDate
    lastTicketDate
    pageInfo {
      endCursor
      firstRecordDateTime
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminManagementSystemSupportTicketsQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemSupportTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemSupportTicketsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketsQuery(baseOptions: Apollo.QueryHookOptions<AdminManagementSystemSupportTicketsQuery, AdminManagementSystemSupportTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemSupportTicketsQuery, AdminManagementSystemSupportTicketsQueryVariables>(AdminManagementSystemSupportTicketsDocument, options);
      }
export function useAdminManagementSystemSupportTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemSupportTicketsQuery, AdminManagementSystemSupportTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemSupportTicketsQuery, AdminManagementSystemSupportTicketsQueryVariables>(AdminManagementSystemSupportTicketsDocument, options);
        }
export type AdminManagementSystemSupportTicketsQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketsQuery>;
export type AdminManagementSystemSupportTicketsLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketsLazyQuery>;
export type AdminManagementSystemSupportTicketsQueryResult = Apollo.QueryResult<AdminManagementSystemSupportTicketsQuery, AdminManagementSystemSupportTicketsQueryVariables>;
export const AdminManagementSystemSupportTicketDocument = gql`
    query AdminManagementSystemSupportTicket($args: AdminManagementSystemSupportTicketArgs!) {
  adminManagementSystemSupportTicket(args: $args) {
    approvedBy
    body
    bodyUpdatedAt
    category
    dateClosed
    dateOpened
    id
    manHoursRequired
    openedBy
    priority
    startDate
    status
    title
    updatedAt
    userId
    userProfileImageUrl
  }
}
    `;

/**
 * __useAdminManagementSystemSupportTicketQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemSupportTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemSupportTicketQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketQuery(baseOptions: Apollo.QueryHookOptions<AdminManagementSystemSupportTicketQuery, AdminManagementSystemSupportTicketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemSupportTicketQuery, AdminManagementSystemSupportTicketQueryVariables>(AdminManagementSystemSupportTicketDocument, options);
      }
export function useAdminManagementSystemSupportTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemSupportTicketQuery, AdminManagementSystemSupportTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemSupportTicketQuery, AdminManagementSystemSupportTicketQueryVariables>(AdminManagementSystemSupportTicketDocument, options);
        }
export type AdminManagementSystemSupportTicketQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketQuery>;
export type AdminManagementSystemSupportTicketLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketLazyQuery>;
export type AdminManagementSystemSupportTicketQueryResult = Apollo.QueryResult<AdminManagementSystemSupportTicketQuery, AdminManagementSystemSupportTicketQueryVariables>;
export const AdminManagementSystemSupportTicketCommentsDocument = gql`
    query AdminManagementSystemSupportTicketComments($args: AdminManagementSystemSupportTicketCommentsArgs!) {
  adminManagementSystemSupportTicketComments(args: $args) {
    editedOn
    id
    message
    postedOn
    userId
    userName
    userProfileImageUrl
  }
}
    `;

/**
 * __useAdminManagementSystemSupportTicketCommentsQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemSupportTicketCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemSupportTicketCommentsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketCommentsQuery(baseOptions: Apollo.QueryHookOptions<AdminManagementSystemSupportTicketCommentsQuery, AdminManagementSystemSupportTicketCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemSupportTicketCommentsQuery, AdminManagementSystemSupportTicketCommentsQueryVariables>(AdminManagementSystemSupportTicketCommentsDocument, options);
      }
export function useAdminManagementSystemSupportTicketCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemSupportTicketCommentsQuery, AdminManagementSystemSupportTicketCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemSupportTicketCommentsQuery, AdminManagementSystemSupportTicketCommentsQueryVariables>(AdminManagementSystemSupportTicketCommentsDocument, options);
        }
export type AdminManagementSystemSupportTicketCommentsQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketCommentsQuery>;
export type AdminManagementSystemSupportTicketCommentsLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketCommentsLazyQuery>;
export type AdminManagementSystemSupportTicketCommentsQueryResult = Apollo.QueryResult<AdminManagementSystemSupportTicketCommentsQuery, AdminManagementSystemSupportTicketCommentsQueryVariables>;
export const AdminManagementSystemSupportTicketUsersDocument = gql`
    query AdminManagementSystemSupportTicketUsers {
  adminManagementSystemSupportTicketUsers {
    userId
    userName
  }
}
    `;

/**
 * __useAdminManagementSystemSupportTicketUsersQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemSupportTicketUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemSupportTicketUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemSupportTicketUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminManagementSystemSupportTicketUsersQuery(baseOptions?: Apollo.QueryHookOptions<AdminManagementSystemSupportTicketUsersQuery, AdminManagementSystemSupportTicketUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemSupportTicketUsersQuery, AdminManagementSystemSupportTicketUsersQueryVariables>(AdminManagementSystemSupportTicketUsersDocument, options);
      }
export function useAdminManagementSystemSupportTicketUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemSupportTicketUsersQuery, AdminManagementSystemSupportTicketUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemSupportTicketUsersQuery, AdminManagementSystemSupportTicketUsersQueryVariables>(AdminManagementSystemSupportTicketUsersDocument, options);
        }
export type AdminManagementSystemSupportTicketUsersQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketUsersQuery>;
export type AdminManagementSystemSupportTicketUsersLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemSupportTicketUsersLazyQuery>;
export type AdminManagementSystemSupportTicketUsersQueryResult = Apollo.QueryResult<AdminManagementSystemSupportTicketUsersQuery, AdminManagementSystemSupportTicketUsersQueryVariables>;
export const AdminManagementSystemAppMainSlidersDocument = gql`
    query AdminManagementSystemAppMainSliders($args: AdminManagementSystemAppMainSlidersArgs) {
  adminManagementSystemAppMainSliders(args: $args) {
    baseCountryCode
    expiryDate
    id
    isVideo
    isYoutube
    linkRoute
    linkTitle
    linkUrl
    order
    posterPayload
    posterTitle
    posterUri
    publish
    slidePayload
    slideUri
    webViewUrl
  }
}
    `;

/**
 * __useAdminManagementSystemAppMainSlidersQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemAppMainSlidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemAppMainSlidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemAppMainSlidersQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminManagementSystemAppMainSlidersQuery(baseOptions?: Apollo.QueryHookOptions<AdminManagementSystemAppMainSlidersQuery, AdminManagementSystemAppMainSlidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemAppMainSlidersQuery, AdminManagementSystemAppMainSlidersQueryVariables>(AdminManagementSystemAppMainSlidersDocument, options);
      }
export function useAdminManagementSystemAppMainSlidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemAppMainSlidersQuery, AdminManagementSystemAppMainSlidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemAppMainSlidersQuery, AdminManagementSystemAppMainSlidersQueryVariables>(AdminManagementSystemAppMainSlidersDocument, options);
        }
export type AdminManagementSystemAppMainSlidersQueryHookResult = ReturnType<typeof useAdminManagementSystemAppMainSlidersQuery>;
export type AdminManagementSystemAppMainSlidersLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemAppMainSlidersLazyQuery>;
export type AdminManagementSystemAppMainSlidersQueryResult = Apollo.QueryResult<AdminManagementSystemAppMainSlidersQuery, AdminManagementSystemAppMainSlidersQueryVariables>;
export const AdminManagementSystemAppMainSliderDocument = gql`
    query AdminManagementSystemAppMainSlider($args: AdminManagementSystemAppMainSliderArgs!) {
  adminManagementSystemAppMainSlider(args: $args) {
    baseCountryCode
    expiryDate
    id
    isVideo
    isYoutube
    linkRoute
    linkTitle
    linkUrl
    order
    posterPayload
    posterTitle
    posterUri
    publish
    slidePayload
    slideUri
    webViewUrl
  }
}
    `;

/**
 * __useAdminManagementSystemAppMainSliderQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemAppMainSliderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemAppMainSliderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemAppMainSliderQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminManagementSystemAppMainSliderQuery(baseOptions: Apollo.QueryHookOptions<AdminManagementSystemAppMainSliderQuery, AdminManagementSystemAppMainSliderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemAppMainSliderQuery, AdminManagementSystemAppMainSliderQueryVariables>(AdminManagementSystemAppMainSliderDocument, options);
      }
export function useAdminManagementSystemAppMainSliderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemAppMainSliderQuery, AdminManagementSystemAppMainSliderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemAppMainSliderQuery, AdminManagementSystemAppMainSliderQueryVariables>(AdminManagementSystemAppMainSliderDocument, options);
        }
export type AdminManagementSystemAppMainSliderQueryHookResult = ReturnType<typeof useAdminManagementSystemAppMainSliderQuery>;
export type AdminManagementSystemAppMainSliderLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemAppMainSliderLazyQuery>;
export type AdminManagementSystemAppMainSliderQueryResult = Apollo.QueryResult<AdminManagementSystemAppMainSliderQuery, AdminManagementSystemAppMainSliderQueryVariables>;
export const ManagementSystemDocument = gql`
    subscription ManagementSystem($args: ManagementSystemArgs!) {
  managementSystem(args: $args) {
    eventId
    evictionFieldNames
    operation
    payload
    ref
    userId
    userName
    userProfileImageUrl
  }
}
    `;

/**
 * __useManagementSystemSubscription__
 *
 * To run a query within a React component, call `useManagementSystemSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagementSystemSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementSystemSubscription({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useManagementSystemSubscription(baseOptions: Apollo.SubscriptionHookOptions<ManagementSystemSubscription, ManagementSystemSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ManagementSystemSubscription, ManagementSystemSubscriptionVariables>(ManagementSystemDocument, options);
      }
export type ManagementSystemSubscriptionHookResult = ReturnType<typeof useManagementSystemSubscription>;
export type ManagementSystemSubscriptionResult = Apollo.SubscriptionResult<ManagementSystemSubscription>;